/* eslint-disable */
import { AxiosPromise } from 'axios';
import ApiService, { IAjaxOptions, AxiosMethod } from '@app/Services/ApiService';
export class BaseApiModelClass< T > {
    constructor(data?: T & {}) {
        if (data)
            for (let property in data)
                if (data.hasOwnProperty(property))
                    (< any >this)[property] = (< any >data)[property];
    }
}
export interface IAircraftsParams {}
export interface IMaintenanceParams {
    dateFrom?: Date
    dateTo?: Date
}
export interface IGetByIdParams {
    id: string
}
export interface IUpdateParams {
    id: string
    body?: AircraftEditModel
}
export interface IGetTypesAllParams {}
export interface IGetTypesParams {
    idQuery?: string
    idPath: string
}
export interface IUpdateTypeParams {
    id: string
    body?: AircraftTypeModel
}
export interface IGetTypeGroupsParams {}
export interface IGetCabinParams {
    body?: AircraftTypeRecencyReportFilter
}
export interface IGetCockpitParams {
    body?: AircraftTypeRecencyReportCockpitFilter
}
export interface IGetByCodeParams {
    threeLetterCode: string
}
export interface IGetAllParams {
    search?: string
    page?: number
    pageSize?: number
    includeDisabled?: boolean
}
export interface IGetAll2Params {
    threeLetterCode: string
}
export interface IGetReportPOSTParams {
    body?: AirportRecencyReportFilter
}
export interface IGetDataParams {
    personId?: string
    date?: Date
}
export interface IGetRulesParams {
    body?: AreaRouteCompetenceRulesReportFilter
}
export interface IListAllParams {}
export interface IRulesListParams {}
export interface ICreateRuleParams {
    body?: AreaRouteCompetenceAirportDto
}
export interface IDeleteRuleParams {
    airportThreeLetterCode?: string
    routeCompetenceId?: string
}
export interface IGetWebBasedTrainingsParams {
    personId?: string
}
export interface IAddWebBasedTrainingParams {
    body?: WebBasedTrainingCreateModel
}
export interface IDeleteWebBasedTrainingParams {
    personId?: string
    competencyId?: string
    date?: Date
}
export interface IGetPOSTParams {
    body?: AreaRouteCompetenceReportFilter
}
export interface IGetListAllParams {}
export interface ICreateReportParams {
    body?: CateringReportCreateModel
}
export interface IGetReportGETParams {
    reportId: string
}
export interface IGetPOST2Params {
    body?: ChangeLogFilter
}
export interface IPutParams {
    body?: ChangeLogModel
}
export interface ITogglePlanningConfirmationParams {
    changeLogItemId?: string
    isConfirmed?: boolean
}
export interface IUpdateReasonParams {
    body?: UpdateChangeLogTextModel
}
export interface IUpdateOldDutyParams {
    body?: UpdateChangeLogTextModel
}
export interface IUpdateNewDutyParams {
    body?: UpdateChangeLogTextModel
}
export interface IGetFlightCommentsParams {
    flightId?: string
}
export interface IPut2Params {
    body?: FlightCommentDto
}
export interface IGetPersonCommentsParams {
    personId?: string
    date?: Date
    showAllComments?: boolean
}
export interface IPostAllParams {
    body?: PersonCommentCreateDto
}
export interface IPut3Params {
    body?: PersonCommentUpdateDto
}
export interface IUpdateCommentParams {
    body?: PersonCommentUpdateDto
}
export interface IGetDayCommentsParams {
    personId?: string
    date?: Date
}
export interface IPostParams {
    body?: DayCommentCreateDto
}
export interface IPut4Params {
    body?: DayCommentUpdateDto
}
export interface IGetStandByCommentsParams {
    personId?: string
    date?: Date
}
export interface ICreateMultiParams {
    body?: MultiDayCommentCreateDto
}
export interface IGetValidationCommentsParams {
    personId?: string
    personDate?: Date
}
export interface IPut5Params {
    body?: ValidationCommentDto
}
export interface IPut6Params {
    body?: DutyCommentDto
}
export interface IGetDutyParams {
    personId?: string
    date?: Date
}
export interface IPutPlanningNoteParams {
    body?: CreatePlaningNoteModel
}
export interface IGetPlanningNoteParams {
    personId?: string
    date?: Date
}
export interface IDeleteParams {
    id?: string
}
export interface IGetAll3Params {
    commentsIds?:string[] | string 
}
export interface IGetPOST3Params {
    body?: CommentReportFilter
}
export interface IGetAll4Params {
    keys?: string
}
export interface IPut7Params {
    body?: ConfigurationModel
}
export interface IGetContractTypesKeyPairValuesParams {}
export interface IGetContractTypesFilterDataParams {}
export interface IGetAll5Params {
    onlyAirportRelated?: boolean
}
export interface IGetCourseListParams {
    body?: CourseManagementFilter
}
export interface IGetCourseParams {
    id?: string
}
export interface ICreateCourseParams {
    body?: CourseDto
}
export interface IDeleteCourseParams {
    id?: string
}
export interface IGetCabinCrewAttestationReportDataParams {
    body?: CabinCrewAttestationReportFilter
}
export interface IGetCoursePdfParams {
    courseId?: string
    personId?: string
}
export interface IGetCourseBazlParams {
    courseId?: string
}
export interface IImportFileParams {
    formFile?: FileParameter
}
export interface IGetPersonCoursesParams {}
export interface IGetCrewPortalCoursePdfParams {
    courseId?: string
}
export interface ISignAttestateParams {
    body?: SignAttestateDto
}
export interface IIncorrectAttestateParams {
    body?: IncorrectAttestateDto
}
export interface IGetAll6Params {}
export interface IPut8Params {
    body?: CrewApiConfigurationModel
}
export interface IDeleteAllParams {
    fourLetterCode?: string
}
export interface IGetMassConfigurationParams {}
export interface IUpdateMassConfigurationParams {
    body?: CrewApiMassRecipientConfiguration
}
export interface IGetConfigurationReportParams {
    loadOptions_HasInvalidEntries?: boolean
    loadOptions_Filter?: any[]
    loadOptions_RequireTotalCount?: boolean
    loadOptions_RequireGroupCount?: boolean
    loadOptions_IsCountQuery?: boolean
    loadOptions_IsSummaryQuery?: boolean
    loadOptions_Skip?: number
    loadOptions_Take?: number
    loadOptions_Sort?: SortingInfo[]
    loadOptions_Group?: GroupingInfo[]
    loadOptions_TotalSummary?: SummaryInfo[]
    loadOptions_GroupSummary?: SummaryInfo[]
    loadOptions_Select?: string[]
    loadOptions_PreSelect?: string[]
    loadOptions_RemoteSelect?: boolean
    loadOptions_RemoteGrouping?: boolean
    loadOptions_ExpandLinqSumType?: boolean
    loadOptions_PrimaryKey?: string[]
    loadOptions_DefaultSort?: string
    loadOptions_StringToLower?: boolean
    loadOptions_PaginateViaPrimaryKey?: boolean
    loadOptions_SortByPrimaryKey?: boolean
    loadOptions_AllowAsyncOverSync?: boolean
    rowLimit?: number
}
export interface IGetByCodeAllParams {
    countryCode: string
}
export interface IGetMessageFormatsParams {}
export interface IGetDeliveryMethodsParams {}
export interface IGetTriggersParams {}
export interface IGetPayloadParams {
    flightId: string
    itemId?: string
}
export interface IGeneratePayloadsParams {
    flightId: string
}
export interface IManuallyProcessFlightParams {
    flightId: string
}
export interface IGetQueueForFLightParams {
    flightId: string
}
export interface IGetQueueParams {
    locationRcd: string
}
export interface IGetFlightsParams {
    periodFrom?: Date
    periodTo?: Date
}
export interface IGetFlights2Params {
    flightId: string
}
export interface IGetHistoryParams {
    periodFrom?: Date
    periodTo?: Date
    personId?: string
    showAll?: boolean
}
export interface IGetHistoryPayloadParams {
    flightId: string
    itemId: string
    showAll?: boolean
}
export interface IGetPaxLstCountParams {
    flightId?: string
    itemId?: string
}
export interface IGetRelatedAirportsParams {}
export interface IGetPersonMclStateParams {
    personId: string
}
export interface IAddPersonToMclQueueParams {
    personId: string
}
export interface IUpdatePersonInMclQueueParams {
    personId: string
}
export interface IDeletePersonInMclQueueParams {
    personId: string
}
export interface ISkipPendingPersonMclChangesParams {
    personId: string
}
export interface IGetMclMissingDataPersonsParams {}
export interface ICrewDutyListReportParams {
    body?: CrewDutyListReportFilter
}
export interface IExportReportParams {
    body?: ExportCrewDutyListReportFilter
}
export interface IGetPOST4Params {
    body?: CrewNotificationTimeReportFilter
}
export interface IGetListParams {
    body?: CustomPersonManagementFilter
}
export interface IGetMarshalParams {
    id: string
}
export interface ICreatePersonParams {
    body?: CustomPersonManagementDialogModel
}
export interface IUpdatePersonParams {
    body?: CustomPersonManagementDialogModel
}
export interface IPingParams {}
export interface IGetVersionParams {}
export interface IGetPOST5Params {
    body?: DooxReportFilter
}
export interface IDosimetryReportParams {
    body?: PersonDosimetryFilter
}
export interface IGetDutiesParams {
    dateFrom?: Date
    dateTo?: Date
    personIds?:string[] | string 
    rosterType?: RosterType
}
export interface IUpdateDutyParams {
    body?: DutyCreateModel
}
export interface IDeleteDutyParams {
    body?: DutyRemoveModel
}
export interface IDownloadValidationParams {
    body?: RevalidatePersonModel
}
export interface IDownloadValidationResultParams {
    body?: RevalidatePersonModel
}
export interface IValidationDataParams {
    date?: Date
    personId?: string
}
export interface IValidationDataGroundParams {
    date?: Date
    personId?: string
}
export interface IValidationDataFseParams {
    date?: Date
    personId?: string
}
export interface ICopyParams {
    body?: CopyDutyModel
}
export interface IGetUndoOperationsParams {}
export interface IUndoParams {
    operationId?: string
}
export interface IDeleteUndoParams {
    operationId?: string
}
export interface IBulkUndoParams {
    body?: BulkUndoModel
}
export interface IGetDayActivitiesParams {
    day?: Date
    ids?:string[] | string 
    functionId?: string
    functionIds?:string[] | string 
    codes?: string[]
    referenceDate?: Date
    referenceDateTo?: Date
    qualificationIds?:string[] | string 
    contractTypes?: ContractType[]
    contractFlagTypes?: ContractFlagType[]
    partialLoadType?: PartialLoadType
    search?: string
    searchByFullName?: boolean
    dutyFilter?: DutyFilter[]
    monthlyTypes?: MonthlyType[]
    releaseFilterTypes?: ReleaseFilterType[]
    sort?: PersonSortOrder
    order?: SortOrder
    sortBaseDate?: Date
    functionFromDate?: Date
    typeRatingFilters?: TypeRatingFilter[]
    instructorFilters?: string
    aeropersMember?: boolean
    nbuCockpitRelated?: boolean
    nbuCabinRelated?: boolean
    includeInactive?: boolean
    page?: number
    pageSize?: number
    optInShowEfaSchedule?: boolean
    includeWithoutEmail?: boolean
}
export interface IGetMonthDutyTypesParams {}
export interface IGetReleaseFilterTypesParams {}
export interface IGetDayHistoryParams {
    body?: DutyHistoryFilter
}
export interface ISeatHistoryParams {
    flightIds?:string[] | string 
    activityRcd?: string
}
export interface IUpdateTitleParams {
    body?: DutyTitle
}
export interface ISwapSectorsParams {
    body?: SwapSectorModel
}
export interface ISwapRotationsParams {
    body?: SwapRotationModel
}
export interface IModeSectorsParams {
    body?: MoveSectorModel
}
export interface ISwapRotations2Params {
    body?: MoveRotationModel
}
export interface IHideDutyParams {
    body?: HideDutyModel
}
export interface IDayDutiesParams {
    date?: Date
    personId?: string
}
export interface IGetPartialLoadTypesParams {}
export interface IGetDutyHoursParams {
    date?: Date
    personId?: string
    activityRcd?: string
}
export interface IChangeDutyHoursParams {
    body?: ChangeDutyHoursModel
}
export interface IGetUrgentDutiesParams {}
export interface IGetUrgentDutiesForReleasePeriodParams {}
export interface ISetPersonCustomLandingParams {
    body?: PersonDayLandingRequest
}
export interface IGetCustomLandingsParams {
    date?: Date
    personId?: string
}
export interface ISetPersonCustomTakeoffParams {
    body?: PersonDayLandingRequest
}
export interface IGetCustomTakeoffsParams {
    date?: Date
    personId?: string
}
export interface IPersistDutiesParams {
    body?: PersonDaysModel[]
}
export interface IServiceBusMessagesForPersonDayParams {
    personId?: string
    date?: Date
}
export interface IConfigurePlanningPeriodVisibilityParams {
    body?: PlanningPeriodConfigRequest
}
export interface IGetPlanningPeriodsParams {}
export interface IGetPlanningRsvPeriodsParams {}
export interface IStartPlanningRsvParams {}
export interface IReleasePlanningRsvParams {}
export interface IGetDutyPartsParams {
    date?: Date
    personId?: string
}
export interface IUpdateDutyPartsParams {
    date?: Date
    personId?: string
    body?: DutyPartUpdateRequest
}
export interface IRecencyLandingsParams {
    dateFrom?: Date
    dateTo?: Date
    personId?: string
}
export interface IRecencyTakeoffsParams {
    dateFrom?: Date
    dateTo?: Date
    personId?: string
}
export interface IGetAll7Params {
    date?: Date
    flightIds?:string[] | string 
}
export interface IPost2Params {
    body?: DutyCheckerTraineeModel
}
export interface IPut9Params {
    body?: DutyCheckerTraineeUpdateModel
}
export interface IDelete2Params {
    ids?:string[] | string 
    rotationId?: string
}
export interface IGetForRotationParams {
    rotationId?: string
}
export interface IGetFlightTeamParams {
    flightIds?:string[] | string 
    functionIds?:string[] | string 
    personExcludeIds?:string[] | string 
}
export interface IGetGroundTeamParams {
    referenceDate?: Date
}
export interface IDelete3Params {
    date?: Date
    personId?: string
}
export interface IGetFunctionsParams {}
export interface ICreateParams {
    body?: DutyPredefinedEditModel
}
export interface IGetAll8Params {}
export interface IUpdate2Params {
    id: string
    body?: DutyPredefinedEditModel
}
export interface IDelete4Params {
    id: string
    functionId?: string
    functionGroupId?: string
}
export interface IGetAll9Params {
    date?: Date
    personId?: string
}
export interface IGetUrgentParams {
    date?: Date
    personId?: string
}
export interface IGetForRangeParams {
    body?: ValidationErrorsRequestModel
}
export interface IGetSuppressReasonsParams {}
export interface IGetLandingAirportsParams {}
export interface ISuppressParams {
    body?: SuppressValidationModel
}
export interface ISuppressErrorsParams {
    body?: SuppressErrorsRequest
}
export interface IResumeParams {
    body?: ResumeValidationModel
}
export interface IGetExplainModelsParams {}
export interface IGetEmailsParams {
    body?: EmailFilter
}
export interface IGetEmailBodyParams {
    emailId?: string
}
export interface IGetEmailAttachmentsParams {
    emailId?: string
}
export interface IGetAttachmentParams {
    id?: string
}
export interface IValidateParams {
    body?: EmailValidateRequest
}
export interface IUpdateStatusParams {
    id: string
    status: MailQueueStatus
}
export interface IPost3Params {
    body?: ClientErrorModel
}
export interface IGetPOST6Params {
    body?: ErrorReportFilter
}
export interface IGetGETParams {}
export interface IExperienceReportParams {
    body?: ExperienceReportFilter
}
export interface IFlightsParams {
    dateFrom?: Date
    dateTo?: Date
    ids?: string
}
export interface IPost4Params {
    body?: FlightFlagsRequest
}
export interface IGetAll10Params {
    year: number
    month: number
    day: number
}
export interface IGetFlightInfosParams {
    date?: Date
    destination?: string
}
export interface IAircraftActivityDetailsParams {
    flightId?: string
}
export interface IForDayParams {
    year: number
    month: number
    day: number
    showFull?: boolean
}
export interface IForFlightIdParams {
    flightId: string
}
export interface IGetUrgentFlightIdParams {}
export interface IGetUrgentFlightId2Params {
    flightId: string
}
export interface IPutUrgentFlightParams {
    body?: UrgentFlightRequest
}
export interface IPersonExtendedAugmentedParams {
    body?: PersonDayExtendedAugmentedRequest
}
export interface IUpdatePersonDayAmendmentTypeParams {
    body?: PersonDayFdpAmendmentTypeRequest
}
export interface IDecodeParams {
    flightId?: string
}
export interface IGetDayHistory2Params {
    flightId?: string
}
export interface IGetFlightInformationParams {
    flightId?: string
}
export interface IPutFlightInformationParams {
    body?: FlightInformationEditModel
}
export interface IRevalidateFlightParams {
    body?: FlightRevalidateModel
}
export interface IServiceBusMessagesForPersonDay2Params {
    flightId?: string
}
export interface IPublishParams {
    flightId?: string
}
export interface IGetMonthDutyTypes2Params {}
export interface IGetCrewParams {
    flightId: string
    function?: CrewFunctionType[]
}
export interface IGetGET2Params {
    date?: Date
}
export interface IDownloadParams {
    date?: Date
    swissTime?: boolean
}
export interface IGetAll11Params {
    date?: Date
}
export interface IGetFunctionGroupParams {}
export interface IGenerateParams {
    body?: GenDecDocumentRequest
}
export interface IPreviewParams {
    body?: GenDecDocumentRequest
}
export interface IGetPayload2Params {
    flightId: string
    itemId?: string
}
export interface IGeneratePayloads2Params {
    flightId: string
}
export interface IGetReportGET2Params {
    reportId: string
}
export interface IGetAircraftRotationsParams {
    periodFrom?: Date
    periodTo?: Date
}
export interface IGetConfigurationsParams {
    countryThreeLetterCode?: string
    airportRcd?: string
}
export interface IPut10Params {
    body?: GenDecConfigurationModel
}
export interface IDeleteAll2Params {
    countryThreeLetterCode?: string
    airportRcd?: string
}
export interface IGetRelatedAirports2Params {}
export interface IGetFlights3Params {
    periodFrom?: Date
    periodTo?: Date
}
export interface IGetFlights4Params {
    flightId: string
}
export interface IGetConfigurationReport2Params {
    loadOptions_HasInvalidEntries?: boolean
    loadOptions_Filter?: any[]
    loadOptions_RequireTotalCount?: boolean
    loadOptions_RequireGroupCount?: boolean
    loadOptions_IsCountQuery?: boolean
    loadOptions_IsSummaryQuery?: boolean
    loadOptions_Skip?: number
    loadOptions_Take?: number
    loadOptions_Sort?: SortingInfo[]
    loadOptions_Group?: GroupingInfo[]
    loadOptions_TotalSummary?: SummaryInfo[]
    loadOptions_GroupSummary?: SummaryInfo[]
    loadOptions_Select?: string[]
    loadOptions_PreSelect?: string[]
    loadOptions_RemoteSelect?: boolean
    loadOptions_RemoteGrouping?: boolean
    loadOptions_ExpandLinqSumType?: boolean
    loadOptions_PrimaryKey?: string[]
    loadOptions_DefaultSort?: string
    loadOptions_StringToLower?: boolean
    loadOptions_PaginateViaPrimaryKey?: boolean
    loadOptions_SortByPrimaryKey?: boolean
    loadOptions_AllowAsyncOverSync?: boolean
    rowLimit?: number
}
export interface IGetAll12Params {
    ids?:string[] | string 
}
export interface IGetReportGET3Params {
    date?: Date
}
export interface IGetGET3Params {}
export interface IErrorParams {
    body?: JsErrorModel
}
export interface IGetHomeStudyParams {
    dateFrom?: Date
    dateTo?: Date
    functionId?: string
    contractTypes?: ContractType[]
    loadOptions_HasInvalidEntries?: boolean
    loadOptions_Filter?: any[]
    loadOptions_RequireTotalCount?: boolean
    loadOptions_RequireGroupCount?: boolean
    loadOptions_IsCountQuery?: boolean
    loadOptions_IsSummaryQuery?: boolean
    loadOptions_Skip?: number
    loadOptions_Take?: number
    loadOptions_Sort?: SortingInfo[]
    loadOptions_Group?: GroupingInfo[]
    loadOptions_TotalSummary?: SummaryInfo[]
    loadOptions_GroupSummary?: SummaryInfo[]
    loadOptions_Select?: string[]
    loadOptions_PreSelect?: string[]
    loadOptions_RemoteSelect?: boolean
    loadOptions_RemoteGrouping?: boolean
    loadOptions_ExpandLinqSumType?: boolean
    loadOptions_PrimaryKey?: string[]
    loadOptions_DefaultSort?: string
    loadOptions_StringToLower?: boolean
    loadOptions_PaginateViaPrimaryKey?: boolean
    loadOptions_SortByPrimaryKey?: boolean
    loadOptions_AllowAsyncOverSync?: boolean
    rowLimit?: number
}
export interface IGetPOST7Params {
    body?: CreateHomeStudyFilter
}
export interface ILocationHotelBookingInfosParams {
    body?: LocationInfoHotelBookingFilter
}
export interface IPreReservationLocationsMonthParams {
    body?: LocationMonthHotelBookingFilter
}
export interface IHotelDetailsParams {
    transitionDate?: Date
    departureDateTimeLt?: Date
    location?: string
    locationRoute?: string
    locationTimeDiff?: string
}
export interface IHotelPersonDetailsParams {
    body?: PersonDetailsHotelBookingFilter
}
export interface IPreReservationHotelDetailsParams {
    location?: string
}
export interface IPreReservationHotelBookingDetailsParams {
    body?: HotelBookingDetailsFilter
}
export interface ICreateEmailForHotelParams {
    transitionDate?: Date
    departureDateTimeLt?: Date
    location?: string
    locationRoute?: string
    locationTimeDiff?: string
}
export interface ICreatePreReservationEmailForHotelParams {
    year?: number
    month?: number
    location?: string
}
export interface IGetGET4Params {
    isForCabin?: boolean
    isForCockpit?: boolean
}
export interface IGetInstructorFiltersParams {
    body?: InstructorFilterGridFilter
}
export interface ICreateOrUpdateFilterParams {
    body?: InstructorFilterDialogModel
}
export interface IDeleteFilterParams {
    codeName?: string
}
export interface IGetByCode2Params {
    codeName: string
}
export interface IGetJeppesenFileParams {
    jobExecutionId?: string
}
export interface IGetRosterExportIfoParams {}
export interface IGetCrewExportIfoParams {}
export interface IGetRosterImportIfoParams {}
export interface IGetRosterImportExecutionsParams {
    body?: RosterImportFilter
}
export interface IGetRosterImportDetailsParams {
    body?: RosterImportDetailsFilter
}
export interface IGetRosterImportDetailsErrorParams {
    importId?: string
}
export interface IGetRosterImportFileDataParams {
    importId?: string
}
export interface IUploadRosterImportParams {
    formFile?: FileParameter
}
export interface IGetCasImportInfoParams {}
export interface IGetCasImportFileParams {}
export interface IUploadCasImportFileParams {
    formFile?: FileParameter
}
export interface IListParams {}
export interface IGetById2Params {
    id: string
}
export interface IStartParams {
    jobName: string
    body?: JobStartModel
}
export interface IParametersGETParams {
    jobName: string
    triggerName?: string
    isJobSettings?: boolean
}
export interface IParametersPOSTParams {
    cronExpression: string
}
export interface IParametersPOST2Params {
    triggerName: string
    body?: JobSaveParametersModel
}
export interface ISettingsParams {
    jobName: string
    body?: JobSaveParametersModel
}
export interface ICreate2Params {
    body?: JobSaveParametersModel
}
export interface IDelete5Params {
    triggerId?: string
    jobName?: string
}
export interface IIsTriggerNameUniqueParams {
    triggerName?: string
}
export interface IStopParams {
    jobName: string
    jobExecutionId?: string
}
export interface IGetRosterImportExecutions2Params {
    body?: LicenseManagementFilter
}
export interface IGetLicenseParams {
    id?: string
}
export interface IPostLicenseParams {
    body?: LicenseManagementDialogModel
}
export interface IPutLicenseParams {
    body?: LicenseManagementDialogModel
}
export interface IDeleteLicenseParams {
    id?: string
}
export interface IGetOptionsParams {}
export interface ILikeResponseParams {
    id: string
}
export interface IDislikeResponseParams {
    id: string
}
export interface IGetSeniorityAllParams {
    body?: LogbookFilter
}
export interface IExportReport2Params {
    body?: ExportLogbookModel
}
export interface IUpdateMaintenanceNotificationParams {
    body?: MaintenanceModel
}
export interface IPut11Params {
    body?: MaintenanceModel
}
export interface IGetGET5Params {}
export interface ICanBypassMaintenanceParams {}
export interface IPing2Params {}
export interface IGetPOST8Params {
    body?: OffDaysReportFilter
}
export interface IGetConnectedClientsParams {}
export interface IGetRosterActivitiesParams {}
export interface IGetAll13Params {}
export interface IGetRolesParams {}
export interface IGetForRoleParams {
    roleId: number
}
export interface IGetGET6Params {
    ids?:string[] | string 
    functionId?: string
    functionIds?:string[] | string 
    codes?: string[]
    referenceDate?: Date
    referenceDateTo?: Date
    qualificationIds?:string[] | string 
    contractTypes?: ContractType[]
    contractFlagTypes?: ContractFlagType[]
    partialLoadType?: PartialLoadType
    search?: string
    searchByFullName?: boolean
    dutyFilter?: DutyFilter[]
    monthlyTypes?: MonthlyType[]
    releaseFilterTypes?: ReleaseFilterType[]
    sort?: PersonSortOrder
    order?: SortOrder
    sortBaseDate?: Date
    functionFromDate?: Date
    typeRatingFilters?: TypeRatingFilter[]
    instructorFilters?: string
    aeropersMember?: boolean
    nbuCockpitRelated?: boolean
    nbuCabinRelated?: boolean
    includeInactive?: boolean
    page?: number
    pageSize?: number
    optInShowEfaSchedule?: boolean
    includeWithoutEmail?: boolean
}
export interface IRevalidateParams {
    body?: RevalidatePersonModel
}
export interface IPublish2Params {
    body?: RevalidatePersonModel
}
export interface ILookupParams {
    body?: PersonFilter
}
export interface IGetGET7Params {
    phone?: string
}
export interface IGetRelatedPersonParams {}
export interface ISendSmsParams {
    body?: SendSmsBody
}
export interface IGetCrewSmsParams {
    flightIds?:string[] | string 
    isEta?: boolean
}
export interface IGetSeatHistoryParams {
    personId?: string
}
export interface IGetMintLicensesParams {
    personId?: string
}
export interface IGetMintLicenseInactivationsParams {
    personId?: string
}
export interface IGetPersonEntriesParams {
    personId?: string
}
export interface IGetPersonFunctionsParams {
    personId?: string
}
export interface IGetPlanningFunctionOverrulesParams {
    personId?: string
}
export interface IGetAircraftActivitiesParams {
    personId?: string
}
export interface IGetSpecialAirportsParams {
    personId?: string
}
export interface IGetPersonExperienceSummaryParams {
    personId?: string
}
export interface IGetShowMyScheduleParams {}
export interface ISetShowMyScheduleParams {
    body?: ShowSettingModel
}
export interface IGetAllowSecondReserveParams {}
export interface ISetAllowSecondReserveParams {
    body?: ShowSettingModel
}
export interface IGetShowMyPhoneParams {}
export interface ISetShowMyPhoneParams {
    body?: ShowSettingModel
}
export interface IGetShowMyScheduleToEFAMembersParams {}
export interface ISetShowMyScheduleToEFAMembersParams {
    body?: ShowSettingModel
}
export interface IGetShowMyScheduleToAeropersMembersParams {}
export interface ISetShowMyScheduleToAeropersMembersParams {
    body?: ShowSettingModel
}
export interface IServiceBusMessagesForPersonDay3Params {
    personId?: string
}
export interface IGetPersonModificationsParams {
    personId: string
}
export interface IGetAll14Params {}
export interface IPost5Params {
    body?: PersonAircraftTypeExperienceOverrule
}
export interface IPut12Params {
    body?: PersonAircraftTypeExperienceOverrule
}
export interface IDelete6Params {
    personId?: string
    aircraftTypeGroupId?: string
    activityId?: string
    date?: Date
}
export interface IGetGET8Params {
    personId: string
    aircraftTypeGroup: string
    activity: string
    date: Date
}
export interface IGetOverruleParams {
    personId: string
    aircraftTypeGroup: string
    activity: string
}
export interface IGetAll15Params {
    personId?: string
}
export interface IGetLastParams {
    personId?: string
}
export interface IConfirmPUTParams {
    body?: PersonChangeLogConfirmModel
}
export interface IGetPersonInfoParams {
    date?: Date
    personIds?:string[] | string 
    functionId?: string
}
export interface IPersonQuarterInfosParams {
    date?: Date
    personIds?:string[] | string 
}
export interface IPersonSummaryFiguresInfosParams {
    date?: Date
    personIds?:string[] | string 
}
export interface IPersonDeltaFiguresInfosParams {
    date?: Date
    personIds?:string[] | string 
}
export interface IPersonConsecutiveMonthsDaysOffInfosParams {
    date?: Date
    personIds?:string[] | string 
}
export interface IPersonDutyPeriodInfosParams {
    personId?: string
    dateFrom?: Date
    dateTo?: Date
}
export interface IPersonDayDutyFiguresParams {
    body?: PersonDayDutyFiguresFilter
}
export interface IUpdateDayStatusParams {
    body?: PlanningGroupDayStatusRequest
}
export interface IChangeCheckInCheckOutParams {
    body?: ChangeCheckInCheckOutModel
}
export interface IResetCheckInCheckOutParams {
    body?: CheckInCheckOutModel
}
export interface IGetCustomCheckInCheckOutInfoParams {
    date?: Date
    personId?: string
}
export interface ISetByEstimatedParams {
    body?: SetEstimatedCiCoModel
}
export interface IPersonDatePopupDataParams {
    date?: Date
    personId?: string
}
export interface IGetLocationParams {
    personId?: string
    date?: Date
}
export interface IGetLicenseDistinctNamesParams {
    functionGroupId?: string
}
export interface IGetByFunctionParams {
    functionId?: string
}
export interface IGetForPersonParams {
    personId?: string
}
export interface IGetValidationSuppressedParams {
    personId?: string
}
export interface ICreateValidationSuppressParams {
    body?: PersonLicenseValidationSuppressCreateModel
}
export interface IUpdateValidationSuppressParams {
    body?: PersonLicenseValidationSuppressUpdateModel
}
export interface IRemoveValidationSuppressParams {
    personId?: string
    id?: string
}
export interface IGetPointsBalanceParams {
    referenceDate?: Date
}
export interface IValidateRequestOffParams {
    periodDateFrom?: Date
    periodDateTo?: Date
    type?: PersonRequestOffType
}
export interface ICreateRequestOffParams {
    body?: PersonOffRequestCreate
}
export interface IUpdateRequestsOffParams {
    id?: string
    body?: PersonOffRequestUpdate
}
export interface ICancelRequestsOffParams {
    id?: string
}
export interface IGetRequestsOffParams {
    type?: PersonRequestOffType
    referenceDate?: Date
}
export interface IResolveRequestParams {
    requestId?: string
}
export interface IGetRequestsFlightsParams {
    dateFrom?: Date
    dateTo?: Date
    location?: string
    aircraft?: string
    flightNumber?: string
    days?: string
    offset?: number
    pageSize?: number
    termType?: PersonRequestFlightTermType
}
export interface IGetRequestsFlightParams {
    referenceDate?: Date
}
export interface IRequestFlightParams {
    body?: PersonFlightRequest
}
export interface IDeleteFlightParams {
    id?: string
}
export interface IGetJobTriggersStatusesParams {
    isCabin?: boolean
    isFlight?: boolean
}
export interface IRejectFlightRequestByPlannerParams {
    body?: PersonRequestFlightRejectModel
}
export interface IGetRequestsParams {
    dateFrom?: Date
    dateTo?: Date
}
export interface IGetPointsLogParams {
    referenceDate?: Date
}
export interface IGetPointsPeriodsParams {}
export interface IPersonRequestPersonInfoDtoParams {
    referenceDate?: Date
}
export interface IGetAvailableRequestRangeParams {}
export interface IGetPersonShortTypeRatingLicensesParams {}
export interface IGetOffLimitsParams {
    referenceDate?: Date
}
export interface IGetFrLimitsCockpitParams {
    referenceDate?: Date
}
export interface IGetFrLimitsCabinParams {
    referenceDate?: Date
}
export interface IGetFrLimitsLogsCabinParams {
    referenceDate?: Date
    type?: FlightRequestLimitRange
}
export interface IGetFrLimitsLogsCockpitParams {
    referenceDate?: Date
}
export interface ICreateFrLimitsCorrectionParams {
    body?: FlightLimitsCorrectionModel
}
export interface IIsConstantCabinFreelancerParams {}
export interface IGetFlightRequestOffsParams {
    body?: RotationOffsRequestModel
}
export interface ICreateVacationDaysManualCorrectionParams {
    body?: PointsManualCorrectionModel
}
export interface IPost6Params {
    body?: PersonRequestBlockedFlightDto
}
export interface IDelete7Params {
    flightId?: string
}
export interface IGetAll16Params {
    dateFrom?: Date
    dateTo?: Date
    term?: string
}
export interface ICreateRequestsOffParams {
    body?: PersonRequestBlockedDayDto
}
export interface IUpdateRequestsOff2Params {
    body?: PersonRequestBlockedDayDto
}
export interface IDeleteBlockedDayParams {
    day?: Date
}
export interface IGetBlockedDaysParams {
    dateFrom?: Date
    dateTo?: Date
}
export interface IGetFreelanceYearsAllParams {}
export interface IGetContractInfosParams {}
export interface IValidateAllParams {
    date?: Date
}
export interface IGetPeriodExportParams {
    yearPeriodId?: string
}
export interface IConfirmPOSTParams {
    body?: PersonRequestFreelanceConfirmModel
}
export interface IDeviateParams {
    body?: PersonRequestFreelanceDeviateModel
}
export interface IUpdateDuty2Params {
    body?: PersonRequestFreelanceCreateModel
}
export interface IPersonNbuReportParams {
    body?: PersonNbuFilter
}
export interface ICreateNbuParams {
    body?: PersonNbuUpdateModel
}
export interface IUpdateNbuParams {
    body?: PersonNbuUpdateModel
}
export interface IDeleteNbuParams {
    id: string
}
export interface ISuppress2Params {
    body?: SuppressValidationModel
}
export interface IResume2Params {
    body?: ResumeValidationModel
}
export interface IGetMonthParams {
    date?: Date
}
export interface IUpdateMonthParams {
    body?: UpdateNbuMonthRequest
}
export interface IGetReserveRequestsParams {
    reserveYearPeriodId?: string
}
export interface ICreateReserveRequestParams {
    body?: PersonReserveRequestCreate
}
export interface IDeleteRequestParams {
    id?: string
}
export interface IGetReserveRequestAvailableParams {
    reserveYearId?: string
}
export interface IGetReserveBlocksAllParams {
    reserveYearPeriodId?: string
}
export interface IGetReservePeriodsParams {
    date?: Date
    includingYearId?: string
}
export interface IGetPersonDutyBlocksParams {
    yearId?: string
}
export interface IGetBalanceParams {
    yearId?: string
}
export interface IGetReserveRequestMandatoryParams {
    reserveYearId?: string
}
export interface IGetFreelanceYearsParams {}
export interface IGetWishTypesParams {}
export interface IGetWishParams {}
export interface ICreateWishParams {
    body?: PersonWishCreateModel
}
export interface IDeleteWishParams {
    id: string
}
export interface IGetWishHistoryParams {}
export interface IGetTzvYearsParams {
    includingTzvYearId?: string
}
export interface IGetTzvBalanceInfoParams {
    yearId?: string
}
export interface IGetTzvBalanceTotalParams {
    yearId?: string
}
export interface IHasTzvContractParams {}
export interface IGetPersonAbsenceDaysParams {
    yearId?: string
}
export interface IGetContractInfos2Params {
    yearId?: string
}
export interface ICreateTzvManualCorrectionParams {
    body?: DaysManualCorrectionModel
}
export interface IUpdateTzvManualCorrectionParams {
    body?: DaysManualCorrectionModel
}
export interface IDeleteTzvManualCorrectionParams {
    id: string
}
export interface IGetPersonTzvDayAssignmentModelsParams {
    periodFrom?: Date
    periodTo?: Date
}
export interface ICreateTzvAssignmentDayParams {
    body?: TzvDayAssigmentCreateModel
}
export interface IDeleteTzvAssignmentDayParams {
    id: string
}
export interface ISetTzvFlexDaysParams {
    body?: Date[]
}
export interface IValidateVacRequestParams {
    periodDateFrom?: Date
    requestBlockId?: string
    periodDateTo?: Date
    type?: PersonRequestVacType
    priority?: PersonRequestVacPriority
    days?: number
    daysMin?: number
    editableRequestId?: string
}
export interface ICreateRequestVacParams {
    body?: PersonRequestVacCreate
}
export interface IUpdateRequestVacParams {
    body?: PersonRequestVacUpdate
}
export interface IGetVacRequestsParams {
    vacationYearPeriodId?: string
}
export interface IUpdateRequestVacBlockPersonAnswerParams {
    body?: PersonRequestVacBlockPersonAnswerModel
}
export interface IDeleteRequestVacParams {
    id: string
}
export interface IVacRulesStatusParams {
    vacationPeriodId?: string
}
export interface IGetAvailableVacSDaysAndDeadlineParams {
    vacationYearPeriodId?: string
}
export interface IGetAvailableVacPDaysAndDeadlineParams {
    vacationYearPeriodId?: string
}
export interface IGetAvailableVacTypesParams {
    vacationYearPeriodId?: string
}
export interface IGetVacationBalanceInfoParams {
    yearId?: string
}
export interface IGetVacationBalanceTotalParams {
    yearId?: string
}
export interface ICreateVacationDaysManualCorrection2Params {
    body?: DaysManualCorrectionModel
}
export interface IUpdateVacationDaysManualCorrectionParams {
    body?: DaysManualCorrectionModel
}
export interface IDeleteVacationDaysManualCorrectionParams {
    id: string
}
export interface IGetVacationPeriodsParams {
    date?: Date
    includingVacationYearId?: string
}
export interface IGetVacationYearsParams {}
export interface IAcceptOrDeclineAlternativeVacationParams {
    requestId: string
    requestBlockId: string
    body?: PersonDecisionModel
}
export interface IGetPersonAbsenceDays2Params {
    yearId?: string
}
export interface IGetRequestVacLogParams {
    requestBlockId: string
}
export interface IPersonReportParams {
    body?: PersonReportFilter
}
export interface IGetMonthDataParams {
    periodFrom?: Date
    periodTo?: Date
    personIds?:string[] | string 
}
export interface IGetCabinViewParams {}
export interface IGetCabinRecencyViewParams {}
export interface IGetCockpitRecencyViewParams {}
export interface IGetPOST9Params {
    body?: PlannedTrainingsReportFilter
}
export interface IGetCandidatesParams {
    activityCode?: string
    date?: Date
    flightIds?:string[] | string 
    rotationId?: string
}
export interface IValidateCandidateParams {
    personId?: string
    activityCode?: string
    date?: Date
    flightIds?:string[] | string 
    rotationId?: string
}
export interface IGetRestTimeTypesParams {
    body?: DutyRestTimeDeltaRequestModel
}
export interface IStartOrToolsParams {
    body?: PlanningRequestModel
}
export interface IGetOrToolsHistoryParams {
    functionId?: string
    periodFrom?: Date
    periodTo?: Date
}
export interface IGetOrToolsByIdParams {
    id: string
}
export interface IGetById3Params {
    id?: string
}
export interface IGetForDayParams {
    personId?: string
    date?: Date
}
export interface IListCodesParams {}
export interface IGetFlights5Params {
    date?: Date
    from?: string
    to?: string
}
export interface IGetAvailableDirectionForADayParams {
    date?: Date
}
export interface IGetCustomsParams {
    type?: PositioningType
}
export interface IGetDateTimeDiffToLtParams {
    date?: Date
}
export interface IGetListAll2Params {}
export interface ICreateReport2Params {
    body?: QualityLoopJobStartModel
}
export interface IGetReportDataParams {
    reportId: string
}
export interface IGetReportMappingParams {
    reportId: string
}
export interface IGetGET9Params {
    personId: string
}
export interface IPersonReport2Params {
    body?: ReccurentTrainingReportFilter
}
export interface IGetReleaseGroupsParams {}
export interface IGetReleasePeriodsParams {}
export interface IGetPersonsWithNotFullDutyMonthParams {
    year?: number
    month?: number
    functionGroupId?: string
    functionId?: string
}
export interface IHistorizeParams {
    year?: number
    month?: number
    functionGroupId?: string
    functionId?: string
}
export interface IGetIsReleasedParams {
    year?: number
    month?: number
    functionGroupId?: string
    functionId?: string
}
export interface IGetReleaseDateParams {}
export interface IGetAll17Params {
    skip?: number
    take?: number
}
export interface ICreate3Params {
    body?: ReleaseNoteModel
}
export interface IGetGET10Params {
    id: string
}
export interface IUpdate3Params {
    id: string
    body?: ReleaseNoteModel
}
export interface IDelete8Params {
    id: string
}
export interface IMarkReadParams {
    id?: string
}
export interface IAnalyzeFileParams {
    formFile?: FileParameter
}
export interface IImportFile2Params {
    body?: RequestCapacityAnalyzedModel
}
export interface IGetCapacityToolOverviewParams {
    periodFrom?: Date
    periodTo?: Date
}
export interface ICapacityFilesParams {
    maxFiles?: number
}
export interface IDownloadCapacityFileParams {
    id?: string
}
export interface IGetPOST10Params {
    body?: ReserveManagementReportFilter
}
export interface IGetReserveYearPeriodModelsParams {}
export interface IChangeStatusParams {
    reserveYearPeriodId: string
    body?: ReservePeriodChangeStatusModel
}
export interface IRequestApproveParams {
    body?: ApproveReserveRequestModel
}
export interface ICloseAndInformPersonRequestParams {
    body?: InformReserveRequestModel
}
export interface IRejectRequestParams {
    body?: RejectReserveRequestModel
}
export interface IUndoRequestParams {
    body?: ReserveRequestModel
}
export interface IChangeCommentParams {
    body?: ReserveRequestChangePlannersCommentModel
}
export interface IGetYearPeriodsFilterOptionsParams {}
export interface IGetReserveBlocksParams {
    body?: ReserveBlocksFilter
}
export interface ICreateReserveBlockParams {
    body?: CreateReserveBlockModel
}
export interface IDeleteReserveBlockParams {
    blockId?: string
}
export interface IImportFileAllParams {
    formFile?: FileParameter
}
export interface IForDay2Params {
    year: number
    month: number
    day: number
}
export interface ILonghaulParams {
    year: number
    month: number
    day: number
    personId?: string
    functionIds?:string[] | string 
}
export interface ILonghaulForPeriodParams {
    direction?: string
    dateFrom?: Date
    dateTo?: Date
}
export interface IGetInfoByIdParams {
    id?: string
    personId?: string
    functionGroupId?: string
}
export interface IGetDirectionsListParams {
    dateFrom?: Date
    dateTo?: Date
    isLonghaulOnly?: boolean
}
export interface IGetApplicableCopyDatesListParams {
    rotationId?: string
}
export interface IGetApplicableFlightDatesListParams {
    direction?: string
    dateFrom?: Date
    dateTo?: Date
}
export interface IGetAvailableFlightsListParams {
    direction?: string
    dateFrom?: Date
    dateTo?: Date
}
export interface IInitRotationParams {
    firstFlightId?: string
    direction?: string
    isForCockpit?: boolean
    isForCabin?: boolean
    isInbound?: boolean
}
export interface IPut13Params {
    body?: RotationModel
}
export interface IGetById4Params {
    id?: string
}
export interface IGetIdByRotationKeyParams {
    personId?: string
    rotationKey?: string
    date?: Date
}
export interface ICopy2Params {
    body?: RotationCopyModel
}
export interface IBuildParams {
    body?: RotationModel
}
export interface IDelete9Params {
    rotationId?: string
}
export interface IGetRotationsParams {
    flightId: string
}
export interface IGetAircraftRotations2Params {
    periodFrom?: Date
    periodTo?: Date
}
export interface ISectorsReportParams {
    body?: SectorsReportFilter
}
export interface IMonitoringParams {}
export interface IMonitoringSendingQueuePersonDayParams {
    ttl?: number
    sentAtLeast?: number
}
export interface IMonitoringJobParams {
    jobName: string
    duration?: number
}
export interface IGetPOST11Params {}
export interface ICheckMonitoringJobsParams {}
export interface ICheckSignalRParams {}
export interface ICheckMonitoringSignalRParams {}
export interface IDatabaseParams {}
export interface ICheckMonitoringDatabaseParams {}
export interface IUpdateDatabaseParams {}
export interface ICheckPersonDayQueueParams {}
export interface ICheckNetlineOpsQueueParams {}
export interface ICheckPersonMessageBusQueueParams {}
export interface ICheckCrewApiQueueParams {}
export interface ICheckCrewApiMclQueueParams {}
export interface ICheckPersonRevalidateParams {}
export interface ICheckEmailQueueParams {}
export interface IGetSeniorityParams {
    body?: SeniorityReportFilter
}
export interface IChangeComment2Params {
    body?: SeniorityCommentModel
}
export interface IChangeExitDateParams {
    body?: SeniorityExitDateModel
}
export interface IChangeEntryDateParams {
    body?: SeniorityEntryDateModel
}
export interface IDownloadMessagesParams {
    fromDateTime?: Date
    toDateTime?: Date
    labelFilter?: string
    tagFilter?: string
}
export interface IGetMessageLabelsParams {
    fromDateTime?: Date
    toDateTime?: Date
}
export interface IGetMessageTagsParams {
    fromDateTime?: Date
    toDateTime?: Date
    labelFilter?: string
}
export interface IDownloadFullLogsParams {
    date?: Date
}
export interface IDownloadDayLogsParams {
    date?: Date
}
export interface IDownloadDeadlettersParams {}
export interface IMessageStatisticsParams {
    dateTimeFrom?: Date
}
export interface IOperationsParams {
    fromDateTime?: Date
    toDateTime?: Date
    top?: number
    showSystem?: boolean
}
export interface IGetDatesWithLogsListParams {}
export interface IGetMessagesDatesListParams {}
export interface IRestartSchedulerParams {}
export interface IQueueStatisticsParams {}
export interface IQueueDeadlettersParams {}
export interface IDeleteDeadletterParams {
    id?: string
}
export interface IGetGET11Params {
    id?: string
}
export interface IGetPOST12Params {
    body?: SimulationReportFilter
}
export interface IPlannedAircraftActivitiesParams {
    date?: Date
}
export interface IGetTraineeCandidatesParams {
    date?: Date
}
export interface IGetSimOverviewParams {
    date?: Date
    includeDuties?: boolean
}
export interface ICreateSimulationCourseParams {
    body?: SimulationCourseDto
}
export interface IDeleteSimulationCourseParams {
    id?: string
}
export interface IGetEbtModulesParams {
    date?: Date
}
export interface IGetSimHistoryParams {
    simId?: string
}
export interface IGetPositionSimHistoryParams {
    simId?:string[] | string 
    position?: SimulationCoursePosition
}
export interface IGetPositionLogSimHistoryParams {
    simId?:string[] | string 
    position?: SimulationCoursePosition
}
export interface IGetSimDeletionHistoryParams {
    date?: Date
}
export interface IGetPOST13Params {
    body?: SimulatorLicenseStatusReportFilter
}
export interface IGetPOST14Params {
    body?: StandbyReportFilter
}
export interface IGetReportFunctionsParams {
    date?: Date
    functionId?: string
    contractTypes?: ContractType[]
    personIds?:string[] | string 
    isIncludeFormerSbx?: boolean
    isOnlyFormerSbx?: boolean
    loadOptions_HasInvalidEntries?: boolean
    loadOptions_Filter?: any[]
    loadOptions_RequireTotalCount?: boolean
    loadOptions_RequireGroupCount?: boolean
    loadOptions_IsCountQuery?: boolean
    loadOptions_IsSummaryQuery?: boolean
    loadOptions_Skip?: number
    loadOptions_Take?: number
    loadOptions_Sort?: SortingInfo[]
    loadOptions_Group?: GroupingInfo[]
    loadOptions_TotalSummary?: SummaryInfo[]
    loadOptions_GroupSummary?: SummaryInfo[]
    loadOptions_Select?: string[]
    loadOptions_PreSelect?: string[]
    loadOptions_RemoteSelect?: boolean
    loadOptions_RemoteGrouping?: boolean
    loadOptions_ExpandLinqSumType?: boolean
    loadOptions_PrimaryKey?: string[]
    loadOptions_DefaultSort?: string
    loadOptions_StringToLower?: boolean
    loadOptions_PaginateViaPrimaryKey?: boolean
    loadOptions_SortByPrimaryKey?: boolean
    loadOptions_AllowAsyncOverSync?: boolean
    rowLimit?: number
}
export interface ICreateStandbyReportAutomationEmailParams {
    reportDate?: Date
}
export interface IPost7Params {
    label?: string
    name?: string
    contentType?: string
    isZipped?: boolean
    file?: FileParameter
}
export interface IGetGET12Params {
    id: string
    name?: string
}
export interface IGetOutageReportParams {}
export interface IGetRecentlySavedFileParams {
    label: string
}
export interface IGetTemplateGroupsParams {}
export interface IGetByCode3Params {
    group: string
    code: string
}
export interface IGetFormattedTemplateParams {
    group: string
    code: string
    body?: TemplateFormattingModel
}
export interface IUpdateTemplateParams {
    group: string
    code: string
    body?: TemplateModel
}
export interface IGetTemplateDataModelParams {
    group: string
    code: string
}
export interface ILocalToUtcParams {
    body?: TimeModel
}
export interface IUtcToLocalParams {
    body?: TimeModel
}
export interface IAvailableTimezonesParams {
    body?: TimeModel
}
export interface ITimezoneOffsetsParams {}
export interface IDefaultTimezoneOffsetParams {}
export interface ICalendarMonthParams {
    type?: CalendarType
}
export interface IGetSwissTimeTransitionsParams {
    periodFrom?: Date
    periodTo?: Date
}
export interface IGetFileParams {
    id?: string
}
export interface IGetExportIfoParams {
    type: TradeUnionExportType
}
export interface IGetAeroPersExportsParams {
    type: TradeUnionExportType
    body?: TradeUnionExportFilter
}
export interface IGetAeroPersExportFileDataParams {
    id?: string
}
export interface IGetGET13Params {
    isForCabin?: boolean
    isForCockpit?: boolean
}
export interface IGetPOST15Params {
    body?: TzvYearOverviewFilter
}
export interface IGetVacationYears2Params {}
export interface IFleetTypesParams {}
export interface IChangeComment3Params {
    body?: TzvYearPlannersCommentModel
}
export interface IGetPOST16Params {
    body?: VacManagementReportFilter
}
export interface IGetPlannerCommentParams {
    requestBlockId: string
    isVisibleToCrewComment?: boolean
}
export interface IChangeComment4Params {
    requestBlockId: string
    body?: VacRequestChangePlannersCommentModel
}
export interface IChangePointsParams {
    requestBlockId: string
    body?: VacRequestChangePlannersPointsModel
}
export interface IGetVacRequestInfoParams {
    requestBlockId: string
}
export interface ICreateAlternativeVacRequestParams {
    requestBlockId: string
    body?: PersonRequestVacAlternativeCreate
}
export interface IDeleteAlternativeVacRequestParams {
    requestId: string
}
export interface IApproveVariantParams {
    requestId: string
    body?: PersonRequestVacApproveModel
}
export interface IRejectRequest2Params {
    requestBlockId: string
    body?: RejectRequestModel
}
export interface IValidateSelectedRangeParams {
    requestId?: string
    selectedDateFrom?: Date
    selectedDateTo?: Date
}
export interface IUpdateSelectedRangeParams {
    body?: VacRequestUpdateSelectedRangeModel
}
export interface ICloseAndInformPersonRequest2Params {
    requestBlockId: string
    body?: PersonRequestVacInformModel
}
export interface IStatusRollbackParams {
    requestBlockId: string
}
export interface IGetAllRequestVacTypeParams {}
export interface IGetVacationYears3Params {}
export interface IGetVacationYearPeriodsParams {}
export interface IGetVacationYearPeriodsFilterOptionsParams {}
export interface IGetVacationYearPeriodModelsParams {}
export interface IChangeStatus2Params {
    vacYearPeriodId: string
    body?: VacPeriodChangeStatusModel
}
export interface IGetVacationCapacityFiguresParams {
    personId?: string
    dateFrom?: Date
    dateTo?: Date
}
export interface IGetVacationCapacityMonthFiguresParams {
    personId?: string
    dateFrom?: Date
    dateTo?: Date
}
export interface IGetMonthFromFilterOptionsParams {}
export interface IGetMonthToFilterOptionsParams {}
export interface IGetPersonVacDetailsParams {
    body?: VacManagementPersonVacDetailsFilter
}
export interface IGetPOST17Params {
    body?: XStarMonitoringReportFilter
}
export interface IChangeComment5Params {
    body?: XStarCommentModel
}
export class ApiClient {
    private baseUrl: string;
    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    aircraftGet( requestOptions?: IAjaxOptions): AxiosPromise<AircraftDto[]> {
        let _url = this.baseUrl + "/api/Aircraft";
        return ApiService.sendRequest<AircraftDto[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    aircraftMaintenanceGet(params?:IMaintenanceParams, requestOptions?: IAjaxOptions): AxiosPromise<AircraftMaintenanceDto[]> {
        let _url = this.baseUrl + "/api/Aircraft/maintenance";
        return ApiService.sendRequest<AircraftMaintenanceDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    aircraftGetById(params?:IGetByIdParams, requestOptions?: IAjaxOptions): AxiosPromise<AircraftInfoModel> {
        let _url = this.baseUrl + "/api/Aircraft/{id}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<AircraftInfoModel>(AxiosMethod.GET, _url, params, requestOptions);
    }
    aircraftPutById(id: string, body: AircraftEditModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Aircraft/{id}";
        _url = ApiService.getDynamicUrl(_url, { id, body });
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    aircraftTypeGet( requestOptions?: IAjaxOptions): AxiosPromise<AircraftTypeModel[]> {
        let _url = this.baseUrl + "/api/Aircraft/type";
        return ApiService.sendRequest<AircraftTypeModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    aircraftTypeGetById(params?:IGetTypesParams, requestOptions?: IAjaxOptions): AxiosPromise<AircraftTypeModel> {
        let _url = this.baseUrl + "/api/Aircraft/type/{id}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<AircraftTypeModel>(AxiosMethod.GET, _url, params, requestOptions);
    }
    aircraftTypePutById(id: string, body: AircraftTypeModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Aircraft/type/{id}";
        _url = ApiService.getDynamicUrl(_url, { id, body });
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    aircraftTypeGroupGet( requestOptions?: IAjaxOptions): AxiosPromise<SelectValueItem[]> {
        let _url = this.baseUrl + "/api/Aircraft/type-group";
        return ApiService.sendRequest<SelectValueItem[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    aircraftTypeRecencyReportCabinPost(body: AircraftTypeRecencyReportFilter, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeResponseAircraftTypeRecencyReportModel> {
        let _url = this.baseUrl + "/api/AircraftTypeRecencyReport/cabin";
        return ApiService.sendRequest<DevExtremeResponseAircraftTypeRecencyReportModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    aircraftTypeRecencyReportCockpitPost(body: AircraftTypeRecencyReportCockpitFilter, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeResponseAircraftTypeRecencyCockpitReportModel> {
        let _url = this.baseUrl + "/api/AircraftTypeRecencyReport/cockpit";
        return ApiService.sendRequest<DevExtremeResponseAircraftTypeRecencyCockpitReportModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    airportGetByThreeLetterCode(params?:IGetByCodeParams, requestOptions?: IAjaxOptions): AxiosPromise<AirportModel> {
        let _url = this.baseUrl + "/api/Airport/{threeLetterCode}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<AirportModel>(AxiosMethod.GET, _url, params, requestOptions);
    }
    airportGet(params?:IGetAllParams, requestOptions?: IAjaxOptions): AxiosPromise<AirportModel[]> {
        let _url = this.baseUrl + "/api/Airport";
        return ApiService.sendRequest<AirportModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    airportDetailsGetByThreeLetterCode(params?:IGetAll2Params, requestOptions?: IAjaxOptions): AxiosPromise<AirportDetailsModel[]> {
        let _url = this.baseUrl + "/api/Airport/{threeLetterCode}/details";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<AirportDetailsModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    airportRecencyReportPost(body: AirportRecencyReportFilter, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeResponseAirportRecencyReportModel> {
        let _url = this.baseUrl + "/api/AirportRecencyReport";
        return ApiService.sendRequest<DevExtremeResponseAirportRecencyReportModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    airportRecencyReportPersonGet(params?:IGetDataParams, requestOptions?: IAjaxOptions): AxiosPromise<AirportRecencyReportModel[]> {
        let _url = this.baseUrl + "/api/AirportRecencyReport/person";
        return ApiService.sendRequest<AirportRecencyReportModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    areaRouteCompetenceRulesReportPost(body: AreaRouteCompetenceRulesReportFilter, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeResponseAreaRouteCompetenceRulesReportModel> {
        let _url = this.baseUrl + "/api/AreaRouteCompetence/rules-report";
        return ApiService.sendRequest<DevExtremeResponseAreaRouteCompetenceRulesReportModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    areaRouteCompetenceListGet( requestOptions?: IAjaxOptions): AxiosPromise<AreaRouteCompetenceDto[]> {
        let _url = this.baseUrl + "/api/AreaRouteCompetence/list";
        return ApiService.sendRequest<AreaRouteCompetenceDto[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    areaRouteCompetenceRulesListGet( requestOptions?: IAjaxOptions): AxiosPromise<AreaRouteCompetenceRulesDto> {
        let _url = this.baseUrl + "/api/AreaRouteCompetence/rules-list";
        return ApiService.sendRequest<AreaRouteCompetenceRulesDto>(AxiosMethod.GET, _url, null, requestOptions);
    }
    areaRouteCompetenceCreateRulePost(body: AreaRouteCompetenceAirportDto, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/AreaRouteCompetence/create-rule";
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, body, requestOptions);
    }
    areaRouteCompetenceDeleteRuleDelete(params?:IDeleteRuleParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/AreaRouteCompetence/delete-rule";
        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }
    areaRouteCompetenceWebBasedTrainingGet(params?:IGetWebBasedTrainingsParams, requestOptions?: IAjaxOptions): AxiosPromise<WebBasedTrainingDto[]> {
        let _url = this.baseUrl + "/api/AreaRouteCompetence/web-based-training";
        return ApiService.sendRequest<WebBasedTrainingDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    areaRouteCompetenceWebBasedTrainingPost(body: WebBasedTrainingCreateModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/AreaRouteCompetence/web-based-training";
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, body, requestOptions);
    }
    areaRouteCompetenceWebBasedTrainingDelete(params?:IDeleteWebBasedTrainingParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/AreaRouteCompetence/web-based-training";
        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }
    areaRouteCompetenceReportPost(body: AreaRouteCompetenceReportFilter, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeResponseAreaRouteCompetenceReportModel> {
        let _url = this.baseUrl + "/api/AreaRouteCompetenceReport";
        return ApiService.sendRequest<DevExtremeResponseAreaRouteCompetenceReportModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    cateringReportGet( requestOptions?: IAjaxOptions): AxiosPromise<CateringReportItem[]> {
        let _url = this.baseUrl + "/api/CateringReport";
        return ApiService.sendRequest<CateringReportItem[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    cateringReportPost(body: CateringReportCreateModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/CateringReport";
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, body, requestOptions);
    }
    cateringReportGetByReportId(params?:IGetReportGETParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/CateringReport/{reportId}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }
    changeLogPost(body: ChangeLogFilter, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeResponseChangeLogModel> {
        let _url = this.baseUrl + "/api/ChangeLog";
        return ApiService.sendRequest<DevExtremeResponseChangeLogModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    changeLogPut(body: ChangeLogModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/ChangeLog";
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    changeLogSetPlanningConfirmationPost(params?:ITogglePlanningConfirmationParams, requestOptions?: IAjaxOptions): AxiosPromise<ChangeLogUpdateConfirmationModel> {
        let _url = this.baseUrl + "/api/ChangeLog/set-planning-confirmation";
        return ApiService.sendRequest<ChangeLogUpdateConfirmationModel>(AxiosMethod.POST, _url, params, requestOptions);
    }
    changeLogReasonPut(body: UpdateChangeLogTextModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/ChangeLog/reason";
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    changeLogOldDutyTextPut(body: UpdateChangeLogTextModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/ChangeLog/oldDutyText";
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    changeLogNewDutyTextPut(body: UpdateChangeLogTextModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/ChangeLog/newDutyText";
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    commentFlightGet(params?:IGetFlightCommentsParams, requestOptions?: IAjaxOptions): AxiosPromise<FlightCommentDto[]> {
        let _url = this.baseUrl + "/api/Comment/flight";
        return ApiService.sendRequest<FlightCommentDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    commentFlightPut(body: FlightCommentDto, requestOptions?: IAjaxOptions): AxiosPromise<FlightCommentDto> {
        let _url = this.baseUrl + "/api/Comment/flight";
        return ApiService.sendRequest<FlightCommentDto>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    commentPersonGet(params?:IGetPersonCommentsParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonCommentReadDto[]> {
        let _url = this.baseUrl + "/api/Comment/person";
        return ApiService.sendRequest<PersonCommentReadDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    commentPersonPost(body: PersonCommentCreateDto, requestOptions?: IAjaxOptions): AxiosPromise<PersonCommentReadDto[]> {
        let _url = this.baseUrl + "/api/Comment/person";
        return ApiService.sendRequest<PersonCommentReadDto[]>(AxiosMethod.POST, _url, body, requestOptions);
    }
    commentPersonPut(body: PersonCommentUpdateDto, requestOptions?: IAjaxOptions): AxiosPromise<PersonCommentReadDto> {
        let _url = this.baseUrl + "/api/Comment/person";
        return ApiService.sendRequest<PersonCommentReadDto>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    commentPersonUpdateCommentPut(body: PersonCommentUpdateDto, requestOptions?: IAjaxOptions): AxiosPromise<PersonCommentReadDto> {
        let _url = this.baseUrl + "/api/Comment/person-update-comment";
        return ApiService.sendRequest<PersonCommentReadDto>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    commentDayGet(params?:IGetDayCommentsParams, requestOptions?: IAjaxOptions): AxiosPromise<DayCommentReadDto[]> {
        let _url = this.baseUrl + "/api/Comment/day";
        return ApiService.sendRequest<DayCommentReadDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    commentDayPost(body: DayCommentCreateDto, requestOptions?: IAjaxOptions): AxiosPromise<DayCommentReadDto> {
        let _url = this.baseUrl + "/api/Comment/day";
        return ApiService.sendRequest<DayCommentReadDto>(AxiosMethod.POST, _url, body, requestOptions);
    }
    commentDayPut(body: DayCommentUpdateDto, requestOptions?: IAjaxOptions): AxiosPromise<DayCommentReadDto> {
        let _url = this.baseUrl + "/api/Comment/day";
        return ApiService.sendRequest<DayCommentReadDto>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    commentStandbyGet(params?:IGetStandByCommentsParams, requestOptions?: IAjaxOptions): AxiosPromise<DayCommentReadDto[]> {
        let _url = this.baseUrl + "/api/Comment/standby";
        return ApiService.sendRequest<DayCommentReadDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    commentCreateMultiPost(body: MultiDayCommentCreateDto, requestOptions?: IAjaxOptions): AxiosPromise<DayCommentReadDto> {
        let _url = this.baseUrl + "/api/Comment/create-multi";
        return ApiService.sendRequest<DayCommentReadDto>(AxiosMethod.POST, _url, body, requestOptions);
    }
    commentValidationGet(params?:IGetValidationCommentsParams, requestOptions?: IAjaxOptions): AxiosPromise<ValidationCommentDto[]> {
        let _url = this.baseUrl + "/api/Comment/validation";
        return ApiService.sendRequest<ValidationCommentDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    commentValidationPut(body: ValidationCommentDto, requestOptions?: IAjaxOptions): AxiosPromise<ValidationCommentDto> {
        let _url = this.baseUrl + "/api/Comment/validation";
        return ApiService.sendRequest<ValidationCommentDto>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    commentDutyPut(body: DutyCommentDto, requestOptions?: IAjaxOptions): AxiosPromise<DutyCommentDto> {
        let _url = this.baseUrl + "/api/Comment/duty";
        return ApiService.sendRequest<DutyCommentDto>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    commentDutyGet(params?:IGetDutyParams, requestOptions?: IAjaxOptions): AxiosPromise<DutyCommentDto> {
        let _url = this.baseUrl + "/api/Comment/duty";
        return ApiService.sendRequest<DutyCommentDto>(AxiosMethod.GET, _url, params, requestOptions);
    }
    commentPlanningNotePut(body: CreatePlaningNoteModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Comment/planning-note";
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    commentPlanningNoteGet(params?:IGetPlanningNoteParams, requestOptions?: IAjaxOptions): AxiosPromise<DutyCommentDto> {
        let _url = this.baseUrl + "/api/Comment/planning-note";
        return ApiService.sendRequest<DutyCommentDto>(AxiosMethod.GET, _url, params, requestOptions);
    }
    commentDelete(params?:IDeleteParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Comment";
        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }
    commentGet(params?:IGetAll3Params, requestOptions?: IAjaxOptions): AxiosPromise<CommentShortDto[]> {
        let _url = this.baseUrl + "/api/Comment";
        return ApiService.sendRequest<CommentShortDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    commentReportPost(body: CommentReportFilter, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeResponseCommentReportModel> {
        let _url = this.baseUrl + "/api/CommentReport";
        return ApiService.sendRequest<DevExtremeResponseCommentReportModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    configurationGet(params?:IGetAll4Params, requestOptions?: IAjaxOptions): AxiosPromise<ConfigurationModel[]> {
        let _url = this.baseUrl + "/api/Configuration";
        return ApiService.sendRequest<ConfigurationModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    configurationPut(body: ConfigurationModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Configuration";
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    contractTypesGet( requestOptions?: IAjaxOptions): AxiosPromise<ContractTypeModel[]> {
        let _url = this.baseUrl + "/api/Contract/types";
        return ApiService.sendRequest<ContractTypeModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    contractFlagTypesGet( requestOptions?: IAjaxOptions): AxiosPromise<ContractFlagTypeModel[]> {
        let _url = this.baseUrl + "/api/Contract/flag-types";
        return ApiService.sendRequest<ContractFlagTypeModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    countryGet(params?:IGetAll5Params, requestOptions?: IAjaxOptions): AxiosPromise<CountryItem[]> {
        let _url = this.baseUrl + "/api/Country";
        return ApiService.sendRequest<CountryItem[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    courseManagementListPost(body: CourseManagementFilter, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeResponseCourseManagementModel> {
        let _url = this.baseUrl + "/api/CourseManagement/list";
        return ApiService.sendRequest<DevExtremeResponseCourseManagementModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    courseManagementGet(params?:IGetCourseParams, requestOptions?: IAjaxOptions): AxiosPromise<CourseDto> {
        let _url = this.baseUrl + "/api/CourseManagement";
        return ApiService.sendRequest<CourseDto>(AxiosMethod.GET, _url, params, requestOptions);
    }
    courseManagementPut(body: CourseDto, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/CourseManagement";
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    courseManagementDelete(params?:IDeleteCourseParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/CourseManagement";
        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }
    courseManagementReportPost(body: CabinCrewAttestationReportFilter, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeResponseCabinCrewAttestationModel> {
        let _url = this.baseUrl + "/api/CourseManagement/report";
        return ApiService.sendRequest<DevExtremeResponseCabinCrewAttestationModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    courseManagementExportPdfGet(params?:IGetCoursePdfParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/CourseManagement/export-pdf";
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }
    courseManagementExportBazlGet(params?:IGetCourseBazlParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/CourseManagement/export-bazl";
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }
    courseManagementImportPost(formFile: FileParameter, requestOptions?: IAjaxOptions): AxiosPromise<CourseImportResultModel> {
        let _url = this.baseUrl + "/api/CourseManagement/import";
        return ApiService.sendRequest<CourseImportResultModel>(AxiosMethod.POST, _url, formFile, requestOptions);
    }
    courseManagementPersonCoursesGet( requestOptions?: IAjaxOptions): AxiosPromise<CabinCrewAttestationModel[]> {
        let _url = this.baseUrl + "/api/CourseManagement/person-courses";
        return ApiService.sendRequest<CabinCrewAttestationModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    courseManagementPersonExportPdfGet(params?:IGetCrewPortalCoursePdfParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/CourseManagement/person-export-pdf";
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }
    courseManagementSignCcaPut(body: SignAttestateDto, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/CourseManagement/sign-cca";
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    courseManagementIncorrectCcaPut(body: IncorrectAttestateDto, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/CourseManagement/incorrect-cca";
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    crewApiConfigurationGet( requestOptions?: IAjaxOptions): AxiosPromise<CrewApiConfigurationModel[]> {
        let _url = this.baseUrl + "/api/CrewApi/configuration";
        return ApiService.sendRequest<CrewApiConfigurationModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    crewApiConfigurationPut(body: CrewApiConfigurationModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/CrewApi/configuration";
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    crewApiConfigurationDelete(params?:IDeleteAllParams, requestOptions?: IAjaxOptions): AxiosPromise<CrewApiConfigurationModel[]> {
        let _url = this.baseUrl + "/api/CrewApi/configuration";
        return ApiService.sendRequest<CrewApiConfigurationModel[]>(AxiosMethod.DELETE, _url, params, requestOptions);
    }
    crewApiMassConfigurationGet( requestOptions?: IAjaxOptions): AxiosPromise<CrewApiMassRecipientConfiguration> {
        let _url = this.baseUrl + "/api/CrewApi/mass-configuration";
        return ApiService.sendRequest<CrewApiMassRecipientConfiguration>(AxiosMethod.GET, _url, null, requestOptions);
    }
    crewApiMassConfigurationPut(body: CrewApiMassRecipientConfiguration, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/CrewApi/mass-configuration";
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    crewApiConfigReportPost(params?:IGetConfigurationReportParams, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeResponseCrewApiConfigReportModel> {
        let _url = this.baseUrl + "/api/CrewApi/config-report";
        return ApiService.sendRequest<DevExtremeResponseCrewApiConfigReportModel>(AxiosMethod.POST, _url, params, requestOptions);
    }
    crewApiConfigurationGetByCountryCode(params?:IGetByCodeAllParams, requestOptions?: IAjaxOptions): AxiosPromise<CrewApiConfigurationModel[]> {
        let _url = this.baseUrl + "/api/CrewApi/configuration/{countryCode}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<CrewApiConfigurationModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    crewApiMessageFormatGet( requestOptions?: IAjaxOptions): AxiosPromise<CrewApiMessageFormatModel[]> {
        let _url = this.baseUrl + "/api/CrewApi/message-format";
        return ApiService.sendRequest<CrewApiMessageFormatModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    crewApiDeliveryMethodGet( requestOptions?: IAjaxOptions): AxiosPromise<CrewApiDeliveryMethodModel[]> {
        let _url = this.baseUrl + "/api/CrewApi/delivery-method";
        return ApiService.sendRequest<CrewApiDeliveryMethodModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    crewApiTriggerGet( requestOptions?: IAjaxOptions): AxiosPromise<CrewApiTriggerTypeModel[]> {
        let _url = this.baseUrl + "/api/CrewApi/trigger";
        return ApiService.sendRequest<CrewApiTriggerTypeModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    crewApiPayloadGetByFlightIdItemId(params?:IGetPayloadParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/CrewApi/payload/{flightId}/{itemId}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }
    crewApiProcessGetByFlightId(params?:IGeneratePayloadsParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/CrewApi/process/{flightId}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }
    crewApiGenerateGetByFlightId(params?:IManuallyProcessFlightParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/CrewApi/generate/{flightId}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }
    crewApiFlightGetByFlightId(params?:IGetQueueForFLightParams, requestOptions?: IAjaxOptions): AxiosPromise<CrewApiSentEvent[]> {
        let _url = this.baseUrl + "/api/CrewApi/flight/{flightId}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<CrewApiSentEvent[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    crewApiLocationGetByLocationRcd(params?:IGetQueueParams, requestOptions?: IAjaxOptions): AxiosPromise<CrewApiSentEvent[]> {
        let _url = this.baseUrl + "/api/CrewApi/location/{locationRcd}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<CrewApiSentEvent[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    crewApiFlightStatusGet(params?:IGetFlightsParams, requestOptions?: IAjaxOptions): AxiosPromise<CrewApiFlightEventStatus[]> {
        let _url = this.baseUrl + "/api/CrewApi/flight-status";
        return ApiService.sendRequest<CrewApiFlightEventStatus[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    crewApiFlightStatusGetByFlightId(params?:IGetFlights2Params, requestOptions?: IAjaxOptions): AxiosPromise<CrewApiFlightEventStatusItem[]> {
        let _url = this.baseUrl + "/api/CrewApi/flight-status/{flightId}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<CrewApiFlightEventStatusItem[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    crewApiHistoryGet(params?:IGetHistoryParams, requestOptions?: IAjaxOptions): AxiosPromise<CrewApiHistoryItem[]> {
        let _url = this.baseUrl + "/api/CrewApi/history";
        return ApiService.sendRequest<CrewApiHistoryItem[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    crewApiHistoryGetByFlightIdItemId(params?:IGetHistoryPayloadParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/CrewApi/history/{flightId}/{itemId}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }
    crewApiHistoryPaxlstCountGet(params?:IGetPaxLstCountParams, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/CrewApi/history/paxlst-count";
        return ApiService.sendRequest<number>(AxiosMethod.GET, _url, params, requestOptions);
    }
    crewApiRelatedAirportsGet( requestOptions?: IAjaxOptions): AxiosPromise<string[]> {
        let _url = this.baseUrl + "/api/CrewApi/related-airports";
        return ApiService.sendRequest<string[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    crewApiPersonStateGetByPersonId(params?:IGetPersonMclStateParams, requestOptions?: IAjaxOptions): AxiosPromise<CrewApiPersonMclState> {
        let _url = this.baseUrl + "/api/CrewApi/person-state/{personId}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<CrewApiPersonMclState>(AxiosMethod.GET, _url, params, requestOptions);
    }
    crewApiAddMclPostByPersonId(params?:IAddPersonToMclQueueParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/CrewApi/add-mcl/{personId}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, params, requestOptions);
    }
    crewApiUpdateMclPostByPersonId(params?:IUpdatePersonInMclQueueParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/CrewApi/update-mcl/{personId}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, params, requestOptions);
    }
    crewApiDeleteMclPostByPersonId(params?:IDeletePersonInMclQueueParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/CrewApi/delete-mcl/{personId}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, params, requestOptions);
    }
    crewApiSkipMclPostByPersonId(params?:ISkipPendingPersonMclChangesParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/CrewApi/skip-mcl/{personId}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, params, requestOptions);
    }
    crewApiMclMissingDataGet( requestOptions?: IAjaxOptions): AxiosPromise<MclNotSentPeopleStatus> {
        let _url = this.baseUrl + "/api/CrewApi/mcl-missing-data";
        return ApiService.sendRequest<MclNotSentPeopleStatus>(AxiosMethod.GET, _url, null, requestOptions);
    }
    crewDutyListReportPost(body: CrewDutyListReportFilter, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeResponseCrewDutyListReportModel> {
        let _url = this.baseUrl + "/api/CrewDutyListReport";
        return ApiService.sendRequest<DevExtremeResponseCrewDutyListReportModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    crewDutyListReportExportPost(body: ExportCrewDutyListReportFilter, requestOptions?: IAjaxOptions): AxiosPromise<ApiV1JobTrigger> {
        let _url = this.baseUrl + "/api/CrewDutyListReport/export";
        return ApiService.sendRequest<ApiV1JobTrigger>(AxiosMethod.POST, _url, body, requestOptions);
    }
    crewNotificationTimePost(body: CrewNotificationTimeReportFilter, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeResponseCrewNotificationTimeReportModel> {
        let _url = this.baseUrl + "/api/CrewNotificationTime";
        return ApiService.sendRequest<DevExtremeResponseCrewNotificationTimeReportModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    customPersonManagementListPost(body: CustomPersonManagementFilter, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeResponseCustomPersonManagementModel> {
        let _url = this.baseUrl + "/api/CustomPersonManagement/list";
        return ApiService.sendRequest<DevExtremeResponseCustomPersonManagementModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    customPersonManagementGetById(params?:IGetMarshalParams, requestOptions?: IAjaxOptions): AxiosPromise<CustomPersonManagementDialogModel> {
        let _url = this.baseUrl + "/api/CustomPersonManagement/{id}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<CustomPersonManagementDialogModel>(AxiosMethod.GET, _url, params, requestOptions);
    }
    customPersonManagementPost(body: CustomPersonManagementDialogModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/CustomPersonManagement";
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, body, requestOptions);
    }
    customPersonManagementPut(body: CustomPersonManagementDialogModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/CustomPersonManagement";
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    devPingGet( requestOptions?: IAjaxOptions): AxiosPromise<string> {
        let _url = this.baseUrl + "/api/Dev/ping";
        return ApiService.sendRequest<string>(AxiosMethod.GET, _url, null, requestOptions);
    }
    devVersionGet( requestOptions?: IAjaxOptions): AxiosPromise<string> {
        let _url = this.baseUrl + "/api/Dev/version";
        return ApiService.sendRequest<string>(AxiosMethod.GET, _url, null, requestOptions);
    }
    dooxReportPost(body: DooxReportFilter, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeResponseDooxReportModel> {
        let _url = this.baseUrl + "/api/DooxReport";
        return ApiService.sendRequest<DevExtremeResponseDooxReportModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    dosimetryReportPost(body: PersonDosimetryFilter, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeResponsePersonDosimetryReportModel> {
        let _url = this.baseUrl + "/api/DosimetryReport";
        return ApiService.sendRequest<DevExtremeResponsePersonDosimetryReportModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    dutyGet(params?:IGetDutiesParams, requestOptions?: IAjaxOptions): AxiosPromise<DutyItem[]> {
        let _url = this.baseUrl + "/api/Duty";
        return ApiService.sendRequest<DutyItem[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    dutyPut(body: DutyCreateModel, requestOptions?: IAjaxOptions): AxiosPromise<DutyUpdateResult> {
        let _url = this.baseUrl + "/api/Duty";
        return ApiService.sendRequest<DutyUpdateResult>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    dutyDeletePost(body: DutyRemoveModel, requestOptions?: IAjaxOptions): AxiosPromise<DutyDeleteResult> {
        let _url = this.baseUrl + "/api/Duty/delete";
        return ApiService.sendRequest<DutyDeleteResult>(AxiosMethod.POST, _url, body, requestOptions);
    }
    dutyDownloadValidationPost(body: RevalidatePersonModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Duty/download-validation";
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, body, requestOptions);
    }
    dutyDownloadValidationResultPost(body: RevalidatePersonModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Duty/download-validation-result";
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, body, requestOptions);
    }
    dutyValidationDataGet(params?:IValidationDataParams, requestOptions?: IAjaxOptions): AxiosPromise<DutyValidationDataModel> {
        let _url = this.baseUrl + "/api/Duty/validation-data";
        return ApiService.sendRequest<DutyValidationDataModel>(AxiosMethod.GET, _url, params, requestOptions);
    }
    dutyValidationDataGroundGet(params?:IValidationDataGroundParams, requestOptions?: IAjaxOptions): AxiosPromise<DutyValidationGroundDataModel> {
        let _url = this.baseUrl + "/api/Duty/validation-data-ground";
        return ApiService.sendRequest<DutyValidationGroundDataModel>(AxiosMethod.GET, _url, params, requestOptions);
    }
    dutyValidationDataFseGet(params?:IValidationDataFseParams, requestOptions?: IAjaxOptions): AxiosPromise<DutyValidationFseDataModel> {
        let _url = this.baseUrl + "/api/Duty/validation-data-fse";
        return ApiService.sendRequest<DutyValidationFseDataModel>(AxiosMethod.GET, _url, params, requestOptions);
    }
    dutyCopyPost(body: CopyDutyModel, requestOptions?: IAjaxOptions): AxiosPromise<DutyUpdateResult> {
        let _url = this.baseUrl + "/api/Duty/copy";
        return ApiService.sendRequest<DutyUpdateResult>(AxiosMethod.POST, _url, body, requestOptions);
    }
    dutyUndoGet( requestOptions?: IAjaxOptions): AxiosPromise<UndoOperationModel[]> {
        let _url = this.baseUrl + "/api/Duty/undo";
        return ApiService.sendRequest<UndoOperationModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    dutyUndoPost(params?:IUndoParams, requestOptions?: IAjaxOptions): AxiosPromise<DutyUpdateResult> {
        let _url = this.baseUrl + "/api/Duty/undo";
        return ApiService.sendRequest<DutyUpdateResult>(AxiosMethod.POST, _url, params, requestOptions);
    }
    dutyRollbackUndoPost(params?:IDeleteUndoParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Duty/rollback-undo";
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, params, requestOptions);
    }
    dutyBulkUndoPost(body: BulkUndoModel, requestOptions?: IAjaxOptions): AxiosPromise<BulkUpdateResponseItem[]> {
        let _url = this.baseUrl + "/api/Duty/bulk-undo";
        return ApiService.sendRequest<BulkUpdateResponseItem[]>(AxiosMethod.POST, _url, body, requestOptions);
    }
    dutyDayActivitiesGet(params?:IGetDayActivitiesParams, requestOptions?: IAjaxOptions): AxiosPromise<DutyFilterItem[]> {
        let _url = this.baseUrl + "/api/Duty/day-activities";
        return ApiService.sendRequest<DutyFilterItem[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    dutyMonthDutyTypesGet( requestOptions?: IAjaxOptions): AxiosPromise<MonthlyTypeModel[]> {
        let _url = this.baseUrl + "/api/Duty/month-duty-types";
        return ApiService.sendRequest<MonthlyTypeModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    dutyReleaseFilterTypesGet( requestOptions?: IAjaxOptions): AxiosPromise<MonthlyTypeModel[]> {
        let _url = this.baseUrl + "/api/Duty/release-filter-types";
        return ApiService.sendRequest<MonthlyTypeModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    dutyHistoryPost(body: DutyHistoryFilter, requestOptions?: IAjaxOptions): AxiosPromise<DutyHistoryModel[]> {
        let _url = this.baseUrl + "/api/Duty/history";
        return ApiService.sendRequest<DutyHistoryModel[]>(AxiosMethod.POST, _url, body, requestOptions);
    }
    dutySeatHistoryPost(params?:ISeatHistoryParams, requestOptions?: IAjaxOptions): AxiosPromise<FlightSeatInfo[]> {
        let _url = this.baseUrl + "/api/Duty/seat-history";
        return ApiService.sendRequest<FlightSeatInfo[]>(AxiosMethod.POST, _url, params, requestOptions);
    }
    dutyUpdateTitlePost(body: DutyTitle, requestOptions?: IAjaxOptions): AxiosPromise<DutyUpdateResult> {
        let _url = this.baseUrl + "/api/Duty/update-title";
        return ApiService.sendRequest<DutyUpdateResult>(AxiosMethod.POST, _url, body, requestOptions);
    }
    dutySectorSwapCrewPost(body: SwapSectorModel, requestOptions?: IAjaxOptions): AxiosPromise<DutyUpdateResult> {
        let _url = this.baseUrl + "/api/Duty/sector/swap-crew";
        return ApiService.sendRequest<DutyUpdateResult>(AxiosMethod.POST, _url, body, requestOptions);
    }
    dutyRotationSwapCrewPost(body: SwapRotationModel, requestOptions?: IAjaxOptions): AxiosPromise<DutyUpdateResult> {
        let _url = this.baseUrl + "/api/Duty/rotation/swap-crew";
        return ApiService.sendRequest<DutyUpdateResult>(AxiosMethod.POST, _url, body, requestOptions);
    }
    dutySectorMoveCrewPost(body: MoveSectorModel, requestOptions?: IAjaxOptions): AxiosPromise<DutyUpdateResult> {
        let _url = this.baseUrl + "/api/Duty/sector/move-crew";
        return ApiService.sendRequest<DutyUpdateResult>(AxiosMethod.POST, _url, body, requestOptions);
    }
    dutyRotationMoveCrewPost(body: MoveRotationModel, requestOptions?: IAjaxOptions): AxiosPromise<DutyUpdateResult> {
        let _url = this.baseUrl + "/api/Duty/rotation/move-crew";
        return ApiService.sendRequest<DutyUpdateResult>(AxiosMethod.POST, _url, body, requestOptions);
    }
    dutyHideDutyPost(body: HideDutyModel, requestOptions?: IAjaxOptions): AxiosPromise<string> {
        let _url = this.baseUrl + "/api/Duty/hide-duty";
        return ApiService.sendRequest<string>(AxiosMethod.POST, _url, body, requestOptions);
    }
    dutyDayDutiesGet(params?:IDayDutiesParams, requestOptions?: IAjaxOptions): AxiosPromise<DutyDescriptionDto[]> {
        let _url = this.baseUrl + "/api/Duty/day-duties";
        return ApiService.sendRequest<DutyDescriptionDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    dutyPartialLoadTypesGet( requestOptions?: IAjaxOptions): AxiosPromise<PartialLoadTypeModel[]> {
        let _url = this.baseUrl + "/api/Duty/partial-load-types";
        return ApiService.sendRequest<PartialLoadTypeModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    dutyGetDutyHoursGet(params?:IGetDutyHoursParams, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/Duty/get-duty-hours";
        return ApiService.sendRequest<number>(AxiosMethod.GET, _url, params, requestOptions);
    }
    dutyChangeDutyHoursPost(body: ChangeDutyHoursModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Duty/change-duty-hours";
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, body, requestOptions);
    }
    dutyUrgentGet( requestOptions?: IAjaxOptions): AxiosPromise<UrgentErrorsModel> {
        let _url = this.baseUrl + "/api/Duty/urgent";
        return ApiService.sendRequest<UrgentErrorsModel>(AxiosMethod.GET, _url, null, requestOptions);
    }
    dutyUrgentReleasePeriodGet( requestOptions?: IAjaxOptions): AxiosPromise<UrgentErrorsModel> {
        let _url = this.baseUrl + "/api/Duty/urgent-release-period";
        return ApiService.sendRequest<UrgentErrorsModel>(AxiosMethod.GET, _url, null, requestOptions);
    }
    dutyPersonDayLandingPut(body: PersonDayLandingRequest, requestOptions?: IAjaxOptions): AxiosPromise<DutyUpdateResult> {
        let _url = this.baseUrl + "/api/Duty/person-day-landing";
        return ApiService.sendRequest<DutyUpdateResult>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    dutyPersonDayLandingGet(params?:IGetCustomLandingsParams, requestOptions?: IAjaxOptions): AxiosPromise<ValidatorCustomLanding[]> {
        let _url = this.baseUrl + "/api/Duty/person-day-landing";
        return ApiService.sendRequest<ValidatorCustomLanding[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    dutyPersonDayTakeoffPut(body: PersonDayLandingRequest, requestOptions?: IAjaxOptions): AxiosPromise<DutyUpdateResult> {
        let _url = this.baseUrl + "/api/Duty/person-day-takeoff";
        return ApiService.sendRequest<DutyUpdateResult>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    dutyPersonDayTakeoffGet(params?:IGetCustomTakeoffsParams, requestOptions?: IAjaxOptions): AxiosPromise<ValidatorCustomLanding[]> {
        let _url = this.baseUrl + "/api/Duty/person-day-takeoff";
        return ApiService.sendRequest<ValidatorCustomLanding[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    dutyPersistPost(body: PersonDaysModel[], requestOptions?: IAjaxOptions): AxiosPromise<string> {
        let _url = this.baseUrl + "/api/Duty/persist";
        return ApiService.sendRequest<string>(AxiosMethod.POST, _url, body, requestOptions);
    }
    dutyPersonDayMessagesGet(params?:IServiceBusMessagesForPersonDayParams, requestOptions?: IAjaxOptions): AxiosPromise<MessageHistoryModel[]> {
        let _url = this.baseUrl + "/api/Duty/person-day-messages";
        return ApiService.sendRequest<MessageHistoryModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    dutyConfigurePlanningPeriodPost(body: PlanningPeriodConfigRequest, requestOptions?: IAjaxOptions): AxiosPromise<MessageHistoryModel[]> {
        let _url = this.baseUrl + "/api/Duty/configure-planning-period";
        return ApiService.sendRequest<MessageHistoryModel[]>(AxiosMethod.POST, _url, body, requestOptions);
    }
    dutyPlanningPeriodsGet( requestOptions?: IAjaxOptions): AxiosPromise<PlanningPeriodDto[]> {
        let _url = this.baseUrl + "/api/Duty/planning-periods";
        return ApiService.sendRequest<PlanningPeriodDto[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    dutyPlanningDutyPeriodGet( requestOptions?: IAjaxOptions): AxiosPromise<DatesRange> {
        let _url = this.baseUrl + "/api/Duty/planning-duty-period";
        return ApiService.sendRequest<DatesRange>(AxiosMethod.GET, _url, null, requestOptions);
    }
    dutyPlanningDutyPeriodStartPost( requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Duty/planning-duty-period-start";
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, null, requestOptions);
    }
    dutyPlanningDutyPeriodReleasePost( requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Duty/planning-duty-period-release";
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, null, requestOptions);
    }
    dutyDutyPartGet(params?:IGetDutyPartsParams, requestOptions?: IAjaxOptions): AxiosPromise<DutyPartItem[]> {
        let _url = this.baseUrl + "/api/Duty/duty-part";
        return ApiService.sendRequest<DutyPartItem[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    dutyDutyPartPut(date: Date, personId: string, body: DutyPartUpdateRequest, requestOptions?: IAjaxOptions): AxiosPromise<DutyUpdateResult> {
        let _url = this.baseUrl + "/api/Duty/duty-part";
        return ApiService.sendRequest<DutyUpdateResult>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    dutyRecencyLandingsGet(params?:IRecencyLandingsParams, requestOptions?: IAjaxOptions): AxiosPromise<LandingDuty[]> {
        let _url = this.baseUrl + "/api/Duty/recency-landings";
        return ApiService.sendRequest<LandingDuty[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    dutyRecencyTakeoffsGet(params?:IRecencyTakeoffsParams, requestOptions?: IAjaxOptions): AxiosPromise<LandingDuty[]> {
        let _url = this.baseUrl + "/api/Duty/recency-takeoffs";
        return ApiService.sendRequest<LandingDuty[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    dutyCheckerTraineeGet(params?:IGetAll7Params, requestOptions?: IAjaxOptions): AxiosPromise<DutyCheckerTraineeDetailsModel[]> {
        let _url = this.baseUrl + "/api/DutyCheckerTrainee";
        return ApiService.sendRequest<DutyCheckerTraineeDetailsModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    dutyCheckerTraineePost(body: DutyCheckerTraineeModel, requestOptions?: IAjaxOptions): AxiosPromise<DutyCheckerTraineeSetResult> {
        let _url = this.baseUrl + "/api/DutyCheckerTrainee";
        return ApiService.sendRequest<DutyCheckerTraineeSetResult>(AxiosMethod.POST, _url, body, requestOptions);
    }
    dutyCheckerTraineePut(body: DutyCheckerTraineeUpdateModel, requestOptions?: IAjaxOptions): AxiosPromise<DutyCheckerTraineeSetResult> {
        let _url = this.baseUrl + "/api/DutyCheckerTrainee";
        return ApiService.sendRequest<DutyCheckerTraineeSetResult>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    dutyCheckerTraineeDelete(params?:IDelete2Params, requestOptions?: IAjaxOptions): AxiosPromise<DutyCheckerTraineeSetResult> {
        let _url = this.baseUrl + "/api/DutyCheckerTrainee";
        return ApiService.sendRequest<DutyCheckerTraineeSetResult>(AxiosMethod.DELETE, _url, params, requestOptions);
    }
    dutyCheckerTraineeLongHaulGet(params?:IGetForRotationParams, requestOptions?: IAjaxOptions): AxiosPromise<DutyCheckerTraineeDetailsModel[]> {
        let _url = this.baseUrl + "/api/DutyCheckerTrainee/long-haul";
        return ApiService.sendRequest<DutyCheckerTraineeDetailsModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    dutyCheckerTraineeFlightTeamGet(params?:IGetFlightTeamParams, requestOptions?: IAjaxOptions): AxiosPromise<FlightCrewMember[]> {
        let _url = this.baseUrl + "/api/DutyCheckerTrainee/flight-team";
        return ApiService.sendRequest<FlightCrewMember[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    dutyCheckerTraineeGroundTeamGet(params?:IGetGroundTeamParams, requestOptions?: IAjaxOptions): AxiosPromise<FlightCrewMember[]> {
        let _url = this.baseUrl + "/api/DutyCheckerTrainee/ground-team";
        return ApiService.sendRequest<FlightCrewMember[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    dutyCheckerTraineePersonDelete(params?:IDelete3Params, requestOptions?: IAjaxOptions): AxiosPromise<DutyCheckerTraineeSetResult> {
        let _url = this.baseUrl + "/api/DutyCheckerTrainee/person";
        return ApiService.sendRequest<DutyCheckerTraineeSetResult>(AxiosMethod.DELETE, _url, params, requestOptions);
    }
    dutyCheckerTraineeFunctionGet( requestOptions?: IAjaxOptions): AxiosPromise<CheckerTraineeFunctionModel[]> {
        let _url = this.baseUrl + "/api/DutyCheckerTrainee/function";
        return ApiService.sendRequest<CheckerTraineeFunctionModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    dutyPredefinedPost(body: DutyPredefinedEditModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/DutyPredefined";
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, body, requestOptions);
    }
    dutyPredefinedGet( requestOptions?: IAjaxOptions): AxiosPromise<DutyPredefinedModel[]> {
        let _url = this.baseUrl + "/api/DutyPredefined";
        return ApiService.sendRequest<DutyPredefinedModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    dutyPredefinedPutById(id: string, body: DutyPredefinedEditModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/DutyPredefined/{id}";
        _url = ApiService.getDynamicUrl(_url, { id, body });
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    dutyPredefinedDeleteById(params?:IDelete4Params, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/DutyPredefined/{id}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }
    dutyValidationGet(params?:IGetAll9Params, requestOptions?: IAjaxOptions): AxiosPromise<DutyValidationErrorModel[]> {
        let _url = this.baseUrl + "/api/DutyValidation";
        return ApiService.sendRequest<DutyValidationErrorModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    dutyValidationUrgentGet(params?:IGetUrgentParams, requestOptions?: IAjaxOptions): AxiosPromise<DutyUrgentDayModel> {
        let _url = this.baseUrl + "/api/DutyValidation/urgent";
        return ApiService.sendRequest<DutyUrgentDayModel>(AxiosMethod.GET, _url, params, requestOptions);
    }
    dutyValidationErrorsInfoPost(body: ValidationErrorsRequestModel, requestOptions?: IAjaxOptions): AxiosPromise<DutyValidationErrorInfoModel[]> {
        let _url = this.baseUrl + "/api/DutyValidation/errors-info";
        return ApiService.sendRequest<DutyValidationErrorInfoModel[]>(AxiosMethod.POST, _url, body, requestOptions);
    }
    dutyValidationSuppressReasonsGet( requestOptions?: IAjaxOptions): AxiosPromise<EnumModel[]> {
        let _url = this.baseUrl + "/api/DutyValidation/suppress-reasons";
        return ApiService.sendRequest<EnumModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    dutyValidationLandingAirportsGet( requestOptions?: IAjaxOptions): AxiosPromise<AirportShortInfo[]> {
        let _url = this.baseUrl + "/api/DutyValidation/landing-airports";
        return ApiService.sendRequest<AirportShortInfo[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    dutyValidationSuppressPost(body: SuppressValidationModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/DutyValidation/suppress";
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, body, requestOptions);
    }
    dutyValidationSuppressErrorsPut(body: SuppressErrorsRequest, requestOptions?: IAjaxOptions): AxiosPromise<SuppressErrorsResult> {
        let _url = this.baseUrl + "/api/DutyValidation/suppress-errors";
        return ApiService.sendRequest<SuppressErrorsResult>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    dutyValidationResumePost(body: ResumeValidationModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/DutyValidation/resume";
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, body, requestOptions);
    }
    dutyValidationExplainModelsGet( requestOptions?: IAjaxOptions): AxiosPromise<EnumModel[]> {
        let _url = this.baseUrl + "/api/DutyValidation/explain-models";
        return ApiService.sendRequest<EnumModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    emailPost(body: EmailFilter, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeEmailViewerGridData> {
        let _url = this.baseUrl + "/api/Email";
        return ApiService.sendRequest<DevExtremeEmailViewerGridData>(AxiosMethod.POST, _url, body, requestOptions);
    }
    emailBodyGet(params?:IGetEmailBodyParams, requestOptions?: IAjaxOptions): AxiosPromise<string> {
        let _url = this.baseUrl + "/api/Email/body";
        return ApiService.sendRequest<string>(AxiosMethod.GET, _url, params, requestOptions);
    }
    emailAttachmentsGet(params?:IGetEmailAttachmentsParams, requestOptions?: IAjaxOptions): AxiosPromise<EmailAttachmentDto[]> {
        let _url = this.baseUrl + "/api/Email/attachments";
        return ApiService.sendRequest<EmailAttachmentDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    emailAttachmentGet(params?:IGetAttachmentParams, requestOptions?: IAjaxOptions): AxiosPromise<File> {
        let _url = this.baseUrl + "/api/Email/attachment";
        return ApiService.sendRequest<File>(AxiosMethod.GET, _url, params, requestOptions);
    }
    emailValidatePost(body: EmailValidateRequest, requestOptions?: IAjaxOptions): AxiosPromise<EmailValidateResponse> {
        let _url = this.baseUrl + "/api/Email/validate";
        return ApiService.sendRequest<EmailValidateResponse>(AxiosMethod.POST, _url, body, requestOptions);
    }
    emailUpdateStatusPostByIdStatus(params?:IUpdateStatusParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Email/update-status/{id}/{status}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, params, requestOptions);
    }
    errorUiPost(body: ClientErrorModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Error/ui";
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, body, requestOptions);
    }
    errorReportPost(body: ErrorReportFilter, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeResponseErrorReportModel> {
        let _url = this.baseUrl + "/api/ErrorReport";
        return ApiService.sendRequest<DevExtremeResponseErrorReportModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    errorReportGet( requestOptions?: IAjaxOptions): AxiosPromise<EasaAlertModel> {
        let _url = this.baseUrl + "/api/ErrorReport";
        return ApiService.sendRequest<EasaAlertModel>(AxiosMethod.GET, _url, null, requestOptions);
    }
    experienceReportPost(body: ExperienceReportFilter, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeResponseExperienceReportModel> {
        let _url = this.baseUrl + "/api/ExperienceReport";
        return ApiService.sendRequest<DevExtremeResponseExperienceReportModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    flightGet(params?:IFlightsParams, requestOptions?: IAjaxOptions): AxiosPromise<FlightDto[]> {
        let _url = this.baseUrl + "/api/Flight";
        return ApiService.sendRequest<FlightDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    flightPost(body: FlightFlagsRequest, requestOptions?: IAjaxOptions): AxiosPromise<DutyUpdateResult> {
        let _url = this.baseUrl + "/api/Flight";
        return ApiService.sendRequest<DutyUpdateResult>(AxiosMethod.POST, _url, body, requestOptions);
    }
    flightGetByYearMonthDay(params?:IGetAll10Params, requestOptions?: IAjaxOptions): AxiosPromise<FlightModel[]> {
        let _url = this.baseUrl + "/api/Flight/{year}/{month}/{day}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<FlightModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    flightInfoGet(params?:IGetFlightInfosParams, requestOptions?: IAjaxOptions): AxiosPromise<FlightInfoModel[]> {
        let _url = this.baseUrl + "/api/Flight/info";
        return ApiService.sendRequest<FlightInfoModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    flightCrewDetailsGet(params?:IAircraftActivityDetailsParams, requestOptions?: IAjaxOptions): AxiosPromise<FlightCrewDetailsModel> {
        let _url = this.baseUrl + "/api/Flight/crew-details";
        return ApiService.sendRequest<FlightCrewDetailsModel>(AxiosMethod.GET, _url, params, requestOptions);
    }
    flightSectorsGetByYearMonthDay(params?:IForDayParams, requestOptions?: IAjaxOptions): AxiosPromise<SectorItem[]> {
        let _url = this.baseUrl + "/api/Flight/sectors/{year}/{month}/{day}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<SectorItem[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    flightSectorGetByFlightId(params?:IForFlightIdParams, requestOptions?: IAjaxOptions): AxiosPromise<SectorItem> {
        let _url = this.baseUrl + "/api/Flight/sector/{flightId}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<SectorItem>(AxiosMethod.GET, _url, params, requestOptions);
    }
    flightUrgentGet( requestOptions?: IAjaxOptions): AxiosPromise<UrgentFlightsModel> {
        let _url = this.baseUrl + "/api/Flight/urgent";
        return ApiService.sendRequest<UrgentFlightsModel>(AxiosMethod.GET, _url, null, requestOptions);
    }
    flightUrgentGetByFlightId(params?:IGetUrgentFlightId2Params, requestOptions?: IAjaxOptions): AxiosPromise<UrgentFlightDetailsModel> {
        let _url = this.baseUrl + "/api/Flight/urgent/{flightId}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<UrgentFlightDetailsModel>(AxiosMethod.GET, _url, params, requestOptions);
    }
    flightUrgentSuppressPut(body: UrgentFlightRequest, requestOptions?: IAjaxOptions): AxiosPromise<UrgentFlightModel[]> {
        let _url = this.baseUrl + "/api/Flight/urgent-suppress";
        return ApiService.sendRequest<UrgentFlightModel[]>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    flightPersonFdpExtensionTypePut(body: PersonDayExtendedAugmentedRequest, requestOptions?: IAjaxOptions): AxiosPromise<DutyUpdateResult> {
        let _url = this.baseUrl + "/api/Flight/person-fdp-extension-type";
        return ApiService.sendRequest<DutyUpdateResult>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    flightPersonFdpAmendmentTypePut(body: PersonDayFdpAmendmentTypeRequest, requestOptions?: IAjaxOptions): AxiosPromise<DutyUpdateResult> {
        let _url = this.baseUrl + "/api/Flight/person-fdp-amendment-type";
        return ApiService.sendRequest<DutyUpdateResult>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    flightDecodeGet(params?:IDecodeParams, requestOptions?: IAjaxOptions): AxiosPromise<FlightIdInfo> {
        let _url = this.baseUrl + "/api/Flight/decode";
        return ApiService.sendRequest<FlightIdInfo>(AxiosMethod.GET, _url, params, requestOptions);
    }
    flightHistoryPost(params?:IGetDayHistory2Params, requestOptions?: IAjaxOptions): AxiosPromise<FlightLogItem[]> {
        let _url = this.baseUrl + "/api/Flight/history";
        return ApiService.sendRequest<FlightLogItem[]>(AxiosMethod.POST, _url, params, requestOptions);
    }
    flightInformationGet(params?:IGetFlightInformationParams, requestOptions?: IAjaxOptions): AxiosPromise<FlightInformationEditModel> {
        let _url = this.baseUrl + "/api/Flight/information";
        return ApiService.sendRequest<FlightInformationEditModel>(AxiosMethod.GET, _url, params, requestOptions);
    }
    flightInformationPut(body: FlightInformationEditModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Flight/information";
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    flightRevalidatePost(body: FlightRevalidateModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Flight/revalidate";
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, body, requestOptions);
    }
    flightMessagesGet(params?:IServiceBusMessagesForPersonDay2Params, requestOptions?: IAjaxOptions): AxiosPromise<MessageHistoryModel[]> {
        let _url = this.baseUrl + "/api/Flight/messages";
        return ApiService.sendRequest<MessageHistoryModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    flightPublishNetlinePost(params?:IPublishParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Flight/publish-netline";
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, params, requestOptions);
    }
    flightCrewTypeGet( requestOptions?: IAjaxOptions): AxiosPromise<string[]> {
        let _url = this.baseUrl + "/api/Flight/crew-type";
        return ApiService.sendRequest<string[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    flightCrewGetByFlightId(params?:IGetCrewParams, requestOptions?: IAjaxOptions): AxiosPromise<FlightResponse> {
        let _url = this.baseUrl + "/api/Flight/{flightId}/crew";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<FlightResponse>(AxiosMethod.GET, _url, params, requestOptions);
    }
    flightDutyRecordGet(params?:IGetGET2Params, requestOptions?: IAjaxOptions): AxiosPromise<FlightDutyRecordReportModel> {
        let _url = this.baseUrl + "/api/FlightDutyRecord";
        return ApiService.sendRequest<FlightDutyRecordReportModel>(AxiosMethod.GET, _url, params, requestOptions);
    }
    flightDutyRecordDownloadGet(params?:IDownloadParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/FlightDutyRecord/download";
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }
    functionGet(params?:IGetAll11Params, requestOptions?: IAjaxOptions): AxiosPromise<FunctionModel[]> {
        let _url = this.baseUrl + "/api/Function";
        return ApiService.sendRequest<FunctionModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    functionGroupGet( requestOptions?: IAjaxOptions): AxiosPromise<FunctionGroupModel[]> {
        let _url = this.baseUrl + "/api/Function/group";
        return ApiService.sendRequest<FunctionGroupModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    genDecPost(body: GenDecDocumentRequest, requestOptions?: IAjaxOptions): AxiosPromise<GenDecReportData> {
        let _url = this.baseUrl + "/api/GenDec";
        return ApiService.sendRequest<GenDecReportData>(AxiosMethod.POST, _url, body, requestOptions);
    }
    genDecPreviewPost(body: GenDecDocumentRequest, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/GenDec/preview";
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, body, requestOptions);
    }
    genDecPayloadGetByFlightIdItemId(params?:IGetPayload2Params, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/GenDec/payload/{flightId}/{itemId}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }
    genDecProcessGetByFlightId(params?:IGeneratePayloads2Params, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/GenDec/process/{flightId}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }
    genDecGetByReportId(params?:IGetReportGET2Params, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/GenDec/{reportId}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }
    genDecRotationGet(params?:IGetAircraftRotationsParams, requestOptions?: IAjaxOptions): AxiosPromise<GenDecAircraftRotation[]> {
        let _url = this.baseUrl + "/api/GenDec/rotation";
        return ApiService.sendRequest<GenDecAircraftRotation[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    genDecConfigurationGet(params?:IGetConfigurationsParams, requestOptions?: IAjaxOptions): AxiosPromise<GenDecConfigurationModel[]> {
        let _url = this.baseUrl + "/api/GenDec/configuration";
        return ApiService.sendRequest<GenDecConfigurationModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    genDecConfigurationPut(body: GenDecConfigurationModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/GenDec/configuration";
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    genDecConfigurationDelete(params?:IDeleteAll2Params, requestOptions?: IAjaxOptions): AxiosPromise<GenDecConfigurationModel[]> {
        let _url = this.baseUrl + "/api/GenDec/configuration";
        return ApiService.sendRequest<GenDecConfigurationModel[]>(AxiosMethod.DELETE, _url, params, requestOptions);
    }
    genDecRelatedAirportsGet( requestOptions?: IAjaxOptions): AxiosPromise<string[]> {
        let _url = this.baseUrl + "/api/GenDec/related-airports";
        return ApiService.sendRequest<string[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    genDecFlightStatusGet(params?:IGetFlights3Params, requestOptions?: IAjaxOptions): AxiosPromise<GenDecFlightEventStatus[]> {
        let _url = this.baseUrl + "/api/GenDec/flight-status";
        return ApiService.sendRequest<GenDecFlightEventStatus[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    genDecFlightStatusGetByFlightId(params?:IGetFlights4Params, requestOptions?: IAjaxOptions): AxiosPromise<GenDecFlightEventStatusItem[]> {
        let _url = this.baseUrl + "/api/GenDec/flight-status/{flightId}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<GenDecFlightEventStatusItem[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    genDecConfigReportPost(params?:IGetConfigurationReport2Params, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeResponseGenDecConfigReportModel> {
        let _url = this.baseUrl + "/api/GenDec/config-report";
        return ApiService.sendRequest<DevExtremeResponseGenDecConfigReportModel>(AxiosMethod.POST, _url, params, requestOptions);
    }
    genDecDeliveryMethodsGet(params?:IGetAll12Params, requestOptions?: IAjaxOptions): AxiosPromise<GenDecConfigurationDeliveryModel[]> {
        let _url = this.baseUrl + "/api/GenDec/delivery-methods";
        return ApiService.sendRequest<GenDecConfigurationDeliveryModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    groundStaffReportGet(params?:IGetReportGET3Params, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/GroundStaffReport";
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }
    holidayGet( requestOptions?: IAjaxOptions): AxiosPromise<HolidayResponseItem> {
        let _url = this.baseUrl + "/api/Holiday";
        return ApiService.sendRequest<HolidayResponseItem>(AxiosMethod.GET, _url, null, requestOptions);
    }
    errorPost(body: JsErrorModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/error";
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, body, requestOptions);
    }
    homeStudyPost(params?:IGetHomeStudyParams, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeResponseDutyHomeStudyItem> {
        let _url = this.baseUrl + "/api/HomeStudy";
        return ApiService.sendRequest<DevExtremeResponseDutyHomeStudyItem>(AxiosMethod.POST, _url, params, requestOptions);
    }
    homeStudyPersonsPost(body: CreateHomeStudyFilter, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeResponsePersonInfoModel> {
        let _url = this.baseUrl + "/api/HomeStudy/persons";
        return ApiService.sendRequest<DevExtremeResponsePersonInfoModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    hotelManagementLocationsPost(body: LocationInfoHotelBookingFilter, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeResponseLocationHotelBookingModel> {
        let _url = this.baseUrl + "/api/HotelManagement/locations";
        return ApiService.sendRequest<DevExtremeResponseLocationHotelBookingModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    hotelManagementLocationsMonthPost(body: LocationMonthHotelBookingFilter, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeResponsePreReservationLocationsModel> {
        let _url = this.baseUrl + "/api/HotelManagement/locations-month";
        return ApiService.sendRequest<DevExtremeResponsePreReservationLocationsModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    hotelManagementHotelDetailsGet(params?:IHotelDetailsParams, requestOptions?: IAjaxOptions): AxiosPromise<HotelBookingDetailModel> {
        let _url = this.baseUrl + "/api/HotelManagement/hotel-details";
        return ApiService.sendRequest<HotelBookingDetailModel>(AxiosMethod.GET, _url, params, requestOptions);
    }
    hotelManagementHotelPersonDetailsPost(body: PersonDetailsHotelBookingFilter, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeResponsePersonHotelBookingDetailModel> {
        let _url = this.baseUrl + "/api/HotelManagement/hotel-person-details";
        return ApiService.sendRequest<DevExtremeResponsePersonHotelBookingDetailModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    hotelManagementPreReservationHotelDetailsGet(params?:IPreReservationHotelDetailsParams, requestOptions?: IAjaxOptions): AxiosPromise<PreReservationHotelBookingDetailModel> {
        let _url = this.baseUrl + "/api/HotelManagement/pre-reservation/hotel-details";
        return ApiService.sendRequest<PreReservationHotelBookingDetailModel>(AxiosMethod.GET, _url, params, requestOptions);
    }
    hotelManagementPreReservationHotelBookingDetailsPost(body: HotelBookingDetailsFilter, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeResponseLocationHotelBookingModel> {
        let _url = this.baseUrl + "/api/HotelManagement/pre-reservation/hotel-booking-details";
        return ApiService.sendRequest<DevExtremeResponseLocationHotelBookingModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    hotelManagementDownloadEmailGet(params?:ICreateEmailForHotelParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/HotelManagement/download-email";
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }
    hotelManagementPreReservationDownloadEmailGet(params?:ICreatePreReservationEmailForHotelParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/HotelManagement/pre-reservation/download-email";
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }
    instructorFilterGet(params?:IGetGET4Params, requestOptions?: IAjaxOptions): AxiosPromise<InstructorFilterModel> {
        let _url = this.baseUrl + "/api/InstructorFilter";
        return ApiService.sendRequest<InstructorFilterModel>(AxiosMethod.GET, _url, params, requestOptions);
    }
    instructorFilterPost(body: InstructorFilterGridFilter, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeResponseInstructorFilterModel> {
        let _url = this.baseUrl + "/api/InstructorFilter";
        return ApiService.sendRequest<DevExtremeResponseInstructorFilterModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    instructorFilterPut(body: InstructorFilterDialogModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/InstructorFilter";
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    instructorFilterDelete(params?:IDeleteFilterParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/InstructorFilter";
        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }
    instructorFilterCodeGetByCodeName(params?:IGetByCode2Params, requestOptions?: IAjaxOptions): AxiosPromise<InstructorFilterDialogModel> {
        let _url = this.baseUrl + "/api/InstructorFilter/code/{codeName}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<InstructorFilterDialogModel>(AxiosMethod.GET, _url, params, requestOptions);
    }
    jeppesenToolDownloadFileGet(params?:IGetJeppesenFileParams, requestOptions?: IAjaxOptions): AxiosPromise<File> {
        let _url = this.baseUrl + "/api/JeppesenTool/download-file";
        return ApiService.sendRequest<File>(AxiosMethod.GET, _url, params, requestOptions);
    }
    jeppesenToolRosterExportInfoGet( requestOptions?: IAjaxOptions): AxiosPromise<JeppesenButtonInfoModel[]> {
        let _url = this.baseUrl + "/api/JeppesenTool/roster-export-info";
        return ApiService.sendRequest<JeppesenButtonInfoModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    jeppesenToolCrewExportInfoGet( requestOptions?: IAjaxOptions): AxiosPromise<JeppesenButtonInfoModel[]> {
        let _url = this.baseUrl + "/api/JeppesenTool/crew-export-info";
        return ApiService.sendRequest<JeppesenButtonInfoModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    jeppesenToolRosterImportInfoGet( requestOptions?: IAjaxOptions): AxiosPromise<JeppesenButtonInfoModel[]> {
        let _url = this.baseUrl + "/api/JeppesenTool/roster-import-info";
        return ApiService.sendRequest<JeppesenButtonInfoModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    jeppesenToolRosterImportsPost(body: RosterImportFilter, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeResponseRosterImportModel> {
        let _url = this.baseUrl + "/api/JeppesenTool/roster-imports";
        return ApiService.sendRequest<DevExtremeResponseRosterImportModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    jeppesenToolRosterImportDetailsPost(body: RosterImportDetailsFilter, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeResponseRosterImportDetailsModel> {
        let _url = this.baseUrl + "/api/JeppesenTool/roster-import-details";
        return ApiService.sendRequest<DevExtremeResponseRosterImportDetailsModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    jeppesenToolRosterImportExceptionGet(params?:IGetRosterImportDetailsErrorParams, requestOptions?: IAjaxOptions): AxiosPromise<RosterImportErrorExceptionModel> {
        let _url = this.baseUrl + "/api/JeppesenTool/roster-import-exception";
        return ApiService.sendRequest<RosterImportErrorExceptionModel>(AxiosMethod.GET, _url, params, requestOptions);
    }
    jeppesenToolRosterImportFileDataGet(params?:IGetRosterImportFileDataParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/JeppesenTool/roster-import-file-data";
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }
    jeppesenToolRosterImportUploadFilePost(formFile: FileParameter, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/JeppesenTool/roster-import-upload-file";
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, formFile, requestOptions);
    }
    jeppesenToolCasImportInfoGet( requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/JeppesenTool/cas-import-info";
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, null, requestOptions);
    }
    jeppesenToolCasImportFileGet( requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/JeppesenTool/cas-import-file";
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, null, requestOptions);
    }
    jeppesenToolCasImportFilePut(formFile: FileParameter, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/JeppesenTool/cas-import-file";
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, formFile, requestOptions);
    }
    jobListGet( requestOptions?: IAjaxOptions): AxiosPromise<ApiV1JobList> {
        let _url = this.baseUrl + "/api/Job/list";
        return ApiService.sendRequest<ApiV1JobList>(AxiosMethod.GET, _url, null, requestOptions);
    }
    jobGetById(params?:IGetById2Params, requestOptions?: IAjaxOptions): AxiosPromise<ApiV1Job> {
        let _url = this.baseUrl + "/api/Job/{id}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<ApiV1Job>(AxiosMethod.GET, _url, params, requestOptions);
    }
    jobStartPostByJobName(jobName: string, body: JobStartModel, requestOptions?: IAjaxOptions): AxiosPromise<ApiV1JobTrigger> {
        let _url = this.baseUrl + "/api/Job/start/{jobName}";
        _url = ApiService.getDynamicUrl(_url, { jobName, body });
        return ApiService.sendRequest<ApiV1JobTrigger>(AxiosMethod.POST, _url, body, requestOptions);
    }
    jobParametersGetByJobName(params?:IParametersGETParams, requestOptions?: IAjaxOptions): AxiosPromise<JobDetailsModel> {
        let _url = this.baseUrl + "/api/Job/parameters/{jobName}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<JobDetailsModel>(AxiosMethod.GET, _url, params, requestOptions);
    }
    jobCronValidationPostByCronExpression(params?:IParametersPOSTParams, requestOptions?: IAjaxOptions): AxiosPromise<CronValidationResult> {
        let _url = this.baseUrl + "/api/Job/cron/validation/{cronExpression}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<CronValidationResult>(AxiosMethod.POST, _url, params, requestOptions);
    }
    jobParametersPostByTriggerName(triggerName: string, body: JobSaveParametersModel, requestOptions?: IAjaxOptions): AxiosPromise<ApiV1Job> {
        let _url = this.baseUrl + "/api/Job/parameters/{triggerName}";
        _url = ApiService.getDynamicUrl(_url, { triggerName, body });
        return ApiService.sendRequest<ApiV1Job>(AxiosMethod.POST, _url, body, requestOptions);
    }
    jobSettingsPostByJobName(jobName: string, body: JobSaveParametersModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Job/settings/{jobName}";
        _url = ApiService.getDynamicUrl(_url, { jobName, body });
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, body, requestOptions);
    }
    jobCreatePost(body: JobSaveParametersModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Job/create";
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, body, requestOptions);
    }
    jobDeleteDelete(params?:IDelete5Params, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Job/delete";
        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }
    jobCheckTriggerNameGet(params?:IIsTriggerNameUniqueParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Job/check-trigger-name";
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }
    jobStopPostByJobNameJobExecutionId(params?:IStopParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Job/stop/{jobName}/{jobExecutionId}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, params, requestOptions);
    }
    licenseManagementLicenseListPost(body: LicenseManagementFilter, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeResponseLicenseManagementModel> {
        let _url = this.baseUrl + "/api/LicenseManagement/license-list";
        return ApiService.sendRequest<DevExtremeResponseLicenseManagementModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    licenseManagementGet(params?:IGetLicenseParams, requestOptions?: IAjaxOptions): AxiosPromise<LicenseManagementDialogModel> {
        let _url = this.baseUrl + "/api/LicenseManagement";
        return ApiService.sendRequest<LicenseManagementDialogModel>(AxiosMethod.GET, _url, params, requestOptions);
    }
    licenseManagementPost(body: LicenseManagementDialogModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/LicenseManagement";
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, body, requestOptions);
    }
    licenseManagementPut(body: LicenseManagementDialogModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/LicenseManagement";
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    licenseManagementDelete(params?:IDeleteLicenseParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/LicenseManagement";
        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }
    licenseManagementLicenseManagementOptionsGet( requestOptions?: IAjaxOptions): AxiosPromise<LicenseManagementOptionsModel> {
        let _url = this.baseUrl + "/api/LicenseManagement/license-management-options";
        return ApiService.sendRequest<LicenseManagementOptionsModel>(AxiosMethod.GET, _url, null, requestOptions);
    }
    llmOperationLikePostById(params?:ILikeResponseParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/LlmOperation/like/{id}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, params, requestOptions);
    }
    llmOperationDislikePostById(params?:IDislikeResponseParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/LlmOperation/dislike/{id}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, params, requestOptions);
    }
    logbookPost(body: LogbookFilter, requestOptions?: IAjaxOptions): AxiosPromise<LogbookModel[]> {
        let _url = this.baseUrl + "/api/Logbook";
        return ApiService.sendRequest<LogbookModel[]>(AxiosMethod.POST, _url, body, requestOptions);
    }
    logbookExportPost(body: ExportLogbookModel, requestOptions?: IAjaxOptions): AxiosPromise<ApiV1JobTrigger> {
        let _url = this.baseUrl + "/api/Logbook/export";
        return ApiService.sendRequest<ApiV1JobTrigger>(AxiosMethod.POST, _url, body, requestOptions);
    }
    maintenanceNotificationPut(body: MaintenanceModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Maintenance/notification";
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    maintenancePut(body: MaintenanceModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Maintenance";
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    maintenanceGet( requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Maintenance";
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, null, requestOptions);
    }
    maintenanceCanBypassMaintenanceGet( requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Maintenance/can-bypass-maintenance";
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, null, requestOptions);
    }
    maintenancePingGet( requestOptions?: IAjaxOptions): AxiosPromise<string> {
        let _url = this.baseUrl + "/api/Maintenance/ping";
        return ApiService.sendRequest<string>(AxiosMethod.GET, _url, null, requestOptions);
    }
    offdaysReportPost(body: OffDaysReportFilter, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeResponseOffDaysReportModel> {
        let _url = this.baseUrl + "/api/OffdaysReport";
        return ApiService.sendRequest<DevExtremeResponseOffDaysReportModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    onlinePrincipalConnectedClientsGet( requestOptions?: IAjaxOptions): AxiosPromise<ConnectedClientModel[]> {
        let _url = this.baseUrl + "/api/OnlinePrincipal/connected-clients";
        return ApiService.sendRequest<ConnectedClientModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    onlinePrincipalRosterActivityGet( requestOptions?: IAjaxOptions): AxiosPromise<PersonRosterActivityModel[]> {
        let _url = this.baseUrl + "/api/OnlinePrincipal/roster-activity";
        return ApiService.sendRequest<PersonRosterActivityModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    permissionGet( requestOptions?: IAjaxOptions): AxiosPromise<PermissionModel[]> {
        let _url = this.baseUrl + "/api/Permission";
        return ApiService.sendRequest<PermissionModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    permissionRoleGet( requestOptions?: IAjaxOptions): AxiosPromise<PredefinedRoleModel[]> {
        let _url = this.baseUrl + "/api/Permission/role";
        return ApiService.sendRequest<PredefinedRoleModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    permissionRoleGetByRoleId(params?:IGetForRoleParams, requestOptions?: IAjaxOptions): AxiosPromise<PermissionModel[]> {
        let _url = this.baseUrl + "/api/Permission/role/{roleId}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<PermissionModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personGet(params?:IGetGET6Params, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Person";
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personRevalidatePost(body: RevalidatePersonModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Person/revalidate";
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, body, requestOptions);
    }
    personPublishPost(body: RevalidatePersonModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Person/publish";
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, body, requestOptions);
    }
    personLookupPost(body: PersonFilter, requestOptions?: IAjaxOptions): AxiosPromise<PersonLookupModel[]> {
        let _url = this.baseUrl + "/api/Person/lookup";
        return ApiService.sendRequest<PersonLookupModel[]>(AxiosMethod.POST, _url, body, requestOptions);
    }
    personLookupByPhoneGet(params?:IGetGET7Params, requestOptions?: IAjaxOptions): AxiosPromise<PersonLookupByPhoneModel> {
        let _url = this.baseUrl + "/api/Person/lookup-by-phone";
        return ApiService.sendRequest<PersonLookupByPhoneModel>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personRelatedPersonGet( requestOptions?: IAjaxOptions): AxiosPromise<RelatedPersonResponse> {
        let _url = this.baseUrl + "/api/Person/related-person";
        return ApiService.sendRequest<RelatedPersonResponse>(AxiosMethod.GET, _url, null, requestOptions);
    }
    personSmsPost(body: SendSmsBody, requestOptions?: IAjaxOptions): AxiosPromise<SendSmsResponse> {
        let _url = this.baseUrl + "/api/Person/sms";
        return ApiService.sendRequest<SendSmsResponse>(AxiosMethod.POST, _url, body, requestOptions);
    }
    personSmsCrewGet(params?:IGetCrewSmsParams, requestOptions?: IAjaxOptions): AxiosPromise<SendCrewSmsInfo> {
        let _url = this.baseUrl + "/api/Person/sms-crew";
        return ApiService.sendRequest<SendCrewSmsInfo>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personLicensesPost(params?:IGetSeatHistoryParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonLicenseInfo[]> {
        let _url = this.baseUrl + "/api/Person/licenses";
        return ApiService.sendRequest<PersonLicenseInfo[]>(AxiosMethod.POST, _url, params, requestOptions);
    }
    personMintLicensesPost(params?:IGetMintLicensesParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonMintLicenseInfo[]> {
        let _url = this.baseUrl + "/api/Person/mint-licenses";
        return ApiService.sendRequest<PersonMintLicenseInfo[]>(AxiosMethod.POST, _url, params, requestOptions);
    }
    personMintLicenseInactivationsPost(params?:IGetMintLicenseInactivationsParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonMintLicenseInactivationInfo[]> {
        let _url = this.baseUrl + "/api/Person/mint-license-inactivations";
        return ApiService.sendRequest<PersonMintLicenseInactivationInfo[]>(AxiosMethod.POST, _url, params, requestOptions);
    }
    personEntriesPost(params?:IGetPersonEntriesParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonEntryModel[]> {
        let _url = this.baseUrl + "/api/Person/entries";
        return ApiService.sendRequest<PersonEntryModel[]>(AxiosMethod.POST, _url, params, requestOptions);
    }
    personFunctionsPost(params?:IGetPersonFunctionsParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonFunctionDto[]> {
        let _url = this.baseUrl + "/api/Person/functions";
        return ApiService.sendRequest<PersonFunctionDto[]>(AxiosMethod.POST, _url, params, requestOptions);
    }
    personPlanningFunctionOverrulesPost(params?:IGetPlanningFunctionOverrulesParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonPlanningFunctionOverruleInfo[]> {
        let _url = this.baseUrl + "/api/Person/planning-function-overrules";
        return ApiService.sendRequest<PersonPlanningFunctionOverruleInfo[]>(AxiosMethod.POST, _url, params, requestOptions);
    }
    personAircraftActivitiesGet(params?:IGetAircraftActivitiesParams, requestOptions?: IAjaxOptions): AxiosPromise<LicenseAircraftActivity[]> {
        let _url = this.baseUrl + "/api/Person/aircraft-activities";
        return ApiService.sendRequest<LicenseAircraftActivity[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personAirportsGet(params?:IGetSpecialAirportsParams, requestOptions?: IAjaxOptions): AxiosPromise<LicenseAirport[]> {
        let _url = this.baseUrl + "/api/Person/airports";
        return ApiService.sendRequest<LicenseAirport[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personExperienceGet(params?:IGetPersonExperienceSummaryParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonExperienceSummary> {
        let _url = this.baseUrl + "/api/Person/experience";
        return ApiService.sendRequest<PersonExperienceSummary>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personShowMyScheduleGet( requestOptions?: IAjaxOptions): AxiosPromise<boolean> {
        let _url = this.baseUrl + "/api/Person/show-my-schedule";
        return ApiService.sendRequest<boolean>(AxiosMethod.GET, _url, null, requestOptions);
    }
    personShowMySchedulePut(body: ShowSettingModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Person/show-my-schedule";
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    personAllowSecondReserveGet( requestOptions?: IAjaxOptions): AxiosPromise<boolean> {
        let _url = this.baseUrl + "/api/Person/allow-second-reserve";
        return ApiService.sendRequest<boolean>(AxiosMethod.GET, _url, null, requestOptions);
    }
    personAllowSecondReservePut(body: ShowSettingModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Person/allow-second-reserve";
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    personShowMyPhoneGet( requestOptions?: IAjaxOptions): AxiosPromise<boolean> {
        let _url = this.baseUrl + "/api/Person/show-my-phone";
        return ApiService.sendRequest<boolean>(AxiosMethod.GET, _url, null, requestOptions);
    }
    personShowMyPhonePut(body: ShowSettingModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Person/show-my-phone";
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    personOptInShowEfaScheduleGet( requestOptions?: IAjaxOptions): AxiosPromise<boolean> {
        let _url = this.baseUrl + "/api/Person/opt-in-show-efa-schedule";
        return ApiService.sendRequest<boolean>(AxiosMethod.GET, _url, null, requestOptions);
    }
    personOptInShowEfaSchedulePut(body: ShowSettingModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Person/opt-in-show-efa-schedule";
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    personOptInShowAeropersScheduleGet( requestOptions?: IAjaxOptions): AxiosPromise<boolean> {
        let _url = this.baseUrl + "/api/Person/opt-in-show-aeropers-schedule";
        return ApiService.sendRequest<boolean>(AxiosMethod.GET, _url, null, requestOptions);
    }
    personOptInShowAeropersSchedulePut(body: ShowSettingModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Person/opt-in-show-aeropers-schedule";
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    personMessagesGet(params?:IServiceBusMessagesForPersonDay3Params, requestOptions?: IAjaxOptions): AxiosPromise<MessageHistoryModel[]> {
        let _url = this.baseUrl + "/api/Person/messages";
        return ApiService.sendRequest<MessageHistoryModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personPersonModificationsGetByPersonId(params?:IGetPersonModificationsParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonModifications> {
        let _url = this.baseUrl + "/api/Person/person-modifications/{personId}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<PersonModifications>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personAircraftTypeExperienceGet( requestOptions?: IAjaxOptions): AxiosPromise<PersonAircraftTypeExperienceOverrule[]> {
        let _url = this.baseUrl + "/api/PersonAircraftTypeExperience";
        return ApiService.sendRequest<PersonAircraftTypeExperienceOverrule[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    personAircraftTypeExperiencePost(body: PersonAircraftTypeExperienceOverrule, requestOptions?: IAjaxOptions): AxiosPromise<PersonAircraftTypeExperienceOverrule> {
        let _url = this.baseUrl + "/api/PersonAircraftTypeExperience";
        return ApiService.sendRequest<PersonAircraftTypeExperienceOverrule>(AxiosMethod.POST, _url, body, requestOptions);
    }
    personAircraftTypeExperiencePut(body: PersonAircraftTypeExperienceOverrule, requestOptions?: IAjaxOptions): AxiosPromise<PersonAircraftTypeExperienceOverrule> {
        let _url = this.baseUrl + "/api/PersonAircraftTypeExperience";
        return ApiService.sendRequest<PersonAircraftTypeExperienceOverrule>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    personAircraftTypeExperienceDelete(params?:IDelete6Params, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/PersonAircraftTypeExperience";
        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }
    personAircraftTypeExperienceGetByPersonIdAircraftTypeGroupActivityDate(params?:IGetGET8Params, requestOptions?: IAjaxOptions): AxiosPromise<PersonAircraftTypeExperienceOverrule> {
        let _url = this.baseUrl + "/api/PersonAircraftTypeExperience/{personId}/{aircraftTypeGroup}/{activity}/{date}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<PersonAircraftTypeExperienceOverrule>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personAircraftTypeExperienceOverruleGetByPersonIdAircraftTypeGroupActivity(params?:IGetOverruleParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonAircraftTypeExperienceOverrule> {
        let _url = this.baseUrl + "/api/PersonAircraftTypeExperience/overrule/{personId}/{aircraftTypeGroup}/{activity}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<PersonAircraftTypeExperienceOverrule>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personChangeLogGet(params?:IGetAll15Params, requestOptions?: IAjaxOptions): AxiosPromise<PersonChangeLogModel[]> {
        let _url = this.baseUrl + "/api/PersonChangeLog";
        return ApiService.sendRequest<PersonChangeLogModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personChangeLogLastGet(params?:IGetLastParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonChangeLogModel> {
        let _url = this.baseUrl + "/api/PersonChangeLog/last";
        return ApiService.sendRequest<PersonChangeLogModel>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personChangeLogConfirmPut(body: PersonChangeLogConfirmModel, requestOptions?: IAjaxOptions): AxiosPromise<PersonChangeLogModel> {
        let _url = this.baseUrl + "/api/PersonChangeLog/confirm";
        return ApiService.sendRequest<PersonChangeLogModel>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    personInfoGet(params?:IGetPersonInfoParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonInfoModel[]> {
        let _url = this.baseUrl + "/api/PersonInfo";
        return ApiService.sendRequest<PersonInfoModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personInfoQuarterGet(params?:IPersonQuarterInfosParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonQuarterDaysOffModel[]> {
        let _url = this.baseUrl + "/api/PersonInfo/quarter";
        return ApiService.sendRequest<PersonQuarterDaysOffModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personInfoSummaryFiguresGet(params?:IPersonSummaryFiguresInfosParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonSummaryFiguresModel[]> {
        let _url = this.baseUrl + "/api/PersonInfo/summary-figures";
        return ApiService.sendRequest<PersonSummaryFiguresModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personInfoDeltaFiguresGet(params?:IPersonDeltaFiguresInfosParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonDeltaFiguresModel[]> {
        let _url = this.baseUrl + "/api/PersonInfo/delta-figures";
        return ApiService.sendRequest<PersonDeltaFiguresModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personInfoConsecutive3monthFiguresGet(params?:IPersonConsecutiveMonthsDaysOffInfosParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonConsecutiveMonthsDaysOffModel[]> {
        let _url = this.baseUrl + "/api/PersonInfo/consecutive3month-figures";
        return ApiService.sendRequest<PersonConsecutiveMonthsDaysOffModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personInfoDutyPeriodsGet(params?:IPersonDutyPeriodInfosParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonDutyPeriodModel[]> {
        let _url = this.baseUrl + "/api/PersonInfo/duty-periods";
        return ApiService.sendRequest<PersonDutyPeriodModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personInfoDutyFiguresPost(body: PersonDayDutyFiguresFilter, requestOptions?: IAjaxOptions): AxiosPromise<PersonDayDutyFiguresModel[]> {
        let _url = this.baseUrl + "/api/PersonInfo/duty-figures";
        return ApiService.sendRequest<PersonDayDutyFiguresModel[]>(AxiosMethod.POST, _url, body, requestOptions);
    }
    personInfoDayStatusPut(body: PlanningGroupDayStatusRequest, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/PersonInfo/day-status";
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    personInfoCicoChangePost(body: ChangeCheckInCheckOutModel, requestOptions?: IAjaxOptions): AxiosPromise<string> {
        let _url = this.baseUrl + "/api/PersonInfo/cico/change";
        return ApiService.sendRequest<string>(AxiosMethod.POST, _url, body, requestOptions);
    }
    personInfoCicoResetPost(body: CheckInCheckOutModel, requestOptions?: IAjaxOptions): AxiosPromise<string> {
        let _url = this.baseUrl + "/api/PersonInfo/cico/reset";
        return ApiService.sendRequest<string>(AxiosMethod.POST, _url, body, requestOptions);
    }
    personInfoCicoGet(params?:IGetCustomCheckInCheckOutInfoParams, requestOptions?: IAjaxOptions): AxiosPromise<FullCheckInCheckOutModel> {
        let _url = this.baseUrl + "/api/PersonInfo/cico";
        return ApiService.sendRequest<FullCheckInCheckOutModel>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personInfoCicoSetByEstimatedPost(body: SetEstimatedCiCoModel, requestOptions?: IAjaxOptions): AxiosPromise<SetEstimatedCiCoResult> {
        let _url = this.baseUrl + "/api/PersonInfo/cico/set-by-estimated";
        return ApiService.sendRequest<SetEstimatedCiCoResult>(AxiosMethod.POST, _url, body, requestOptions);
    }
    personInfoPopupDataGet(params?:IPersonDatePopupDataParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonDatePopupDataModel> {
        let _url = this.baseUrl + "/api/PersonInfo/popup-data";
        return ApiService.sendRequest<PersonDatePopupDataModel>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personInfoLocationGet(params?:IGetLocationParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonLocation> {
        let _url = this.baseUrl + "/api/PersonInfo/location";
        return ApiService.sendRequest<PersonLocation>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personLicenseAirbusTypesGet(params?:IGetLicenseDistinctNamesParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonAirbusTypeModel[]> {
        let _url = this.baseUrl + "/api/PersonLicense/airbus-types";
        return ApiService.sendRequest<PersonAirbusTypeModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personLicenseFunctionGet(params?:IGetByFunctionParams, requestOptions?: IAjaxOptions): AxiosPromise<LicenseApiModel[]> {
        let _url = this.baseUrl + "/api/PersonLicense/function";
        return ApiService.sendRequest<LicenseApiModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personLicensePersonGet(params?:IGetForPersonParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonLicenseInfo[]> {
        let _url = this.baseUrl + "/api/PersonLicense/person";
        return ApiService.sendRequest<PersonLicenseInfo[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personLicenseValidationSuppressGet(params?:IGetValidationSuppressedParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonLicenseSuppressionItemModel[]> {
        let _url = this.baseUrl + "/api/PersonLicense/validation-suppress";
        return ApiService.sendRequest<PersonLicenseSuppressionItemModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personLicenseValidationSuppressPost(body: PersonLicenseValidationSuppressCreateModel, requestOptions?: IAjaxOptions): AxiosPromise<PersonLicenseSuppressionItemModel> {
        let _url = this.baseUrl + "/api/PersonLicense/validation-suppress";
        return ApiService.sendRequest<PersonLicenseSuppressionItemModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    personLicenseValidationSuppressPut(body: PersonLicenseValidationSuppressUpdateModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/PersonLicense/validation-suppress";
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    personLicenseValidationSuppressDelete(params?:IRemoveValidationSuppressParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/PersonLicense/validation-suppress";
        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }
    personRequestPointsBalanceGet(params?:IGetPointsBalanceParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestPointsActualBalance> {
        let _url = this.baseUrl + "/api/PersonRequest/points-balance";
        return ApiService.sendRequest<PersonRequestPointsActualBalance>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personRequestValidateOffGet(params?:IValidateRequestOffParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestOffValidationResult> {
        let _url = this.baseUrl + "/api/PersonRequest/validate-off";
        return ApiService.sendRequest<PersonRequestOffValidationResult>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personRequestOffPost(body: PersonOffRequestCreate, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestOffDto> {
        let _url = this.baseUrl + "/api/PersonRequest/off";
        return ApiService.sendRequest<PersonRequestOffDto>(AxiosMethod.POST, _url, body, requestOptions);
    }
    personRequestOffPut(id: string, body: PersonOffRequestUpdate, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestOffDto> {
        let _url = this.baseUrl + "/api/PersonRequest/off";
        return ApiService.sendRequest<PersonRequestOffDto>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    personRequestOffDelete(params?:ICancelRequestsOffParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestOffDto> {
        let _url = this.baseUrl + "/api/PersonRequest/off";
        return ApiService.sendRequest<PersonRequestOffDto>(AxiosMethod.DELETE, _url, params, requestOptions);
    }
    personRequestOffGet(params?:IGetRequestsOffParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestOffDto[]> {
        let _url = this.baseUrl + "/api/PersonRequest/off";
        return ApiService.sendRequest<PersonRequestOffDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personRequestResolvePost(params?:IResolveRequestParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestItemDto[]> {
        let _url = this.baseUrl + "/api/PersonRequest/resolve";
        return ApiService.sendRequest<PersonRequestItemDto[]>(AxiosMethod.POST, _url, params, requestOptions);
    }
    personRequestAvailableFlightsGet(params?:IGetRequestsFlightsParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestAvailableFlightsDto> {
        let _url = this.baseUrl + "/api/PersonRequest/available-flights";
        return ApiService.sendRequest<PersonRequestAvailableFlightsDto>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personRequestFlightGet(params?:IGetRequestsFlightParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestFlightWithBidsDto[]> {
        let _url = this.baseUrl + "/api/PersonRequest/flight";
        return ApiService.sendRequest<PersonRequestFlightWithBidsDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personRequestFlightPost(body: PersonFlightRequest, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestFlightCreateResult> {
        let _url = this.baseUrl + "/api/PersonRequest/flight";
        return ApiService.sendRequest<PersonRequestFlightCreateResult>(AxiosMethod.POST, _url, body, requestOptions);
    }
    personRequestFlightDelete(params?:IDeleteFlightParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestFlightWithBidsDto> {
        let _url = this.baseUrl + "/api/PersonRequest/flight";
        return ApiService.sendRequest<PersonRequestFlightWithBidsDto>(AxiosMethod.DELETE, _url, params, requestOptions);
    }
    personRequestGrantJobStatusGet(params?:IGetJobTriggersStatusesParams, requestOptions?: IAjaxOptions): AxiosPromise<JobTrigerStatus[]> {
        let _url = this.baseUrl + "/api/PersonRequest/grant-job-status";
        return ApiService.sendRequest<JobTrigerStatus[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personRequestFlightRejectedByPlannerPost(body: PersonRequestFlightRejectModel, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestFlightWithBidsDto> {
        let _url = this.baseUrl + "/api/PersonRequest/flight/rejected-by-planner";
        return ApiService.sendRequest<PersonRequestFlightWithBidsDto>(AxiosMethod.POST, _url, body, requestOptions);
    }
    personRequestRequestsGet(params?:IGetRequestsParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestDto[]> {
        let _url = this.baseUrl + "/api/PersonRequest/requests";
        return ApiService.sendRequest<PersonRequestDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personRequestPointsLogGet(params?:IGetPointsLogParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestPointsLogDto[]> {
        let _url = this.baseUrl + "/api/PersonRequest/points-log";
        return ApiService.sendRequest<PersonRequestPointsLogDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personRequestPointsPeriodsGet( requestOptions?: IAjaxOptions): AxiosPromise<PersonPointsPeriodDto[]> {
        let _url = this.baseUrl + "/api/PersonRequest/points-periods";
        return ApiService.sendRequest<PersonPointsPeriodDto[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    personRequestPersonInfoGet(params?:IPersonRequestPersonInfoDtoParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestPersonInfoDto[]> {
        let _url = this.baseUrl + "/api/PersonRequest/person-info";
        return ApiService.sendRequest<PersonRequestPersonInfoDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personRequestAvailableRequestRangeGet( requestOptions?: IAjaxOptions): AxiosPromise<AvailableRequestRange> {
        let _url = this.baseUrl + "/api/PersonRequest/available-request-range";
        return ApiService.sendRequest<AvailableRequestRange>(AxiosMethod.GET, _url, null, requestOptions);
    }
    personRequestShortTrLicensesGet( requestOptions?: IAjaxOptions): AxiosPromise<PersonDateRange[]> {
        let _url = this.baseUrl + "/api/PersonRequest/short-tr-licenses";
        return ApiService.sendRequest<PersonDateRange[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    personRequestOffLimitsGet(params?:IGetOffLimitsParams, requestOptions?: IAjaxOptions): AxiosPromise<OffLimitsDto> {
        let _url = this.baseUrl + "/api/PersonRequest/off-limits";
        return ApiService.sendRequest<OffLimitsDto>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personRequestFlightLimitsCockpitGet(params?:IGetFrLimitsCockpitParams, requestOptions?: IAjaxOptions): AxiosPromise<FlightLimitsDto> {
        let _url = this.baseUrl + "/api/PersonRequest/flight-limits-cockpit";
        return ApiService.sendRequest<FlightLimitsDto>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personRequestFlightLimitsCabinGet(params?:IGetFrLimitsCabinParams, requestOptions?: IAjaxOptions): AxiosPromise<FlightLimitsCabinDto> {
        let _url = this.baseUrl + "/api/PersonRequest/flight-limits-cabin";
        return ApiService.sendRequest<FlightLimitsCabinDto>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personRequestFlightLimitsLogsCabinGet(params?:IGetFrLimitsLogsCabinParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestPointsLogDto[]> {
        let _url = this.baseUrl + "/api/PersonRequest/flight-limits-logs-cabin";
        return ApiService.sendRequest<PersonRequestPointsLogDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personRequestFlightLimitsLogsCockpitGet(params?:IGetFrLimitsLogsCockpitParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestPointsLogDto[]> {
        let _url = this.baseUrl + "/api/PersonRequest/flight-limits-logs-cockpit";
        return ApiService.sendRequest<PersonRequestPointsLogDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personRequestFlightLimitsCorrectionPost(body: FlightLimitsCorrectionModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/PersonRequest/flight-limits-correction";
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, body, requestOptions);
    }
    personRequestIsConstantFreelancerGet( requestOptions?: IAjaxOptions): AxiosPromise<ConstantFreelanceContractResponse> {
        let _url = this.baseUrl + "/api/PersonRequest/is-constant-freelancer";
        return ApiService.sendRequest<ConstantFreelanceContractResponse>(AxiosMethod.GET, _url, null, requestOptions);
    }
    personRequestRotationOffsPost(body: RotationOffsRequestModel, requestOptions?: IAjaxOptions): AxiosPromise<RotationOffsModel> {
        let _url = this.baseUrl + "/api/PersonRequest/rotation-offs";
        return ApiService.sendRequest<RotationOffsModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    personRequestManualCorrectionPut(body: PointsManualCorrectionModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/PersonRequest/manual-correction";
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    personRequestBlockingFlightFlightPost(body: PersonRequestBlockedFlightDto, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestBlockedFlightInfoDto> {
        let _url = this.baseUrl + "/api/PersonRequestBlockingFlight/flight";
        return ApiService.sendRequest<PersonRequestBlockedFlightInfoDto>(AxiosMethod.POST, _url, body, requestOptions);
    }
    personRequestBlockingFlightFlightDelete(params?:IDelete7Params, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/PersonRequestBlockingFlight/flight";
        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }
    personRequestBlockingFlightFlightGet(params?:IGetAll16Params, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestBlockedFlightInfoDto[]> {
        let _url = this.baseUrl + "/api/PersonRequestBlockingFlight/flight";
        return ApiService.sendRequest<PersonRequestBlockedFlightInfoDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personRequestBlockingPeriodDayPost(body: PersonRequestBlockedDayDto, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestBlockedDayDto> {
        let _url = this.baseUrl + "/api/PersonRequestBlockingPeriod/day";
        return ApiService.sendRequest<PersonRequestBlockedDayDto>(AxiosMethod.POST, _url, body, requestOptions);
    }
    personRequestBlockingPeriodDayPut(body: PersonRequestBlockedDayDto, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestBlockedDayDto> {
        let _url = this.baseUrl + "/api/PersonRequestBlockingPeriod/day";
        return ApiService.sendRequest<PersonRequestBlockedDayDto>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    personRequestBlockingPeriodDayDelete(params?:IDeleteBlockedDayParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/PersonRequestBlockingPeriod/day";
        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }
    personRequestBlockingPeriodDayGet(params?:IGetBlockedDaysParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestBlockedDayDto[]> {
        let _url = this.baseUrl + "/api/PersonRequestBlockingPeriod/day";
        return ApiService.sendRequest<PersonRequestBlockedDayDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personRequestFreelanceFreelanceYearsGet( requestOptions?: IAjaxOptions): AxiosPromise<FreelanceYearDto[]> {
        let _url = this.baseUrl + "/api/PersonRequestFreelance/freelance-years";
        return ApiService.sendRequest<FreelanceYearDto[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    personRequestFreelanceContractInfoGet( requestOptions?: IAjaxOptions): AxiosPromise<PersonFreelanceContractInfo[]> {
        let _url = this.baseUrl + "/api/PersonRequestFreelance/contract-info";
        return ApiService.sendRequest<PersonFreelanceContractInfo[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    personRequestFreelanceValidateGet(params?:IValidateAllParams, requestOptions?: IAjaxOptions): AxiosPromise<PeriodValidationErrorsModel[]> {
        let _url = this.baseUrl + "/api/PersonRequestFreelance/validate";
        return ApiService.sendRequest<PeriodValidationErrorsModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personRequestFreelancePeriodExportGet(params?:IGetPeriodExportParams, requestOptions?: IAjaxOptions): AxiosPromise<FreelanceExportDto[]> {
        let _url = this.baseUrl + "/api/PersonRequestFreelance/period-export";
        return ApiService.sendRequest<FreelanceExportDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personRequestFreelanceConfirmPost(body: PersonRequestFreelanceConfirmModel, requestOptions?: IAjaxOptions): AxiosPromise<FreelanceYearPeriodUpdateResult> {
        let _url = this.baseUrl + "/api/PersonRequestFreelance/confirm";
        return ApiService.sendRequest<FreelanceYearPeriodUpdateResult>(AxiosMethod.POST, _url, body, requestOptions);
    }
    personRequestFreelanceDeviatePost(body: PersonRequestFreelanceDeviateModel, requestOptions?: IAjaxOptions): AxiosPromise<FreelanceYearPeriodUpdateResult> {
        let _url = this.baseUrl + "/api/PersonRequestFreelance/deviate";
        return ApiService.sendRequest<FreelanceYearPeriodUpdateResult>(AxiosMethod.POST, _url, body, requestOptions);
    }
    personRequestFreelancePut(body: PersonRequestFreelanceCreateModel, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestFreelanceResultModel> {
        let _url = this.baseUrl + "/api/PersonRequestFreelance";
        return ApiService.sendRequest<PersonRequestFreelanceResultModel>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    personRequestNbuPost(body: PersonNbuFilter, requestOptions?: IAjaxOptions): AxiosPromise<PersonNbuModel[]> {
        let _url = this.baseUrl + "/api/PersonRequestNbu";
        return ApiService.sendRequest<PersonNbuModel[]>(AxiosMethod.POST, _url, body, requestOptions);
    }
    personRequestNbuDutyPost(body: PersonNbuUpdateModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/PersonRequestNbu/duty";
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, body, requestOptions);
    }
    personRequestNbuDutyPut(body: PersonNbuUpdateModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/PersonRequestNbu/duty";
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    personRequestNbuDutyDeleteById(params?:IDeleteNbuParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/PersonRequestNbu/duty/{id}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }
    personRequestNbuErrorSuppressPost(body: SuppressValidationModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/PersonRequestNbu/error/suppress";
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, body, requestOptions);
    }
    personRequestNbuErrorResumePost(body: ResumeValidationModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/PersonRequestNbu/error/resume";
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, body, requestOptions);
    }
    personRequestNbuMonthGet(params?:IGetMonthParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonNbuMonthModel> {
        let _url = this.baseUrl + "/api/PersonRequestNbu/month";
        return ApiService.sendRequest<PersonNbuMonthModel>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personRequestNbuMonthPut(body: UpdateNbuMonthRequest, requestOptions?: IAjaxOptions): AxiosPromise<boolean> {
        let _url = this.baseUrl + "/api/PersonRequestNbu/month";
        return ApiService.sendRequest<boolean>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    personRequestReserveGet(params?:IGetReserveRequestsParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestReserveDto[]> {
        let _url = this.baseUrl + "/api/PersonRequestReserve";
        return ApiService.sendRequest<PersonRequestReserveDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personRequestReservePost(body: PersonReserveRequestCreate, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestReserveCreateResult> {
        let _url = this.baseUrl + "/api/PersonRequestReserve";
        return ApiService.sendRequest<PersonRequestReserveCreateResult>(AxiosMethod.POST, _url, body, requestOptions);
    }
    personRequestReserveDelete(params?:IDeleteRequestParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestReserveDto> {
        let _url = this.baseUrl + "/api/PersonRequestReserve";
        return ApiService.sendRequest<PersonRequestReserveDto>(AxiosMethod.DELETE, _url, params, requestOptions);
    }
    personRequestReserveReserveRequestAvailableGet(params?:IGetReserveRequestAvailableParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestReserveAvailableDto> {
        let _url = this.baseUrl + "/api/PersonRequestReserve/reserve-request-available";
        return ApiService.sendRequest<PersonRequestReserveAvailableDto>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personRequestReserveReserveBlocksGet(params?:IGetReserveBlocksAllParams, requestOptions?: IAjaxOptions): AxiosPromise<ReserveBlockGroupDTO[]> {
        let _url = this.baseUrl + "/api/PersonRequestReserve/reserve-blocks";
        return ApiService.sendRequest<ReserveBlockGroupDTO[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personRequestReserveReservePeriodsGet(params?:IGetReservePeriodsParams, requestOptions?: IAjaxOptions): AxiosPromise<ReserveYearPeriodDto[]> {
        let _url = this.baseUrl + "/api/PersonRequestReserve/reserve-periods";
        return ApiService.sendRequest<ReserveYearPeriodDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personRequestReserveReserveDutyBlocksGet(params?:IGetPersonDutyBlocksParams, requestOptions?: IAjaxOptions): AxiosPromise<DutiesBlocksGroupedByMonthModel[]> {
        let _url = this.baseUrl + "/api/PersonRequestReserve/reserve-duty-blocks";
        return ApiService.sendRequest<DutiesBlocksGroupedByMonthModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personRequestReserveBalanceGet(params?:IGetBalanceParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestReserveBalance> {
        let _url = this.baseUrl + "/api/PersonRequestReserve/balance";
        return ApiService.sendRequest<PersonRequestReserveBalance>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personRequestReserveReserveRequestMandatoryGet(params?:IGetReserveRequestMandatoryParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestReserveMandatoryDto> {
        let _url = this.baseUrl + "/api/PersonRequestReserve/reserve-request-mandatory";
        return ApiService.sendRequest<PersonRequestReserveMandatoryDto>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personRequestSeniorityFlightHoursOverviewGet( requestOptions?: IAjaxOptions): AxiosPromise<PersonFlightOverviewModel> {
        let _url = this.baseUrl + "/api/PersonRequestSeniority/flight-hours-overview";
        return ApiService.sendRequest<PersonFlightOverviewModel>(AxiosMethod.GET, _url, null, requestOptions);
    }
    personRequestSeniorityWishTypesGet( requestOptions?: IAjaxOptions): AxiosPromise<WishTypeModel[]> {
        let _url = this.baseUrl + "/api/PersonRequestSeniority/wish-types";
        return ApiService.sendRequest<WishTypeModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    personRequestSeniorityWishGet( requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestWishModel> {
        let _url = this.baseUrl + "/api/PersonRequestSeniority/wish";
        return ApiService.sendRequest<PersonRequestWishModel>(AxiosMethod.GET, _url, null, requestOptions);
    }
    personRequestSeniorityWishPost(body: PersonWishCreateModel, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestWishModel> {
        let _url = this.baseUrl + "/api/PersonRequestSeniority/wish";
        return ApiService.sendRequest<PersonRequestWishModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    personRequestSeniorityWishDeleteById(params?:IDeleteWishParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/PersonRequestSeniority/wish/{id}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }
    personRequestSeniorityWishHistoryGet( requestOptions?: IAjaxOptions): AxiosPromise<WishHistoryModel[]> {
        let _url = this.baseUrl + "/api/PersonRequestSeniority/wish-history";
        return ApiService.sendRequest<WishHistoryModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    personRequestTzvTzvYearsGet(params?:IGetTzvYearsParams, requestOptions?: IAjaxOptions): AxiosPromise<TzvYearDto[]> {
        let _url = this.baseUrl + "/api/PersonRequestTzv/tzv-years";
        return ApiService.sendRequest<TzvYearDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personRequestTzvTzvBalanceInfoGet(params?:IGetTzvBalanceInfoParams, requestOptions?: IAjaxOptions): AxiosPromise<TzvDaysBalanceInfo[]> {
        let _url = this.baseUrl + "/api/PersonRequestTzv/tzv-balance-info";
        return ApiService.sendRequest<TzvDaysBalanceInfo[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personRequestTzvTzvBalanceInfoTotalGet(params?:IGetTzvBalanceTotalParams, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/PersonRequestTzv/tzv-balance-info/total";
        return ApiService.sendRequest<number>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personRequestTzvHasTzvContractGet( requestOptions?: IAjaxOptions): AxiosPromise<boolean> {
        let _url = this.baseUrl + "/api/PersonRequestTzv/has-tzv-contract";
        return ApiService.sendRequest<boolean>(AxiosMethod.GET, _url, null, requestOptions);
    }
    personRequestTzvTzvBlocksGet(params?:IGetPersonAbsenceDaysParams, requestOptions?: IAjaxOptions): AxiosPromise<DutiesBlocksGroupedByMonthModel[]> {
        let _url = this.baseUrl + "/api/PersonRequestTzv/tzv-blocks";
        return ApiService.sendRequest<DutiesBlocksGroupedByMonthModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personRequestTzvContractInfoGet(params?:IGetContractInfos2Params, requestOptions?: IAjaxOptions): AxiosPromise<PersonTzvContractInfo[]> {
        let _url = this.baseUrl + "/api/PersonRequestTzv/contract-info";
        return ApiService.sendRequest<PersonTzvContractInfo[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personRequestTzvBalanceManualCorrectionPut(body: DaysManualCorrectionModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/PersonRequestTzv/balance/manual-correction";
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    personRequestTzvBalanceManualCorrectionPost(body: DaysManualCorrectionModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/PersonRequestTzv/balance/manual-correction";
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, body, requestOptions);
    }
    personRequestTzvBalanceManualCorrectionDeleteById(params?:IDeleteTzvManualCorrectionParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/PersonRequestTzv/balance/manual-correction/{id}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }
    personRequestTzvTzvAssignmentGet(params?:IGetPersonTzvDayAssignmentModelsParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonTzvDayAssignmentModel[]> {
        let _url = this.baseUrl + "/api/PersonRequestTzv/tzv-assignment";
        return ApiService.sendRequest<PersonTzvDayAssignmentModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personRequestTzvTzvAssignmentPost(body: TzvDayAssigmentCreateModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/PersonRequestTzv/tzv-assignment";
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, body, requestOptions);
    }
    personRequestTzvTzvAssignmentDeleteById(params?:IDeleteTzvAssignmentDayParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/PersonRequestTzv/tzv-assignment/{id}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }
    personRequestTzvTzvFlexPost(body: Date[], requestOptions?: IAjaxOptions): AxiosPromise<DutyUpdateResult> {
        let _url = this.baseUrl + "/api/PersonRequestTzv/tzv-flex";
        return ApiService.sendRequest<DutyUpdateResult>(AxiosMethod.POST, _url, body, requestOptions);
    }
    personRequestVacValidationGet(params?:IValidateVacRequestParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestVacValidationResult> {
        let _url = this.baseUrl + "/api/PersonRequestVac/validation";
        return ApiService.sendRequest<PersonRequestVacValidationResult>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personRequestVacPost(body: PersonRequestVacCreate, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestVacBlockDto> {
        let _url = this.baseUrl + "/api/PersonRequestVac";
        return ApiService.sendRequest<PersonRequestVacBlockDto>(AxiosMethod.POST, _url, body, requestOptions);
    }
    personRequestVacPut(body: PersonRequestVacUpdate, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestVacBlockDto> {
        let _url = this.baseUrl + "/api/PersonRequestVac";
        return ApiService.sendRequest<PersonRequestVacBlockDto>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    personRequestVacGet(params?:IGetVacRequestsParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestVacBlockDto[]> {
        let _url = this.baseUrl + "/api/PersonRequestVac";
        return ApiService.sendRequest<PersonRequestVacBlockDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personRequestVacRequestBlockPut(body: PersonRequestVacBlockPersonAnswerModel, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestVacBlockDto> {
        let _url = this.baseUrl + "/api/PersonRequestVac/request-block";
        return ApiService.sendRequest<PersonRequestVacBlockDto>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    personRequestVacDeleteById(params?:IDeleteRequestVacParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/PersonRequestVac/{id}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }
    personRequestVacRulesStatusGet(params?:IVacRulesStatusParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestVacRulesStatus> {
        let _url = this.baseUrl + "/api/PersonRequestVac/rules-status";
        return ApiService.sendRequest<PersonRequestVacRulesStatus>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personRequestVacVacSDeadlineInfoGet(params?:IGetAvailableVacSDaysAndDeadlineParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonAvailableVacTypeDaysAndDeadline> {
        let _url = this.baseUrl + "/api/PersonRequestVac/vac-s-deadline-info";
        return ApiService.sendRequest<PersonAvailableVacTypeDaysAndDeadline>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personRequestVacVacPDeadlineInfoGet(params?:IGetAvailableVacPDaysAndDeadlineParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonAvailableVacTypeDaysAndDeadline> {
        let _url = this.baseUrl + "/api/PersonRequestVac/vac-p-deadline-info";
        return ApiService.sendRequest<PersonAvailableVacTypeDaysAndDeadline>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personRequestVacAvailableTypesGet(params?:IGetAvailableVacTypesParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestVacTypeModel[]> {
        let _url = this.baseUrl + "/api/PersonRequestVac/available-types";
        return ApiService.sendRequest<PersonRequestVacTypeModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personRequestVacBalanceInfoGet(params?:IGetVacationBalanceInfoParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestVacationDaysBalanceInfo> {
        let _url = this.baseUrl + "/api/PersonRequestVac/balance-info";
        return ApiService.sendRequest<PersonRequestVacationDaysBalanceInfo>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personRequestVacBalanceInfoTotalGet(params?:IGetVacationBalanceTotalParams, requestOptions?: IAjaxOptions): AxiosPromise<number> {
        let _url = this.baseUrl + "/api/PersonRequestVac/balance-info/total";
        return ApiService.sendRequest<number>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personRequestVacBalanceManualCorrectionPut(body: DaysManualCorrectionModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/PersonRequestVac/balance/manual-correction";
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    personRequestVacBalanceManualCorrectionPost(body: DaysManualCorrectionModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/PersonRequestVac/balance/manual-correction";
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, body, requestOptions);
    }
    personRequestVacBalanceManualCorrectionDeleteById(params?:IDeleteVacationDaysManualCorrectionParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/PersonRequestVac/balance/manual-correction/{id}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }
    personRequestVacVacationPeriodsGet(params?:IGetVacationPeriodsParams, requestOptions?: IAjaxOptions): AxiosPromise<VacationYearPeriodDto[]> {
        let _url = this.baseUrl + "/api/PersonRequestVac/vacation-periods";
        return ApiService.sendRequest<VacationYearPeriodDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personRequestVacVacationYearsGet( requestOptions?: IAjaxOptions): AxiosPromise<VacYearFilterModel[]> {
        let _url = this.baseUrl + "/api/PersonRequestVac/vacation-years";
        return ApiService.sendRequest<VacYearFilterModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    personRequestVacRequestBlockAlternativesCrewDecisionPostByRequestBlockIdRequestId(requestId: string, requestBlockId: string, body: PersonDecisionModel, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestVacBlockDto> {
        let _url = this.baseUrl + "/api/PersonRequestVac/request-block/{requestBlockId}/alternatives/{requestId}/crew-decision";
        _url = ApiService.getDynamicUrl(_url, { requestId, requestBlockId, body });
        return ApiService.sendRequest<PersonRequestVacBlockDto>(AxiosMethod.POST, _url, body, requestOptions);
    }
    personRequestVacVacBlocksGet(params?:IGetPersonAbsenceDays2Params, requestOptions?: IAjaxOptions): AxiosPromise<DutiesBlockModel[]> {
        let _url = this.baseUrl + "/api/PersonRequestVac/vac-blocks";
        return ApiService.sendRequest<DutiesBlockModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personRequestVacRequestBlockLogGetByRequestBlockId(params?:IGetRequestVacLogParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestVacBlockLogInfo[]> {
        let _url = this.baseUrl + "/api/PersonRequestVac/request-block/{requestBlockId}/log";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<PersonRequestVacBlockLogInfo[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personsReportPost(body: PersonReportFilter, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeResponseMedicalLicenseReportModel> {
        let _url = this.baseUrl + "/api/PersonsReport";
        return ApiService.sendRequest<DevExtremeResponseMedicalLicenseReportModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    personStatisticsMonthGet(params?:IGetMonthDataParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonMonthDataResponse[]> {
        let _url = this.baseUrl + "/api/PersonStatistics/month";
        return ApiService.sendRequest<PersonMonthDataResponse[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    personViewGet( requestOptions?: IAjaxOptions): AxiosPromise<PersonViewModel> {
        let _url = this.baseUrl + "/api/PersonView";
        return ApiService.sendRequest<PersonViewModel>(AxiosMethod.GET, _url, null, requestOptions);
    }
    personViewCabinRecencyGet( requestOptions?: IAjaxOptions): AxiosPromise<AircraftTypeRecencyReportModel> {
        let _url = this.baseUrl + "/api/PersonView/cabin-recency";
        return ApiService.sendRequest<AircraftTypeRecencyReportModel>(AxiosMethod.GET, _url, null, requestOptions);
    }
    personViewCockpitRecencyGet( requestOptions?: IAjaxOptions): AxiosPromise<AircraftTypeRecencyCockpitReportModel> {
        let _url = this.baseUrl + "/api/PersonView/cockpit-recency";
        return ApiService.sendRequest<AircraftTypeRecencyCockpitReportModel>(AxiosMethod.GET, _url, null, requestOptions);
    }
    plannedTrainingsReportPost(body: PlannedTrainingsReportFilter, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeResponsePlannedTrainingReportModel> {
        let _url = this.baseUrl + "/api/PlannedTrainingsReport";
        return ApiService.sendRequest<DevExtremeResponsePlannedTrainingReportModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    planningFlightActivityCandidatesGet(params?:IGetCandidatesParams, requestOptions?: IAjaxOptions): AxiosPromise<FlightActivityPersonCandidate[]> {
        let _url = this.baseUrl + "/api/Planning/flight-activity-candidates";
        return ApiService.sendRequest<FlightActivityPersonCandidate[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    planningValidateFlightCandidateGet(params?:IValidateCandidateParams, requestOptions?: IAjaxOptions): AxiosPromise<AssignFlightValidationResult[]> {
        let _url = this.baseUrl + "/api/Planning/validate-flight-candidate";
        return ApiService.sendRequest<AssignFlightValidationResult[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    planningRestDeltaTimesPost(body: DutyRestTimeDeltaRequestModel, requestOptions?: IAjaxOptions): AxiosPromise<DutyRestTimeDeltaModel> {
        let _url = this.baseUrl + "/api/Planning/rest-delta-times";
        return ApiService.sendRequest<DutyRestTimeDeltaModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    planningOrtoolsPost(body: PlanningRequestModel, requestOptions?: IAjaxOptions): AxiosPromise<ApiV1JobTrigger> {
        let _url = this.baseUrl + "/api/Planning/ortools";
        return ApiService.sendRequest<ApiV1JobTrigger>(AxiosMethod.POST, _url, body, requestOptions);
    }
    planningOrtoolsGet(params?:IGetOrToolsHistoryParams, requestOptions?: IAjaxOptions): AxiosPromise<GeneratedPlanHistoryItem[]> {
        let _url = this.baseUrl + "/api/Planning/ortools";
        return ApiService.sendRequest<GeneratedPlanHistoryItem[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    planningOrtoolsGetById(params?:IGetOrToolsByIdParams, requestOptions?: IAjaxOptions): AxiosPromise<GeneratedPlanHistoryItem> {
        let _url = this.baseUrl + "/api/Planning/ortools/{id}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<GeneratedPlanHistoryItem>(AxiosMethod.GET, _url, params, requestOptions);
    }
    positioningGet(params?:IGetById3Params, requestOptions?: IAjaxOptions): AxiosPromise<PositioningModel> {
        let _url = this.baseUrl + "/api/Positioning";
        return ApiService.sendRequest<PositioningModel>(AxiosMethod.GET, _url, params, requestOptions);
    }
    positioningForDayGet(params?:IGetForDayParams, requestOptions?: IAjaxOptions): AxiosPromise<PositioningModel[]> {
        let _url = this.baseUrl + "/api/Positioning/for-day";
        return ApiService.sendRequest<PositioningModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    positioningCodesGet( requestOptions?: IAjaxOptions): AxiosPromise<string[]> {
        let _url = this.baseUrl + "/api/Positioning/codes";
        return ApiService.sendRequest<string[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    positioningFlightsGet(params?:IGetFlights5Params, requestOptions?: IAjaxOptions): AxiosPromise<FlightModel[]> {
        let _url = this.baseUrl + "/api/Positioning/flights";
        return ApiService.sendRequest<FlightModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    positioningAvailableDirectionsGet(params?:IGetAvailableDirectionForADayParams, requestOptions?: IAjaxOptions): AxiosPromise<AvailableDirectionModel> {
        let _url = this.baseUrl + "/api/Positioning/available-directions";
        return ApiService.sendRequest<AvailableDirectionModel>(AxiosMethod.GET, _url, params, requestOptions);
    }
    positioningCustomsGet(params?:IGetCustomsParams, requestOptions?: IAjaxOptions): AxiosPromise<PositioningCustomModel[]> {
        let _url = this.baseUrl + "/api/Positioning/customs";
        return ApiService.sendRequest<PositioningCustomModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    positioningDiffToLtGet(params?:IGetDateTimeDiffToLtParams, requestOptions?: IAjaxOptions): AxiosPromise<LocationDateTimeDiffToLt[]> {
        let _url = this.baseUrl + "/api/Positioning/diff-to-lt";
        return ApiService.sendRequest<LocationDateTimeDiffToLt[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    qualityLoopExportGet( requestOptions?: IAjaxOptions): AxiosPromise<QualityLoopExportReportItem[]> {
        let _url = this.baseUrl + "/api/QualityLoopExport";
        return ApiService.sendRequest<QualityLoopExportReportItem[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    qualityLoopExportPost(body: QualityLoopJobStartModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/QualityLoopExport";
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, body, requestOptions);
    }
    qualityLoopExportDataGetByReportId(params?:IGetReportDataParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/QualityLoopExport/data/{reportId}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }
    qualityLoopExportIdMappingGetByReportId(params?:IGetReportMappingParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/QualityLoopExport/id-mapping/{reportId}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }
    recencyGetByPersonId(params?:IGetGET9Params, requestOptions?: IAjaxOptions): AxiosPromise<RecencyResponse> {
        let _url = this.baseUrl + "/api/Recency/{personId}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<RecencyResponse>(AxiosMethod.GET, _url, params, requestOptions);
    }
    recurrentTrainingReportPost(body: ReccurentTrainingReportFilter, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeResponseRecurrentTrainingReportModel> {
        let _url = this.baseUrl + "/api/RecurrentTrainingReport";
        return ApiService.sendRequest<DevExtremeResponseRecurrentTrainingReportModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    releaseHistoryReleaseGroupsGet( requestOptions?: IAjaxOptions): AxiosPromise<PlanningGroupDto[]> {
        let _url = this.baseUrl + "/api/ReleaseHistory/release-groups";
        return ApiService.sendRequest<PlanningGroupDto[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    releaseHistoryReleasePeriodsGet( requestOptions?: IAjaxOptions): AxiosPromise<ReleasedPeriodDto[]> {
        let _url = this.baseUrl + "/api/ReleaseHistory/release-periods";
        return ApiService.sendRequest<ReleasedPeriodDto[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    releaseHistoryNotFullPersonsGet(params?:IGetPersonsWithNotFullDutyMonthParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonIdCodeModel[]> {
        let _url = this.baseUrl + "/api/ReleaseHistory/not-full-persons";
        return ApiService.sendRequest<PersonIdCodeModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    releaseHistoryReleasePut(params?:IHistorizeParams, requestOptions?: IAjaxOptions): AxiosPromise<ReleasePeriodModel> {
        let _url = this.baseUrl + "/api/ReleaseHistory/release";
        return ApiService.sendRequest<ReleasePeriodModel>(AxiosMethod.PUT, _url, params, requestOptions);
    }
    releaseHistoryReleaseStatusGet(params?:IGetIsReleasedParams, requestOptions?: IAjaxOptions): AxiosPromise<ReleaseStatus> {
        let _url = this.baseUrl + "/api/ReleaseHistory/release-status";
        return ApiService.sendRequest<ReleaseStatus>(AxiosMethod.GET, _url, params, requestOptions);
    }
    releaseHistoryReleaseDateGet( requestOptions?: IAjaxOptions): AxiosPromise<ReleaseHistoryDateItem[]> {
        let _url = this.baseUrl + "/api/ReleaseHistory/release-date";
        return ApiService.sendRequest<ReleaseHistoryDateItem[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    releaseNotesGet(params?:IGetAll17Params, requestOptions?: IAjaxOptions): AxiosPromise<ReleaseNoteDtoShort[]> {
        let _url = this.baseUrl + "/api/ReleaseNotes";
        return ApiService.sendRequest<ReleaseNoteDtoShort[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    releaseNotesPost(body: ReleaseNoteModel, requestOptions?: IAjaxOptions): AxiosPromise<ReleaseNoteResponseItem> {
        let _url = this.baseUrl + "/api/ReleaseNotes";
        return ApiService.sendRequest<ReleaseNoteResponseItem>(AxiosMethod.POST, _url, body, requestOptions);
    }
    releaseNotesGetById(params?:IGetGET10Params, requestOptions?: IAjaxOptions): AxiosPromise<ReleaseNoteResponseItem> {
        let _url = this.baseUrl + "/api/ReleaseNotes/{id}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<ReleaseNoteResponseItem>(AxiosMethod.GET, _url, params, requestOptions);
    }
    releaseNotesPutById(id: string, body: ReleaseNoteModel, requestOptions?: IAjaxOptions): AxiosPromise<ReleaseNoteResponseItem> {
        let _url = this.baseUrl + "/api/ReleaseNotes/{id}";
        _url = ApiService.getDynamicUrl(_url, { id, body });
        return ApiService.sendRequest<ReleaseNoteResponseItem>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    releaseNotesDeleteById(params?:IDelete8Params, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/ReleaseNotes/{id}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }
    releaseNotesMarkAsReadPost(params?:IMarkReadParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/ReleaseNotes/mark-as-read";
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, params, requestOptions);
    }
    requestCapacityToolAnalyzePost(formFile: FileParameter, requestOptions?: IAjaxOptions): AxiosPromise<RequestCapacityAnalyzedModel> {
        let _url = this.baseUrl + "/api/RequestCapacityTool/analyze";
        return ApiService.sendRequest<RequestCapacityAnalyzedModel>(AxiosMethod.POST, _url, formFile, requestOptions);
    }
    requestCapacityToolImportPost(body: RequestCapacityAnalyzedModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/RequestCapacityTool/import";
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, body, requestOptions);
    }
    requestCapacityToolOverviewGet(params?:IGetCapacityToolOverviewParams, requestOptions?: IAjaxOptions): AxiosPromise<RequestCapacityToolOverview> {
        let _url = this.baseUrl + "/api/RequestCapacityTool/overview";
        return ApiService.sendRequest<RequestCapacityToolOverview>(AxiosMethod.GET, _url, params, requestOptions);
    }
    requestCapacityToolFilesGet(params?:ICapacityFilesParams, requestOptions?: IAjaxOptions): AxiosPromise<CapacityFileInfo[]> {
        let _url = this.baseUrl + "/api/RequestCapacityTool/files";
        return ApiService.sendRequest<CapacityFileInfo[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    requestCapacityToolDownloadGet(params?:IDownloadCapacityFileParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/RequestCapacityTool/download";
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }
    reserveManagementRequestsPost(body: ReserveManagementReportFilter, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeResponseReserveRequestReportModel> {
        let _url = this.baseUrl + "/api/ReserveManagement/requests";
        return ApiService.sendRequest<DevExtremeResponseReserveRequestReportModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    reserveManagementReservePeriodsGet( requestOptions?: IAjaxOptions): AxiosPromise<ReserveYearPeriodModel[]> {
        let _url = this.baseUrl + "/api/ReserveManagement/reserve-periods";
        return ApiService.sendRequest<ReserveYearPeriodModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    reserveManagementReservePeriodsPutByReserveYearPeriodId(reserveYearPeriodId: string, body: ReservePeriodChangeStatusModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/ReserveManagement/reserve-periods/{reserveYearPeriodId}";
        _url = ApiService.getDynamicUrl(_url, { reserveYearPeriodId, body });
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    reserveManagementRequestApprovePost(body: ApproveReserveRequestModel, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestReserveDto> {
        let _url = this.baseUrl + "/api/ReserveManagement/request/approve";
        return ApiService.sendRequest<PersonRequestReserveDto>(AxiosMethod.POST, _url, body, requestOptions);
    }
    reserveManagementRequestInformPost(body: InformReserveRequestModel, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestVacBlockDto> {
        let _url = this.baseUrl + "/api/ReserveManagement/request/inform";
        return ApiService.sendRequest<PersonRequestVacBlockDto>(AxiosMethod.POST, _url, body, requestOptions);
    }
    reserveManagementRequestRejectPost(body: RejectReserveRequestModel, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestReserveDto> {
        let _url = this.baseUrl + "/api/ReserveManagement/request/reject";
        return ApiService.sendRequest<PersonRequestReserveDto>(AxiosMethod.POST, _url, body, requestOptions);
    }
    reserveManagementRequestUndoPost(body: ReserveRequestModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/ReserveManagement/request/undo";
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, body, requestOptions);
    }
    reserveManagementRequestPlannerCommentPut(body: ReserveRequestChangePlannersCommentModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/ReserveManagement/request/planner-comment";
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    reserveManagementYearPeriodsFilterOptionsGet( requestOptions?: IAjaxOptions): AxiosPromise<ReserveYearPeriodReportFilterOption[]> {
        let _url = this.baseUrl + "/api/ReserveManagement/year-periods-filter-options";
        return ApiService.sendRequest<ReserveYearPeriodReportFilterOption[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    reserveManagementReserveBlocksPost(body: ReserveBlocksFilter, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeResponseReserveBlocksModel> {
        let _url = this.baseUrl + "/api/ReserveManagement/reserve-blocks";
        return ApiService.sendRequest<DevExtremeResponseReserveBlocksModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    reserveManagementReserveBlocksPut(body: CreateReserveBlockModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/ReserveManagement/reserve-blocks";
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    reserveManagementReserveBlocksDelete(params?:IDeleteReserveBlockParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/ReserveManagement/reserve-blocks";
        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }
    reserveManagementImportPost(formFile: FileParameter, requestOptions?: IAjaxOptions): AxiosPromise<string[]> {
        let _url = this.baseUrl + "/api/ReserveManagement/import";
        return ApiService.sendRequest<string[]>(AxiosMethod.POST, _url, formFile, requestOptions);
    }
    rotationForDayGetByYearMonthDay(params?:IForDay2Params, requestOptions?: IAjaxOptions): AxiosPromise<RotationDutiesItem[]> {
        let _url = this.baseUrl + "/api/Rotation/for-day/{year}/{month}/{day}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<RotationDutiesItem[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    rotationLongHaulGetByYearMonthDay(params?:ILonghaulParams, requestOptions?: IAjaxOptions): AxiosPromise<RotationModel[]> {
        let _url = this.baseUrl + "/api/Rotation/long-haul/{year}/{month}/{day}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<RotationModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    rotationLongHaulForPeriodGet(params?:ILonghaulForPeriodParams, requestOptions?: IAjaxOptions): AxiosPromise<RotationModel[]> {
        let _url = this.baseUrl + "/api/Rotation/long-haul/for-period";
        return ApiService.sendRequest<RotationModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    rotationLongHaulSingleGet(params?:IGetInfoByIdParams, requestOptions?: IAjaxOptions): AxiosPromise<RotationInfoWithActivities> {
        let _url = this.baseUrl + "/api/Rotation/long-haul/single";
        return ApiService.sendRequest<RotationInfoWithActivities>(AxiosMethod.GET, _url, params, requestOptions);
    }
    rotationDirectionsGet(params?:IGetDirectionsListParams, requestOptions?: IAjaxOptions): AxiosPromise<string[]> {
        let _url = this.baseUrl + "/api/Rotation/directions";
        return ApiService.sendRequest<string[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    rotationDatesGet(params?:IGetApplicableCopyDatesListParams, requestOptions?: IAjaxOptions): AxiosPromise<string[]> {
        let _url = this.baseUrl + "/api/Rotation/dates";
        return ApiService.sendRequest<string[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    rotationFlightDatesGet(params?:IGetApplicableFlightDatesListParams, requestOptions?: IAjaxOptions): AxiosPromise<string[]> {
        let _url = this.baseUrl + "/api/Rotation/flight-dates";
        return ApiService.sendRequest<string[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    rotationAvailableFlightsGet(params?:IGetAvailableFlightsListParams, requestOptions?: IAjaxOptions): AxiosPromise<AvailableFlightModel[]> {
        let _url = this.baseUrl + "/api/Rotation/available-flights";
        return ApiService.sendRequest<AvailableFlightModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    rotationInitRotationGet(params?:IInitRotationParams, requestOptions?: IAjaxOptions): AxiosPromise<RotationModel> {
        let _url = this.baseUrl + "/api/Rotation/init-rotation";
        return ApiService.sendRequest<RotationModel>(AxiosMethod.GET, _url, params, requestOptions);
    }
    rotationPut(body: RotationModel, requestOptions?: IAjaxOptions): AxiosPromise<RotationModel> {
        let _url = this.baseUrl + "/api/Rotation";
        return ApiService.sendRequest<RotationModel>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    rotationGet(params?:IGetById4Params, requestOptions?: IAjaxOptions): AxiosPromise<RotationInfo> {
        let _url = this.baseUrl + "/api/Rotation";
        return ApiService.sendRequest<RotationInfo>(AxiosMethod.GET, _url, params, requestOptions);
    }
    rotationRotationIdGet(params?:IGetIdByRotationKeyParams, requestOptions?: IAjaxOptions): AxiosPromise<string> {
        let _url = this.baseUrl + "/api/Rotation/rotation-id";
        return ApiService.sendRequest<string>(AxiosMethod.GET, _url, params, requestOptions);
    }
    rotationCopyPost(body: RotationCopyModel, requestOptions?: IAjaxOptions): AxiosPromise<RotationModel> {
        let _url = this.baseUrl + "/api/Rotation/copy";
        return ApiService.sendRequest<RotationModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    rotationBuildPost(body: RotationModel, requestOptions?: IAjaxOptions): AxiosPromise<RotationModel> {
        let _url = this.baseUrl + "/api/Rotation/build";
        return ApiService.sendRequest<RotationModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    rotationDeleteDelete(params?:IDelete9Params, requestOptions?: IAjaxOptions): AxiosPromise<RotationActionResult> {
        let _url = this.baseUrl + "/api/Rotation/delete";
        return ApiService.sendRequest<RotationActionResult>(AxiosMethod.DELETE, _url, params, requestOptions);
    }
    rotationFlightPostByFlightId(params?:IGetRotationsParams, requestOptions?: IAjaxOptions): AxiosPromise<FlightRotationInfo[]> {
        let _url = this.baseUrl + "/api/Rotation/flight/{flightId}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<FlightRotationInfo[]>(AxiosMethod.POST, _url, params, requestOptions);
    }
    rotationAircraftGet(params?:IGetAircraftRotations2Params, requestOptions?: IAjaxOptions): AxiosPromise<AircraftRotation[]> {
        let _url = this.baseUrl + "/api/Rotation/aircraft";
        return ApiService.sendRequest<AircraftRotation[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    sectorsReportPost(body: SectorsReportFilter, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeResponseSectorsReportModel> {
        let _url = this.baseUrl + "/api/SectorsReport";
        return ApiService.sendRequest<DevExtremeResponseSectorsReportModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    monitoringGet( requestOptions?: IAjaxOptions): AxiosPromise<SelfTestResult[]> {
        let _url = this.baseUrl + "/api/monitoring";
        return ApiService.sendRequest<SelfTestResult[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    monitoringSendingQueuePersonDayGet(params?:IMonitoringSendingQueuePersonDayParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/monitoring/sending-queue/person-day";
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }
    monitoringJobGetByJobName(params?:IMonitoringJobParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/monitoring/job/{jobName}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }
    selfTestJobsPost( requestOptions?: IAjaxOptions): AxiosPromise<SelfTestResult> {
        let _url = this.baseUrl + "/api/SelfTest/jobs";
        return ApiService.sendRequest<SelfTestResult>(AxiosMethod.POST, _url, null, requestOptions);
    }
    monitoringJobsGet( requestOptions?: IAjaxOptions): AxiosPromise<SelfTestResult> {
        let _url = this.baseUrl + "/api/monitoring/jobs";
        return ApiService.sendRequest<SelfTestResult>(AxiosMethod.GET, _url, null, requestOptions);
    }
    selfTestSignalrPost( requestOptions?: IAjaxOptions): AxiosPromise<SelfTestResult> {
        let _url = this.baseUrl + "/api/SelfTest/signalr";
        return ApiService.sendRequest<SelfTestResult>(AxiosMethod.POST, _url, null, requestOptions);
    }
    monitoringSignalrGet( requestOptions?: IAjaxOptions): AxiosPromise<SelfTestResult> {
        let _url = this.baseUrl + "/api/monitoring/signalr";
        return ApiService.sendRequest<SelfTestResult>(AxiosMethod.GET, _url, null, requestOptions);
    }
    selfTestDatabasePost( requestOptions?: IAjaxOptions): AxiosPromise<SelfTestResult> {
        let _url = this.baseUrl + "/api/SelfTest/database";
        return ApiService.sendRequest<SelfTestResult>(AxiosMethod.POST, _url, null, requestOptions);
    }
    monitoringDatabaseGet( requestOptions?: IAjaxOptions): AxiosPromise<SelfTestResult> {
        let _url = this.baseUrl + "/api/monitoring/database";
        return ApiService.sendRequest<SelfTestResult>(AxiosMethod.GET, _url, null, requestOptions);
    }
    selfTestUpdateDatabasePost( requestOptions?: IAjaxOptions): AxiosPromise<SelfTestResult> {
        let _url = this.baseUrl + "/api/SelfTest/update-database";
        return ApiService.sendRequest<SelfTestResult>(AxiosMethod.POST, _url, null, requestOptions);
    }
    selfTestPersondayqueuePost( requestOptions?: IAjaxOptions): AxiosPromise<SelfTestResult> {
        let _url = this.baseUrl + "/api/SelfTest/persondayqueue";
        return ApiService.sendRequest<SelfTestResult>(AxiosMethod.POST, _url, null, requestOptions);
    }
    selfTestNetlineOpsQueuePost( requestOptions?: IAjaxOptions): AxiosPromise<SelfTestResult> {
        let _url = this.baseUrl + "/api/SelfTest/netline-ops-queue";
        return ApiService.sendRequest<SelfTestResult>(AxiosMethod.POST, _url, null, requestOptions);
    }
    selfTestPersonMessageBusQueuePost( requestOptions?: IAjaxOptions): AxiosPromise<SelfTestResult> {
        let _url = this.baseUrl + "/api/SelfTest/person-message-bus-queue";
        return ApiService.sendRequest<SelfTestResult>(AxiosMethod.POST, _url, null, requestOptions);
    }
    selfTestCrewApiQueuePost( requestOptions?: IAjaxOptions): AxiosPromise<SelfTestResult> {
        let _url = this.baseUrl + "/api/SelfTest/crew-api-queue";
        return ApiService.sendRequest<SelfTestResult>(AxiosMethod.POST, _url, null, requestOptions);
    }
    selfTestCrewApiMclQueuePost( requestOptions?: IAjaxOptions): AxiosPromise<SelfTestResult> {
        let _url = this.baseUrl + "/api/SelfTest/crew-api-mcl-queue";
        return ApiService.sendRequest<SelfTestResult>(AxiosMethod.POST, _url, null, requestOptions);
    }
    selfTestPersonrevalidatePost( requestOptions?: IAjaxOptions): AxiosPromise<SelfTestResult> {
        let _url = this.baseUrl + "/api/SelfTest/personrevalidate";
        return ApiService.sendRequest<SelfTestResult>(AxiosMethod.POST, _url, null, requestOptions);
    }
    selfTestEmailqueuePost( requestOptions?: IAjaxOptions): AxiosPromise<SelfTestResult> {
        let _url = this.baseUrl + "/api/SelfTest/emailqueue";
        return ApiService.sendRequest<SelfTestResult>(AxiosMethod.POST, _url, null, requestOptions);
    }
    seniorityReportPost(body: SeniorityReportFilter, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeResponseSeniorityReportModel> {
        let _url = this.baseUrl + "/api/SeniorityReport";
        return ApiService.sendRequest<DevExtremeResponseSeniorityReportModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    seniorityReportSeniorityCommentPut(body: SeniorityCommentModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/SeniorityReport/seniority-comment";
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    seniorityReportSeniorityExitDatePut(body: SeniorityExitDateModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/SeniorityReport/seniority-exit-date";
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    seniorityReportSeniorityEntryDatePut(body: SeniorityEntryDateModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/SeniorityReport/seniority-entry-date";
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    serviceDownloadMessagesGet(params?:IDownloadMessagesParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Service/download-messages";
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }
    serviceMessageLabelsGet(params?:IGetMessageLabelsParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Service/message-labels";
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }
    serviceMessageTagsGet(params?:IGetMessageTagsParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Service/message-tags";
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }
    serviceDownloadFullLogsGet(params?:IDownloadFullLogsParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Service/download-full-logs";
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }
    serviceDownloadDayLogsGet(params?:IDownloadDayLogsParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Service/download-day-logs";
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }
    serviceDownloadDeadlettersGet( requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Service/download-deadletters";
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, null, requestOptions);
    }
    serviceMessageStatisticsGet(params?:IMessageStatisticsParams, requestOptions?: IAjaxOptions): AxiosPromise<MessageStatisticsModel[]> {
        let _url = this.baseUrl + "/api/Service/message-statistics";
        return ApiService.sendRequest<MessageStatisticsModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    serviceOperationsGet(params?:IOperationsParams, requestOptions?: IAjaxOptions): AxiosPromise<OperationGroup[]> {
        let _url = this.baseUrl + "/api/Service/operations";
        return ApiService.sendRequest<OperationGroup[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    serviceLogsDatesGet( requestOptions?: IAjaxOptions): AxiosPromise<Date[]> {
        let _url = this.baseUrl + "/api/Service/logs-dates";
        return ApiService.sendRequest<Date[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    serviceMessagesDatesGet( requestOptions?: IAjaxOptions): AxiosPromise<Date[]> {
        let _url = this.baseUrl + "/api/Service/messages-dates";
        return ApiService.sendRequest<Date[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    serviceRestartSchedulerPost( requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Service/restart-scheduler";
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, null, requestOptions);
    }
    serviceInputQueueStatisticsPost( requestOptions?: IAjaxOptions): AxiosPromise<QueueStatisticsModel[]> {
        let _url = this.baseUrl + "/api/Service/input-queue-statistics";
        return ApiService.sendRequest<QueueStatisticsModel[]>(AxiosMethod.POST, _url, null, requestOptions);
    }
    serviceInputQueueDeadlettersPost( requestOptions?: IAjaxOptions): AxiosPromise<DeadletterInfoModel[]> {
        let _url = this.baseUrl + "/api/Service/input-queue-deadletters";
        return ApiService.sendRequest<DeadletterInfoModel[]>(AxiosMethod.POST, _url, null, requestOptions);
    }
    serviceInputQueueDeadlettersDelete(params?:IDeleteDeadletterParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/Service/input-queue-deadletters";
        return ApiService.sendRequest<void>(AxiosMethod.DELETE, _url, params, requestOptions);
    }
    simulationGet(params?:IGetGET11Params, requestOptions?: IAjaxOptions): AxiosPromise<SimulationModel> {
        let _url = this.baseUrl + "/api/Simulation";
        return ApiService.sendRequest<SimulationModel>(AxiosMethod.GET, _url, params, requestOptions);
    }
    simulationPost(body: SimulationReportFilter, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeResponseSimulationReportModel> {
        let _url = this.baseUrl + "/api/Simulation";
        return ApiService.sendRequest<DevExtremeResponseSimulationReportModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    simulationActivityPlannedGet(params?:IPlannedAircraftActivitiesParams, requestOptions?: IAjaxOptions): AxiosPromise<PlannedSimulationModel[]> {
        let _url = this.baseUrl + "/api/Simulation/activity/planned";
        return ApiService.sendRequest<PlannedSimulationModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    simulationTraineeCandidatesGet(params?:IGetTraineeCandidatesParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonShortInfoModel[]> {
        let _url = this.baseUrl + "/api/Simulation/trainee-candidates";
        return ApiService.sendRequest<PersonShortInfoModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    simulationSimOverviewGet(params?:IGetSimOverviewParams, requestOptions?: IAjaxOptions): AxiosPromise<SimulationCourseDto[]> {
        let _url = this.baseUrl + "/api/Simulation/sim-overview";
        return ApiService.sendRequest<SimulationCourseDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    simulationSimOverviewPut(body: SimulationCourseDto, requestOptions?: IAjaxOptions): AxiosPromise<SimulationCourseResult> {
        let _url = this.baseUrl + "/api/Simulation/sim-overview";
        return ApiService.sendRequest<SimulationCourseResult>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    simulationSimOverviewDelete(params?:IDeleteSimulationCourseParams, requestOptions?: IAjaxOptions): AxiosPromise<SimulationCourseResult> {
        let _url = this.baseUrl + "/api/Simulation/sim-overview";
        return ApiService.sendRequest<SimulationCourseResult>(AxiosMethod.DELETE, _url, params, requestOptions);
    }
    simulationEbtModulesGet(params?:IGetEbtModulesParams, requestOptions?: IAjaxOptions): AxiosPromise<EbtModuleModel[]> {
        let _url = this.baseUrl + "/api/Simulation/ebt-modules";
        return ApiService.sendRequest<EbtModuleModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    simulationHistoryPost(params?:IGetSimHistoryParams, requestOptions?: IAjaxOptions): AxiosPromise<SimLogItem[]> {
        let _url = this.baseUrl + "/api/Simulation/history";
        return ApiService.sendRequest<SimLogItem[]>(AxiosMethod.POST, _url, params, requestOptions);
    }
    simulationPositionHistoryPost(params?:IGetPositionSimHistoryParams, requestOptions?: IAjaxOptions): AxiosPromise<SimCoursePositionInfo[]> {
        let _url = this.baseUrl + "/api/Simulation/position-history";
        return ApiService.sendRequest<SimCoursePositionInfo[]>(AxiosMethod.POST, _url, params, requestOptions);
    }
    simulationPositionHistoryLogPost(params?:IGetPositionLogSimHistoryParams, requestOptions?: IAjaxOptions): AxiosPromise<SimCoursePositionLogInfo[]> {
        let _url = this.baseUrl + "/api/Simulation/position-history-log";
        return ApiService.sendRequest<SimCoursePositionLogInfo[]>(AxiosMethod.POST, _url, params, requestOptions);
    }
    simulationDeletionHistoryPost(params?:IGetSimDeletionHistoryParams, requestOptions?: IAjaxOptions): AxiosPromise<SimLogItem[]> {
        let _url = this.baseUrl + "/api/Simulation/deletion-history";
        return ApiService.sendRequest<SimLogItem[]>(AxiosMethod.POST, _url, params, requestOptions);
    }
    simulatorLicenseStatusReportPost(body: SimulatorLicenseStatusReportFilter, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeResponseSimulatorLicenseStatusReportModel> {
        let _url = this.baseUrl + "/api/SimulatorLicenseStatusReport";
        return ApiService.sendRequest<DevExtremeResponseSimulatorLicenseStatusReportModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    standbyReportPost(body: StandbyReportFilter, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeResponseStandbyReportModel> {
        let _url = this.baseUrl + "/api/StandbyReport";
        return ApiService.sendRequest<DevExtremeResponseStandbyReportModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    standbyReportFunctionsGet(params?:IGetReportFunctionsParams, requestOptions?: IAjaxOptions): AxiosPromise<string[]> {
        let _url = this.baseUrl + "/api/StandbyReport/functions";
        return ApiService.sendRequest<string[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    standbyReportDownloadEmailGet(params?:ICreateStandbyReportAutomationEmailParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/StandbyReport/download-email";
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }
    tempFilePost(label: string, name: string, contentType: string, isZipped: boolean, file: FileParameter, requestOptions?: IAjaxOptions): AxiosPromise<string> {
        let _url = this.baseUrl + "/api/TempFile";
        return ApiService.sendRequest<string>(AxiosMethod.POST, _url, file, requestOptions);
    }
    tempFileGetByIdName(params?:IGetGET12Params, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/TempFile/{id}/{name}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }
    tempFileOutageRosterReportGet( requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/TempFile/outage-roster-report";
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, null, requestOptions);
    }
    tempFileRecentlyGetByLabel(params?:IGetRecentlySavedFileParams, requestOptions?: IAjaxOptions): AxiosPromise<TempFileDto[]> {
        let _url = this.baseUrl + "/api/TempFile/recently/{label}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<TempFileDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    templatesManagementCodesGet( requestOptions?: IAjaxOptions): AxiosPromise<TemplateGroupModel[]> {
        let _url = this.baseUrl + "/api/TemplatesManagement/codes";
        return ApiService.sendRequest<TemplateGroupModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    templatesManagementGetByGroupCode(params?:IGetByCode3Params, requestOptions?: IAjaxOptions): AxiosPromise<TemplateModel> {
        let _url = this.baseUrl + "/api/TemplatesManagement/{group}/{code}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<TemplateModel>(AxiosMethod.GET, _url, params, requestOptions);
    }
    templatesManagementPostByGroupCode(group: string, code: string, body: TemplateFormattingModel, requestOptions?: IAjaxOptions): AxiosPromise<TemplateModel> {
        let _url = this.baseUrl + "/api/TemplatesManagement/{group}/{code}";
        _url = ApiService.getDynamicUrl(_url, { group, code, body });
        return ApiService.sendRequest<TemplateModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    templatesManagementPutByGroupCode(group: string, code: string, body: TemplateModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/TemplatesManagement/{group}/{code}";
        _url = ApiService.getDynamicUrl(_url, { group, code, body });
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    templatesManagementModelGetByGroupCode(params?:IGetTemplateDataModelParams, requestOptions?: IAjaxOptions): AxiosPromise<string> {
        let _url = this.baseUrl + "/api/TemplatesManagement/{group}/{code}/model";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<string>(AxiosMethod.GET, _url, params, requestOptions);
    }
    timeLocalToUtcPost(body: TimeModel, requestOptions?: IAjaxOptions): AxiosPromise<DateTimeModel> {
        let _url = this.baseUrl + "/api/Time/local-to-utc";
        return ApiService.sendRequest<DateTimeModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    timeUtcToLocalPost(body: TimeModel, requestOptions?: IAjaxOptions): AxiosPromise<Date> {
        let _url = this.baseUrl + "/api/Time/utc-to-local";
        return ApiService.sendRequest<Date>(AxiosMethod.POST, _url, body, requestOptions);
    }
    timeAvailableTimezonesPost(body: TimeModel, requestOptions?: IAjaxOptions): AxiosPromise<string[]> {
        let _url = this.baseUrl + "/api/Time/available-timezones";
        return ApiService.sendRequest<string[]>(AxiosMethod.POST, _url, body, requestOptions);
    }
    timeTimezoneOffsetsGet( requestOptions?: IAjaxOptions): AxiosPromise<string[]> {
        let _url = this.baseUrl + "/api/Time/timezone-offsets";
        return ApiService.sendRequest<string[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    timeDefaultTimezoneGet( requestOptions?: IAjaxOptions): AxiosPromise<string> {
        let _url = this.baseUrl + "/api/Time/default-timezone";
        return ApiService.sendRequest<string>(AxiosMethod.GET, _url, null, requestOptions);
    }
    timeCalendarMonthGet(params?:ICalendarMonthParams, requestOptions?: IAjaxOptions): AxiosPromise<CalendarMonthDto[]> {
        let _url = this.baseUrl + "/api/Time/calendar-month";
        return ApiService.sendRequest<CalendarMonthDto[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    timeSwissTransitionsGet(params?:IGetSwissTimeTransitionsParams, requestOptions?: IAjaxOptions): AxiosPromise<TimeTransitionEvent[]> {
        let _url = this.baseUrl + "/api/Time/swiss-transitions";
        return ApiService.sendRequest<TimeTransitionEvent[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    tradeUnionInterfaceDownloadFileGet(params?:IGetFileParams, requestOptions?: IAjaxOptions): AxiosPromise<File> {
        let _url = this.baseUrl + "/api/TradeUnionInterface/download-file";
        return ApiService.sendRequest<File>(AxiosMethod.GET, _url, params, requestOptions);
    }
    tradeUnionInterfaceExportInfoGetByType(params?:IGetExportIfoParams, requestOptions?: IAjaxOptions): AxiosPromise<TradeUnionButtonInfoModel[]> {
        let _url = this.baseUrl + "/api/TradeUnionInterface/export-info/{type}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<TradeUnionButtonInfoModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    tradeUnionInterfaceExportsPostByType(type: TradeUnionExportType, body: TradeUnionExportFilter, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeResponseTradeUnionExportModel> {
        let _url = this.baseUrl + "/api/TradeUnionInterface/exports/{type}";
        _url = ApiService.getDynamicUrl(_url, { type, body });
        return ApiService.sendRequest<DevExtremeResponseTradeUnionExportModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    tradeUnionInterfaceFileDataGet(params?:IGetAeroPersExportFileDataParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/TradeUnionInterface/file-data";
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }
    typeRatingFilterGet(params?:IGetGET13Params, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/TypeRatingFilter";
        return ApiService.sendRequest<void>(AxiosMethod.GET, _url, params, requestOptions);
    }
    tzvYearOverviewReportPost(body: TzvYearOverviewFilter, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeResponseTzvYearOverviewModel> {
        let _url = this.baseUrl + "/api/TzvYearOverviewReport";
        return ApiService.sendRequest<DevExtremeResponseTzvYearOverviewModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    tzvYearOverviewReportTzvYearsGet( requestOptions?: IAjaxOptions): AxiosPromise<TzvYearFilterModel[]> {
        let _url = this.baseUrl + "/api/TzvYearOverviewReport/tzv-years";
        return ApiService.sendRequest<TzvYearFilterModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    tzvYearOverviewReportFleetTypesGet( requestOptions?: IAjaxOptions): AxiosPromise<FleetTypeModel[]> {
        let _url = this.baseUrl + "/api/TzvYearOverviewReport/fleet-types";
        return ApiService.sendRequest<FleetTypeModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    tzvYearOverviewReportPlannerCommentPut(body: TzvYearPlannersCommentModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/TzvYearOverviewReport/planner-comment";
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    vacManagementRequestsPost(body: VacManagementReportFilter, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeResponseVacRequestReportModel> {
        let _url = this.baseUrl + "/api/VacManagement/requests";
        return ApiService.sendRequest<DevExtremeResponseVacRequestReportModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    vacManagementRequestBlockPlannerCommentGetByRequestBlockId(params?:IGetPlannerCommentParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestVacCommentDto> {
        let _url = this.baseUrl + "/api/VacManagement/request-block/{requestBlockId}/planner-comment";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<PersonRequestVacCommentDto>(AxiosMethod.GET, _url, params, requestOptions);
    }
    vacManagementRequestBlockPlannerCommentPutByRequestBlockId(requestBlockId: string, body: VacRequestChangePlannersCommentModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/VacManagement/request-block/{requestBlockId}/planner-comment";
        _url = ApiService.getDynamicUrl(_url, { requestBlockId, body });
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    vacManagementRequestBlockPointsPutByRequestBlockId(requestBlockId: string, body: VacRequestChangePlannersPointsModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/VacManagement/request-block/{requestBlockId}/points";
        _url = ApiService.getDynamicUrl(_url, { requestBlockId, body });
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    vacManagementRequestBlockGetByRequestBlockId(params?:IGetVacRequestInfoParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestVacBlockDto> {
        let _url = this.baseUrl + "/api/VacManagement/request-block/{requestBlockId}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<PersonRequestVacBlockDto>(AxiosMethod.GET, _url, params, requestOptions);
    }
    vacManagementRequestBlockAlternativesPostByRequestBlockId(requestBlockId: string, body: PersonRequestVacAlternativeCreate, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestVacBlockDto> {
        let _url = this.baseUrl + "/api/VacManagement/request-block/{requestBlockId}/alternatives";
        _url = ApiService.getDynamicUrl(_url, { requestBlockId, body });
        return ApiService.sendRequest<PersonRequestVacBlockDto>(AxiosMethod.POST, _url, body, requestOptions);
    }
    vacManagementRequestsDeleteByRequestId(params?:IDeleteAlternativeVacRequestParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestVacBlockDto> {
        let _url = this.baseUrl + "/api/VacManagement/requests/{requestId}";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<PersonRequestVacBlockDto>(AxiosMethod.DELETE, _url, params, requestOptions);
    }
    vacManagementRequestsApprovePostByRequestId(requestId: string, body: PersonRequestVacApproveModel, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestVacBlockDto> {
        let _url = this.baseUrl + "/api/VacManagement/requests/{requestId}/approve";
        _url = ApiService.getDynamicUrl(_url, { requestId, body });
        return ApiService.sendRequest<PersonRequestVacBlockDto>(AxiosMethod.POST, _url, body, requestOptions);
    }
    vacManagementRequestBlockRejectPostByRequestBlockId(requestBlockId: string, body: RejectRequestModel, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestVacBlockDto> {
        let _url = this.baseUrl + "/api/VacManagement/request-block/{requestBlockId}/reject";
        _url = ApiService.getDynamicUrl(_url, { requestBlockId, body });
        return ApiService.sendRequest<PersonRequestVacBlockDto>(AxiosMethod.POST, _url, body, requestOptions);
    }
    vacManagementSelectedRangeValidationGet(params?:IValidateSelectedRangeParams, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestVacValidationResult> {
        let _url = this.baseUrl + "/api/VacManagement/selected-range-validation";
        return ApiService.sendRequest<PersonRequestVacValidationResult>(AxiosMethod.GET, _url, params, requestOptions);
    }
    vacManagementUpdateSelectedRangePost(body: VacRequestUpdateSelectedRangeModel, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestVacDto> {
        let _url = this.baseUrl + "/api/VacManagement/update-selected-range";
        return ApiService.sendRequest<PersonRequestVacDto>(AxiosMethod.POST, _url, body, requestOptions);
    }
    vacManagementRequestBlockInformedPostByRequestBlockId(requestBlockId: string, body: PersonRequestVacInformModel, requestOptions?: IAjaxOptions): AxiosPromise<PersonRequestVacBlockDto> {
        let _url = this.baseUrl + "/api/VacManagement/request-block/{requestBlockId}/informed";
        _url = ApiService.getDynamicUrl(_url, { requestBlockId, body });
        return ApiService.sendRequest<PersonRequestVacBlockDto>(AxiosMethod.POST, _url, body, requestOptions);
    }
    vacManagementRequestBlockStatusRollbackPostByRequestBlockId(params?:IStatusRollbackParams, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/VacManagement/request-block/{requestBlockId}/status-rollback";
        _url = ApiService.getDynamicUrl(_url, params);
        return ApiService.sendRequest<void>(AxiosMethod.POST, _url, params, requestOptions);
    }
    vacManagementVacTypesGet( requestOptions?: IAjaxOptions): AxiosPromise<VacRequestTypeModel[]> {
        let _url = this.baseUrl + "/api/VacManagement/vac-types";
        return ApiService.sendRequest<VacRequestTypeModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    vacManagementVacationYearsGet( requestOptions?: IAjaxOptions): AxiosPromise<VacYearReportFilterModel[]> {
        let _url = this.baseUrl + "/api/VacManagement/vacation-years";
        return ApiService.sendRequest<VacYearReportFilterModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    vacManagementVacationYearPeriodsGet( requestOptions?: IAjaxOptions): AxiosPromise<VacYearPeriodReportFilterModel[]> {
        let _url = this.baseUrl + "/api/VacManagement/vacation-year-periods";
        return ApiService.sendRequest<VacYearPeriodReportFilterModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    vacManagementVacationYearPeriodsFilterOptionsGet( requestOptions?: IAjaxOptions): AxiosPromise<VacYearPeriodReportFilterOption[]> {
        let _url = this.baseUrl + "/api/VacManagement/vacation-year-periods-filter-options";
        return ApiService.sendRequest<VacYearPeriodReportFilterOption[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    vacManagementVacationPeriodsGet( requestOptions?: IAjaxOptions): AxiosPromise<VacYearPeriodModel[]> {
        let _url = this.baseUrl + "/api/VacManagement/vacation-periods";
        return ApiService.sendRequest<VacYearPeriodModel[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    vacManagementVacationPeriodsPutByVacYearPeriodId(vacYearPeriodId: string, body: VacPeriodChangeStatusModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/VacManagement/vacation-periods/{vacYearPeriodId}";
        _url = ApiService.getDynamicUrl(_url, { vacYearPeriodId, body });
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
    vacManagementCapacityFiguresGet(params?:IGetVacationCapacityFiguresParams, requestOptions?: IAjaxOptions): AxiosPromise<VacManagementCapacityGroupingModel[]> {
        let _url = this.baseUrl + "/api/VacManagement/capacity-figures";
        return ApiService.sendRequest<VacManagementCapacityGroupingModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    vacManagementCapacityMonthFiguresGet(params?:IGetVacationCapacityMonthFiguresParams, requestOptions?: IAjaxOptions): AxiosPromise<VacManagementCapacityMonthGroupingModel[]> {
        let _url = this.baseUrl + "/api/VacManagement/capacity-month-figures";
        return ApiService.sendRequest<VacManagementCapacityMonthGroupingModel[]>(AxiosMethod.GET, _url, params, requestOptions);
    }
    vacManagementMonthFromOptionsGet( requestOptions?: IAjaxOptions): AxiosPromise<VacManagementMonthOptions[]> {
        let _url = this.baseUrl + "/api/VacManagement/month-from-options";
        return ApiService.sendRequest<VacManagementMonthOptions[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    vacManagementMonthToOptionsGet( requestOptions?: IAjaxOptions): AxiosPromise<VacManagementMonthOptions[]> {
        let _url = this.baseUrl + "/api/VacManagement/month-to-options";
        return ApiService.sendRequest<VacManagementMonthOptions[]>(AxiosMethod.GET, _url, null, requestOptions);
    }
    vacManagementPersonVacYearDetailsPost(body: VacManagementPersonVacDetailsFilter, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeResponsePersonVacDetailsModel> {
        let _url = this.baseUrl + "/api/VacManagement/person-vac-year-details";
        return ApiService.sendRequest<DevExtremeResponsePersonVacDetailsModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    xStarMonitoringReportPost(body: XStarMonitoringReportFilter, requestOptions?: IAjaxOptions): AxiosPromise<DevExtremeResponseXStarMonitoringReportModel> {
        let _url = this.baseUrl + "/api/XStarMonitoringReport";
        return ApiService.sendRequest<DevExtremeResponseXStarMonitoringReportModel>(AxiosMethod.POST, _url, body, requestOptions);
    }
    xStarMonitoringReportCommentPut(body: XStarCommentModel, requestOptions?: IAjaxOptions): AxiosPromise<void> {
        let _url = this.baseUrl + "/api/XStarMonitoringReport/comment";
        return ApiService.sendRequest<void>(AxiosMethod.PUT, _url, body, requestOptions);
    }
}
export enum AcclimatisationStatus {
    B = "B",
    D = "D",
    Invalid = "Invalid",
    NotDefined = "NotDefined",
    X = "X",
    XStar = "XStar",
}

export enum ActivityType {
    Action = "Action",
    Calculated = "Calculated",
    FlagDuty = "FlagDuty",
    FlagNonDuty = "FlagNonDuty",
    FlightRelated = "FlightRelated",
    NonFlight = "NonFlight",
}

export enum ActualMfdpType {
    EasaExtendedExtension = "EasaExtendedExtension",
    EasaExtension = "EasaExtension",
    Ifr = "Ifr",
    NoIfr = "NoIfr",
    Normal = "Normal",
}

export interface IAircraftDto {
    id: string;
    registrationNumber: string;
    aircraftTypeRcd: string;
    inServiceDateFrom: Date;
    inServiceDateTo?: Date;
    isInUseActually: boolean;
}
export class AircraftDto extends BaseApiModelClass< IAircraftDto > implements IAircraftDto {
    id: string;
    registrationNumber: string;
    aircraftTypeRcd: string;
    inServiceDateFrom: Date;
    inServiceDateTo?: Date;
    isInUseActually: boolean;
}

export interface IAircraftEditModel {
    aircraftTypeId: string;
    includeFseToCrewApi: boolean;
}
export class AircraftEditModel extends BaseApiModelClass< IAircraftEditModel > implements IAircraftEditModel {
    aircraftTypeId: string;
    includeFseToCrewApi: boolean;
}

export interface IAircraftInfoModel {
    aircraftTypeId: string;
    includeFseToCrewApi: boolean;
    isDisabled: boolean;
    inServiceFromDate: Date;
    inServiceToDate?: Date;
}
export class AircraftInfoModel extends BaseApiModelClass< IAircraftInfoModel > implements IAircraftInfoModel {
    aircraftTypeId: string;
    includeFseToCrewApi: boolean;
    isDisabled: boolean;
    inServiceFromDate: Date;
    inServiceToDate?: Date;
}

export interface IAircraftMaintenanceDto {
    id: string;
    aircraftId: string;
    dateTimeFromUtc: Date;
    dateTimeToUtc: Date;
    title: string;
}
export class AircraftMaintenanceDto extends BaseApiModelClass< IAircraftMaintenanceDto > implements IAircraftMaintenanceDto {
    id: string;
    aircraftId: string;
    dateTimeFromUtc: Date;
    dateTimeToUtc: Date;
    title: string;
}

export interface IAircraftRotation {
    items: AircraftRotationItem[];
}
export class AircraftRotation extends BaseApiModelClass< IAircraftRotation > implements IAircraftRotation {
    items: AircraftRotationItem[];
}

export interface IAircraftRotationItem {
    flightId: string;
    airlineRcd: string;
    flightNumber: number;
    departureDateTimeUtc: Date;
    departureDateTimeDiffToLt: string;
    arrivalDateTimeUtc: Date;
    arrivalDateTimeDiffToLt: string;
    estimatedDepartureDateTimeUtc?: Date;
    estimatedArrivalDateTimeUtc?: Date;
    outOfTheGateDateTimeUtc?: Date;
    aircraftRegistrationNumber?: string;
    originRcd: string;
    destinationRcd: string;
    aircraftTypeRcd?: string;
    isLongHaul: boolean;
}
export class AircraftRotationItem extends BaseApiModelClass< IAircraftRotationItem > implements IAircraftRotationItem {
    flightId: string;
    airlineRcd: string;
    flightNumber: number;
    departureDateTimeUtc: Date;
    departureDateTimeDiffToLt: string;
    arrivalDateTimeUtc: Date;
    arrivalDateTimeDiffToLt: string;
    estimatedDepartureDateTimeUtc?: Date;
    estimatedArrivalDateTimeUtc?: Date;
    outOfTheGateDateTimeUtc?: Date;
    aircraftRegistrationNumber?: string;
    originRcd: string;
    destinationRcd: string;
    aircraftTypeRcd?: string;
    isLongHaul: boolean;
}

export enum AircraftType {
    A320 = "A320",
    A330 = "A330",
    A334 = "A334",
    A340 = "A340",
    A345 = "A345",
    A350 = "A350",
    None = "None",
}

export interface IAircraftTypeModel {
    id: string;
    codeName: string;
    restFacilityId: string;
    status: AircraftTypeStatus;
    aircraftTypeGroupId?: string;
}
export class AircraftTypeModel extends BaseApiModelClass< IAircraftTypeModel > implements IAircraftTypeModel {
    id: string;
    codeName: string;
    restFacilityId: string;
    status: AircraftTypeStatus;
    aircraftTypeGroupId?: string;
}

export interface IAircraftTypeRecencyCockpitReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    personCode: string;
    personName?: string;
    personFunction?: string;
    personContract?: string;
    aircraftType: string;
    actualRecencyTillDate?: Date;
    actualLandingRecencyTillDate?: Date;
    actualTakeoffRecencyTillDate?: Date;
    plannedRecencyTillDate?: Date;
    plannedLandingRecencyTillDate?: Date;
    plannedTakeoffRecencyTillDate?: Date;
    last1stLandingDate?: Date;
    last2ndLandingDate?: Date;
    last3rdLandingDate?: Date;
    next1stLandingDate?: Date;
    next2ndLandingDate?: Date;
    next3rdLandingDate?: Date;
    last1stTakeoffDate?: Date;
    last2ndTakeoffDate?: Date;
    last3rdTakeoffDate?: Date;
    next1stTakeoffDate?: Date;
    next2ndTakeoffDate?: Date;
    next3rdTakeoffDate?: Date;
    typeRating?: string;
    lastRecencyTillDate?: Date;
    lastLandingRecencyTillDate?: Date;
    lastTakeoffRecencyTillDate?: Date;
}
export class AircraftTypeRecencyCockpitReportModel extends BaseApiModelClass< IAircraftTypeRecencyCockpitReportModel > implements IAircraftTypeRecencyCockpitReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    personCode: string;
    personName?: string;
    personFunction?: string;
    personContract?: string;
    aircraftType: string;
    actualRecencyTillDate?: Date;
    actualLandingRecencyTillDate?: Date;
    actualTakeoffRecencyTillDate?: Date;
    plannedRecencyTillDate?: Date;
    plannedLandingRecencyTillDate?: Date;
    plannedTakeoffRecencyTillDate?: Date;
    last1stLandingDate?: Date;
    last2ndLandingDate?: Date;
    last3rdLandingDate?: Date;
    next1stLandingDate?: Date;
    next2ndLandingDate?: Date;
    next3rdLandingDate?: Date;
    last1stTakeoffDate?: Date;
    last2ndTakeoffDate?: Date;
    last3rdTakeoffDate?: Date;
    next1stTakeoffDate?: Date;
    next2ndTakeoffDate?: Date;
    next3rdTakeoffDate?: Date;
    typeRating?: string;
    lastRecencyTillDate?: Date;
    lastLandingRecencyTillDate?: Date;
    lastTakeoffRecencyTillDate?: Date;
}

export interface IAircraftTypeRecencyCockpitReportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}
export class AircraftTypeRecencyCockpitReportModelDataSourceLoadOptions extends BaseApiModelClass< IAircraftTypeRecencyCockpitReportModelDataSourceLoadOptions > implements IAircraftTypeRecencyCockpitReportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}

export enum AircraftTypeRecencyLandingType {
    CustomLanding = "CustomLanding",
    SIM = "SIM",
    SimpleLanding = "SimpleLanding",
    Training = "Training",
}

export interface IAircraftTypeRecencyReportCockpitFilter {
    rowLimit?: number;
    functionId: string;
    personId?: string;
    isCloseExpiry: boolean;
}
export class AircraftTypeRecencyReportCockpitFilter extends BaseApiModelClass< IAircraftTypeRecencyReportCockpitFilter > implements IAircraftTypeRecencyReportCockpitFilter {
    rowLimit?: number;
    functionId: string;
    personId?: string;
    isCloseExpiry: boolean;
}

export interface IAircraftTypeRecencyReportFilter {
    rowLimit?: number;
    date: Date;
    functionId: string;
    personId?: string;
}
export class AircraftTypeRecencyReportFilter extends BaseApiModelClass< IAircraftTypeRecencyReportFilter > implements IAircraftTypeRecencyReportFilter {
    rowLimit?: number;
    date: Date;
    functionId: string;
    personId?: string;
}

export interface IAircraftTypeRecencyReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    personCrewId?: string;
    personCode: string;
    personName?: string;
    personFunction?: string;
    personContract?: string;
    aircraftTypeGroup?: string;
    recencyTillDate?: Date;
    easaRecencyTillDate?: Date;
    recencyDescription?: string;
    personEntryDateFrom?: Date;
    personEntryDateTo?: Date;
    recencyLandings: PersonAircraftTypeRecencyLandingModel[];
}
export class AircraftTypeRecencyReportModel extends BaseApiModelClass< IAircraftTypeRecencyReportModel > implements IAircraftTypeRecencyReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    personCrewId?: string;
    personCode: string;
    personName?: string;
    personFunction?: string;
    personContract?: string;
    aircraftTypeGroup?: string;
    recencyTillDate?: Date;
    easaRecencyTillDate?: Date;
    recencyDescription?: string;
    personEntryDateFrom?: Date;
    personEntryDateTo?: Date;
    recencyLandings: PersonAircraftTypeRecencyLandingModel[];
}

export interface IAircraftTypeRecencyReportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}
export class AircraftTypeRecencyReportModelDataSourceLoadOptions extends BaseApiModelClass< IAircraftTypeRecencyReportModelDataSourceLoadOptions > implements IAircraftTypeRecencyReportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}

export enum AircraftTypeStatus {
    Active = "Active",
    Disabled = "Disabled",
}

export interface IAirportDetailsLicenseActivityModel {
    activityRcd: string;
    licenseIds: string[];
}
export class AirportDetailsLicenseActivityModel extends BaseApiModelClass< IAirportDetailsLicenseActivityModel > implements IAirportDetailsLicenseActivityModel {
    activityRcd: string;
    licenseIds: string[];
}

export interface IAirportDetailsModel {
    fourLetterCode: string;
    threeLetterCode: string;
    name: string;
    countryCode?: string;
    isDisabled: boolean;
    latitude?: number;
    longitude?: number;
    countryName?: string;
    countryRegion?: string;
    isHandoverRelated: boolean;
    stationManagerEmail?: string;
    stationManagerFirstname?: string;
    stationManagerLastname?: string;
    stationManagerPhone?: string;
    activityLicenses: AirportDetailsLicenseActivityModel[];
    rules: AirportExperienceRuleInfo[];
    hotelDetails: AirportHotelDetailsModel[];
}
export class AirportDetailsModel extends BaseApiModelClass< IAirportDetailsModel > implements IAirportDetailsModel {
    fourLetterCode: string;
    threeLetterCode: string;
    name: string;
    countryCode?: string;
    isDisabled: boolean;
    latitude?: number;
    longitude?: number;
    countryName?: string;
    countryRegion?: string;
    isHandoverRelated: boolean;
    stationManagerEmail?: string;
    stationManagerFirstname?: string;
    stationManagerLastname?: string;
    stationManagerPhone?: string;
    activityLicenses: AirportDetailsLicenseActivityModel[];
    rules: AirportExperienceRuleInfo[];
    hotelDetails: AirportHotelDetailsModel[];
}

export interface IAirportExperienceConditionInfo {
    activityCode: string;
    conditionType: AirportExperienceConditionType;
    value: string;
    andGroup?: number;
}
export class AirportExperienceConditionInfo extends BaseApiModelClass< IAirportExperienceConditionInfo > implements IAirportExperienceConditionInfo {
    activityCode: string;
    conditionType: AirportExperienceConditionType;
    value: string;
    andGroup?: number;
}

export enum AirportExperienceConditionType {
    BlockHours = "BlockHours",
    CheckerTraineeFunction = "CheckerTraineeFunction",
    HasAircraftExperience = "HasAircraftExperience",
    InexperiencedPilotsLimit = "InexperiencedPilotsLimit",
    LicenseGroup = "LicenseGroup",
    LicenseId = "LicenseId",
    RecentMonthsLanding = "RecentMonthsLanding",
    RecentMonthsLandingAndTakeoffs = "RecentMonthsLandingAndTakeoffs",
}

export interface IAirportExperienceRuleInfo {
    id: string;
    name: string;
    isActive: boolean;
    dataPeriodFrom?: Date;
    periodFrom?: Date;
    periodTo?: Date;
    applicableActivityCode?: string;
    isForLanding?: boolean;
    isForReleased: boolean;
    errorMessage: string;
    errorType: string;
    airportThreeLetterCodes: string[];
    conditions: AirportExperienceConditionInfo[];
}
export class AirportExperienceRuleInfo extends BaseApiModelClass< IAirportExperienceRuleInfo > implements IAirportExperienceRuleInfo {
    id: string;
    name: string;
    isActive: boolean;
    readonly dataPeriodFrom?: Date;
    periodFrom?: Date;
    periodTo?: Date;
    applicableActivityCode?: string;
    isForLanding?: boolean;
    isForReleased: boolean;
    errorMessage: string;
    errorType: string;
    airportThreeLetterCodes: string[];
    conditions: AirportExperienceConditionInfo[];
}

export interface IAirportHotelDetailsModel {
    type: HotelDetailType;
    value?: string;
}
export class AirportHotelDetailsModel extends BaseApiModelClass< IAirportHotelDetailsModel > implements IAirportHotelDetailsModel {
    type: HotelDetailType;
    value?: string;
}

export interface IAirportModel {
    fourLetterCode: string;
    threeLetterCode: string;
    name: string;
    countryCode?: string;
    isActive: boolean;
    latitude?: number;
    longitude?: number;
}
export class AirportModel extends BaseApiModelClass< IAirportModel > implements IAirportModel {
    fourLetterCode: string;
    threeLetterCode: string;
    name: string;
    countryCode?: string;
    isActive: boolean;
    latitude?: number;
    longitude?: number;
}

export interface IAirportRecencyReportFilter {
    rowLimit?: number;
    referenceDate?: Date;
    personId?: string;
}
export class AirportRecencyReportFilter extends BaseApiModelClass< IAirportRecencyReportFilter > implements IAirportRecencyReportFilter {
    rowLimit?: number;
    referenceDate?: Date;
    personId?: string;
}

export interface IAirportRecencyReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    personId: string;
    personCode: string;
    personName: string;
    personContract: string;
    functionName: string;
    fleetType?: FleetType;
    licenseFleet?: string;
    airportRcd: string;
    lastDutyLandingDate?: Date;
    lastSimTrainingDate?: Date;
    lastCustomLandingDate?: Date;
    lastDutyTakeoffDate?: Date;
    lastCustomTakeoffDate?: Date;
    lastAirportLandingDate?: Date;
    lastAirportTakeoffDate?: Date;
    recencyMonths: number;
    recencyMonthsEom: boolean;
    typeId: AirportExperienceConditionType;
    actualAirportRecencyExpiration3MonthsDate?: Date;
    actualAirportRecencyExpirationFinalDate?: Date;
    nextDutyLandingDate?: Date;
    nextSimTrainingDate?: Date;
    nextCustomLandingDate?: Date;
    nextDutyTakeoffDate?: Date;
    nextCustomTakeoffDate?: Date;
    nextAirportLandingDate?: Date;
    nextAirportTakeoffDate?: Date;
    plannedAirportRecencyExpiration3MonthsDate?: Date;
    plannedAirportRecencyExpirationFinalDate?: Date;
}
export class AirportRecencyReportModel extends BaseApiModelClass< IAirportRecencyReportModel > implements IAirportRecencyReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    personId: string;
    personCode: string;
    personName: string;
    personContract: string;
    functionName: string;
    fleetType?: FleetType;
    licenseFleet?: string;
    airportRcd: string;
    lastDutyLandingDate?: Date;
    lastSimTrainingDate?: Date;
    lastCustomLandingDate?: Date;
    lastDutyTakeoffDate?: Date;
    lastCustomTakeoffDate?: Date;
    readonly lastAirportLandingDate?: Date;
    readonly lastAirportTakeoffDate?: Date;
    recencyMonths: number;
    recencyMonthsEom: boolean;
    typeId: AirportExperienceConditionType;
    readonly actualAirportRecencyExpiration3MonthsDate?: Date;
    readonly actualAirportRecencyExpirationFinalDate?: Date;
    nextDutyLandingDate?: Date;
    nextSimTrainingDate?: Date;
    nextCustomLandingDate?: Date;
    nextDutyTakeoffDate?: Date;
    nextCustomTakeoffDate?: Date;
    readonly nextAirportLandingDate?: Date;
    readonly nextAirportTakeoffDate?: Date;
    readonly plannedAirportRecencyExpiration3MonthsDate?: Date;
    readonly plannedAirportRecencyExpirationFinalDate?: Date;
}

export interface IAirportRecencyReportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}
export class AirportRecencyReportModelDataSourceLoadOptions extends BaseApiModelClass< IAirportRecencyReportModelDataSourceLoadOptions > implements IAirportRecencyReportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}

export interface IAirportShortInfo {
    threeLetterCode: string;
    fourLetterCode: string;
    aircraftTypes: string[];
}
export class AirportShortInfo extends BaseApiModelClass< IAirportShortInfo > implements IAirportShortInfo {
    threeLetterCode: string;
    fourLetterCode: string;
    aircraftTypes: string[];
}

export interface IApiV1Job {
    id: string;
    name: string;
    description?: string;
    jobType: string;
    lastRunDateTimeUtc?: Date;
    nextRunDateTimeUtc?: Date;
    lastRunTriggerName?: string;
    nextRunTriggerName?: string;
    lastErrorMessage?: string;
    lastStatus?: JobStatus;
    timestampDateTimeUtc: Date;
    triggers: JobTriggerShortInfo[];
    permissionName?: string;
    lastExecutionInfoMessage?: string;
}
export class ApiV1Job extends BaseApiModelClass< IApiV1Job > implements IApiV1Job {
    id: string;
    name: string;
    description?: string;
    jobType: string;
    lastRunDateTimeUtc?: Date;
    nextRunDateTimeUtc?: Date;
    lastRunTriggerName?: string;
    nextRunTriggerName?: string;
    lastErrorMessage?: string;
    lastStatus?: JobStatus;
    timestampDateTimeUtc: Date;
    triggers: JobTriggerShortInfo[];
    permissionName?: string;
    lastExecutionInfoMessage?: string;
}

export interface IApiV1JobList {
    jobs: ApiV1Job[];
    status?: SchedulerStatus;
    startupException?: string;
}
export class ApiV1JobList extends BaseApiModelClass< IApiV1JobList > implements IApiV1JobList {
    jobs: ApiV1Job[];
    status?: SchedulerStatus;
    startupException?: string;
}

export interface IApiV1JobTrigger {
    executionId?: string;
    id: string;
    nextRunDateTime?: Date;
    lastRunDateTime?: Date;
    lastErrorMessage?: string;
    status?: JobStatus;
    isActive: boolean;
    cronSchedule?: string;
    progressMessage?: string;
}
export class ApiV1JobTrigger extends BaseApiModelClass< IApiV1JobTrigger > implements IApiV1JobTrigger {
    executionId?: string;
    id: string;
    nextRunDateTime?: Date;
    lastRunDateTime?: Date;
    lastErrorMessage?: string;
    status?: JobStatus;
    isActive: boolean;
    cronSchedule?: string;
    progressMessage?: string;
}

export interface IApproveReserveRequestModel {
    id: string;
    ignoreValidationWarnings: boolean;
}
export class ApproveReserveRequestModel extends BaseApiModelClass< IApproveReserveRequestModel > implements IApproveReserveRequestModel {
    id: string;
    ignoreValidationWarnings: boolean;
}

export interface IAreaRouteCompetenceAirportDto {
    airportThreeLetterCode: string;
    routeCompetenceId: string;
}
export class AreaRouteCompetenceAirportDto extends BaseApiModelClass< IAreaRouteCompetenceAirportDto > implements IAreaRouteCompetenceAirportDto {
    airportThreeLetterCode: string;
    routeCompetenceId: string;
}

export interface IAreaRouteCompetenceDate {
    competenceId: string;
    competenceName: string;
    competencyDate?: Date;
    competencyFlightDate?: Date;
    plannedDate?: Date;
}
export class AreaRouteCompetenceDate extends BaseApiModelClass< IAreaRouteCompetenceDate > implements IAreaRouteCompetenceDate {
    competenceId: string;
    competenceName: string;
    competencyDate?: Date;
    competencyFlightDate?: Date;
    plannedDate?: Date;
}

export interface IAreaRouteCompetenceDto {
    id: string;
    displayName: string;
    sortOrder: number;
}
export class AreaRouteCompetenceDto extends BaseApiModelClass< IAreaRouteCompetenceDto > implements IAreaRouteCompetenceDto {
    id: string;
    displayName: string;
    sortOrder: number;
}

export interface IAreaRouteCompetenceReportFilter {
    rowLimit?: number;
    referenceDate?: Date;
    personId?: string;
}
export class AreaRouteCompetenceReportFilter extends BaseApiModelClass< IAreaRouteCompetenceReportFilter > implements IAreaRouteCompetenceReportFilter {
    rowLimit?: number;
    referenceDate?: Date;
    personId?: string;
}

export interface IAreaRouteCompetenceReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    personId: string;
    personCode: string;
    crewId: string;
    personName: string;
    functionName: string;
    fleetType?: FleetType;
    licenseFleet: string;
    hasCrpLicense: boolean;
    competencies: string[];
    competenciesCount: number;
    competenceDates: AreaRouteCompetenceDate[];
    expirationDate?: Date;
    expirationFlightDate?: Date;
}
export class AreaRouteCompetenceReportModel extends BaseApiModelClass< IAreaRouteCompetenceReportModel > implements IAreaRouteCompetenceReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    personId: string;
    personCode: string;
    readonly crewId: string;
    personName: string;
    functionName: string;
    fleetType?: FleetType;
    licenseFleet: string;
    hasCrpLicense: boolean;
    competencies: string[];
    readonly competenciesCount: number;
    competenceDates: AreaRouteCompetenceDate[];
    readonly expirationDate?: Date;
    readonly expirationFlightDate?: Date;
}

export interface IAreaRouteCompetenceReportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}
export class AreaRouteCompetenceReportModelDataSourceLoadOptions extends BaseApiModelClass< IAreaRouteCompetenceReportModelDataSourceLoadOptions > implements IAreaRouteCompetenceReportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}

export interface IAreaRouteCompetenceRulesDto {
    areaRouteCompetences: AreaRouteCompetenceDto[];
    airportThreeLetterCodes: string[];
}
export class AreaRouteCompetenceRulesDto extends BaseApiModelClass< IAreaRouteCompetenceRulesDto > implements IAreaRouteCompetenceRulesDto {
    areaRouteCompetences: AreaRouteCompetenceDto[];
    airportThreeLetterCodes: string[];
}

export interface IAreaRouteCompetenceRulesReportFilter {
    rowLimit?: number;
    personId?: string;
}
export class AreaRouteCompetenceRulesReportFilter extends BaseApiModelClass< IAreaRouteCompetenceRulesReportFilter > implements IAreaRouteCompetenceRulesReportFilter {
    rowLimit?: number;
    personId?: string;
}

export interface IAreaRouteCompetenceRulesReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    airportThreeLetterCode: string;
    routeCompetenceId: string;
}
export class AreaRouteCompetenceRulesReportModel extends BaseApiModelClass< IAreaRouteCompetenceRulesReportModel > implements IAreaRouteCompetenceRulesReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    airportThreeLetterCode: string;
    routeCompetenceId: string;
}

export interface IAreaRouteCompetenceRulesReportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}
export class AreaRouteCompetenceRulesReportModelDataSourceLoadOptions extends BaseApiModelClass< IAreaRouteCompetenceRulesReportModelDataSourceLoadOptions > implements IAreaRouteCompetenceRulesReportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}

export interface IAssignFlightValidationResult {
    isValid: boolean;
    rotationStartDate: Date;
    rotationEndDate: Date;
    person?: PersonInfoModel;
    bh28DaysSecs?: number;
    blockHours12MSecs?: number;
    blockHours1YearSecs?: number;
    dh28DaysSecs?: number;
    dh14DaysSecs?: number;
    dh7DaysSecs?: number;
    score: number;
}
export class AssignFlightValidationResult extends BaseApiModelClass< IAssignFlightValidationResult > implements IAssignFlightValidationResult {
    isValid: boolean;
    rotationStartDate: Date;
    rotationEndDate: Date;
    person?: PersonInfoModel;
    bh28DaysSecs?: number;
    blockHours12MSecs?: number;
    blockHours1YearSecs?: number;
    dh28DaysSecs?: number;
    dh14DaysSecs?: number;
    dh7DaysSecs?: number;
    score: number;
}

export interface IAssignedFlight {
    flightNumber: number;
    originRcd: string;
    destinationRcd: string;
    departureDateTimeUtc: Date;
    arrivalDateTimeUtc: Date;
    isIncompleteOooi: boolean;
    isIntroFlight: boolean;
    isObserverFlight: boolean;
}
export class AssignedFlight extends BaseApiModelClass< IAssignedFlight > implements IAssignedFlight {
    flightNumber: number;
    originRcd: string;
    destinationRcd: string;
    departureDateTimeUtc: Date;
    arrivalDateTimeUtc: Date;
    isIncompleteOooi: boolean;
    isIntroFlight: boolean;
    isObserverFlight: boolean;
}

export interface IAvailableDirectionModel {
    originRcds: string[];
    destinationRcds: string[];
}
export class AvailableDirectionModel extends BaseApiModelClass< IAvailableDirectionModel > implements IAvailableDirectionModel {
    originRcds: string[];
    destinationRcds: string[];
}

export interface IAvailableFlightModel {
    id: string;
    flightNumber: number;
    date: Date;
    isForCockpit: boolean;
    isForCabin: boolean;
    isInbound: boolean;
}
export class AvailableFlightModel extends BaseApiModelClass< IAvailableFlightModel > implements IAvailableFlightModel {
    id: string;
    flightNumber: number;
    date: Date;
    isForCockpit: boolean;
    isForCabin: boolean;
    isInbound: boolean;
}

export interface IAvailableRequestRange {
    shortTermOffStartDate?: Date;
    shortTermOffEndDate?: Date;
    longTermOffStartDate?: Date;
    longTermOffEndDate?: Date;
    longTermFlightStartDate: Date;
    longTermFlightEndDate: Date;
    shortTermFlightStartDate?: Date;
    shortTermFlightEndDate?: Date;
}
export class AvailableRequestRange extends BaseApiModelClass< IAvailableRequestRange > implements IAvailableRequestRange {
    shortTermOffStartDate?: Date;
    shortTermOffEndDate?: Date;
    longTermOffStartDate?: Date;
    longTermOffEndDate?: Date;
    longTermFlightStartDate: Date;
    longTermFlightEndDate: Date;
    shortTermFlightStartDate?: Date;
    shortTermFlightEndDate?: Date;
}

export enum BlockSplitType {
    Block = "Block",
    Split = "Split",
}

export enum BlockedDayType {
    All = "All",
    Flights = "Flights",
    OFFs = "OFFs",
}

export interface IBulkUndoModel {
    operationIds: string[];
    allowUndoSystemOperation: boolean;
}
export class BulkUndoModel extends BaseApiModelClass< IBulkUndoModel > implements IBulkUndoModel {
    operationIds: string[];
    allowUndoSystemOperation: boolean;
}

export interface IBulkUpdateResponseItem {
    operationId: string;
    errorMessage?: string;
}
export class BulkUpdateResponseItem extends BaseApiModelClass< IBulkUpdateResponseItem > implements IBulkUpdateResponseItem {
    operationId: string;
    errorMessage?: string;
}

export interface ICabinCrewAttestationModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    id?: string;
    refName: string;
    personId: string;
    personCode: string;
    personFirstName?: string;
    personLastName?: string;
    personBirthDate?: Date;
    personPlaceOfBirth?: string;
    personNationality?: string;
    courseId: string;
    courseName: string;
    courseStart: Date;
    courseEnd: Date;
    courseStatus: CourseStatus;
    isAvailableCCA: boolean;
    hasCompleteCourse: boolean;
    personSignatureId?: string;
    status: CabinCrewAttestationStatus;
}
export class CabinCrewAttestationModel extends BaseApiModelClass< ICabinCrewAttestationModel > implements ICabinCrewAttestationModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    id?: string;
    refName: string;
    personId: string;
    personCode: string;
    personFirstName?: string;
    personLastName?: string;
    personBirthDate?: Date;
    personPlaceOfBirth?: string;
    personNationality?: string;
    courseId: string;
    courseName: string;
    courseStart: Date;
    courseEnd: Date;
    courseStatus: CourseStatus;
    isAvailableCCA: boolean;
    hasCompleteCourse: boolean;
    personSignatureId?: string;
    status: CabinCrewAttestationStatus;
}

export interface ICabinCrewAttestationModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}
export class CabinCrewAttestationModelDataSourceLoadOptions extends BaseApiModelClass< ICabinCrewAttestationModelDataSourceLoadOptions > implements ICabinCrewAttestationModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}

export interface ICabinCrewAttestationReportFilter {
    rowLimit?: number;
}
export class CabinCrewAttestationReportFilter extends BaseApiModelClass< ICabinCrewAttestationReportFilter > implements ICabinCrewAttestationReportFilter {
    rowLimit?: number;
}

export enum CabinCrewAttestationStatus {
    Cancelled = "Cancelled",
    Created = "Created",
    Incorrect = "Incorrect",
    Paused = "Paused",
    Ready = "Ready",
    Signed = "Signed",
    Uploaded = "Uploaded",
}

export interface ICalendarMonthDto {
    month: number;
    year: number;
    name: string;
}
export class CalendarMonthDto extends BaseApiModelClass< ICalendarMonthDto > implements ICalendarMonthDto {
    month: number;
    year: number;
    name: string;
}

export enum CalendarType {
    Fdr = "Fdr",
    InstructorFdr = "InstructorFdr",
}

export interface ICapacityFileInfo {
    id: string;
    fileName: string;
    fileSize: number;
    uploadedAt: Date;
    status: RequestCapacityFileImportedStatus;
}
export class CapacityFileInfo extends BaseApiModelClass< ICapacityFileInfo > implements ICapacityFileInfo {
    id: string;
    fileName: string;
    fileSize: number;
    uploadedAt: Date;
    status: RequestCapacityFileImportedStatus;
}

export enum CapacityLevel {
    High = "High",
    Low = "Low",
    None = "None",
}

export interface ICapacityModel {
    date: Date;
    value: number;
}
export class CapacityModel extends BaseApiModelClass< ICapacityModel > implements ICapacityModel {
    date: Date;
    value: number;
}

export interface ICateringReportCreateModel {
    periodFrom?: Date;
    periodTo?: Date;
    reportType: MealReportType;
}
export class CateringReportCreateModel extends BaseApiModelClass< ICateringReportCreateModel > implements ICateringReportCreateModel {
    periodFrom?: Date;
    periodTo?: Date;
    reportType: MealReportType;
}

export interface ICateringReportItem {
    id: string;
    createdAtUtc: Date;
    createdBy?: string;
    periodFrom: Date;
    periodTo: Date;
    type: MealReportType;
    fileName: string;
}
export class CateringReportItem extends BaseApiModelClass< ICateringReportItem > implements ICateringReportItem {
    id: string;
    createdAtUtc: Date;
    createdBy?: string;
    periodFrom: Date;
    periodTo: Date;
    type: MealReportType;
    fileName: string;
}

export interface IChangeCheckInCheckOutModel {
    date: Date;
    personId: string;
    isCo: boolean;
    checkInDateTime?: Date;
    checkOutDateTime?: Date;
}
export class ChangeCheckInCheckOutModel extends BaseApiModelClass< IChangeCheckInCheckOutModel > implements IChangeCheckInCheckOutModel {
    date: Date;
    personId: string;
    isCo: boolean;
    checkInDateTime?: Date;
    checkOutDateTime?: Date;
}

export interface IChangeDutyHoursModel {
    personId: string;
    date: Date;
    activityRcd: string;
    dutyTimeSec?: number;
}
export class ChangeDutyHoursModel extends BaseApiModelClass< IChangeDutyHoursModel > implements IChangeDutyHoursModel {
    personId: string;
    date: Date;
    activityRcd: string;
    dutyTimeSec?: number;
}

export interface IChangeField {
    name: string;
    oldValue?: string;
    newValue?: string;
}
export class ChangeField extends BaseApiModelClass< IChangeField > implements IChangeField {
    name: string;
    oldValue?: string;
    newValue?: string;
}

export interface IChangeLogFilter {
    rowLimit?: number;
    ids: string[];
    changeLogStatuses: ChangeLogStatus[];
    dateFrom?: Date;
    dateTo?: Date;
}
export class ChangeLogFilter extends BaseApiModelClass< IChangeLogFilter > implements IChangeLogFilter {
    rowLimit?: number;
    ids: string[];
    changeLogStatuses: ChangeLogStatus[];
    dateFrom?: Date;
    dateTo?: Date;
}

export interface IChangeLogModel {
    personId: string;
    date: Date;
    oldDuty: string;
    newDuty: string;
    reason?: string;
    alertTypeId?: number;
}
export class ChangeLogModel extends BaseApiModelClass< IChangeLogModel > implements IChangeLogModel {
    personId: string;
    date: Date;
    oldDuty: string;
    newDuty: string;
    reason?: string;
    alertTypeId?: number;
}

export interface IChangeLogReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    id: string;
    personId: string;
    personCode: string;
    personName?: string;
    personFunction?: string;
    personPhoneNumber?: string;
    personPhone?: string;
    personPhoneMobile?: string;
    personPhoneMobilePrivate?: string;
    personPhonePrivate?: string;
    personEmail?: string;
    dutyDate: Date;
    oldDuty: string;
    newDuty: string;
    reason: string;
    createdDate: Date;
    createdByPrincipal: string;
    isConfirmedByPlanningTeam: boolean;
    confirmedByPlanningTeamAtDate?: Date;
    confirmedByCrewAtDate?: Date;
    confirmedBy?: string;
    totalUnconfirmedCount?: number;
}
export class ChangeLogReportModel extends BaseApiModelClass< IChangeLogReportModel > implements IChangeLogReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    id: string;
    personId: string;
    personCode: string;
    personName?: string;
    personFunction?: string;
    personPhoneNumber?: string;
    personPhone?: string;
    personPhoneMobile?: string;
    personPhoneMobilePrivate?: string;
    personPhonePrivate?: string;
    personEmail?: string;
    dutyDate: Date;
    oldDuty: string;
    newDuty: string;
    reason: string;
    createdDate: Date;
    createdByPrincipal: string;
    isConfirmedByPlanningTeam: boolean;
    confirmedByPlanningTeamAtDate?: Date;
    confirmedByCrewAtDate?: Date;
    confirmedBy?: string;
    totalUnconfirmedCount?: number;
}

export interface IChangeLogReportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}
export class ChangeLogReportModelDataSourceLoadOptions extends BaseApiModelClass< IChangeLogReportModelDataSourceLoadOptions > implements IChangeLogReportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}

export enum ChangeLogStatus {
    Confirmed = "Confirmed",
    NotConfirmed = "NotConfirmed",
}

export interface IChangeLogUpdateConfirmationModel {
    isConfirmedByPlanningTeam: boolean;
    confirmedAt?: Date;
    confirmedBy?: string;
}
export class ChangeLogUpdateConfirmationModel extends BaseApiModelClass< IChangeLogUpdateConfirmationModel > implements IChangeLogUpdateConfirmationModel {
    isConfirmedByPlanningTeam: boolean;
    confirmedAt?: Date;
    confirmedBy?: string;
}

export interface ICheckInCheckOutModel {
    date: Date;
    personId: string;
    isCo: boolean;
}
export class CheckInCheckOutModel extends BaseApiModelClass< ICheckInCheckOutModel > implements ICheckInCheckOutModel {
    date: Date;
    personId: string;
    isCo: boolean;
}

export enum CheckerTraineeFunction {
    Cl = "Cl",
    ClEf = "ClEf",
    CompetencyCheck = "CompetencyCheck",
    CrpLc = "CrpLc",
    Ef = "Ef",
    EisCrew = "EisCrew",
    FLc = "FLc",
    Lc = "Lc",
    Le = "Le",
    Lifus = "Lifus",
    Lpl4 = "Lpl4",
    None = "None",
    Refam = "Refam",
    SafetyPilot = "SafetyPilot",
    ScEf = "ScEf",
    Sf = "Sf",
}

export enum CheckerTraineeFunctionCrewType {
    Cabin = "Cabin",
    Cockpit = "Cockpit",
    Ground = "Ground",
}

export interface ICheckerTraineeFunctionModel {
    value: number;
    name: string;
    description: string;
    crewType: CheckerTraineeFunctionCrewType;
    isSingleFunction: boolean;
}
export class CheckerTraineeFunctionModel extends BaseApiModelClass< ICheckerTraineeFunctionModel > implements ICheckerTraineeFunctionModel {
    value: number;
    name: string;
    description: string;
    crewType: CheckerTraineeFunctionCrewType;
    isSingleFunction: boolean;
}

export interface IClientErrorModel {
    message?: string;
    source?: string;
    url?: string;
    navigatorUserAgent?: string;
    navigatorVendor?: string;
    screenSize?: string;
}
export class ClientErrorModel extends BaseApiModelClass< IClientErrorModel > implements IClientErrorModel {
    message?: string;
    source?: string;
    url?: string;
    navigatorUserAgent?: string;
    navigatorVendor?: string;
    screenSize?: string;
}

export enum CommentCategory {
    Day = "Day",
    Duty = "Duty",
    Flight = "Flight",
    Person = "Person",
    PlanningNote = "PlanningNote",
    Seniority = "Seniority",
    TzvYear = "TzvYear",
    Validation = "Validation",
    XStar = "XStar",
}

export interface ICommentReportFilter {
    rowLimit?: number;
    dateFrom?: Date;
    dateTo?: Date;
}
export class CommentReportFilter extends BaseApiModelClass< ICommentReportFilter > implements ICommentReportFilter {
    rowLimit?: number;
    dateFrom?: Date;
    dateTo?: Date;
}

export interface ICommentReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    id: string;
    personCode: string;
    personName?: string;
    date?: Date;
    text: string;
    category: CommentCategory;
    validTillDate?: Date;
    createdDateUtc: Date;
    createdBy: string;
}
export class CommentReportModel extends BaseApiModelClass< ICommentReportModel > implements ICommentReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    id: string;
    personCode: string;
    personName?: string;
    date?: Date;
    text: string;
    category: CommentCategory;
    validTillDate?: Date;
    createdDateUtc: Date;
    createdBy: string;
}

export interface ICommentReportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}
export class CommentReportModelDataSourceLoadOptions extends BaseApiModelClass< ICommentReportModelDataSourceLoadOptions > implements ICommentReportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}

export interface ICommentShortDto {
    id: string;
    text: string;
}
export class CommentShortDto extends BaseApiModelClass< ICommentShortDto > implements ICommentShortDto {
    id: string;
    text: string;
}

export enum ConfigType {
    Boolean = "Boolean",
    Date = "Date",
    DateTime = "DateTime",
    Html = "Html",
    Number = "Number",
    Select = "Select",
    Text = "Text",
    Uri = "Uri",
}

export interface IConfigurationModel {
    key: string;
    group: string;
    value: string;
    description?: string;
    type?: ConfigType;
    isSystem?: boolean;
    options?: string;
    permission?: string;
}
export class ConfigurationModel extends BaseApiModelClass< IConfigurationModel > implements IConfigurationModel {
    key: string;
    group: string;
    value: string;
    description?: string;
    type?: ConfigType;
    isSystem?: boolean;
    options?: string;
    permission?: string;
}

export interface IConnectedClientModel {
    identity: string;
    fullName?: string;
    roles: string[];
    locations: PageLocation[];
}
export class ConnectedClientModel extends BaseApiModelClass< IConnectedClientModel > implements IConnectedClientModel {
    identity: string;
    fullName?: string;
    roles: string[];
    locations: PageLocation[];
}

export interface IConstantFreelanceContractResponse {
    isConstantFreelancer: boolean;
    hasFreelancerContract: boolean;
}
export class ConstantFreelanceContractResponse extends BaseApiModelClass< IConstantFreelanceContractResponse > implements IConstantFreelanceContractResponse {
    isConstantFreelancer: boolean;
    hasFreelancerContract: boolean;
}

export enum ContractFlagType {
    Fix = "Fix",
    Freelance = "Freelance",
    Fse = "Fse",
    GroundOnly = "GroundOnly",
    None = "None",
    Tzv = "Tzv",
}

export interface IContractFlagTypeModel {
    name: string;
    value: number;
}
export class ContractFlagTypeModel extends BaseApiModelClass< IContractFlagTypeModel > implements IContractFlagTypeModel {
    name: string;
    value: number;
}

export enum ContractModelType {
    FL_A = "FL_A",
    FL_B = "FL_B",
    FL_C = "FL_C",
    FL_S = "FL_S",
    None = "None",
    TZV_Day = "TZV_Day",
    TZV_FixBlock = "TZV_FixBlock",
    TZV_FixDay = "TZV_FixDay",
    TZV_FixDay_Mff = "TZV_FixDay_Mff",
    TZV_FixDay_Sh = "TZV_FixDay_Sh",
    TZV_Ground = "TZV_Ground",
    TZV_Month = "TZV_Month",
    TZV_R = "TZV_R",
    TZV_Spez = "TZV_Spez",
    TZV_VariableBlock = "TZV_VariableBlock",
    TZV_VariableDay = "TZV_VariableDay",
    TZV_VariableDay_LhSff = "TZV_VariableDay_LhSff",
}

export enum ContractType {
    Fix = "Fix",
    Freelance = "Freelance",
    Fse = "Fse",
    None = "None",
    Tzv = "Tzv",
}

export interface IContractTypeModel {
    name: string;
    value: number;
}
export class ContractTypeModel extends BaseApiModelClass< IContractTypeModel > implements IContractTypeModel {
    name: string;
    value: number;
}

export interface ICopyDutyData {
    sourceDutyIds: string[];
    destinationCells: DutyCellModel[];
}
export class CopyDutyData extends BaseApiModelClass< ICopyDutyData > implements ICopyDutyData {
    sourceDutyIds: string[];
    destinationCells: DutyCellModel[];
}

export interface ICopyDutyModel {
    commentIdsToDelete: string[];
    operations: CopyDutyData[];
    overrideAllowed: boolean;
    isMoving: boolean;
}
export class CopyDutyModel extends BaseApiModelClass< ICopyDutyModel > implements ICopyDutyModel {
    commentIdsToDelete: string[];
    operations: CopyDutyData[];
    overrideAllowed: boolean;
    isMoving: boolean;
}

export interface ICountryItem {
    name: string;
    threeLetterCode: string;
    twoLetterCode: string;
    region?: string;
    subRegion?: string;
    intermediateRegion?: string;
}
export class CountryItem extends BaseApiModelClass< ICountryItem > implements ICountryItem {
    name: string;
    threeLetterCode: string;
    twoLetterCode: string;
    region?: string;
    subRegion?: string;
    intermediateRegion?: string;
}

export interface ICourseDto {
    id?: string;
    name: string;
    startDate: Date;
    endDate: Date;
    type: CourseType;
    status: CourseStatus;
    persons: PersonCourseDto[];
}
export class CourseDto extends BaseApiModelClass< ICourseDto > implements ICourseDto {
    id?: string;
    name: string;
    startDate: Date;
    endDate: Date;
    type: CourseType;
    status: CourseStatus;
    persons: PersonCourseDto[];
}

export interface ICourseImportResultModel {
    courses: CourseDto[];
    errors: string[];
}
export class CourseImportResultModel extends BaseApiModelClass< ICourseImportResultModel > implements ICourseImportResultModel {
    courses: CourseDto[];
    errors: string[];
}

export interface ICourseManagementFilter {
    rowLimit?: number;
}
export class CourseManagementFilter extends BaseApiModelClass< ICourseManagementFilter > implements ICourseManagementFilter {
    rowLimit?: number;
}

export interface ICourseManagementModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    id: string;
    name: string;
    startDate: Date;
    endDate: Date;
    type: CourseType;
    status: CourseStatus;
    isBazlSent: boolean;
    bazlMailAttachmentId?: string;
    bazlMailFileName?: string;
}
export class CourseManagementModel extends BaseApiModelClass< ICourseManagementModel > implements ICourseManagementModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    id: string;
    name: string;
    startDate: Date;
    endDate: Date;
    type: CourseType;
    status: CourseStatus;
    isBazlSent: boolean;
    bazlMailAttachmentId?: string;
    bazlMailFileName?: string;
}

export interface ICourseManagementModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}
export class CourseManagementModelDataSourceLoadOptions extends BaseApiModelClass< ICourseManagementModelDataSourceLoadOptions > implements ICourseManagementModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}

export enum CourseStatus {
    Cancelled = "Cancelled",
    Closed = "Closed",
    InProgress = "InProgress",
    Open = "Open",
}

export enum CourseType {
    InitialCourse = "InitialCourse",
}

export interface ICreateHomeStudyFilter {
    rowLimit?: number;
    ids?: string[];
    functionFromDate?: Date;
    referenceDate?: Date;
    functionId?: string;
    contractTypes?: ContractType[];
}
export class CreateHomeStudyFilter extends BaseApiModelClass< ICreateHomeStudyFilter > implements ICreateHomeStudyFilter {
    rowLimit?: number;
    ids?: string[];
    functionFromDate?: Date;
    referenceDate?: Date;
    functionId?: string;
    contractTypes?: ContractType[];
}

export interface ICreatePlaningNoteModel {
    selectedCells: PersonDayDto[];
    planningNote: string;
}
export class CreatePlaningNoteModel extends BaseApiModelClass< ICreatePlaningNoteModel > implements ICreatePlaningNoteModel {
    selectedCells: PersonDayDto[];
    planningNote: string;
}

export interface ICreateReserveBlockModel {
    dateFrom: Date;
    dateTo: Date;
    rsvGroup: PersonRequestReserveGroupType;
    function: string;
}
export class CreateReserveBlockModel extends BaseApiModelClass< ICreateReserveBlockModel > implements ICreateReserveBlockModel {
    dateFrom: Date;
    dateTo: Date;
    rsvGroup: PersonRequestReserveGroupType;
    function: string;
}

export interface ICrewApiConfigReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    countryTwoLetterCode: string;
    countryThreeLetterCode: string;
    countryName: string;
    triggerType: FlightTriggerType;
    isInbound: boolean;
    messageFormat: CrewApiMessageFormat;
    deliveryMethod: CrewApiDeliveryMethod;
    isActive: boolean;
}
export class CrewApiConfigReportModel extends BaseApiModelClass< ICrewApiConfigReportModel > implements ICrewApiConfigReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    countryTwoLetterCode: string;
    countryThreeLetterCode: string;
    countryName: string;
    triggerType: FlightTriggerType;
    isInbound: boolean;
    messageFormat: CrewApiMessageFormat;
    deliveryMethod: CrewApiDeliveryMethod;
    isActive: boolean;
}

export interface ICrewApiConfigurationDeliveryModel {
    method: CrewApiDeliveryMethod;
    configuration: string;
}
export class CrewApiConfigurationDeliveryModel extends BaseApiModelClass< ICrewApiConfigurationDeliveryModel > implements ICrewApiConfigurationDeliveryModel {
    method: CrewApiDeliveryMethod;
    configuration: string;
}

export interface ICrewApiConfigurationModel {
    threeLetterCode: string;
    twoLetterCode: string;
    name: string;
    region?: string;
    subRegion?: string;
    intermediateRegion?: string;
    isActive: boolean;
    messageFormat: CrewApiMessageFormat;
    messageFormatConfiguration?: string;
    deliveryMethods: CrewApiConfigurationDeliveryModel[];
    triggersInbound: FlightTriggerType[];
    triggersOutbound: FlightTriggerType[];
    relatedAirports: string[];
    countryAirports: string[];
    hasMcl: boolean;
}
export class CrewApiConfigurationModel extends BaseApiModelClass< ICrewApiConfigurationModel > implements ICrewApiConfigurationModel {
    threeLetterCode: string;
    twoLetterCode: string;
    name: string;
    region?: string;
    subRegion?: string;
    intermediateRegion?: string;
    isActive: boolean;
    messageFormat: CrewApiMessageFormat;
    messageFormatConfiguration?: string;
    deliveryMethods: CrewApiConfigurationDeliveryModel[];
    triggersInbound: FlightTriggerType[];
    triggersOutbound: FlightTriggerType[];
    relatedAirports: string[];
    countryAirports: string[];
    hasMcl: boolean;
}

export enum CrewApiDeliveryMethod {
    EAPIS = "eAPIS",
    EmailPlaintextBody = "EmailPlaintextBody",
    EmailWithTextAttachment = "EmailWithTextAttachment",
    ManualWebUpload = "ManualWebUpload",
    WebRequest = "WebRequest",
}

export interface ICrewApiDeliveryMethodModel {
    name: string;
    value: CrewApiDeliveryMethod;
}
export class CrewApiDeliveryMethodModel extends BaseApiModelClass< ICrewApiDeliveryMethodModel > implements ICrewApiDeliveryMethodModel {
    name: string;
    value: CrewApiDeliveryMethod;
}

export interface ICrewApiFlightEventStatus {
    flightId: string;
    items: CrewApiFlightEventStatusItem[];
}
export class CrewApiFlightEventStatus extends BaseApiModelClass< ICrewApiFlightEventStatus > implements ICrewApiFlightEventStatus {
    flightId: string;
    items: CrewApiFlightEventStatusItem[];
}

export interface ICrewApiFlightEventStatusItem {
    triggerType: FlightTriggerType;
    airportRcd: string;
    countryThreeLetterCode: string;
    isOutbound?: boolean;
    isRelated: boolean;
    eventTimeUtc?: Date;
    queueItemId?: string;
    isProcessed: boolean;
    processedAtUtc?: Date;
    failedCount: number;
    retryAtUtc?: Date;
    errorMessage?: string;
    resultStatus?: FlightQueueResultStatus;
    operationName?: string;
    hasMcl: boolean;
}
export class CrewApiFlightEventStatusItem extends BaseApiModelClass< ICrewApiFlightEventStatusItem > implements ICrewApiFlightEventStatusItem {
    triggerType: FlightTriggerType;
    airportRcd: string;
    countryThreeLetterCode: string;
    isOutbound?: boolean;
    isRelated: boolean;
    eventTimeUtc?: Date;
    queueItemId?: string;
    isProcessed: boolean;
    processedAtUtc?: Date;
    failedCount: number;
    retryAtUtc?: Date;
    errorMessage?: string;
    resultStatus?: FlightQueueResultStatus;
    operationName?: string;
    hasMcl: boolean;
}

export interface ICrewApiHistoryItem {
    flightId: string;
    airlineRcd: string;
    departureUtc: Date;
    processedAtUtc?: Date;
    queueId: string;
    isOutbound?: boolean;
    isRelated?: boolean;
    flightNumber: number;
    originRcd: string;
    destinationRcd: string;
    countryThreeLetterCode?: string;
    operationName?: string;
    hasDuty: boolean;
    hasMcl: boolean;
    triggerType: FlightTriggerType;
    data: CrewApiHistoryPayload[];
}
export class CrewApiHistoryItem extends BaseApiModelClass< ICrewApiHistoryItem > implements ICrewApiHistoryItem {
    flightId: string;
    airlineRcd: string;
    departureUtc: Date;
    processedAtUtc?: Date;
    queueId: string;
    isOutbound?: boolean;
    isRelated?: boolean;
    flightNumber: number;
    originRcd: string;
    destinationRcd: string;
    countryThreeLetterCode?: string;
    operationName?: string;
    hasDuty: boolean;
    hasMcl: boolean;
    triggerType: FlightTriggerType;
    data: CrewApiHistoryPayload[];
}

export interface ICrewApiHistoryPayload {
    type: string;
    sentDate?: Date;
    eventTime: Date;
    status?: MailQueueStatus;
    errorMessage?: string;
    personsCount?: number;
}
export class CrewApiHistoryPayload extends BaseApiModelClass< ICrewApiHistoryPayload > implements ICrewApiHistoryPayload {
    type: string;
    sentDate?: Date;
    eventTime: Date;
    status?: MailQueueStatus;
    errorMessage?: string;
    personsCount?: number;
}

export interface ICrewApiMassRecipientConfiguration {
    jobTriggerRecipients: CrewApiRecipient[];
    countryRecipients: { [key: string]: CrewApiRecipient[]; };
}
export class CrewApiMassRecipientConfiguration extends BaseApiModelClass< ICrewApiMassRecipientConfiguration > implements ICrewApiMassRecipientConfiguration {
    jobTriggerRecipients: CrewApiRecipient[];
    countryRecipients: { [key: string]: CrewApiRecipient[]; };
}

export enum CrewApiMessageFormat {
    BatchUploadMru2023 = "BatchUploadMru2023",
    BatchUploadV2 = "BatchUploadV2",
    BatchUploadV4 = "BatchUploadV4",
    BatchUploadV5 = "BatchUploadV5",
    BatchUploadV8 = "BatchUploadV8",
    Paxlst = "Paxlst",
    Xls = "Xls",
    XlsxGbr2025 = "XlsxGbr2025",
}

export interface ICrewApiMessageFormatModel {
    name: string;
    value: CrewApiMessageFormat;
}
export class CrewApiMessageFormatModel extends BaseApiModelClass< ICrewApiMessageFormatModel > implements ICrewApiMessageFormatModel {
    name: string;
    value: CrewApiMessageFormat;
}

export enum CrewApiPersonChangeAction {
    Create = "Create",
    CreateInFuture = "CreateInFuture",
    Delete = "Delete",
    IgnoredByFunction = "IgnoredByFunction",
    Recreate = "Recreate",
    Update = "Update",
    Validation = "Validation",
}

export interface ICrewApiPersonMclState {
    code: string;
    isActive: boolean;
    isPlanningEnable: boolean;
    isPublished: boolean;
    snapshotFunctionGroupId?: string;
    actualFunctionGroupId?: string;
    lastFlyingFunctionGroupId?: string;
    validationErrors?: string[];
    items: CrewApiPersonMclStateItem[];
}
export class CrewApiPersonMclState extends BaseApiModelClass< ICrewApiPersonMclState > implements ICrewApiPersonMclState {
    code: string;
    isActive: boolean;
    isPlanningEnable: boolean;
    isPublished: boolean;
    snapshotFunctionGroupId?: string;
    actualFunctionGroupId?: string;
    lastFlyingFunctionGroupId?: string;
    validationErrors?: string[];
    items: CrewApiPersonMclStateItem[];
}

export interface ICrewApiPersonMclStateItem {
    processedAtUtc?: Date;
    action?: CrewApiPersonChangeAction;
    flightId?: string;
    airlineRcd?: string;
    queueId?: string;
    flightNumber?: number;
    isPending: boolean;
}
export class CrewApiPersonMclStateItem extends BaseApiModelClass< ICrewApiPersonMclStateItem > implements ICrewApiPersonMclStateItem {
    processedAtUtc?: Date;
    action?: CrewApiPersonChangeAction;
    flightId?: string;
    airlineRcd?: string;
    queueId?: string;
    flightNumber?: number;
    isPending: boolean;
}

export interface ICrewApiRecipient {
    email: string;
    timeFrom?: string;
    timeTo?: string;
}
export class CrewApiRecipient extends BaseApiModelClass< ICrewApiRecipient > implements ICrewApiRecipient {
    email: string;
    timeFrom?: string;
    timeTo?: string;
}

export interface ICrewApiSentEvent {
    id: string;
    flightId: string;
    airportRcd: string;
    countryThreeLetterCode: string;
    isProcessed: boolean;
    processedAtUtc?: Date;
    failedCount: number;
    retryAtUtc?: Date;
    errorMessage?: string;
    isExpired: boolean;
    triggerType: FlightTriggerType;
    eventTimeUtc: Date;
    resultStatus?: FlightQueueResultStatus;
    operationName?: string;
    hasMcl: boolean;
}
export class CrewApiSentEvent extends BaseApiModelClass< ICrewApiSentEvent > implements ICrewApiSentEvent {
    id: string;
    flightId: string;
    airportRcd: string;
    countryThreeLetterCode: string;
    isProcessed: boolean;
    processedAtUtc?: Date;
    failedCount: number;
    retryAtUtc?: Date;
    errorMessage?: string;
    isExpired: boolean;
    triggerType: FlightTriggerType;
    eventTimeUtc: Date;
    resultStatus?: FlightQueueResultStatus;
    operationName?: string;
    hasMcl: boolean;
}

export interface ICrewApiTriggerTypeModel {
    name: string;
    value: FlightTriggerType;
}
export class CrewApiTriggerTypeModel extends BaseApiModelClass< ICrewApiTriggerTypeModel > implements ICrewApiTriggerTypeModel {
    name: string;
    value: FlightTriggerType;
}

export interface ICrewDutyListReportFilter {
    rowLimit?: number;
    functionId: string;
    instructorFilter?: string;
    contractFlagTypes?: ContractFlagType[];
    dateFrom: Date;
    dateTo: Date;
    personIds?: string[];
    dooType: DooType[];
    resetCache: boolean;
    key: string;
}
export class CrewDutyListReportFilter extends BaseApiModelClass< ICrewDutyListReportFilter > implements ICrewDutyListReportFilter {
    rowLimit?: number;
    functionId: string;
    instructorFilter?: string;
    contractFlagTypes?: ContractFlagType[];
    dateFrom: Date;
    dateTo: Date;
    personIds?: string[];
    dooType: DooType[];
    resetCache: boolean;
    readonly key: string;
}

export interface ICrewDutyListReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    personId?: string;
    personCode: string;
    personName?: string;
    personUserName?: string;
    fleetType?: FleetType;
    licenseFleet?: string;
    personContract?: number;
    personFunction?: string;
    birthDate?: Date;
    entryDate: Date;
    exitDate?: Date;
    officePercentage?: number;
    date: Date;
    duty?: string;
    lastDuty?: string;
    dutyDetailed?: string;
    dooType: DooType;
    flightDuty?: string;
    routing?: string;
    isWish: boolean;
    isPriority: boolean;
    isFtl: boolean;
    isGav: boolean;
    isImportant: boolean;
    aircraftType?: string;
    posTo?: string;
    posBy?: string;
    isStandby: boolean;
    isWasStandby: boolean;
    standbyFromDate?: Date;
    standbyToDate?: Date;
    standbyType?: string;
    modifiedDate: Date;
    modifiedBy?: string;
    offMonthCount?: number;
    offYear?: number;
    bh1DSecs?: number;
    bh28DSecs?: number;
    bh1MSecs?: number;
    bh1YSecs?: number;
    bh12MSecs?: number;
    dh1DSecs?: number;
    dh7DSecs?: number;
    dh14DSecs?: number;
    dh28DSecs?: number;
    dh1MSecs?: number;
    dh1YSecs?: number;
    staDate?: Date;
    stdDate?: Date;
    fdp: number;
    dutyPeriodFromDate?: Date;
    dutyPeriodToDate?: Date;
    training?: string;
    checkerTrainee?: string;
    special?: string;
    simInstructorRequirements?: InstructorRequirements;
    simLocation?: string;
    simAirport?: string;
    checkInDateTimeUtc?: Date;
    checkOutDateTimeUtc?: Date;
    mfdp?: number;
    has334C: boolean;
    has345C: boolean;
}
export class CrewDutyListReportModel extends BaseApiModelClass< ICrewDutyListReportModel > implements ICrewDutyListReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    personId?: string;
    personCode: string;
    personName?: string;
    personUserName?: string;
    fleetType?: FleetType;
    licenseFleet?: string;
    personContract?: number;
    personFunction?: string;
    birthDate?: Date;
    entryDate: Date;
    exitDate?: Date;
    officePercentage?: number;
    date: Date;
    duty?: string;
    lastDuty?: string;
    dutyDetailed?: string;
    dooType: DooType;
    flightDuty?: string;
    routing?: string;
    isWish: boolean;
    isPriority: boolean;
    isFtl: boolean;
    isGav: boolean;
    isImportant: boolean;
    aircraftType?: string;
    posTo?: string;
    posBy?: string;
    isStandby: boolean;
    isWasStandby: boolean;
    standbyFromDate?: Date;
    standbyToDate?: Date;
    standbyType?: string;
    modifiedDate: Date;
    modifiedBy?: string;
    offMonthCount?: number;
    offYear?: number;
    bh1DSecs?: number;
    bh28DSecs?: number;
    bh1MSecs?: number;
    bh1YSecs?: number;
    bh12MSecs?: number;
    dh1DSecs?: number;
    dh7DSecs?: number;
    dh14DSecs?: number;
    dh28DSecs?: number;
    dh1MSecs?: number;
    dh1YSecs?: number;
    staDate?: Date;
    stdDate?: Date;
    fdp: number;
    dutyPeriodFromDate?: Date;
    dutyPeriodToDate?: Date;
    training?: string;
    checkerTrainee?: string;
    special?: string;
    simInstructorRequirements?: InstructorRequirements;
    simLocation?: string;
    simAirport?: string;
    checkInDateTimeUtc?: Date;
    checkOutDateTimeUtc?: Date;
    mfdp?: number;
    has334C: boolean;
    has345C: boolean;
}

export interface ICrewDutyListReportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}
export class CrewDutyListReportModelDataSourceLoadOptions extends BaseApiModelClass< ICrewDutyListReportModelDataSourceLoadOptions > implements ICrewDutyListReportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}

export enum CrewFunctionType {
    Cabin = "Cabin",
    Cc = "Cc",
    Cockpit = "Cockpit",
    Ffx = "Ffx",
    Fo = "Fo",
    Fse = "Fse",
    Marshal = "Marshal",
    Pic = "Pic",
    Sc = "Sc",
    Tig = "Tig",
}

export interface ICrewItem {
    activityRcd: string;
    personId?: string;
    personCode: string;
    personFirstName?: string;
    personLastName?: string;
    functionName: string;
}
export class CrewItem extends BaseApiModelClass< ICrewItem > implements ICrewItem {
    activityRcd: string;
    personId?: string;
    personCode: string;
    personFirstName?: string;
    personLastName?: string;
    functionName: string;
}

export interface ICrewNotificationTimeReportFilter {
    rowLimit?: number;
    date: Date;
}
export class CrewNotificationTimeReportFilter extends BaseApiModelClass< ICrewNotificationTimeReportFilter > implements ICrewNotificationTimeReportFilter {
    rowLimit?: number;
    date: Date;
}

export interface ICrewNotificationTimeReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    personId: string;
    personCode: string;
    personName: string;
    personFunction: string;
    date: Date;
    duty: string;
    checkInTimeUtc: Date;
    changedAtTimeUtc: Date;
    differenceMins: number;
}
export class CrewNotificationTimeReportModel extends BaseApiModelClass< ICrewNotificationTimeReportModel > implements ICrewNotificationTimeReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    personId: string;
    personCode: string;
    personName: string;
    personFunction: string;
    date: Date;
    duty: string;
    checkInTimeUtc: Date;
    changedAtTimeUtc: Date;
    differenceMins: number;
}

export interface ICrewNotificationTimeReportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}
export class CrewNotificationTimeReportModelDataSourceLoadOptions extends BaseApiModelClass< ICrewNotificationTimeReportModelDataSourceLoadOptions > implements ICrewNotificationTimeReportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}

export enum CrewType {
    Cabin = "Cabin",
    Cockpit = "Cockpit",
    Full = "Full",
}

export interface ICronValidationResult {
    isValid: boolean;
    validationErrorMessage?: string;
    expressionSummary?: string;
    nextInvalidTime?: Date;
}
export class CronValidationResult extends BaseApiModelClass< ICronValidationResult > implements ICronValidationResult {
    isValid: boolean;
    validationErrorMessage?: string;
    expressionSummary?: string;
    nextInvalidTime?: Date;
}

export interface ICustomPersonManagementDialogModel {
    id?: string;
    functionId: string;
    firstName?: string;
    lastName?: string;
    birthDate: Date;
    sex: Gender;
    passportNumber?: string;
    passportExpirationDate: Date;
    dateFrom: Date;
    dateTo?: Date;
    nationality?: string;
}
export class CustomPersonManagementDialogModel extends BaseApiModelClass< ICustomPersonManagementDialogModel > implements ICustomPersonManagementDialogModel {
    id?: string;
    functionId: string;
    firstName?: string;
    lastName?: string;
    birthDate: Date;
    sex: Gender;
    passportNumber?: string;
    passportExpirationDate: Date;
    dateFrom: Date;
    dateTo?: Date;
    nationality?: string;
}

export interface ICustomPersonManagementFilter {
    rowLimit?: number;
    functionId?: string;
    personId?: string;
}
export class CustomPersonManagementFilter extends BaseApiModelClass< ICustomPersonManagementFilter > implements ICustomPersonManagementFilter {
    rowLimit?: number;
    functionId?: string;
    personId?: string;
}

export interface ICustomPersonManagementModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    id: string;
    functionId: string;
    functionName: string;
    code: string;
    firstName?: string;
    lastName?: string;
    birthdate: Date;
    sex: Gender;
    passportNumber?: string;
    passportExpirationDate: Date;
    dateFrom: Date;
    dateTo?: Date;
    nationality?: string;
    email?: string;
}
export class CustomPersonManagementModel extends BaseApiModelClass< ICustomPersonManagementModel > implements ICustomPersonManagementModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    id: string;
    functionId: string;
    functionName: string;
    code: string;
    firstName?: string;
    lastName?: string;
    birthdate: Date;
    sex: Gender;
    passportNumber?: string;
    passportExpirationDate: Date;
    dateFrom: Date;
    dateTo?: Date;
    nationality?: string;
    email?: string;
}

export interface ICustomPersonManagementModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}
export class CustomPersonManagementModelDataSourceLoadOptions extends BaseApiModelClass< ICustomPersonManagementModelDataSourceLoadOptions > implements ICustomPersonManagementModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}

export enum DailyDutyFiguresType {
    Full = "Full",
    Short = "Short",
}

export interface IDateTimeModel {
    date?: Date;
}
export class DateTimeModel extends BaseApiModelClass< IDateTimeModel > implements IDateTimeModel {
    date?: Date;
}

export interface IDatesRange {
    dateFrom: Date;
    dateTo: Date;
    days: number;
}
export class DatesRange extends BaseApiModelClass< IDatesRange > implements IDatesRange {
    dateFrom: Date;
    dateTo: Date;
    readonly days: number;
}

export interface IDayCommentCreateDto {
    text: string;
    isStandby: boolean;
    isVisibleByCrewMember: boolean;
    isVisibleToAllUsers: boolean;
    personId: string;
    date: Date;
}
export class DayCommentCreateDto extends BaseApiModelClass< IDayCommentCreateDto > implements IDayCommentCreateDto {
    text: string;
    isStandby: boolean;
    isVisibleByCrewMember: boolean;
    isVisibleToAllUsers: boolean;
    personId: string;
    date: Date;
}

export interface IDayCommentReadDto {
    text: string;
    isStandby: boolean;
    isVisibleByCrewMember: boolean;
    isVisibleToAllUsers: boolean;
    personId: string;
    id: string;
    date: Date;
    category?: CommentCategory;
    modifiedAtDateUtc?: Date;
    modifiedBy: string;
    createdAtDateUtc?: Date;
    createdBy: string;
}
export class DayCommentReadDto extends BaseApiModelClass< IDayCommentReadDto > implements IDayCommentReadDto {
    text: string;
    isStandby: boolean;
    isVisibleByCrewMember: boolean;
    isVisibleToAllUsers: boolean;
    personId: string;
    id: string;
    date: Date;
    category?: CommentCategory;
    modifiedAtDateUtc?: Date;
    modifiedBy: string;
    createdAtDateUtc?: Date;
    createdBy: string;
}

export interface IDayCommentUpdateDto {
    text: string;
    isStandby: boolean;
    isVisibleByCrewMember: boolean;
    isVisibleToAllUsers: boolean;
    id?: string;
}
export class DayCommentUpdateDto extends BaseApiModelClass< IDayCommentUpdateDto > implements IDayCommentUpdateDto {
    text: string;
    isStandby: boolean;
    isVisibleByCrewMember: boolean;
    isVisibleToAllUsers: boolean;
    id?: string;
}

export interface IDaysManualCorrectionModel {
    id: string;
    days: number;
    reason?: string;
    yearId: string;
}
export class DaysManualCorrectionModel extends BaseApiModelClass< IDaysManualCorrectionModel > implements IDaysManualCorrectionModel {
    id: string;
    days: number;
    reason?: string;
    yearId: string;
}

export interface IDeadletterInfoModel {
    id: string;
    label: MessageLabel;
    messageBody: string;
    error: string;
}
export class DeadletterInfoModel extends BaseApiModelClass< IDeadletterInfoModel > implements IDeadletterInfoModel {
    id: string;
    label: MessageLabel;
    messageBody: string;
    error: string;
}

export interface IDevExtremeEmailViewerGridData {
    data?: DevExtremeEmailViewerItemData[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeEmailViewerGridData extends BaseApiModelClass< IDevExtremeEmailViewerGridData > implements IDevExtremeEmailViewerGridData {
    data?: DevExtremeEmailViewerItemData[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeEmailViewerItemData {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    id: string;
    createdDate: Date;
    sentDate?: Date;
    from: string;
    to: string;
    subject: string;
    bodyContentType?: string;
    cc?: string;
    bcc?: string;
    type?: MailQueueType;
    label?: string;
    status: MailQueueStatus;
    hasAttachments: boolean;
    errorMessage?: string;
}
export class DevExtremeEmailViewerItemData extends BaseApiModelClass< IDevExtremeEmailViewerItemData > implements IDevExtremeEmailViewerItemData {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    id: string;
    createdDate: Date;
    sentDate?: Date;
    from: string;
    to: string;
    subject: string;
    bodyContentType?: string;
    cc?: string;
    bcc?: string;
    type?: MailQueueType;
    label?: string;
    status: MailQueueStatus;
    hasAttachments: boolean;
    errorMessage?: string;
}

export interface IDevExtremeEmailViewerItemDataDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}
export class DevExtremeEmailViewerItemDataDataSourceLoadOptions extends BaseApiModelClass< IDevExtremeEmailViewerItemDataDataSourceLoadOptions > implements IDevExtremeEmailViewerItemDataDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}

export interface IDevExtremeResponseAircraftTypeRecencyCockpitReportModel {
    data?: AircraftTypeRecencyCockpitReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeResponseAircraftTypeRecencyCockpitReportModel extends BaseApiModelClass< IDevExtremeResponseAircraftTypeRecencyCockpitReportModel > implements IDevExtremeResponseAircraftTypeRecencyCockpitReportModel {
    data?: AircraftTypeRecencyCockpitReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeResponseAircraftTypeRecencyReportModel {
    data?: AircraftTypeRecencyReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeResponseAircraftTypeRecencyReportModel extends BaseApiModelClass< IDevExtremeResponseAircraftTypeRecencyReportModel > implements IDevExtremeResponseAircraftTypeRecencyReportModel {
    data?: AircraftTypeRecencyReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeResponseAirportRecencyReportModel {
    data?: AirportRecencyReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeResponseAirportRecencyReportModel extends BaseApiModelClass< IDevExtremeResponseAirportRecencyReportModel > implements IDevExtremeResponseAirportRecencyReportModel {
    data?: AirportRecencyReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeResponseAreaRouteCompetenceReportModel {
    data?: AreaRouteCompetenceReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeResponseAreaRouteCompetenceReportModel extends BaseApiModelClass< IDevExtremeResponseAreaRouteCompetenceReportModel > implements IDevExtremeResponseAreaRouteCompetenceReportModel {
    data?: AreaRouteCompetenceReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeResponseAreaRouteCompetenceRulesReportModel {
    data?: AreaRouteCompetenceRulesReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeResponseAreaRouteCompetenceRulesReportModel extends BaseApiModelClass< IDevExtremeResponseAreaRouteCompetenceRulesReportModel > implements IDevExtremeResponseAreaRouteCompetenceRulesReportModel {
    data?: AreaRouteCompetenceRulesReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeResponseCabinCrewAttestationModel {
    data?: CabinCrewAttestationModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeResponseCabinCrewAttestationModel extends BaseApiModelClass< IDevExtremeResponseCabinCrewAttestationModel > implements IDevExtremeResponseCabinCrewAttestationModel {
    data?: CabinCrewAttestationModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeResponseChangeLogModel {
    data?: ChangeLogReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeResponseChangeLogModel extends BaseApiModelClass< IDevExtremeResponseChangeLogModel > implements IDevExtremeResponseChangeLogModel {
    data?: ChangeLogReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeResponseCommentReportModel {
    data?: CommentReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeResponseCommentReportModel extends BaseApiModelClass< IDevExtremeResponseCommentReportModel > implements IDevExtremeResponseCommentReportModel {
    data?: CommentReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeResponseCourseManagementModel {
    data?: CourseManagementModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeResponseCourseManagementModel extends BaseApiModelClass< IDevExtremeResponseCourseManagementModel > implements IDevExtremeResponseCourseManagementModel {
    data?: CourseManagementModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeResponseCrewApiConfigReportModel {
    data?: CrewApiConfigReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeResponseCrewApiConfigReportModel extends BaseApiModelClass< IDevExtremeResponseCrewApiConfigReportModel > implements IDevExtremeResponseCrewApiConfigReportModel {
    data?: CrewApiConfigReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeResponseCrewDutyListReportModel {
    data?: CrewDutyListReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeResponseCrewDutyListReportModel extends BaseApiModelClass< IDevExtremeResponseCrewDutyListReportModel > implements IDevExtremeResponseCrewDutyListReportModel {
    data?: CrewDutyListReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeResponseCrewNotificationTimeReportModel {
    data?: CrewNotificationTimeReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeResponseCrewNotificationTimeReportModel extends BaseApiModelClass< IDevExtremeResponseCrewNotificationTimeReportModel > implements IDevExtremeResponseCrewNotificationTimeReportModel {
    data?: CrewNotificationTimeReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeResponseCustomPersonManagementModel {
    data?: CustomPersonManagementModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeResponseCustomPersonManagementModel extends BaseApiModelClass< IDevExtremeResponseCustomPersonManagementModel > implements IDevExtremeResponseCustomPersonManagementModel {
    data?: CustomPersonManagementModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeResponseDooxReportModel {
    data?: DooxReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeResponseDooxReportModel extends BaseApiModelClass< IDevExtremeResponseDooxReportModel > implements IDevExtremeResponseDooxReportModel {
    data?: DooxReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeResponseDutyHomeStudyItem {
    data?: DutyHomeStudyItem[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeResponseDutyHomeStudyItem extends BaseApiModelClass< IDevExtremeResponseDutyHomeStudyItem > implements IDevExtremeResponseDutyHomeStudyItem {
    data?: DutyHomeStudyItem[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeResponseErrorReportModel {
    data?: ErrorReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeResponseErrorReportModel extends BaseApiModelClass< IDevExtremeResponseErrorReportModel > implements IDevExtremeResponseErrorReportModel {
    data?: ErrorReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeResponseExperienceReportModel {
    data?: ExperienceReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeResponseExperienceReportModel extends BaseApiModelClass< IDevExtremeResponseExperienceReportModel > implements IDevExtremeResponseExperienceReportModel {
    data?: ExperienceReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeResponseGenDecConfigReportModel {
    data?: GenDecConfigReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeResponseGenDecConfigReportModel extends BaseApiModelClass< IDevExtremeResponseGenDecConfigReportModel > implements IDevExtremeResponseGenDecConfigReportModel {
    data?: GenDecConfigReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeResponseInstructorFilterModel {
    data?: InstructorFilterDialogModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeResponseInstructorFilterModel extends BaseApiModelClass< IDevExtremeResponseInstructorFilterModel > implements IDevExtremeResponseInstructorFilterModel {
    data?: InstructorFilterDialogModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeResponseLicenseManagementModel {
    data?: LicenseManagementModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeResponseLicenseManagementModel extends BaseApiModelClass< IDevExtremeResponseLicenseManagementModel > implements IDevExtremeResponseLicenseManagementModel {
    data?: LicenseManagementModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeResponseLocationHotelBookingModel {
    data?: LocationHotelBookingModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeResponseLocationHotelBookingModel extends BaseApiModelClass< IDevExtremeResponseLocationHotelBookingModel > implements IDevExtremeResponseLocationHotelBookingModel {
    data?: LocationHotelBookingModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeResponseMedicalLicenseReportModel {
    data?: MedicalLicenseReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeResponseMedicalLicenseReportModel extends BaseApiModelClass< IDevExtremeResponseMedicalLicenseReportModel > implements IDevExtremeResponseMedicalLicenseReportModel {
    data?: MedicalLicenseReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeResponseOffDaysReportModel {
    data?: OffDaysReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeResponseOffDaysReportModel extends BaseApiModelClass< IDevExtremeResponseOffDaysReportModel > implements IDevExtremeResponseOffDaysReportModel {
    data?: OffDaysReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeResponsePersonDosimetryReportModel {
    data?: PersonDosimetryReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeResponsePersonDosimetryReportModel extends BaseApiModelClass< IDevExtremeResponsePersonDosimetryReportModel > implements IDevExtremeResponsePersonDosimetryReportModel {
    data?: PersonDosimetryReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeResponsePersonHotelBookingDetailModel {
    data?: PersonHotelBookingDetailModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeResponsePersonHotelBookingDetailModel extends BaseApiModelClass< IDevExtremeResponsePersonHotelBookingDetailModel > implements IDevExtremeResponsePersonHotelBookingDetailModel {
    data?: PersonHotelBookingDetailModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeResponsePersonInfoModel {
    data?: PersonInfoModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeResponsePersonInfoModel extends BaseApiModelClass< IDevExtremeResponsePersonInfoModel > implements IDevExtremeResponsePersonInfoModel {
    data?: PersonInfoModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeResponsePersonVacDetailsModel {
    data?: PersonVacDetailsModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeResponsePersonVacDetailsModel extends BaseApiModelClass< IDevExtremeResponsePersonVacDetailsModel > implements IDevExtremeResponsePersonVacDetailsModel {
    data?: PersonVacDetailsModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeResponsePlannedTrainingReportModel {
    data?: PlannedTrainingReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeResponsePlannedTrainingReportModel extends BaseApiModelClass< IDevExtremeResponsePlannedTrainingReportModel > implements IDevExtremeResponsePlannedTrainingReportModel {
    data?: PlannedTrainingReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeResponsePreReservationLocationsModel {
    data?: PreReservationLocationsModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeResponsePreReservationLocationsModel extends BaseApiModelClass< IDevExtremeResponsePreReservationLocationsModel > implements IDevExtremeResponsePreReservationLocationsModel {
    data?: PreReservationLocationsModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeResponseRecurrentTrainingReportModel {
    data?: RecurrentTrainingReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeResponseRecurrentTrainingReportModel extends BaseApiModelClass< IDevExtremeResponseRecurrentTrainingReportModel > implements IDevExtremeResponseRecurrentTrainingReportModel {
    data?: RecurrentTrainingReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeResponseReserveBlocksModel {
    data?: ReserveBlockDTO[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeResponseReserveBlocksModel extends BaseApiModelClass< IDevExtremeResponseReserveBlocksModel > implements IDevExtremeResponseReserveBlocksModel {
    data?: ReserveBlockDTO[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeResponseReserveRequestReportModel {
    data?: ReserveRequestReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeResponseReserveRequestReportModel extends BaseApiModelClass< IDevExtremeResponseReserveRequestReportModel > implements IDevExtremeResponseReserveRequestReportModel {
    data?: ReserveRequestReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeResponseRosterImportDetailsModel {
    data?: RosterImportErrorMessageModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeResponseRosterImportDetailsModel extends BaseApiModelClass< IDevExtremeResponseRosterImportDetailsModel > implements IDevExtremeResponseRosterImportDetailsModel {
    data?: RosterImportErrorMessageModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeResponseRosterImportModel {
    data?: RosterImportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeResponseRosterImportModel extends BaseApiModelClass< IDevExtremeResponseRosterImportModel > implements IDevExtremeResponseRosterImportModel {
    data?: RosterImportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeResponseSectorsReportModel {
    data?: SectorsReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeResponseSectorsReportModel extends BaseApiModelClass< IDevExtremeResponseSectorsReportModel > implements IDevExtremeResponseSectorsReportModel {
    data?: SectorsReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeResponseSeniorityReportModel {
    data?: SeniorityReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeResponseSeniorityReportModel extends BaseApiModelClass< IDevExtremeResponseSeniorityReportModel > implements IDevExtremeResponseSeniorityReportModel {
    data?: SeniorityReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeResponseSimulationReportModel {
    data?: SimulationReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeResponseSimulationReportModel extends BaseApiModelClass< IDevExtremeResponseSimulationReportModel > implements IDevExtremeResponseSimulationReportModel {
    data?: SimulationReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeResponseSimulatorLicenseStatusReportModel {
    data?: SimulatorLicenseStatusReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeResponseSimulatorLicenseStatusReportModel extends BaseApiModelClass< IDevExtremeResponseSimulatorLicenseStatusReportModel > implements IDevExtremeResponseSimulatorLicenseStatusReportModel {
    data?: SimulatorLicenseStatusReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeResponseStandbyReportModel {
    data?: StandbyReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeResponseStandbyReportModel extends BaseApiModelClass< IDevExtremeResponseStandbyReportModel > implements IDevExtremeResponseStandbyReportModel {
    data?: StandbyReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeResponseTradeUnionExportModel {
    data?: TradeUnionExportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeResponseTradeUnionExportModel extends BaseApiModelClass< IDevExtremeResponseTradeUnionExportModel > implements IDevExtremeResponseTradeUnionExportModel {
    data?: TradeUnionExportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeResponseTzvYearOverviewModel {
    data?: TzvYearOverviewModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeResponseTzvYearOverviewModel extends BaseApiModelClass< IDevExtremeResponseTzvYearOverviewModel > implements IDevExtremeResponseTzvYearOverviewModel {
    data?: TzvYearOverviewModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeResponseVacRequestReportModel {
    data?: VacRequestReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeResponseVacRequestReportModel extends BaseApiModelClass< IDevExtremeResponseVacRequestReportModel > implements IDevExtremeResponseVacRequestReportModel {
    data?: VacRequestReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export interface IDevExtremeResponseXStarMonitoringReportModel {
    data?: XStarMonitoringReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}
export class DevExtremeResponseXStarMonitoringReportModel extends BaseApiModelClass< IDevExtremeResponseXStarMonitoringReportModel > implements IDevExtremeResponseXStarMonitoringReportModel {
    data?: XStarMonitoringReportModel[];
    rowNumber: number;
    queryHasInvalidEntries: boolean;
    totalCount: number;
    summary?: any[];
    groupCount: number;
}

export enum DirectionType {
    DeadletterToInbox = "DeadletterToInbox",
    In = "In",
    Out = "Out",
}

export interface IDisruptiveScheduleModel {
    isDisruptive: boolean;
    isEarlyStart: boolean;
    isLateFinish: boolean;
    isNightDuty: boolean;
}
export class DisruptiveScheduleModel extends BaseApiModelClass< IDisruptiveScheduleModel > implements IDisruptiveScheduleModel {
    isDisruptive: boolean;
    isEarlyStart: boolean;
    isLateFinish: boolean;
    isNightDuty: boolean;
}

export enum DooType {
    DOOF = "DOOF",
    DOOO = "DOOO",
    DOOO1 = "DOOO1",
    DOOO2 = "DOOO2",
    DOOT = "DOOT",
    DOOU = "DOOU",
    DOOV = "DOOV",
    None = "None",
}

export interface IDooxReportFilter {
    rowLimit?: number;
    dateFrom: Date;
    dateTo: Date;
    functionId?: string;
}
export class DooxReportFilter extends BaseApiModelClass< IDooxReportFilter > implements IDooxReportFilter {
    rowLimit?: number;
    dateFrom: Date;
    dateTo: Date;
    functionId?: string;
}

export interface IDooxReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    personId: string;
    personCode: string;
    personName?: string;
    personRank: number;
    date: Date;
    dooxType: DooType;
    personFunction?: string;
    comment?: string;
}
export class DooxReportModel extends BaseApiModelClass< IDooxReportModel > implements IDooxReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    personId: string;
    personCode: string;
    personName?: string;
    personRank: number;
    date: Date;
    dooxType: DooType;
    personFunction?: string;
    comment?: string;
}

export interface IDooxReportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}
export class DooxReportModelDataSourceLoadOptions extends BaseApiModelClass< IDooxReportModelDataSourceLoadOptions > implements IDooxReportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}

export interface IDutiesBlockModel {
    personId: string;
    fromDate: Date;
    toDate: Date;
    daysCount: number;
    activity: string;
    vacationType?: VacationType;
    hasVacRequestId: boolean;
    monthNumber: number;
}
export class DutiesBlockModel extends BaseApiModelClass< IDutiesBlockModel > implements IDutiesBlockModel {
    personId: string;
    fromDate: Date;
    toDate: Date;
    daysCount: number;
    activity: string;
    vacationType?: VacationType;
    hasVacRequestId: boolean;
    readonly monthNumber: number;
}

export interface IDutiesBlocksGroupedByMonthModel {
    blocks: DutiesBlockModel[];
    monthValue: number;
    totalDays: number;
    monthTitle: string;
}
export class DutiesBlocksGroupedByMonthModel extends BaseApiModelClass< IDutiesBlocksGroupedByMonthModel > implements IDutiesBlocksGroupedByMonthModel {
    blocks: DutiesBlockModel[];
    monthValue: number;
    totalDays: number;
    readonly monthTitle: string;
}

export interface IDutyBlockHoursModel {
    dutyBlockHours28Days: number;
    dutyBlockHours28DaysLimit: number;
    dutyBlockHours12Month: number;
    dutyBlockHours12MonthLimit: number;
    dutyBlockHours1Year: number;
    dutyBlockHours1YearLimit: number;
    blockHours1Day: number;
    blockHoursTotalSec: number;
}
export class DutyBlockHoursModel extends BaseApiModelClass< IDutyBlockHoursModel > implements IDutyBlockHoursModel {
    dutyBlockHours28Days: number;
    dutyBlockHours28DaysLimit: number;
    dutyBlockHours12Month: number;
    dutyBlockHours12MonthLimit: number;
    dutyBlockHours1Year: number;
    dutyBlockHours1YearLimit: number;
    blockHours1Day: number;
    blockHoursTotalSec: number;
}

export interface IDutyCellModel {
    personId: string;
    date: Date;
}
export class DutyCellModel extends BaseApiModelClass< IDutyCellModel > implements IDutyCellModel {
    personId: string;
    date: Date;
}

export interface IDutyChangeRegion {
    personId: string;
    dateFrom: Date;
    dateTo: Date;
    days: Date[];
    hasDutyChanges: boolean;
}
export class DutyChangeRegion extends BaseApiModelClass< IDutyChangeRegion > implements IDutyChangeRegion {
    personId: string;
    dateFrom: Date;
    dateTo: Date;
    days: Date[];
    hasDutyChanges: boolean;
}

export interface IDutyChangeRegions {
    regions: DutyChangeRegion[];
    daysCount: number;
}
export class DutyChangeRegions extends BaseApiModelClass< IDutyChangeRegions > implements IDutyChangeRegions {
    readonly regions: DutyChangeRegion[];
    readonly daysCount: number;
}

export interface IDutyCheckerTraineeDetailsModel {
    id: string;
    date: Date;
    flightId?: string;
    flightNumber?: number;
    flightIsLongHaul: boolean;
    flightDepartureDateTimeUtc?: Date;
    checkerPersonId?: string;
    checkerPersonCodeName?: string;
    checkerPersonDisplayName?: string;
    traineePersonId?: string;
    traineePersonCodeName?: string;
    traineePersonDisplayName?: string;
    traineePersonFunctionName?: string;
    function: CheckerTraineeFunction;
    instructorRequirements?: InstructorRequirements;
    functionDisplayName: string;
    trainingNumber?: number;
    traineeActivityId?: string;
    flightAircraftTypeGroup?: string;
    activityRcd: string;
}
export class DutyCheckerTraineeDetailsModel extends BaseApiModelClass< IDutyCheckerTraineeDetailsModel > implements IDutyCheckerTraineeDetailsModel {
    id: string;
    date: Date;
    flightId?: string;
    flightNumber?: number;
    flightIsLongHaul: boolean;
    flightDepartureDateTimeUtc?: Date;
    checkerPersonId?: string;
    checkerPersonCodeName?: string;
    checkerPersonDisplayName?: string;
    traineePersonId?: string;
    traineePersonCodeName?: string;
    traineePersonDisplayName?: string;
    traineePersonFunctionName?: string;
    function: CheckerTraineeFunction;
    instructorRequirements?: InstructorRequirements;
    functionDisplayName: string;
    trainingNumber?: number;
    traineeActivityId?: string;
    flightAircraftTypeGroup?: string;
    activityRcd: string;
}

export interface IDutyCheckerTraineeModel {
    checkerPersonId?: string;
    traineePersonId?: string;
    flightIds?: string[];
    rotationId?: string;
    function: CheckerTraineeFunction;
    instructorRequirements?: InstructorRequirements;
    date: Date;
}
export class DutyCheckerTraineeModel extends BaseApiModelClass< IDutyCheckerTraineeModel > implements IDutyCheckerTraineeModel {
    checkerPersonId?: string;
    traineePersonId?: string;
    flightIds?: string[];
    rotationId?: string;
    function: CheckerTraineeFunction;
    instructorRequirements?: InstructorRequirements;
    date: Date;
}

export interface IDutyCheckerTraineeSetResult {
    operationId: string;
    relationships: DutyCheckerTraineeDetailsModel[];
    affectedPersonIds?: string[];
}
export class DutyCheckerTraineeSetResult extends BaseApiModelClass< IDutyCheckerTraineeSetResult > implements IDutyCheckerTraineeSetResult {
    operationId: string;
    relationships: DutyCheckerTraineeDetailsModel[];
    affectedPersonIds?: string[];
}

export interface IDutyCheckerTraineeUpdateItem {
    id: string;
    checkerPersonId?: string;
    traineePersonId?: string;
    function: CheckerTraineeFunction;
    instructorRequirements?: InstructorRequirements;
}
export class DutyCheckerTraineeUpdateItem extends BaseApiModelClass< IDutyCheckerTraineeUpdateItem > implements IDutyCheckerTraineeUpdateItem {
    id: string;
    checkerPersonId?: string;
    traineePersonId?: string;
    function: CheckerTraineeFunction;
    instructorRequirements?: InstructorRequirements;
}

export interface IDutyCheckerTraineeUpdateModel {
    relationships?: DutyCheckerTraineeUpdateItem[];
    rotationId?: string;
}
export class DutyCheckerTraineeUpdateModel extends BaseApiModelClass< IDutyCheckerTraineeUpdateModel > implements IDutyCheckerTraineeUpdateModel {
    relationships?: DutyCheckerTraineeUpdateItem[];
    rotationId?: string;
}

export interface IDutyCommentDto {
    personId: string;
    date: Date;
    text: string;
}
export class DutyCommentDto extends BaseApiModelClass< IDutyCommentDto > implements IDutyCommentDto {
    personId: string;
    date: Date;
    text: string;
}

export interface IDutyCreateModel {
    overrideAllowed: boolean;
    comment?: string;
    commentIdsToDelete: string[];
    swapType?: PersonDutySwapType;
    ltoRequestComment?: string;
    stoRequestComment?: string;
    flightRequestComment?: string;
    doNotRevertPoints: boolean;
    title?: string;
    date?: Date;
    dateTimeFromLt?: Date;
    dateTimeToLt?: Date;
    dutyTimeSec?: number;
    dateTimeFromDiffToLt?: string;
    dateTimeToDiffToLt?: string;
    blockTimeSec: number;
    activityCodeName: string;
    selectedCells: DutyCellModel[];
    rotationIds?: string[];
    flightIds?: string[];
    keepFlightIds?: string[];
    doNotAllowToOverride: boolean;
    resOffAllowed: boolean;
    simCourseMultiPositionOverride: boolean;
    suppressCommentsWarning: boolean;
    keepDutyCommentForSameDuty?: boolean;
    isControlPressed: boolean;
    isShiftPressed: boolean;
    forceSetFlags: boolean;
    keepOriginalAuthor: boolean;
    needToDelete: boolean;
    activityType?: VacationType;
    requestId?: string;
    isFullDayOverride: boolean;
    keepExistingDuties: boolean;
    posDutyData?: PosDutyData;
    simDutyData?: SimDutyData;
    swapDutyData?: SwapDutyData;
    copyDutyData?: CopyDutyData;
    requestDutyData?: RequestDutyData;
    allowedToOverrideActivities?: string[];
    preventUpdateForExistingActivity?: boolean;
    introFlightFlag: boolean;
    observerFlightFlag: boolean;
}
export class DutyCreateModel extends BaseApiModelClass< IDutyCreateModel > implements IDutyCreateModel {
    overrideAllowed: boolean;
    comment?: string;
    commentIdsToDelete: string[];
    swapType?: PersonDutySwapType;
    ltoRequestComment?: string;
    stoRequestComment?: string;
    flightRequestComment?: string;
    doNotRevertPoints: boolean;
    title?: string;
    date?: Date;
    dateTimeFromLt?: Date;
    dateTimeToLt?: Date;
    dutyTimeSec?: number;
    dateTimeFromDiffToLt?: string;
    dateTimeToDiffToLt?: string;
    blockTimeSec: number;
    activityCodeName: string;
    selectedCells: DutyCellModel[];
    rotationIds?: string[];
    flightIds?: string[];
    keepFlightIds?: string[];
    doNotAllowToOverride: boolean;
    resOffAllowed: boolean;
    simCourseMultiPositionOverride: boolean;
    suppressCommentsWarning: boolean;
    keepDutyCommentForSameDuty?: boolean;
    isControlPressed: boolean;
    isShiftPressed: boolean;
    forceSetFlags: boolean;
    keepOriginalAuthor: boolean;
    needToDelete: boolean;
    activityType?: VacationType;
    requestId?: string;
    isFullDayOverride: boolean;
    keepExistingDuties: boolean;
    posDutyData?: PosDutyData;
    simDutyData?: SimDutyData;
    swapDutyData?: SwapDutyData;
    copyDutyData?: CopyDutyData;
    requestDutyData?: RequestDutyData;
    allowedToOverrideActivities?: string[];
    preventUpdateForExistingActivity?: boolean;
    introFlightFlag: boolean;
    observerFlightFlag: boolean;
}

export interface IDutyDeleteResult {
    operationId: string;
}
export class DutyDeleteResult extends BaseApiModelClass< IDutyDeleteResult > implements IDutyDeleteResult {
    operationId: string;
}

export interface IDutyDescriptionDto {
    id: string;
    date: Date;
    codeName: string;
    briefInfo?: string;
    customTitle?: string;
    flightId?: string;
    title?: string;
    dateTimeFromUtc?: Date;
    dateTimeFromDiffToLt?: string;
    dateTimeToUtc?: Date;
    dateTimeToDiffToLt?: string;
    positioningId?: string;
    vacationType?: string;
    sim?: SimulationBriefInfo;
    activityType: ActivityType;
    flag?: DutyFlag;
}
export class DutyDescriptionDto extends BaseApiModelClass< IDutyDescriptionDto > implements IDutyDescriptionDto {
    id: string;
    date: Date;
    codeName: string;
    briefInfo?: string;
    customTitle?: string;
    flightId?: string;
    title?: string;
    dateTimeFromUtc?: Date;
    dateTimeFromDiffToLt?: string;
    dateTimeToUtc?: Date;
    dateTimeToDiffToLt?: string;
    positioningId?: string;
    vacationType?: string;
    sim?: SimulationBriefInfo;
    activityType: ActivityType;
    flag?: DutyFlag;
}

export interface IDutyFilter {
    date: Date;
    activityIds: string[];
    flightIds: string[];
    flags: string[];
    errorTypes: MonthlyType[];
}
export class DutyFilter extends BaseApiModelClass< IDutyFilter > implements IDutyFilter {
    date: Date;
    activityIds: string[];
    flightIds: string[];
    flags: string[];
    errorTypes: MonthlyType[];
}

export interface IDutyFilterItem {
    id: string;
    title: string;
    isFlight: boolean;
    isLongHaul: boolean;
    isError: boolean;
    isFlag: boolean;
}
export class DutyFilterItem extends BaseApiModelClass< IDutyFilterItem > implements IDutyFilterItem {
    id: string;
    title: string;
    isFlight: boolean;
    isLongHaul: boolean;
    isError: boolean;
    isFlag: boolean;
}

export enum DutyFlag {
    FlightShiftedNextDay = "FlightShiftedNextDay",
    FlightShiftedPrevDay = "FlightShiftedPrevDay",
    IntroFlight = "IntroFlight",
    IsLongHaulRelated = "IsLongHaulRelated",
    NoBreak = "NoBreak",
    None = "None",
    ObserverFlight = "ObserverFlight",
    Pikett = "Pikett",
}

export interface IDutyFlagItem {
    id: string;
    activityCodeName: string;
}
export class DutyFlagItem extends BaseApiModelClass< IDutyFlagItem > implements IDutyFlagItem {
    id: string;
    activityCodeName: string;
}

export interface IDutyHistoryFilter {
    rowLimit?: number;
    personId: string;
    dateFrom: Date;
    dateTo: Date;
}
export class DutyHistoryFilter extends BaseApiModelClass< IDutyHistoryFilter > implements IDutyHistoryFilter {
    rowLimit?: number;
    personId: string;
    dateFrom: Date;
    dateTo: Date;
}

export interface IDutyHistoryModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    date: Date;
    modifiedAtDate: Date;
    modifiedBy: string;
    newTitle: string;
    operationName: string;
    rotationKey: string;
    operationId: string;
    isChangeLogEnabled: boolean;
    isSystem: boolean;
    personDutySwapType?: PersonDutySwapType;
}
export class DutyHistoryModel extends BaseApiModelClass< IDutyHistoryModel > implements IDutyHistoryModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    date: Date;
    modifiedAtDate: Date;
    modifiedBy: string;
    newTitle: string;
    operationName: string;
    rotationKey: string;
    operationId: string;
    isChangeLogEnabled: boolean;
    isSystem: boolean;
    personDutySwapType?: PersonDutySwapType;
}

export interface IDutyHistoryModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}
export class DutyHistoryModelDataSourceLoadOptions extends BaseApiModelClass< IDutyHistoryModelDataSourceLoadOptions > implements IDutyHistoryModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}

export interface IDutyHomeStudyItem {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    dutyId: string;
    personId: string;
    personCode: string;
    personName?: string;
    personFunction?: string;
    personContract?: string;
    title?: string;
    date: Date;
    dutyTimeSec: number;
    duration: string;
    createDate: Date;
    createdBy: string;
}
export class DutyHomeStudyItem extends BaseApiModelClass< IDutyHomeStudyItem > implements IDutyHomeStudyItem {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    dutyId: string;
    personId: string;
    personCode: string;
    personName?: string;
    personFunction?: string;
    personContract?: string;
    title?: string;
    date: Date;
    dutyTimeSec: number;
    duration: string;
    createDate: Date;
    createdBy: string;
}

export interface IDutyHoursModel {
    dutyHours7Days: number;
    dutyHours7DaysLimit: number;
    dutyHours14Days: number;
    dutyHours14DaysLimit: number;
    dutyHours28Days: number;
    dutyHours28DaysLimit: number;
    dutyHours12Month: number;
    dutyHours12MonthLimit: number;
    dutyHours1Day: number;
}
export class DutyHoursModel extends BaseApiModelClass< IDutyHoursModel > implements IDutyHoursModel {
    dutyHours7Days: number;
    dutyHours7DaysLimit: number;
    dutyHours14Days: number;
    dutyHours14DaysLimit: number;
    dutyHours28Days: number;
    dutyHours28DaysLimit: number;
    dutyHours12Month: number;
    dutyHours12MonthLimit: number;
    dutyHours1Day: number;
}

export interface IDutyItem {
    personId: string;
    date: Date;
    activities: DutySubItem[];
    flagDutyList?: DutyFlagItem[];
    isValid: boolean;
    hasValidationErrors: boolean;
    hasTitle: boolean;
    hasFtlErrors: boolean;
    hasGavErrors: boolean;
    hasLteErrors: boolean;
    hasEasaErrors: boolean;
    hasAgreementErrors: boolean;
    hasOtherErrors: boolean;
    hasGroundWarnings: boolean;
    hasGroundErrors: boolean;
    isNotCountableOff: boolean;
    customTitle?: string;
    planningNote?: string;
    isAfterNightDuty: boolean;
    isBeforeNightDuty: boolean;
    isAfterLongTermEvening: boolean;
    isGav: boolean;
    isFtl: boolean;
    isWish: boolean;
    isPriority: boolean;
    isImportant: boolean;
    isFlex: boolean;
    isParty: boolean;
    checkinDateTimeUtc?: Date;
    checkoutDateTimeUtc?: Date;
    hasCustomCheckin: boolean;
    hasCustomCheckout: boolean;
    hasNoContract: boolean;
    hasAugmentedFlight: boolean;
    hasExtendedFlight: boolean;
    hasXStarFlight: boolean;
    hasLongHaulFlight: boolean;
    hasComment: boolean;
    shadowDutyType?: ShadowDutyType;
    shadowOffType?: ShadowOffType;
    isShadowOffOptional?: boolean;
    haveCapacity?: boolean;
    capacityTotal?: number;
    capacityRequested?: number;
    capacityUsed?: number;
    capacityLevel?: CapacityLevel;
    capacityLevelCockpit?: CapacityLevel;
    isFormerStandbyOrReserve: boolean;
    isChecker: boolean;
    isTrainee: boolean;
    isRsvHidden: boolean;
    isCrewHidden: boolean;
    isLoading: boolean;
    isPlan: boolean;
    requestedItemStatus?: string;
    requestedItemPriority?: string;
    requestedItemType?: string;
    requestedItemVacationType?: string;
    requestedItemIsAlternative: boolean;
    requestedItemColorizeType?: string;
    requestedItemVacationTypesCount: number;
    requestedFlightNumber?: string;
    requestedActivity?: string;
    hasCustomLanding: boolean;
    hasCustomTakeoff: boolean;
    dooType: DooType;
    fdpAmendmentType?: FdpAmendmentType;
    requestId?: string;
    timestampDateTimeUtc: Date;
    isPlanningPeriodHidden?: boolean;
    hasNotFullSuppressed?: boolean;
}
export class DutyItem extends BaseApiModelClass< IDutyItem > implements IDutyItem {
    personId: string;
    date: Date;
    activities: DutySubItem[];
    flagDutyList?: DutyFlagItem[];
    readonly isValid: boolean;
    hasValidationErrors: boolean;
    hasTitle: boolean;
    hasFtlErrors: boolean;
    hasGavErrors: boolean;
    hasLteErrors: boolean;
    hasEasaErrors: boolean;
    hasAgreementErrors: boolean;
    hasOtherErrors: boolean;
    hasGroundWarnings: boolean;
    hasGroundErrors: boolean;
    isNotCountableOff: boolean;
    customTitle?: string;
    planningNote?: string;
    isAfterNightDuty: boolean;
    isBeforeNightDuty: boolean;
    isAfterLongTermEvening: boolean;
    isGav: boolean;
    isFtl: boolean;
    isWish: boolean;
    isPriority: boolean;
    isImportant: boolean;
    isFlex: boolean;
    isParty: boolean;
    checkinDateTimeUtc?: Date;
    checkoutDateTimeUtc?: Date;
    hasCustomCheckin: boolean;
    hasCustomCheckout: boolean;
    hasNoContract: boolean;
    hasAugmentedFlight: boolean;
    hasExtendedFlight: boolean;
    hasXStarFlight: boolean;
    hasLongHaulFlight: boolean;
    hasComment: boolean;
    shadowDutyType?: ShadowDutyType;
    shadowOffType?: ShadowOffType;
    isShadowOffOptional?: boolean;
    haveCapacity?: boolean;
    capacityTotal?: number;
    capacityRequested?: number;
    capacityUsed?: number;
    capacityLevel?: CapacityLevel;
    capacityLevelCockpit?: CapacityLevel;
    isFormerStandbyOrReserve: boolean;
    isChecker: boolean;
    isTrainee: boolean;
    isRsvHidden: boolean;
    isCrewHidden: boolean;
    isLoading: boolean;
    isPlan: boolean;
    requestedItemStatus?: string;
    requestedItemPriority?: string;
    requestedItemType?: string;
    requestedItemVacationType?: string;
    requestedItemIsAlternative: boolean;
    requestedItemColorizeType?: string;
    requestedItemVacationTypesCount: number;
    requestedFlightNumber?: string;
    requestedActivity?: string;
    hasCustomLanding: boolean;
    hasCustomTakeoff: boolean;
    dooType: DooType;
    fdpAmendmentType?: FdpAmendmentType;
    requestId?: string;
    timestampDateTimeUtc: Date;
    isPlanningPeriodHidden?: boolean;
    hasNotFullSuppressed?: boolean;
}

export enum DutyLogType {
    Added = "Added",
    Modified = "Modified",
    Removed = "Removed",
}

export interface IDutyPartItem {
    id: string;
    periodFromLt: Date;
    periodToLt: Date;
    message?: string;
    noBreak: boolean;
    pikett: boolean;
}
export class DutyPartItem extends BaseApiModelClass< IDutyPartItem > implements IDutyPartItem {
    id: string;
    periodFromLt: Date;
    periodToLt: Date;
    message?: string;
    noBreak: boolean;
    pikett: boolean;
}

export interface IDutyPartUpdateRequest {
    items?: DutyPartItem[];
}
export class DutyPartUpdateRequest extends BaseApiModelClass< IDutyPartUpdateRequest > implements IDutyPartUpdateRequest {
    items?: DutyPartItem[];
}

export interface IDutyPersonActivity {
    date: Date;
    personId: string;
    personCode: string;
    flightId?: string;
    activityCodeName?: string;
    activityId: string;
    title?: string;
    vacationType?: VacationType;
    fdpExtensionType: FdpExtensionType;
    personFunction?: string;
}
export class DutyPersonActivity extends BaseApiModelClass< IDutyPersonActivity > implements IDutyPersonActivity {
    date: Date;
    personId: string;
    personCode: string;
    flightId?: string;
    activityCodeName?: string;
    activityId: string;
    title?: string;
    vacationType?: VacationType;
    fdpExtensionType: FdpExtensionType;
    personFunction?: string;
}

export interface IDutyPredefinedEditModel {
    functionId?: string;
    functionGroupId?: string;
    type: string;
    label: string;
    title: string;
    sortOrder: number;
    fromTimeSec: number;
    toTimeSec: number;
    dutyTimeSec: number;
}
export class DutyPredefinedEditModel extends BaseApiModelClass< IDutyPredefinedEditModel > implements IDutyPredefinedEditModel {
    functionId?: string;
    functionGroupId?: string;
    type: string;
    label: string;
    title: string;
    sortOrder: number;
    fromTimeSec: number;
    toTimeSec: number;
    dutyTimeSec: number;
}

export interface IDutyPredefinedModel {
    functionId?: string;
    functionGroupId?: string;
    type: string;
    label: string;
    title: string;
    sortOrder: number;
    fromTimeSec: number;
    toTimeSec: number;
    dutyTimeSec: number;
    id: string;
}
export class DutyPredefinedModel extends BaseApiModelClass< IDutyPredefinedModel > implements IDutyPredefinedModel {
    functionId?: string;
    functionGroupId?: string;
    type: string;
    label: string;
    title: string;
    sortOrder: number;
    fromTimeSec: number;
    toTimeSec: number;
    dutyTimeSec: number;
    id: string;
}

export interface IDutyRemoveModel {
    ids?: string[];
}
export class DutyRemoveModel extends BaseApiModelClass< IDutyRemoveModel > implements IDutyRemoveModel {
    ids?: string[];
}

export interface IDutyRestTimeDeltaErrorModel {
    error: string;
    errorType: string;
}
export class DutyRestTimeDeltaErrorModel extends BaseApiModelClass< IDutyRestTimeDeltaErrorModel > implements IDutyRestTimeDeltaErrorModel {
    error: string;
    errorType: string;
}

export interface IDutyRestTimeDeltaItemModel {
    key: string;
    flightIds: string[];
    deltaFromSecs?: number;
    deltaToSecs?: number;
    errors: DutyRestTimeDeltaErrorModel[];
}
export class DutyRestTimeDeltaItemModel extends BaseApiModelClass< IDutyRestTimeDeltaItemModel > implements IDutyRestTimeDeltaItemModel {
    key: string;
    flightIds: string[];
    deltaFromSecs?: number;
    deltaToSecs?: number;
    errors: DutyRestTimeDeltaErrorModel[];
}

export interface IDutyRestTimeDeltaModel {
    items: DutyRestTimeDeltaItemModel[];
    parallelCalculations: number;
}
export class DutyRestTimeDeltaModel extends BaseApiModelClass< IDutyRestTimeDeltaModel > implements IDutyRestTimeDeltaModel {
    items: DutyRestTimeDeltaItemModel[];
    parallelCalculations: number;
}

export interface IDutyRestTimeDeltaRequestItemModel {
    flightIds: string[];
    key: string;
}
export class DutyRestTimeDeltaRequestItemModel extends BaseApiModelClass< IDutyRestTimeDeltaRequestItemModel > implements IDutyRestTimeDeltaRequestItemModel {
    flightIds: string[];
    key: string;
}

export interface IDutyRestTimeDeltaRequestModel {
    items: DutyRestTimeDeltaRequestItemModel[];
    personId: string;
    isCockpit: boolean;
    date: Date;
    packSize?: number;
}
export class DutyRestTimeDeltaRequestModel extends BaseApiModelClass< IDutyRestTimeDeltaRequestModel > implements IDutyRestTimeDeltaRequestModel {
    items: DutyRestTimeDeltaRequestItemModel[];
    personId: string;
    isCockpit: boolean;
    date: Date;
    packSize?: number;
}

export interface IDutySubItem {
    id: string;
    title?: string;
    activityCodeName: string;
    flightId?: string;
    nextAircraftFlightId?: string;
    flightNumber?: number;
    rotationKey?: string;
    dateStartUtc?: Date;
    dateEndUtc?: Date;
    estimatedStartUtc?: Date;
    estimatedEndUtc?: Date;
    dutyTimeSec: number;
    blockTimeSec: number;
    simulationId?: string;
    positioningId?: string;
    positioningFlightId?: string;
    vacationType?: string;
    isIntroFlight: boolean;
    isObserverFlight: boolean;
}
export class DutySubItem extends BaseApiModelClass< IDutySubItem > implements IDutySubItem {
    id: string;
    title?: string;
    activityCodeName: string;
    flightId?: string;
    nextAircraftFlightId?: string;
    flightNumber?: number;
    rotationKey?: string;
    dateStartUtc?: Date;
    dateEndUtc?: Date;
    estimatedStartUtc?: Date;
    estimatedEndUtc?: Date;
    dutyTimeSec: number;
    blockTimeSec: number;
    simulationId?: string;
    positioningId?: string;
    positioningFlightId?: string;
    vacationType?: string;
    isIntroFlight: boolean;
    isObserverFlight: boolean;
}

export interface IDutyTitle {
    id: string;
    title: string;
}
export class DutyTitle extends BaseApiModelClass< IDutyTitle > implements IDutyTitle {
    id: string;
    title: string;
}

export interface IDutyTraineeCheckerPopupInfoModel {
    flightNumbers: string;
    personCode: string;
    functionDescription: string;
    instructorRequirements: string;
}
export class DutyTraineeCheckerPopupInfoModel extends BaseApiModelClass< IDutyTraineeCheckerPopupInfoModel > implements IDutyTraineeCheckerPopupInfoModel {
    flightNumbers: string;
    personCode: string;
    functionDescription: string;
    instructorRequirements: string;
}

export interface IDutyUpdateResult {
    duties: DutyItem[];
    operationId?: string;
    errorMessage?: string;
}
export class DutyUpdateResult extends BaseApiModelClass< IDutyUpdateResult > implements IDutyUpdateResult {
    duties: DutyItem[];
    operationId?: string;
    errorMessage?: string;
}

export interface IDutyUrgentDayModel {
    errors: DutyValidationErrorModel[];
    causeOperations: UrgentErrorDetailOperation[];
}
export class DutyUrgentDayModel extends BaseApiModelClass< IDutyUrgentDayModel > implements IDutyUrgentDayModel {
    errors: DutyValidationErrorModel[];
    causeOperations: UrgentErrorDetailOperation[];
}

export interface IDutyValidationDataModel {
    dayDuties: DutyDescriptionDto[];
    validationErrors: DutyValidationErrorModel[];
    experience: PersonAircraftTypeExperienceModel[];
    recency: PersonAircraftTypeRecencyModel[];
    blockHours: DutyBlockHoursModel;
    dutyHours: DutyHoursModel;
    acclimatisationStatus?: string;
    flightInformation: FlightInformationData;
    assignedFlights: AssignedFlight[];
    customLandings: ValidatorCustomLanding[];
    customTakeoffs: ValidatorCustomTakeoff[];
    offDaysModel: OffDaysModel;
    singleDaysModel: SingleDaysModel;
    localDaysModel: LocalDaysModel;
    disruptiveSchedule: DisruptiveScheduleModel;
    modifiedDate?: Date;
    modifiedBy?: string;
    currentLocation?: string;
    isFullDutyMonth: boolean;
    isFullDutyQuarter: boolean;
    isFullDutyYear: boolean;
    isAfterNightDuty: boolean;
    isBeforeNightDuty: boolean;
    planningDayInfo?: PlanningDayDto;
    afterTrainingExperience?: PersonAfterTrainingExperience;
}
export class DutyValidationDataModel extends BaseApiModelClass< IDutyValidationDataModel > implements IDutyValidationDataModel {
    dayDuties: DutyDescriptionDto[];
    validationErrors: DutyValidationErrorModel[];
    experience: PersonAircraftTypeExperienceModel[];
    recency: PersonAircraftTypeRecencyModel[];
    blockHours: DutyBlockHoursModel;
    dutyHours: DutyHoursModel;
    acclimatisationStatus?: string;
    flightInformation: FlightInformationData;
    assignedFlights: AssignedFlight[];
    customLandings: ValidatorCustomLanding[];
    customTakeoffs: ValidatorCustomTakeoff[];
    offDaysModel: OffDaysModel;
    singleDaysModel: SingleDaysModel;
    localDaysModel: LocalDaysModel;
    disruptiveSchedule: DisruptiveScheduleModel;
    modifiedDate?: Date;
    modifiedBy?: string;
    currentLocation?: string;
    isFullDutyMonth: boolean;
    isFullDutyQuarter: boolean;
    isFullDutyYear: boolean;
    isAfterNightDuty: boolean;
    isBeforeNightDuty: boolean;
    planningDayInfo?: PlanningDayDto;
    afterTrainingExperience?: PersonAfterTrainingExperience;
}

export interface IDutyValidationErrorInfoModel {
    message: string;
    errorType: string;
    errorTypeName: string;
    category: ValidationErrorCategory;
}
export class DutyValidationErrorInfoModel extends BaseApiModelClass< IDutyValidationErrorInfoModel > implements IDutyValidationErrorInfoModel {
    message: string;
    errorType: string;
    errorTypeName: string;
    category: ValidationErrorCategory;
}

export interface IDutyValidationErrorModel {
    message: string;
    category: ValidationErrorCategory;
    errorType?: string;
    key: string;
    isSuppressed: boolean;
    isUrgent: boolean;
    suppressedCommentText?: string;
    suppressReason?: string;
    modifiedDate?: Date;
    modifiedByPrincipalName?: string;
    isValidation: boolean;
    isPersisted: boolean;
    isApplicable?: boolean;
    secondModifiedDate?: Date;
    secondModifiedByPrincipalName?: string;
    isFirstSuppressed: boolean;
    isSecondSuppressed: boolean;
    commentModifiedByPrincipalName?: string;
    commentModifiedDate?: Date;
    modifiedByPrincipalEmail?: string;
    secondModifiedByPrincipalEmail?: string;
}
export class DutyValidationErrorModel extends BaseApiModelClass< IDutyValidationErrorModel > implements IDutyValidationErrorModel {
    message: string;
    category: ValidationErrorCategory;
    errorType?: string;
    key: string;
    isSuppressed: boolean;
    isUrgent: boolean;
    suppressedCommentText?: string;
    suppressReason?: string;
    modifiedDate?: Date;
    modifiedByPrincipalName?: string;
    isValidation: boolean;
    isPersisted: boolean;
    isApplicable?: boolean;
    secondModifiedDate?: Date;
    secondModifiedByPrincipalName?: string;
    isFirstSuppressed: boolean;
    isSecondSuppressed: boolean;
    commentModifiedByPrincipalName?: string;
    commentModifiedDate?: Date;
    modifiedByPrincipalEmail?: string;
    secondModifiedByPrincipalEmail?: string;
}

export interface IDutyValidationFseDataModel {
    dayDuties: DutyDescriptionDto[];
    validationErrors: DutyValidationErrorModel[];
    acclimatisationStatus?: string;
    flightInformation: FlightInformationData;
    assignedFlights: AssignedFlight[];
    disruptiveSchedule: DisruptiveScheduleModel;
    dutyHours1Day: number;
    modifiedDate?: Date;
    modifiedBy?: string;
    currentLocation?: string;
    isAfterNightDuty: boolean;
    isBeforeNightDuty: boolean;
}
export class DutyValidationFseDataModel extends BaseApiModelClass< IDutyValidationFseDataModel > implements IDutyValidationFseDataModel {
    dayDuties: DutyDescriptionDto[];
    validationErrors: DutyValidationErrorModel[];
    acclimatisationStatus?: string;
    flightInformation: FlightInformationData;
    assignedFlights: AssignedFlight[];
    disruptiveSchedule: DisruptiveScheduleModel;
    dutyHours1Day: number;
    modifiedDate?: Date;
    modifiedBy?: string;
    currentLocation?: string;
    isAfterNightDuty: boolean;
    isBeforeNightDuty: boolean;
}

export interface IDutyValidationGroundDataModel {
    dayDuties: DutyDescriptionDto[];
    validationErrors: DutyValidationErrorModel[];
    workHours: WorkHoursModel;
    modifiedDate?: Date;
    modifiedBy: string;
    workSundayDays: number;
    workSaturdayDays: number;
    assignedFlights: AssignedFlight[];
    isBeforeNightDuty: boolean;
    isAfterNightDuty: boolean;
    customTitle?: string;
    staDateTimeUtc?: Date;
    stdDateTimeUtc?: Date;
    staDateTimeLt?: Date;
    stdDateTimeLt?: Date;
}
export class DutyValidationGroundDataModel extends BaseApiModelClass< IDutyValidationGroundDataModel > implements IDutyValidationGroundDataModel {
    dayDuties: DutyDescriptionDto[];
    validationErrors: DutyValidationErrorModel[];
    workHours: WorkHoursModel;
    modifiedDate?: Date;
    modifiedBy: string;
    workSundayDays: number;
    workSaturdayDays: number;
    assignedFlights: AssignedFlight[];
    isBeforeNightDuty: boolean;
    isAfterNightDuty: boolean;
    customTitle?: string;
    staDateTimeUtc?: Date;
    stdDateTimeUtc?: Date;
    staDateTimeLt?: Date;
    stdDateTimeLt?: Date;
}

export interface IDutyWarningModel {
    date: Date;
    activityCodeName: string;
    personCodeName: string;
    personFirstName?: string;
    personLastName?: string;
    isGav: boolean;
    isFtl: boolean;
    isWish: boolean;
    isPriority: boolean;
    isImportant: boolean;
    flightNumber?: number;
    commentId?: string;
    commentText?: string;
    commentValidFromDate: Date;
    commentValidToDate?: Date;
    isDeleteConfirmRequired: boolean;
    type: DutyWarningType;
    isRequested: boolean;
    requestedPoints?: number;
    isFlightRequestReplaced: boolean;
    personSwapYearCount: number;
    isMaxAllowedSwapsReached: boolean;
    personId: string;
    haveCapacity?: boolean;
}
export class DutyWarningModel extends BaseApiModelClass< IDutyWarningModel > implements IDutyWarningModel {
    date: Date;
    activityCodeName: string;
    personCodeName: string;
    personFirstName?: string;
    personLastName?: string;
    isGav: boolean;
    isFtl: boolean;
    isWish: boolean;
    isPriority: boolean;
    isImportant: boolean;
    flightNumber?: number;
    commentId?: string;
    commentText?: string;
    commentValidFromDate: Date;
    commentValidToDate?: Date;
    isDeleteConfirmRequired: boolean;
    type: DutyWarningType;
    isRequested: boolean;
    requestedPoints?: number;
    isFlightRequestReplaced: boolean;
    readonly personSwapYearCount: number;
    readonly isMaxAllowedSwapsReached: boolean;
    personId: string;
    haveCapacity?: boolean;
}

export enum DutyWarningType {
    IsByLongHaulOverride = "IsByLongHaulOverride",
    IsByShortHaulOverride = "IsByShortHaulOverride",
    IsBySingleOverride = "IsBySingleOverride",
    IsChangedInUnreleasedMonth = "IsChangedInUnreleasedMonth",
    IsChangeLogDisabled = "IsChangeLogDisabled",
    IsComment = "IsComment",
    IsFlightPositionWillBeUnknown = "IsFlightPositionWillBeUnknown",
    IsFlightRequestAdded = "IsFlightRequestAdded",
    IsFlightRequestReplaced = "IsFlightRequestReplaced",
    IsLtoDeleted = "IsLtoDeleted",
    IsLtoOverlap = "IsLtoOverlap",
    IsNotAllowedByContractWithoutSet = "IsNotAllowedByContractWithoutSet",
    IsNotAllowedByTypeRatingWithSet = "IsNotAllowedByTypeRatingWithSet",
    IsNotAllowedToOverWriteDutyWhenPlanning = "IsNotAllowedToOverWriteDutyWhenPlanning",
    IsNotAllowToOverWrite = "IsNotAllowToOverWrite",
    IsNotAllowToSwap = "IsNotAllowToSwap",
    IsOverrideByOff = "IsOverrideByOff",
    IsReserveRequestReplaced = "IsReserveRequestReplaced",
    IsShortTermFlightRequestReplaced = "IsShortTermFlightRequestReplaced",
    IsStoRequestReplaced = "IsStoRequestReplaced",
    IsSwap = "IsSwap",
    None = "None",
}

export interface IEasaAlertModel {
    messages?: string[];
    hasErrors: boolean;
}
export class EasaAlertModel extends BaseApiModelClass< IEasaAlertModel > implements IEasaAlertModel {
    messages?: string[];
    hasErrors: boolean;
}

export interface IEbtModuleModel {
    id: string;
    type: EbtModuleType;
    typeName: string;
    startDate: Date;
    endDate: Date;
}
export class EbtModuleModel extends BaseApiModelClass< IEbtModuleModel > implements IEbtModuleModel {
    id: string;
    type: EbtModuleType;
    typeName: string;
    startDate: Date;
    endDate: Date;
}

export enum EbtModuleType {
    M1 = "M1",
    M2 = "M2",
    M3 = "M3",
    M4 = "M4",
    M5 = "M5",
    M6 = "M6",
}

export interface IEmailAttachmentDto {
    id: string;
    name?: string;
    type: EmailContentType;
    size?: number;
}
export class EmailAttachmentDto extends BaseApiModelClass< IEmailAttachmentDto > implements IEmailAttachmentDto {
    id: string;
    name?: string;
    type: EmailContentType;
    size?: number;
}

export enum EmailContentType {
    None = "None",
    Pdf = "Pdf",
    Xls = "Xls",
    Xlsx = "Xlsx",
    Xml = "Xml",
}

export interface IEmailFilter {
    rowLimit?: number;
    periodFrom: Date;
    periodTo?: Date;
    searchTerm?: string;
}
export class EmailFilter extends BaseApiModelClass< IEmailFilter > implements IEmailFilter {
    rowLimit?: number;
    periodFrom: Date;
    periodTo?: Date;
    searchTerm?: string;
}

export interface IEmailValidateRequest {
    value?: string;
}
export class EmailValidateRequest extends BaseApiModelClass< IEmailValidateRequest > implements IEmailValidateRequest {
    value?: string;
}

export interface IEmailValidateResponse {
    isValid: boolean;
    errorMessage?: string;
}
export class EmailValidateResponse extends BaseApiModelClass< IEmailValidateResponse > implements IEmailValidateResponse {
    isValid: boolean;
    errorMessage?: string;
}

export interface IEnumModel {
    code: string;
    name: string;
}
export class EnumModel extends BaseApiModelClass< IEnumModel > implements IEnumModel {
    code: string;
    name: string;
}

export interface IErrorReportFilter {
    rowLimit?: number;
    dateFrom: Date;
    dateTo: Date;
    isHistorized: boolean;
    is48hView: boolean;
}
export class ErrorReportFilter extends BaseApiModelClass< IErrorReportFilter > implements IErrorReportFilter {
    rowLimit?: number;
    dateFrom: Date;
    dateTo: Date;
    isHistorized: boolean;
    is48hView: boolean;
}

export interface IErrorReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    personId: string;
    personCode: string;
    functionName?: string;
    date: Date;
    actualDuty?: string;
    message: string;
    isSuppressed: boolean;
    isApplicable?: boolean;
    suppressReason?: string;
    category: string;
    errorCategory?: ValidationErrorCategory;
    is1stSuppressed: boolean;
    is2ndSuppressed: boolean;
    principalName?: string;
    secondPrincipalName?: string;
}
export class ErrorReportModel extends BaseApiModelClass< IErrorReportModel > implements IErrorReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    personId: string;
    personCode: string;
    functionName?: string;
    date: Date;
    actualDuty?: string;
    message: string;
    isSuppressed: boolean;
    isApplicable?: boolean;
    suppressReason?: string;
    category: string;
    errorCategory?: ValidationErrorCategory;
    is1stSuppressed: boolean;
    is2ndSuppressed: boolean;
    principalName?: string;
    secondPrincipalName?: string;
}

export interface IErrorReportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}
export class ErrorReportModelDataSourceLoadOptions extends BaseApiModelClass< IErrorReportModelDataSourceLoadOptions > implements IErrorReportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}

export interface IExperienceModel {
    id: string;
    codeName: string;
    displayName: string;
}
export class ExperienceModel extends BaseApiModelClass< IExperienceModel > implements IExperienceModel {
    id: string;
    codeName: string;
    displayName: string;
}

export interface IExperienceReportFilter {
    rowLimit?: number;
    year: number;
    month: number;
    personId?: string;
}
export class ExperienceReportFilter extends BaseApiModelClass< IExperienceReportFilter > implements IExperienceReportFilter {
    rowLimit?: number;
    year: number;
    month: number;
    personId?: string;
}

export interface IExperienceReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    personId: string;
    code: string;
    name?: string;
    contract?: string;
    function?: string;
    status320: boolean;
    status330: boolean;
    status340: boolean;
    status350: boolean;
    blockHoursSec320: number;
    blockHoursSec330: number;
    blockHoursSec340: number;
    blockHoursSec350: number;
    sectors320: number;
    sectors330: number;
    sectors340: number;
    sectors350: number;
    activityFlcBhLimit320?: number;
    activityFlcBhLimit330?: number;
    activityFlcBhLimit340?: number;
    activityFlcBhLimit350?: number;
    activityFlcSecLimit320?: number;
    activityFlcSecLimit330?: number;
    activityFlcSecLimit340?: number;
    activityFlcSecLimit350?: number;
}
export class ExperienceReportModel extends BaseApiModelClass< IExperienceReportModel > implements IExperienceReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    personId: string;
    code: string;
    name?: string;
    contract?: string;
    function?: string;
    status320: boolean;
    status330: boolean;
    status340: boolean;
    status350: boolean;
    blockHoursSec320: number;
    blockHoursSec330: number;
    blockHoursSec340: number;
    blockHoursSec350: number;
    sectors320: number;
    sectors330: number;
    sectors340: number;
    sectors350: number;
    activityFlcBhLimit320?: number;
    activityFlcBhLimit330?: number;
    activityFlcBhLimit340?: number;
    activityFlcBhLimit350?: number;
    activityFlcSecLimit320?: number;
    activityFlcSecLimit330?: number;
    activityFlcSecLimit340?: number;
    activityFlcSecLimit350?: number;
}

export interface IExperienceReportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}
export class ExperienceReportModelDataSourceLoadOptions extends BaseApiModelClass< IExperienceReportModelDataSourceLoadOptions > implements IExperienceReportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}

export interface IExportCrewDutyListReportColumn {
    caption?: string;
    dataField?: string;
    width?: number;
}
export class ExportCrewDutyListReportColumn extends BaseApiModelClass< IExportCrewDutyListReportColumn > implements IExportCrewDutyListReportColumn {
    caption?: string;
    dataField?: string;
    width?: number;
}

export interface IExportCrewDutyListReportFilter {
    rowLimit?: number;
    functionId: string;
    instructorFilter?: string;
    contractFlagTypes?: ContractFlagType[];
    dateFrom: Date;
    dateTo: Date;
    personIds?: string[];
    dooType: DooType[];
    resetCache: boolean;
    key: string;
    columnsInfo?: ExportCrewDutyListReportColumn[];
    showReleased: boolean;
}
export class ExportCrewDutyListReportFilter extends BaseApiModelClass< IExportCrewDutyListReportFilter > implements IExportCrewDutyListReportFilter {
    rowLimit?: number;
    functionId: string;
    instructorFilter?: string;
    contractFlagTypes?: ContractFlagType[];
    dateFrom: Date;
    dateTo: Date;
    personIds?: string[];
    dooType: DooType[];
    resetCache: boolean;
    readonly key: string;
    columnsInfo?: ExportCrewDutyListReportColumn[];
    showReleased: boolean;
}

export interface IExportLogbookModel {
    exportType: LogbookExportType;
}
export class ExportLogbookModel extends BaseApiModelClass< IExportLogbookModel > implements IExportLogbookModel {
    exportType: LogbookExportType;
}

export enum FdpAmendmentType {
    PreferFdpCombine = "PreferFdpCombine",
    PreferFdpSplit = "PreferFdpSplit",
    SplitDuty = "SplitDuty",
    SplitDutyWithoutHotel = "SplitDutyWithoutHotel",
}

export enum FdpExtensionType {
    Augmented = "Augmented",
    Extended = "Extended",
    None = "None",
    XStar = "XStar",
}

export interface IFile {
}
export class File extends BaseApiModelClass< IFile > implements IFile {
}

export enum FleetType {
    A320 = "A320",
    A320_A330 = "A320_A330",
    A320_A340 = "A320_A340",
    A330_A340 = "A330_A340",
    A340 = "A340",
    A350 = "A350",
    Cabin = "Cabin",
    Ground = "Ground",
}

export interface IFleetTypeModel {
    label: string;
    value: number;
}
export class FleetTypeModel extends BaseApiModelClass< IFleetTypeModel > implements IFleetTypeModel {
    label: string;
    value: number;
}

export interface IFlightActivityItem {
    activityCodeName: string;
    personCode: string;
    personId: string;
    personFunction?: string;
}
export class FlightActivityItem extends BaseApiModelClass< IFlightActivityItem > implements IFlightActivityItem {
    activityCodeName: string;
    personCode: string;
    personId: string;
    personFunction?: string;
}

export interface IFlightActivityLicense {
    activityCodeName: string;
    licenseId: string;
}
export class FlightActivityLicense extends BaseApiModelClass< IFlightActivityLicense > implements IFlightActivityLicense {
    activityCodeName: string;
    licenseId: string;
}

export interface IFlightActivityPersonCandidate {
    personId: string;
    code: string;
}
export class FlightActivityPersonCandidate extends BaseApiModelClass< IFlightActivityPersonCandidate > implements IFlightActivityPersonCandidate {
    personId: string;
    code: string;
}

export interface IFlightCommentDto {
    flightId: string;
    text: string;
}
export class FlightCommentDto extends BaseApiModelClass< IFlightCommentDto > implements IFlightCommentDto {
    flightId: string;
    text: string;
}

export interface IFlightCrewDetailsModel {
    flightId: string;
    netlineOpsLegId?: number;
    landingPilotCode?: string;
    monitoringPilotCode?: string;
    takeOffPilotCode?: string;
    takeOffPilotMonitoringCode?: string;
    isForecastLanding: boolean;
    isForecastTakeoff: boolean;
    activities: FlightActivityItem[];
    delays: FlightDelayItem[];
    activityLicenses: FlightActivityLicense[];
}
export class FlightCrewDetailsModel extends BaseApiModelClass< IFlightCrewDetailsModel > implements IFlightCrewDetailsModel {
    flightId: string;
    netlineOpsLegId?: number;
    landingPilotCode?: string;
    monitoringPilotCode?: string;
    takeOffPilotCode?: string;
    takeOffPilotMonitoringCode?: string;
    isForecastLanding: boolean;
    isForecastTakeoff: boolean;
    activities: FlightActivityItem[];
    delays: FlightDelayItem[];
    activityLicenses: FlightActivityLicense[];
}

export interface IFlightCrewMember {
    id: string;
    code: string;
    notFoundFlights: number[];
    hasAllDuties: boolean;
}
export class FlightCrewMember extends BaseApiModelClass< IFlightCrewMember > implements IFlightCrewMember {
    id: string;
    code: string;
    notFoundFlights: number[];
    readonly hasAllDuties: boolean;
}

export interface IFlightDelayItem {
    id: string;
    delayCode: string;
    delaySubCode?: string;
    delayTime: number;
    delayDescription?: string;
}
export class FlightDelayItem extends BaseApiModelClass< IFlightDelayItem > implements IFlightDelayItem {
    id: string;
    delayCode: string;
    delaySubCode?: string;
    delayTime: number;
    delayDescription?: string;
}

export interface IFlightDto {
    id: string;
    airlineRcd: string;
    flightNumber: number;
    operationalSuffix?: string;
    originRcd: string;
    destinationRcd: string;
    date: Date;
    netlineOpsLegId?: number;
    status: FlightStatus;
    statusIdentifier?: string;
    statusSupplementaryInfo?: string;
    statusChangeReason?: string;
    statusActionIdentifier?: string;
    isLongHaul: boolean;
    isLongHaulCabinOverride?: boolean;
    departureDateTimeUtc: Date;
    departureDateTimeLt: Date;
    arrivalDateTimeUtc: Date;
    arrivalDateTimeLt: Date;
    outOfTheGateUtc?: Date;
    offTheGroundUtc?: Date;
    onTheGroundUtc?: Date;
    intoTheGateUtc?: Date;
    aircraftId?: string;
    legSequenceNumber: number;
    originalFlightId?: string;
    estimatedDepartureDateTimeUtc?: Date;
    estimatedArrivalDateTimeUtc?: Date;
    landingPilotFlyingId?: string;
    landingPilotMonitoringId?: string;
    takeOffPilotFlyingId?: string;
    takeOffPilotMonitoringId?: string;
    isTypeRatingExam: boolean;
    cockpitCrewEmployer: string;
    cabinCrewEmployer: string;
    plannedAircraftTypeRcd?: string;
    totalDosimetry: number;
    hasDuties: boolean;
}
export class FlightDto extends BaseApiModelClass< IFlightDto > implements IFlightDto {
    id: string;
    airlineRcd: string;
    flightNumber: number;
    operationalSuffix?: string;
    originRcd: string;
    destinationRcd: string;
    date: Date;
    netlineOpsLegId?: number;
    status: FlightStatus;
    statusIdentifier?: string;
    statusSupplementaryInfo?: string;
    statusChangeReason?: string;
    statusActionIdentifier?: string;
    isLongHaul: boolean;
    isLongHaulCabinOverride?: boolean;
    departureDateTimeUtc: Date;
    departureDateTimeLt: Date;
    arrivalDateTimeUtc: Date;
    arrivalDateTimeLt: Date;
    outOfTheGateUtc?: Date;
    offTheGroundUtc?: Date;
    onTheGroundUtc?: Date;
    intoTheGateUtc?: Date;
    aircraftId?: string;
    legSequenceNumber: number;
    originalFlightId?: string;
    estimatedDepartureDateTimeUtc?: Date;
    estimatedArrivalDateTimeUtc?: Date;
    landingPilotFlyingId?: string;
    landingPilotMonitoringId?: string;
    takeOffPilotFlyingId?: string;
    takeOffPilotMonitoringId?: string;
    isTypeRatingExam: boolean;
    cockpitCrewEmployer: string;
    cabinCrewEmployer: string;
    plannedAircraftTypeRcd?: string;
    totalDosimetry: number;
    hasDuties: boolean;
}

export interface IFlightDutyRecordModel {
    date: Date;
    dutyText?: string;
    dutyItems: FlightDutyRecordTitleItem[];
    historizedDutyText?: string;
    route?: string;
    details?: string;
    hasAugmentedFlight: boolean;
    hasExtendedFlight: boolean;
    hasXStarFlight: boolean;
    dutyFromUtc?: Date;
    dutyFromDiffToLt?: string;
    dutyToUtc?: Date;
    dutyToDiffToLt?: string;
    historizedDutyFromUtc?: Date;
    historizedDutyFromDiffToLt?: string;
    historizedDutyToUtc?: Date;
    historizedDutyToDiffToLt?: string;
    flightCheckinDateUtc?: Date;
    flightCheckinDateDiffToLt?: string;
    flightCheckoutDateUtc?: Date;
    flightCheckoutDateDiffToLt?: string;
    flightShiftedCheckinDateUtc?: Date;
    flightShiftedCheckinDateDiffToLt?: string;
    flightShiftedCheckoutDateUtc?: Date;
    flightShiftedCheckoutDateDiffToLt?: string;
    fdpStartDiffToLt?: string;
    fdpEndDiffToLt?: string;
    flightStdDate?: Date;
    flightStaDate?: Date;
    flightBlockOnDate?: Date;
    flightBlockOffDate?: Date;
    aircraftType?: string;
    blockHoursFdp?: number;
    blockHoursOfDay: number;
    blockHours: number;
    blockHours28Days: number;
    dutyHours: number;
    historizedDutyHoursFdp?: number;
    dutyHoursFdp?: number;
    dutyHours7Days: number;
    dutyHours14Days: number;
    dutyHours28Days: number;
    dosimetryMsv: number;
    expensesSalaryMoney?: number;
    expensesSalaryDays?: number;
    expensesSalaryHours?: number;
    expensesComment?: string;
    positionings: FlightDutyRecordPositioning[];
    expensesSalaryHourlyShiftMoney?: number;
    expensesSalarySupportPikketMoney?: number;
    expensesSalaryWeekendHolidayMoney?: number;
    workHourTib1DaySecs?: number;
    historizedFlightCheckinDateUtc?: Date;
    historizedFlightCheckinDateDiffToLt?: string;
    historizedFlightCheckoutDateUtc?: Date;
    historizedFlightCheckoutDateDiffToLt?: string;
    dutyParts?: DatesRange[];
    mfdpTimeSecs?: number;
}
export class FlightDutyRecordModel extends BaseApiModelClass< IFlightDutyRecordModel > implements IFlightDutyRecordModel {
    date: Date;
    dutyText?: string;
    dutyItems: FlightDutyRecordTitleItem[];
    historizedDutyText?: string;
    route?: string;
    details?: string;
    hasAugmentedFlight: boolean;
    hasExtendedFlight: boolean;
    hasXStarFlight: boolean;
    dutyFromUtc?: Date;
    dutyFromDiffToLt?: string;
    dutyToUtc?: Date;
    dutyToDiffToLt?: string;
    historizedDutyFromUtc?: Date;
    historizedDutyFromDiffToLt?: string;
    historizedDutyToUtc?: Date;
    historizedDutyToDiffToLt?: string;
    flightCheckinDateUtc?: Date;
    flightCheckinDateDiffToLt?: string;
    flightCheckoutDateUtc?: Date;
    flightCheckoutDateDiffToLt?: string;
    flightShiftedCheckinDateUtc?: Date;
    flightShiftedCheckinDateDiffToLt?: string;
    flightShiftedCheckoutDateUtc?: Date;
    flightShiftedCheckoutDateDiffToLt?: string;
    fdpStartDiffToLt?: string;
    fdpEndDiffToLt?: string;
    flightStdDate?: Date;
    flightStaDate?: Date;
    flightBlockOnDate?: Date;
    flightBlockOffDate?: Date;
    aircraftType?: string;
    blockHoursFdp?: number;
    blockHoursOfDay: number;
    blockHours: number;
    blockHours28Days: number;
    dutyHours: number;
    historizedDutyHoursFdp?: number;
    dutyHoursFdp?: number;
    dutyHours7Days: number;
    dutyHours14Days: number;
    dutyHours28Days: number;
    dosimetryMsv: number;
    expensesSalaryMoney?: number;
    expensesSalaryDays?: number;
    expensesSalaryHours?: number;
    expensesComment?: string;
    positionings: FlightDutyRecordPositioning[];
    expensesSalaryHourlyShiftMoney?: number;
    expensesSalarySupportPikketMoney?: number;
    expensesSalaryWeekendHolidayMoney?: number;
    workHourTib1DaySecs?: number;
    historizedFlightCheckinDateUtc?: Date;
    historizedFlightCheckinDateDiffToLt?: string;
    historizedFlightCheckoutDateUtc?: Date;
    historizedFlightCheckoutDateDiffToLt?: string;
    dutyParts?: DatesRange[];
    mfdpTimeSecs?: number;
}

export interface IFlightDutyRecordPositioning {
    originRcd: string;
    destinationRcd: string;
    startUtc: Date;
    startDiffToLt: string;
    endUtc: Date;
    endDiffToLt: string;
}
export class FlightDutyRecordPositioning extends BaseApiModelClass< IFlightDutyRecordPositioning > implements IFlightDutyRecordPositioning {
    originRcd: string;
    destinationRcd: string;
    startUtc: Date;
    startDiffToLt: string;
    endUtc: Date;
    endDiffToLt: string;
}

export interface IFlightDutyRecordReportModel {
    flightDutyRecords: FlightDutyRecordModel[];
    blockHoursYear?: number;
    dutyHoursYear?: number;
    dutyHours12Months?: number;
    homeStudyDhSec?: number;
    homeStudyDhYtdSec?: number;
    daysOffYear?: number;
    daysOffMonth?: number;
    localDaysYear?: number;
    localDaysMonth?: number;
    isExpensesSalaryReceived: boolean;
    expensesSalaryResponseErrorMessage?: string;
    personId: string;
    personDisplayName: string;
    personCode: string;
    periodName: string;
    totalYearDosimetry: number;
    expensesDutyFree: number;
    vasaStatus: VasaSalaryPeriodStatus;
    workHoursMonthActualSecs?: number;
    workHoursMonthShouldSecs?: number;
    workHoursBalanceMonthSecs?: number;
    workHoursBalancePrevMonthSecs?: number;
    historizedWorkHoursMonthActualSecs?: number;
    isGround: boolean;
    isCabin: boolean;
    isCockpit: boolean;
}
export class FlightDutyRecordReportModel extends BaseApiModelClass< IFlightDutyRecordReportModel > implements IFlightDutyRecordReportModel {
    flightDutyRecords: FlightDutyRecordModel[];
    blockHoursYear?: number;
    dutyHoursYear?: number;
    dutyHours12Months?: number;
    homeStudyDhSec?: number;
    homeStudyDhYtdSec?: number;
    daysOffYear?: number;
    daysOffMonth?: number;
    localDaysYear?: number;
    localDaysMonth?: number;
    isExpensesSalaryReceived: boolean;
    expensesSalaryResponseErrorMessage?: string;
    personId: string;
    personDisplayName: string;
    personCode: string;
    periodName: string;
    totalYearDosimetry: number;
    expensesDutyFree: number;
    vasaStatus: VasaSalaryPeriodStatus;
    workHoursMonthActualSecs?: number;
    workHoursMonthShouldSecs?: number;
    workHoursBalanceMonthSecs?: number;
    workHoursBalancePrevMonthSecs?: number;
    historizedWorkHoursMonthActualSecs?: number;
    isGround: boolean;
    isCabin: boolean;
    isCockpit: boolean;
}

export interface IFlightDutyRecordTitleItem {
    displayText: string;
    flightId?: string;
}
export class FlightDutyRecordTitleItem extends BaseApiModelClass< IFlightDutyRecordTitleItem > implements IFlightDutyRecordTitleItem {
    displayText: string;
    flightId?: string;
}

export interface IFlightFlags {
    flightId: string;
    flightIsAugmented: boolean;
    flightIsExtended: boolean;
    flightIsXStar: boolean;
    functionGroupId: string;
}
export class FlightFlags extends BaseApiModelClass< IFlightFlags > implements IFlightFlags {
    flightId: string;
    flightIsAugmented: boolean;
    flightIsExtended: boolean;
    flightIsXStar: boolean;
    functionGroupId: string;
}

export interface IFlightFlagsRequest {
    isOverrideAllowed: boolean;
    flags: FlightFlags[];
}
export class FlightFlagsRequest extends BaseApiModelClass< IFlightFlagsRequest > implements IFlightFlagsRequest {
    isOverrideAllowed: boolean;
    flags: FlightFlags[];
}

export interface IFlightFlagsResponse {
    isSuccessful: boolean;
    conflicts: string[];
    updateResult: UpdateDutyResult;
}
export class FlightFlagsResponse extends BaseApiModelClass< IFlightFlagsResponse > implements IFlightFlagsResponse {
    isSuccessful: boolean;
    conflicts: string[];
    updateResult: UpdateDutyResult;
}

export interface IFlightIdInfo {
    flightNumber: number;
    airlineRcd: string;
    originRcd: string;
    destinationRcd: string;
    legNumber: number;
    date: Date;
}
export class FlightIdInfo extends BaseApiModelClass< IFlightIdInfo > implements IFlightIdInfo {
    flightNumber: number;
    airlineRcd: string;
    originRcd: string;
    destinationRcd: string;
    legNumber: number;
    date: Date;
}

export interface IFlightInfoModel {
    id: string;
    flightNumber: number;
    operationalSuffix?: string;
    originRcd: string;
    destinationRcd: string;
    departureDateTimeUtc: Date;
    arrivalDateTimeUtc: Date;
    aircraftTypeRcd?: string;
    cockpitCrewEmployer?: string;
    cabinCrewEmployer?: string;
}
export class FlightInfoModel extends BaseApiModelClass< IFlightInfoModel > implements IFlightInfoModel {
    id: string;
    flightNumber: number;
    operationalSuffix?: string;
    originRcd: string;
    destinationRcd: string;
    departureDateTimeUtc: Date;
    arrivalDateTimeUtc: Date;
    aircraftTypeRcd?: string;
    cockpitCrewEmployer?: string;
    cabinCrewEmployer?: string;
}

export interface IFlightInformationData {
    dutyHoursSecs: number;
    blockHoursSecs: number;
    fdpTimeSecs: number;
    checkinDateTimeUtc?: Date;
    checkinDateTimeLt?: Date;
    checkoutDateTimeUtc?: Date;
    checkoutDateTimeLt?: Date;
    staDateTimeUtc?: Date;
    staDateTimeLt?: Date;
    stdDateTimeUtc?: Date;
    stdDateTimeLt?: Date;
    plannedCheckinDateTimeUtc?: Date;
    plannedCheckoutDateTimeUtc?: Date;
    isDelayedReporting?: boolean;
    mfdpSbSecs?: number;
    awakeTimeSec?: number;
    mfdpTimeSecs?: number;
    mfdpeTimeSecs?: number;
    mfdpeIfr3Secs?: number;
    mfdpeIfr4Secs?: number;
    mfdpeIfrSecs?: number;
    fdpExtendedReason?: string;
    fdpAugmentedReason?: string;
    ftl2019MfdpTimeSecs?: number;
    ftl2019MfdpeTimeSecs?: number;
    ftl2019MfdpeIfr3Secs?: number;
    ftl2019MfdpeIfr4Secs?: number;
    ftl2019MfdpSbSecs?: number;
    cdr2025Mfdp3SectorsEasa?: number;
    cdr2025Mfdpe3SectorsEasa?: number;
    ftl2019MfdpActualType?: ActualMfdpType;
    hasCustomCheckin: boolean;
    hasCustomCheckout: boolean;
    isFdpAugmented: boolean;
    isFdpExtended: boolean;
    isFdpXStar: boolean;
}
export class FlightInformationData extends BaseApiModelClass< IFlightInformationData > implements IFlightInformationData {
    dutyHoursSecs: number;
    blockHoursSecs: number;
    fdpTimeSecs: number;
    checkinDateTimeUtc?: Date;
    checkinDateTimeLt?: Date;
    checkoutDateTimeUtc?: Date;
    checkoutDateTimeLt?: Date;
    staDateTimeUtc?: Date;
    staDateTimeLt?: Date;
    stdDateTimeUtc?: Date;
    stdDateTimeLt?: Date;
    plannedCheckinDateTimeUtc?: Date;
    plannedCheckoutDateTimeUtc?: Date;
    isDelayedReporting?: boolean;
    mfdpSbSecs?: number;
    awakeTimeSec?: number;
    mfdpTimeSecs?: number;
    mfdpeTimeSecs?: number;
    mfdpeIfr3Secs?: number;
    mfdpeIfr4Secs?: number;
    mfdpeIfrSecs?: number;
    fdpExtendedReason?: string;
    fdpAugmentedReason?: string;
    ftl2019MfdpTimeSecs?: number;
    ftl2019MfdpeTimeSecs?: number;
    ftl2019MfdpeIfr3Secs?: number;
    ftl2019MfdpeIfr4Secs?: number;
    ftl2019MfdpSbSecs?: number;
    cdr2025Mfdp3SectorsEasa?: number;
    cdr2025Mfdpe3SectorsEasa?: number;
    ftl2019MfdpActualType?: ActualMfdpType;
    hasCustomCheckin: boolean;
    hasCustomCheckout: boolean;
    isFdpAugmented: boolean;
    isFdpExtended: boolean;
    isFdpXStar: boolean;
}

export interface IFlightInformationEditModel {
    id: string;
    status: FlightStatus;
    arrivalDateTimeUtc: Date;
    departureDateTimeUtc: Date;
    outOfTheGateDateTimeUtc?: Date;
    offTheGroundDateTimeUtc?: Date;
    onTheGroundDateTimeUtc?: Date;
    intoTheGateDateTimeUtc?: Date;
    estimatedDepartureDateTimeUtc?: Date;
    estimatedArrivalDateTimeUtc?: Date;
    originalId?: string;
    comment?: string;
    aircraftId?: string;
    cockpitCrewEmployer?: string;
    cabinCrewEmployer?: string;
}
export class FlightInformationEditModel extends BaseApiModelClass< IFlightInformationEditModel > implements IFlightInformationEditModel {
    id: string;
    status: FlightStatus;
    arrivalDateTimeUtc: Date;
    departureDateTimeUtc: Date;
    outOfTheGateDateTimeUtc?: Date;
    offTheGroundDateTimeUtc?: Date;
    onTheGroundDateTimeUtc?: Date;
    intoTheGateDateTimeUtc?: Date;
    estimatedDepartureDateTimeUtc?: Date;
    estimatedArrivalDateTimeUtc?: Date;
    originalId?: string;
    comment?: string;
    aircraftId?: string;
    cockpitCrewEmployer?: string;
    cabinCrewEmployer?: string;
}

export interface IFlightLimitsCabinDto {
    personId: string;
    frCountLeftLh: number;
    frCountLeftSh: number;
    maxFlightRequestsLhCountStartPeriod?: number;
    maxFlightRequestsLhCountEndPeriod?: number;
    countLhOnStartPeriodContractYear?: number;
    maxFlightRequestsShCountStartPeriod?: number;
    maxFlightRequestsShCountEndPeriod?: number;
    countShOnStartPeriodContractYear?: number;
    dateOfStartNextContractYear?: Date;
}
export class FlightLimitsCabinDto extends BaseApiModelClass< IFlightLimitsCabinDto > implements IFlightLimitsCabinDto {
    personId: string;
    frCountLeftLh: number;
    frCountLeftSh: number;
    maxFlightRequestsLhCountStartPeriod?: number;
    maxFlightRequestsLhCountEndPeriod?: number;
    countLhOnStartPeriodContractYear?: number;
    maxFlightRequestsShCountStartPeriod?: number;
    maxFlightRequestsShCountEndPeriod?: number;
    countShOnStartPeriodContractYear?: number;
    dateOfStartNextContractYear?: Date;
}

export interface IFlightLimitsCorrectionModel {
    referenceDate: Date;
    type: FlightRequestLimitRange;
    amount: number;
    reason: string;
}
export class FlightLimitsCorrectionModel extends BaseApiModelClass< IFlightLimitsCorrectionModel > implements IFlightLimitsCorrectionModel {
    referenceDate: Date;
    type: FlightRequestLimitRange;
    amount: number;
    reason: string;
}

export interface IFlightLimitsDto {
    personId: string;
    maxAllowedFlightsThisYear: number;
    frCountAllowedPerPeriod: number;
    frCountCurrent: number;
}
export class FlightLimitsDto extends BaseApiModelClass< IFlightLimitsDto > implements IFlightLimitsDto {
    personId: string;
    maxAllowedFlightsThisYear: number;
    frCountAllowedPerPeriod: number;
    frCountCurrent: number;
}

export interface IFlightLogItem {
    id: string;
    timestamp: Date;
    operationName: string;
    status?: FlightStatus;
    statusIdentifier?: string;
    statusChangeReason?: string;
    statusSupplementaryInfo?: string;
    statusActionIdentifier?: string;
    netlineOpsLegId?: number;
    estimatedDepartureDateTimeUtc?: Date;
    estimatedArrivalDateTimeUtc?: Date;
    cockpitCrewEmployer?: string;
    cabinCrewEmployer?: string;
    operationalSuffix?: string;
    outOfTheGateDateTimeUtc?: Date;
    offTheGroundDateTimeUtc?: Date;
    onTheGroundDateTimeUtc?: Date;
    intoTheGateDateTimeUtc?: Date;
    aircraftRegistrationNumber?: string;
    aircraftType?: string;
    totalDosimetry?: number;
    modifiedBy: string;
    departureDateTimeUtc?: Date;
    arrivalDateTimeUtc?: Date;
    originalId?: string;
    originalInfo?: string;
}
export class FlightLogItem extends BaseApiModelClass< IFlightLogItem > implements IFlightLogItem {
    id: string;
    timestamp: Date;
    operationName: string;
    status?: FlightStatus;
    statusIdentifier?: string;
    statusChangeReason?: string;
    statusSupplementaryInfo?: string;
    statusActionIdentifier?: string;
    netlineOpsLegId?: number;
    estimatedDepartureDateTimeUtc?: Date;
    estimatedArrivalDateTimeUtc?: Date;
    cockpitCrewEmployer?: string;
    cabinCrewEmployer?: string;
    operationalSuffix?: string;
    outOfTheGateDateTimeUtc?: Date;
    offTheGroundDateTimeUtc?: Date;
    onTheGroundDateTimeUtc?: Date;
    intoTheGateDateTimeUtc?: Date;
    aircraftRegistrationNumber?: string;
    aircraftType?: string;
    totalDosimetry?: number;
    modifiedBy: string;
    departureDateTimeUtc?: Date;
    arrivalDateTimeUtc?: Date;
    originalId?: string;
    originalInfo?: string;
}

export interface IFlightModel {
    id: string;
    airlineRcd: string;
    flightNumber: number;
    operationalSuffix?: string;
    originRcd: string;
    destinationRcd: string;
    isAirportMissing: boolean;
    originCountryThreeLetterCode?: string;
    destinationCountryThreeLetterCode?: string;
    departureDateTimeUtc: Date;
    arrivalDateTimeUtc: Date;
    departureTimeDiffToLt: string;
    arrivalTimeDiffToLt: string;
    aircraftTypeRcd?: string;
    outTheGateDateTimeUtc?: Date;
    offTheGroundDateTimeUtc?: Date;
    onTheGroundDateTimeUtc?: Date;
    intoTheGateDateTimeUtc?: Date;
    aircraftId?: string;
    isLongHaul: boolean;
    isLongHaulCabin: boolean;
    aircraftRegistrationNumber?: string;
}
export class FlightModel extends BaseApiModelClass< IFlightModel > implements IFlightModel {
    id: string;
    airlineRcd: string;
    flightNumber: number;
    operationalSuffix?: string;
    originRcd: string;
    destinationRcd: string;
    isAirportMissing: boolean;
    originCountryThreeLetterCode?: string;
    destinationCountryThreeLetterCode?: string;
    departureDateTimeUtc: Date;
    arrivalDateTimeUtc: Date;
    departureTimeDiffToLt: string;
    arrivalTimeDiffToLt: string;
    aircraftTypeRcd?: string;
    outTheGateDateTimeUtc?: Date;
    offTheGroundDateTimeUtc?: Date;
    onTheGroundDateTimeUtc?: Date;
    intoTheGateDateTimeUtc?: Date;
    aircraftId?: string;
    isLongHaul: boolean;
    isLongHaulCabin: boolean;
    readonly aircraftRegistrationNumber?: string;
}

export enum FlightQueueResultStatus {
    DutyChangeAfterFlightDone = "DutyChangeAfterFlightDone",
    DutyChangeIgnored = "DutyChangeIgnored",
    FlightInWrongState = "FlightInWrongState",
    FlightNoConfiguration = "FlightNoConfiguration",
    InsufficientInformation = "InsufficientInformation",
    NoAssignments = "NoAssignments",
    NoCountryDeliveryMethodDefined = "NoCountryDeliveryMethodDefined",
    PayloadGenerated = "PayloadGenerated",
    PersonChangeAfterFlightDone = "PersonChangeAfterFlightDone",
    PersonChangeIgnored = "PersonChangeIgnored",
    SkippedAsDuplicate = "SkippedAsDuplicate",
    WaitingForNextTrigger = "WaitingForNextTrigger",
}

export enum FlightRequestLimitRange {
    LH = "LH",
    SH = "SH",
    Total = "Total",
}

export interface IFlightResponse {
    flightId: string;
    items: CrewItem[];
}
export class FlightResponse extends BaseApiModelClass< IFlightResponse > implements IFlightResponse {
    flightId: string;
    items: CrewItem[];
}

export interface IFlightRevalidateModel {
    id: string;
}
export class FlightRevalidateModel extends BaseApiModelClass< IFlightRevalidateModel > implements IFlightRevalidateModel {
    id: string;
}

export interface IFlightRotationComplements {
    crewFunction: RotationCrewComplementsFunction;
    count: number;
}
export class FlightRotationComplements extends BaseApiModelClass< IFlightRotationComplements > implements IFlightRotationComplements {
    crewFunction: RotationCrewComplementsFunction;
    count: number;
}

export interface IFlightRotationInfo {
    id: string;
    name: string;
    isDeleted: boolean;
    isForCabin: boolean;
    isForCockpit: boolean;
    timestamp: Date;
    periodDateFrom: Date;
    periodDateTo: Date;
    type: RotationType;
    dutiesAsText: string;
    functionNames: string[];
    complements: FlightRotationComplements[];
    dutiesIsAugmented?: boolean;
    dutiesIsExtended?: boolean;
}
export class FlightRotationInfo extends BaseApiModelClass< IFlightRotationInfo > implements IFlightRotationInfo {
    id: string;
    name: string;
    isDeleted: boolean;
    isForCabin: boolean;
    isForCockpit: boolean;
    timestamp: Date;
    periodDateFrom: Date;
    periodDateTo: Date;
    type: RotationType;
    dutiesAsText: string;
    functionNames: string[];
    complements: FlightRotationComplements[];
    dutiesIsAugmented?: boolean;
    dutiesIsExtended?: boolean;
}

export interface IFlightSeatInfo {
    timestamp: Date;
    operationName: string;
    date: Date;
    personId: string;
    personCode: string;
    principalName: string;
    activityRcd: string;
    isChangeLogEnabled: boolean;
}
export class FlightSeatInfo extends BaseApiModelClass< IFlightSeatInfo > implements IFlightSeatInfo {
    timestamp: Date;
    operationName: string;
    date: Date;
    personId: string;
    personCode: string;
    principalName: string;
    activityRcd: string;
    isChangeLogEnabled: boolean;
}

export enum FlightStatus {
    Actual = "Actual",
    Cancelled = "Cancelled",
    Changed = "Changed",
    Deleted = "Deleted",
}

export enum FlightTriggerType {
    DC = "DC",
    Duty = "Duty",
    FC = "FC",
    Manual = "Manual",
    Person = "Person",
    Print = "Print",
    RDC = "RDC",
    RFC = "RFC",
    RTM0 = "RTM0",
    RTM0_5 = "RTM0_5",
    RTM1 = "RTM1",
    RTM1_15 = "RTM1_15",
    RTM24 = "RTM24",
    TM0 = "TM0",
    TM0_5 = "TM0_5",
    TM1 = "TM1",
    TM1_15 = "TM1_15",
    TM24 = "TM24",
}

export enum FreelanceActivityType {
    A = "A",
    A_N = "A_N",
    AE_ = "AE_",
    AL_ = "AL_",
    AN_ = "AN_",
    Empty = "Empty",
    N_A = "N_A",
    O_R = "O_R",
}

export interface IFreelanceExportDto {
    date: Date;
    duty?: string;
}
export class FreelanceExportDto extends BaseApiModelClass< IFreelanceExportDto > implements IFreelanceExportDto {
    date: Date;
    duty?: string;
}

export enum FreelancePeriodStatus {
    DeviatedByCrew = "DeviatedByCrew",
    DeviatedByPlanner = "DeviatedByPlanner",
    None = "None",
    SavedByCrew = "SavedByCrew",
    SavedByPlanner = "SavedByPlanner",
}

export interface IFreelanceYearDto {
    id: string;
    codeName: string;
    planningFunctionGroupId: string;
    contractTypeModel?: ContractModelType;
    dateFrom: Date;
    dateTo: Date;
    periods: FreelanceYearPeriodDto[];
}
export class FreelanceYearDto extends BaseApiModelClass< IFreelanceYearDto > implements IFreelanceYearDto {
    id: string;
    codeName: string;
    planningFunctionGroupId: string;
    contractTypeModel?: ContractModelType;
    dateFrom: Date;
    dateTo: Date;
    periods: FreelanceYearPeriodDto[];
}

export interface IFreelanceYearPeriodDto {
    dateFrom: Date;
    dateTo: Date;
    days: number;
    id: string;
    yearId: string;
    codeName: string;
    offeringsDeadlineDate: Date;
    processedDateUtc?: Date;
    modifiedAtUtc?: Date;
    planerModifiedAtUtc?: Date;
    modifiedByPrincipal?: string;
    status: FreelancePeriodStatus;
}
export class FreelanceYearPeriodDto extends BaseApiModelClass< IFreelanceYearPeriodDto > implements IFreelanceYearPeriodDto {
    dateFrom: Date;
    dateTo: Date;
    readonly days: number;
    id: string;
    yearId: string;
    codeName: string;
    offeringsDeadlineDate: Date;
    processedDateUtc?: Date;
    modifiedAtUtc?: Date;
    planerModifiedAtUtc?: Date;
    modifiedByPrincipal?: string;
    status: FreelancePeriodStatus;
}

export interface IFreelanceYearPeriodUpdateResult {
    id: string;
    modifiedAtUtc?: Date;
    planerModifiedAtUtc?: Date;
    modifiedByPrincipal?: string;
    status: FreelancePeriodStatus;
}
export class FreelanceYearPeriodUpdateResult extends BaseApiModelClass< IFreelanceYearPeriodUpdateResult > implements IFreelanceYearPeriodUpdateResult {
    id: string;
    modifiedAtUtc?: Date;
    planerModifiedAtUtc?: Date;
    modifiedByPrincipal?: string;
    status: FreelancePeriodStatus;
}

export interface IFullCheckInCheckOutModel {
    date: Date;
    personId: string;
    isCo: boolean;
    checkInDateTime?: Date;
    checkOutDateTime?: Date;
    personCode: string;
    hasCustomCheckIn: boolean;
    hasCustomCheckOut: boolean;
}
export class FullCheckInCheckOutModel extends BaseApiModelClass< IFullCheckInCheckOutModel > implements IFullCheckInCheckOutModel {
    date: Date;
    personId: string;
    isCo: boolean;
    checkInDateTime?: Date;
    checkOutDateTime?: Date;
    personCode: string;
    hasCustomCheckIn: boolean;
    hasCustomCheckOut: boolean;
}

export interface IFunctionGroupModel {
    id: string;
    name: string;
    functions: FunctionModel[];
}
export class FunctionGroupModel extends BaseApiModelClass< IFunctionGroupModel > implements IFunctionGroupModel {
    id: string;
    name: string;
    functions: FunctionModel[];
}

export interface IFunctionModel {
    id: string;
    name: string;
    functionGroupId?: string;
    planningFunctionGroupId?: string;
    sinceDate: Date;
    isNewcomer: boolean;
    newcomerExperienceDate?: Date;
    planningGroup?: string;
    planningFunctionId?: string;
}
export class FunctionModel extends BaseApiModelClass< IFunctionModel > implements IFunctionModel {
    id: string;
    name: string;
    functionGroupId?: string;
    planningFunctionGroupId?: string;
    sinceDate: Date;
    isNewcomer: boolean;
    newcomerExperienceDate?: Date;
    planningGroup?: string;
    readonly planningFunctionId?: string;
}

export enum FunctionOverruleType {
    CC = "CC",
    CCA_320 = "CCA_320",
    CCA_334 = "CCA_334",
    CCA_345 = "CCA_345",
    FO = "FO",
    FOA_320 = "FOA_320",
    FOA_330 = "FOA_330",
    FOA_340 = "FOA_340",
    FOA_350 = "FOA_350",
    FON_320 = "FON_320",
    FON_330 = "FON_330",
    FON_340 = "FON_340",
    FON_350 = "FON_350",
    PIC = "PIC",
    PICA_320 = "PICA_320",
    PICA_330 = "PICA_330",
    PICA_340 = "PICA_340",
    PICA_350 = "PICA_350",
    PICN_320 = "PICN_320",
    PICN_330 = "PICN_330",
    PICN_340 = "PICN_340",
    PICN_350 = "PICN_350",
    SC = "SC",
    SCA_320 = "SCA_320",
    SCA_334 = "SCA_334",
    SCA_345 = "SCA_345",
}

export interface IGenDecAircraftRotation {
    items: GenDecAircraftRotationItem[];
}
export class GenDecAircraftRotation extends BaseApiModelClass< IGenDecAircraftRotation > implements IGenDecAircraftRotation {
    items: GenDecAircraftRotationItem[];
}

export interface IGenDecAircraftRotationItem {
    flightId: string;
    airlineRcd: string;
    flightNumber: number;
    departureDateTimeUtc: Date;
    departureDateTimeDiffToLt: string;
    arrivalDateTimeUtc: Date;
    arrivalDateTimeDiffToLt: string;
    estimatedDepartureDateTimeUtc?: Date;
    estimatedArrivalDateTimeUtc?: Date;
    outOfTheGateDateTimeUtc?: Date;
    aircraftRegistrationNumber?: string;
    originRcd: string;
    destinationRcd: string;
    aircraftTypeRcd?: string;
    isLongHaul: boolean;
    genDecInfo?: GenDecFlightInfo;
}
export class GenDecAircraftRotationItem extends BaseApiModelClass< IGenDecAircraftRotationItem > implements IGenDecAircraftRotationItem {
    flightId: string;
    airlineRcd: string;
    flightNumber: number;
    departureDateTimeUtc: Date;
    departureDateTimeDiffToLt: string;
    arrivalDateTimeUtc: Date;
    arrivalDateTimeDiffToLt: string;
    estimatedDepartureDateTimeUtc?: Date;
    estimatedArrivalDateTimeUtc?: Date;
    outOfTheGateDateTimeUtc?: Date;
    aircraftRegistrationNumber?: string;
    originRcd: string;
    destinationRcd: string;
    aircraftTypeRcd?: string;
    isLongHaul: boolean;
    genDecInfo?: GenDecFlightInfo;
}

export interface IGenDecConfigReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    countryTwoLetterCode: string;
    countryThreeLetterCode: string;
    countryName: string;
    airportThreeLetterCode: string;
    triggerType?: FlightTriggerType;
    isActive: boolean;
    isRequired: boolean;
    printOutNumber: number;
    method?: GenDecDeliveryMethod;
}
export class GenDecConfigReportModel extends BaseApiModelClass< IGenDecConfigReportModel > implements IGenDecConfigReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    countryTwoLetterCode: string;
    countryThreeLetterCode: string;
    countryName: string;
    airportThreeLetterCode: string;
    triggerType?: FlightTriggerType;
    isActive: boolean;
    isRequired: boolean;
    printOutNumber: number;
    method?: GenDecDeliveryMethod;
}

export interface IGenDecConfigurationDeliveryModel {
    method: GenDecDeliveryMethod;
    configuration: string;
}
export class GenDecConfigurationDeliveryModel extends BaseApiModelClass< IGenDecConfigurationDeliveryModel > implements IGenDecConfigurationDeliveryModel {
    method: GenDecDeliveryMethod;
    configuration: string;
}

export interface IGenDecConfigurationItem {
    groupNumber: number;
    triggers: FlightTriggerType[];
    deliveryMethods: GenDecConfigurationDeliveryModel[];
}
export class GenDecConfigurationItem extends BaseApiModelClass< IGenDecConfigurationItem > implements IGenDecConfigurationItem {
    groupNumber: number;
    triggers: FlightTriggerType[];
    deliveryMethods: GenDecConfigurationDeliveryModel[];
}

export interface IGenDecConfigurationModel {
    id: string;
    countryThreeLetterCode: string;
    countryTwoLetterCode: string;
    airportThreeLetterCode?: string;
    name: string;
    region?: string;
    subRegion?: string;
    intermediateRegion?: string;
    isActive: boolean;
    isRequired: boolean;
    numberOfPrintOuts: number;
    items: GenDecConfigurationItem[];
}
export class GenDecConfigurationModel extends BaseApiModelClass< IGenDecConfigurationModel > implements IGenDecConfigurationModel {
    id: string;
    countryThreeLetterCode: string;
    countryTwoLetterCode: string;
    airportThreeLetterCode?: string;
    name: string;
    region?: string;
    subRegion?: string;
    intermediateRegion?: string;
    isActive: boolean;
    isRequired: boolean;
    numberOfPrintOuts: number;
    items: GenDecConfigurationItem[];
}

export enum GenDecCrewType {
    Cabin = "Cabin",
    Cockpit = "Cockpit",
    DeadHead = "DeadHead",
    FFX = "FFX",
    Fse = "Fse",
    Full = "Full",
    None = "None",
    TIG = "TIG",
}

export enum GenDecDeliveryMethod {
    EmailToCrew = "EmailToCrew",
    Manual = "Manual",
    PdfAttachment = "PdfAttachment",
    PdfAttachmentByRoute = "PdfAttachmentByRoute",
}

export interface IGenDecDocumentRequest {
    flightIds?: string[];
    isPrint: boolean;
    includeEmptyPages: boolean;
    allowTemplate: boolean;
    crewTypes?: GenDecCrewType[];
}
export class GenDecDocumentRequest extends BaseApiModelClass< IGenDecDocumentRequest > implements IGenDecDocumentRequest {
    flightIds?: string[];
    isPrint: boolean;
    includeEmptyPages: boolean;
    allowTemplate: boolean;
    crewTypes?: GenDecCrewType[];
}

export interface IGenDecFlightEventStatus {
    flightId: string;
    items: GenDecFlightEventStatusItem[];
}
export class GenDecFlightEventStatus extends BaseApiModelClass< IGenDecFlightEventStatus > implements IGenDecFlightEventStatus {
    flightId: string;
    items: GenDecFlightEventStatusItem[];
}

export interface IGenDecFlightEventStatusItem {
    triggerType: FlightTriggerType;
    airportRcd: string;
    countryThreeLetterCode: string;
    eventTimeUtc?: Date;
    queueItemId?: string;
    isProcessed: boolean;
    processedAtUtc?: Date;
    failedCount: number;
    retryAtUtc?: Date;
    errorMessage?: string;
    resultStatus?: FlightQueueResultStatus;
    operationName?: string;
    ignoredMethods?: string;
}
export class GenDecFlightEventStatusItem extends BaseApiModelClass< IGenDecFlightEventStatusItem > implements IGenDecFlightEventStatusItem {
    triggerType: FlightTriggerType;
    airportRcd: string;
    countryThreeLetterCode: string;
    eventTimeUtc?: Date;
    queueItemId?: string;
    isProcessed: boolean;
    processedAtUtc?: Date;
    failedCount: number;
    retryAtUtc?: Date;
    errorMessage?: string;
    resultStatus?: FlightQueueResultStatus;
    operationName?: string;
    ignoredMethods?: string;
}

export interface IGenDecFlightInfo {
    fightId: string;
    documentId?: string;
    documentTimestamp?: Date;
    documentPrincipalId?: string;
    documentPrincipalFullName?: string;
    isAirportMissing: boolean;
    genDecRequiredOrigin: boolean;
    genDecRequiredDestination: boolean;
    printOutNumberOrigin?: number;
    printOutNumberDestination?: number;
    emailSentAt?: Date;
    emailFailedAt?: Date;
    emailFailureReason?: string;
}
export class GenDecFlightInfo extends BaseApiModelClass< IGenDecFlightInfo > implements IGenDecFlightInfo {
    fightId: string;
    documentId?: string;
    documentTimestamp?: Date;
    documentPrincipalId?: string;
    documentPrincipalFullName?: string;
    isAirportMissing: boolean;
    genDecRequiredOrigin: boolean;
    genDecRequiredDestination: boolean;
    printOutNumberOrigin?: number;
    printOutNumberDestination?: number;
    emailSentAt?: Date;
    emailFailedAt?: Date;
    emailFailureReason?: string;
}

export interface IGenDecReportData {
    reportId: string;
}
export class GenDecReportData extends BaseApiModelClass< IGenDecReportData > implements IGenDecReportData {
    reportId: string;
}

export enum Gender {
    Female = "Female",
    Male = "Male",
    None = "None",
}

export interface IGeneratedPlanHistoryItem {
    id: string;
    functionCode?: string;
    periodFrom: Date;
    periodTo: Date;
    createdAt: Date;
    createdByDisplayName: string;
    status: GeneratedPlanHistoryStatus;
}
export class GeneratedPlanHistoryItem extends BaseApiModelClass< IGeneratedPlanHistoryItem > implements IGeneratedPlanHistoryItem {
    id: string;
    functionCode?: string;
    periodFrom: Date;
    periodTo: Date;
    createdAt: Date;
    createdByDisplayName: string;
    status: GeneratedPlanHistoryStatus;
}

export enum GeneratedPlanHistoryStatus {
    Completed = "Completed",
    Failed = "Failed",
    InProgress = "InProgress",
    Queued = "Queued",
}

export interface IGroupingInfo {
    selector?: string;
    desc: boolean;
    groupInterval?: string;
    isExpanded?: boolean;
}
export class GroupingInfo extends BaseApiModelClass< IGroupingInfo > implements IGroupingInfo {
    selector?: string;
    desc: boolean;
    groupInterval?: string;
    isExpanded?: boolean;
}

export interface IHideDutyModel {
    days: PersonDaysModel[];
    hide: boolean;
}
export class HideDutyModel extends BaseApiModelClass< IHideDutyModel > implements IHideDutyModel {
    days: PersonDaysModel[];
    hide: boolean;
}

export interface IHolidayResponseItem {
    date: Date;
    displayName: string;
    weekendWeight: number;
}
export class HolidayResponseItem extends BaseApiModelClass< IHolidayResponseItem > implements IHolidayResponseItem {
    date: Date;
    displayName: string;
    weekendWeight: number;
}

export interface IHotelBookingDetailModel {
    transitionDate: string;
    transitionEmailDate: string;
    location: string;
    hotelEmail?: string;
    hotelTitle?: string;
    locationArrivalDateLt?: Date;
    locationEmailArrivalLt?: string;
    locationEmailArrivalDateLt?: string;
    locationArrivalRouteCode: string;
    locationDepartureDateLt?: Date;
    locationEmailDepartureLt?: string;
    locationEmailDepartureDateLt?: string;
    locationDepartureRouteCode: string;
    hotelDays: number;
    rooms: number;
}
export class HotelBookingDetailModel extends BaseApiModelClass< IHotelBookingDetailModel > implements IHotelBookingDetailModel {
    transitionDate: string;
    transitionEmailDate: string;
    location: string;
    hotelEmail?: string;
    hotelTitle?: string;
    locationArrivalDateLt?: Date;
    locationEmailArrivalLt?: string;
    locationEmailArrivalDateLt?: string;
    locationArrivalRouteCode: string;
    locationDepartureDateLt?: Date;
    locationEmailDepartureLt?: string;
    locationEmailDepartureDateLt?: string;
    locationDepartureRouteCode: string;
    hotelDays: number;
    rooms: number;
}

export interface IHotelBookingDetailsFilter {
    rowLimit?: number;
    year: number;
    month: number;
    location?: string;
}
export class HotelBookingDetailsFilter extends BaseApiModelClass< IHotelBookingDetailsFilter > implements IHotelBookingDetailsFilter {
    rowLimit?: number;
    year: number;
    month: number;
    location?: string;
}

export enum HotelDetailType {
    Company = "Company",
    Contact = "Contact",
    Email = "Email",
    Fax = "Fax",
    Mobile = "Mobile",
    Phone = "Phone",
    Remarks = "Remarks",
}

export interface IIncorrectAttestateDto {
    courseId: string;
    firstNameError?: string;
    lastNameError?: string;
    nationalityError?: string;
    birthDateError?: string;
    placeOfBirthError?: string;
}
export class IncorrectAttestateDto extends BaseApiModelClass< IIncorrectAttestateDto > implements IIncorrectAttestateDto {
    courseId: string;
    firstNameError?: string;
    lastNameError?: string;
    nationalityError?: string;
    birthDateError?: string;
    placeOfBirthError?: string;
}

export interface IInformReserveRequestModel {
    id: string;
    doNotSendEmail: boolean;
    overrideAllowed: boolean;
}
export class InformReserveRequestModel extends BaseApiModelClass< IInformReserveRequestModel > implements IInformReserveRequestModel {
    id: string;
    doNotSendEmail: boolean;
    overrideAllowed: boolean;
}

export interface IInstructorFilterDialogModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    codeName: string;
    name: string;
    sortOrder: number;
    isForCockpit: boolean;
    isForCabin: boolean;
    isActive: boolean;
    licenses: string[];
}
export class InstructorFilterDialogModel extends BaseApiModelClass< IInstructorFilterDialogModel > implements IInstructorFilterDialogModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    codeName: string;
    name: string;
    sortOrder: number;
    isForCockpit: boolean;
    isForCabin: boolean;
    isActive: boolean;
    licenses: string[];
}

export interface IInstructorFilterDialogModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}
export class InstructorFilterDialogModelDataSourceLoadOptions extends BaseApiModelClass< IInstructorFilterDialogModelDataSourceLoadOptions > implements IInstructorFilterDialogModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}

export interface IInstructorFilterGridFilter {
    rowLimit?: number;
}
export class InstructorFilterGridFilter extends BaseApiModelClass< IInstructorFilterGridFilter > implements IInstructorFilterGridFilter {
    rowLimit?: number;
}

export interface IInstructorFilterModel {
    code: string;
    name: string;
}
export class InstructorFilterModel extends BaseApiModelClass< IInstructorFilterModel > implements IInstructorFilterModel {
    code: string;
    name: string;
}

export enum InstructorRequirements {
    EBTI = "EBTI",
    SeniorTre = "SeniorTre",
    SFE = "SFE",
    SFI = "SFI",
    TC = "TC",
    TRE = "TRE",
    TRE3y = "TRE3y",
    TRI = "TRI",
    TRIr = "TRIr",
}

export interface IJeppesenButtonInfoModel {
    jobExecutionId?: string;
    jobTriggerName?: string;
    lastModifiedDateTimeUtc?: Date;
    jobTriggerStartDateTimeUtc?: Date;
    exportedFileName?: string;
    isFileExist: boolean;
    fileSize: number;
}
export class JeppesenButtonInfoModel extends BaseApiModelClass< IJeppesenButtonInfoModel > implements IJeppesenButtonInfoModel {
    jobExecutionId?: string;
    jobTriggerName?: string;
    lastModifiedDateTimeUtc?: Date;
    jobTriggerStartDateTimeUtc?: Date;
    exportedFileName?: string;
    isFileExist: boolean;
    fileSize: number;
}

export interface IJobDetailsModel {
    name: string;
    isActive: boolean;
    cronSchedule?: string;
    dateTimeSchedule?: Date;
    parameters: JobParameterDescriptionModel[];
}
export class JobDetailsModel extends BaseApiModelClass< IJobDetailsModel > implements IJobDetailsModel {
    name: string;
    isActive: boolean;
    cronSchedule?: string;
    dateTimeSchedule?: Date;
    parameters: JobParameterDescriptionModel[];
}

export interface IJobEnumModel {
    label: string;
    value: string;
}
export class JobEnumModel extends BaseApiModelClass< IJobEnumModel > implements IJobEnumModel {
    label: string;
    value: string;
}

export enum JobMisfireInstruction {
    Default = "Default",
    DoNothing = "DoNothing",
    FireAndProceed = "FireAndProceed",
    IgnoreMisfires = "IgnoreMisfires",
}

export interface IJobParameterDescriptionModel {
    name: string;
    valueRaw?: string;
    jobValueRaw?: string;
    displayName?: string;
    description?: string;
    type: JobParameterType;
    isRequired: boolean;
    isOverrule?: boolean;
    enumValues: JobEnumModel[];
    permissionName?: string;
}
export class JobParameterDescriptionModel extends BaseApiModelClass< IJobParameterDescriptionModel > implements IJobParameterDescriptionModel {
    name: string;
    valueRaw?: string;
    jobValueRaw?: string;
    displayName?: string;
    description?: string;
    type: JobParameterType;
    isRequired: boolean;
    isOverrule?: boolean;
    enumValues: JobEnumModel[];
    permissionName?: string;
}

export interface IJobParameterModel {
    name: string;
    value?: string;
}
export class JobParameterModel extends BaseApiModelClass< IJobParameterModel > implements IJobParameterModel {
    name: string;
    value?: string;
}

export enum JobParameterType {
    Boolean = "Boolean",
    Date = "Date",
    DateTime = "DateTime",
    Enum = "Enum",
    Integer = "Integer",
    Multiline = "Multiline",
    String = "String",
}

export interface IJobSaveParametersModel {
    jobName: string;
    triggerName: string;
    isActive: boolean;
    cronSchedule?: string;
    dateTimeSchedule?: Date;
    parameters?: JobParameterModel[];
    useZrhTimeZone: boolean;
    misfireLogic: JobMisfireInstruction;
    isJobSettings: boolean;
}
export class JobSaveParametersModel extends BaseApiModelClass< IJobSaveParametersModel > implements IJobSaveParametersModel {
    jobName: string;
    triggerName: string;
    isActive: boolean;
    cronSchedule?: string;
    dateTimeSchedule?: Date;
    parameters?: JobParameterModel[];
    useZrhTimeZone: boolean;
    misfireLogic: JobMisfireInstruction;
    isJobSettings: boolean;
}

export interface IJobSaveParametersResult {
    errors: string[];
    hasErrors: boolean;
}
export class JobSaveParametersResult extends BaseApiModelClass< IJobSaveParametersResult > implements IJobSaveParametersResult {
    errors: string[];
    readonly hasErrors: boolean;
}

export interface IJobStartModel {
    parameters?: JobParameterModel[];
}
export class JobStartModel extends BaseApiModelClass< IJobStartModel > implements IJobStartModel {
    parameters?: JobParameterModel[];
}

export enum JobStatus {
    Fail = "Fail",
    Pending = "Pending",
    Success = "Success",
}

export interface IJobTrigerStatus {
    isExecuting: boolean;
    triggerName: string;
}
export class JobTrigerStatus extends BaseApiModelClass< IJobTrigerStatus > implements IJobTrigerStatus {
    isExecuting: boolean;
    triggerName: string;
}

export interface IJobTriggerShortInfo {
    name: string;
    isActive: boolean;
    cronSchedule?: string;
    nextRunDateTime?: Date;
    nextAfterLastRunDateTime?: Date;
    lastRunDateTime?: Date;
    status?: JobStatus;
    progressMax?: number;
    progressCurrent?: number;
    currentMessage?: string;
    scheduleError?: string;
    dateTimeSchedule?: Date;
    useZrhTimeZone: boolean;
    misfireLogic: JobMisfireInstruction;
}
export class JobTriggerShortInfo extends BaseApiModelClass< IJobTriggerShortInfo > implements IJobTriggerShortInfo {
    name: string;
    isActive: boolean;
    cronSchedule?: string;
    nextRunDateTime?: Date;
    nextAfterLastRunDateTime?: Date;
    lastRunDateTime?: Date;
    status?: JobStatus;
    progressMax?: number;
    progressCurrent?: number;
    currentMessage?: string;
    scheduleError?: string;
    dateTimeSchedule?: Date;
    useZrhTimeZone: boolean;
    misfireLogic: JobMisfireInstruction;
}

export interface IJsErrorModel {
    message?: string;
    source?: string;
    url?: string;
}
export class JsErrorModel extends BaseApiModelClass< IJsErrorModel > implements IJsErrorModel {
    message?: string;
    source?: string;
    url?: string;
}

export interface ILandingDuty {
    date: Date;
    aircraftTypeGroupRcd: string;
    personDuties: LandingDutyItem[];
    crewDuties: LandingDutyItem[];
}
export class LandingDuty extends BaseApiModelClass< ILandingDuty > implements ILandingDuty {
    date: Date;
    aircraftTypeGroupRcd: string;
    personDuties: LandingDutyItem[];
    crewDuties: LandingDutyItem[];
}

export interface ILandingDutyItem {
    activityRcd?: string;
    isLanding: boolean;
    isTakeoff: boolean;
    isMonitoring: boolean;
    isForecast: boolean;
    personCode?: string;
    personFirstName?: string;
    personLastName?: string;
    personId: string;
    landingType: AircraftTypeRecencyLandingType;
    flightId?: string;
}
export class LandingDutyItem extends BaseApiModelClass< ILandingDutyItem > implements ILandingDutyItem {
    activityRcd?: string;
    isLanding: boolean;
    isTakeoff: boolean;
    isMonitoring: boolean;
    isForecast: boolean;
    personCode?: string;
    personFirstName?: string;
    personLastName?: string;
    personId: string;
    landingType: AircraftTypeRecencyLandingType;
    flightId?: string;
}

export enum LandingType {
    Combined = "Combined",
    Easa = "Easa",
    Edw = "Edw",
    Landing = "Landing",
    TakeOff = "TakeOff",
}

export interface ILicenseAircraftActivity {
    aircrafTypeName: string;
    aircrafTypeGroupName: string;
    activities: string[];
    functionActivities: string[];
    functionName?: string;
    activitiesAsString: string;
}
export class LicenseAircraftActivity extends BaseApiModelClass< ILicenseAircraftActivity > implements ILicenseAircraftActivity {
    aircrafTypeName: string;
    aircrafTypeGroupName: string;
    activities: string[];
    functionActivities: string[];
    functionName?: string;
    readonly activitiesAsString: string;
}

export interface ILicenseAirport {
    activityName?: string;
    airports: string[];
}
export class LicenseAirport extends BaseApiModelClass< ILicenseAirport > implements ILicenseAirport {
    activityName?: string;
    airports: string[];
}

export interface ILicenseApiModel {
    id: string;
    name: string;
    shortNameNeutral: string;
    isAircraftRelated: boolean;
    isAirportRelated: boolean;
    isFlightRelated: boolean;
    sortOrder: number;
}
export class LicenseApiModel extends BaseApiModelClass< ILicenseApiModel > implements ILicenseApiModel {
    id: string;
    name: string;
    shortNameNeutral: string;
    isAircraftRelated: boolean;
    isAirportRelated: boolean;
    isFlightRelated: boolean;
    sortOrder: number;
}

export interface ILicenseManagementAirportActivity {
    airportFourLetterCode?: string;
    activityCode?: string;
    validDateFrom: Date;
    validDateTo?: Date;
    groupName?: string;
}
export class LicenseManagementAirportActivity extends BaseApiModelClass< ILicenseManagementAirportActivity > implements ILicenseManagementAirportActivity {
    airportFourLetterCode?: string;
    activityCode?: string;
    validDateFrom: Date;
    validDateTo?: Date;
    groupName?: string;
}

export interface ILicenseManagementDialogModel {
    id?: string;
    name: string;
    licenseId: string;
    shortName: string;
    shortNameNeutral?: string;
    visibleInRoster: boolean;
    visibleInFilter: boolean;
    sortOrder: number;
    qualificationCategory?: QualificationCategory;
    functions: string[];
    airportActivities: LicenseManagementAirportActivity[];
    showFlightRequestWarning: boolean;
    flightRequestWarningText?: string;
}
export class LicenseManagementDialogModel extends BaseApiModelClass< ILicenseManagementDialogModel > implements ILicenseManagementDialogModel {
    id?: string;
    name: string;
    licenseId: string;
    shortName: string;
    shortNameNeutral?: string;
    visibleInRoster: boolean;
    visibleInFilter: boolean;
    sortOrder: number;
    qualificationCategory?: QualificationCategory;
    functions: string[];
    airportActivities: LicenseManagementAirportActivity[];
    showFlightRequestWarning: boolean;
    flightRequestWarningText?: string;
}

export interface ILicenseManagementFilter {
    rowLimit?: number;
}
export class LicenseManagementFilter extends BaseApiModelClass< ILicenseManagementFilter > implements ILicenseManagementFilter {
    rowLimit?: number;
}

export interface ILicenseManagementModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    id: string;
    name: string;
    licenseId: string;
    shortName: string;
    shortNameNeutral: string;
    qualificationCategory?: QualificationCategory;
    visibleInRoster: boolean;
    visibleInFilter: boolean;
    sortOrder: number;
    functions: string[];
    airportLicenses: LicenseManagementAirportActivity[];
    showFlightRequestWarning: boolean;
    flightRequestWarningText?: string;
}
export class LicenseManagementModel extends BaseApiModelClass< ILicenseManagementModel > implements ILicenseManagementModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    id: string;
    name: string;
    licenseId: string;
    shortName: string;
    shortNameNeutral: string;
    qualificationCategory?: QualificationCategory;
    visibleInRoster: boolean;
    visibleInFilter: boolean;
    sortOrder: number;
    functions: string[];
    airportLicenses: LicenseManagementAirportActivity[];
    showFlightRequestWarning: boolean;
    flightRequestWarningText?: string;
}

export interface ILicenseManagementModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}
export class LicenseManagementModelDataSourceLoadOptions extends BaseApiModelClass< ILicenseManagementModelDataSourceLoadOptions > implements ILicenseManagementModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}

export interface ILicenseManagementOptionsModel {
    airports: AirportShortInfo[];
    functionActivities: string[];
    flyingActivities: string[];
    nonFlyingActivities: string[];
}
export class LicenseManagementOptionsModel extends BaseApiModelClass< ILicenseManagementOptionsModel > implements ILicenseManagementOptionsModel {
    airports: AirportShortInfo[];
    functionActivities: string[];
    flyingActivities: string[];
    nonFlyingActivities: string[];
}

export interface ILicenseModel {
    personId: string;
    id: string;
    name: string;
    licenseId: string;
    shortName: string;
    visibleInRoster: boolean;
    isTrainee: boolean;
    sortOrder: number;
    licenseIssueDate?: Date;
    licenseExpirationDate?: Date;
}
export class LicenseModel extends BaseApiModelClass< ILicenseModel > implements ILicenseModel {
    personId: string;
    id: string;
    name: string;
    licenseId: string;
    shortName: string;
    visibleInRoster: boolean;
    isTrainee: boolean;
    sortOrder: number;
    licenseIssueDate?: Date;
    licenseExpirationDate?: Date;
}

export interface ILocalDaysModel {
    localDaysMonthPt: number;
    localDaysMonthInvalid: boolean;
    localDaysYearPt: number;
    localDaysYearMinDays: number;
    localDaysYearInvalid: boolean;
}
export class LocalDaysModel extends BaseApiModelClass< ILocalDaysModel > implements ILocalDaysModel {
    localDaysMonthPt: number;
    localDaysMonthInvalid: boolean;
    localDaysYearPt: number;
    localDaysYearMinDays: number;
    localDaysYearInvalid: boolean;
}

export interface ILocationDateTimeDiffToLt {
    locationRcd: string;
    displayDateTimeDiffToLt?: string;
}
export class LocationDateTimeDiffToLt extends BaseApiModelClass< ILocationDateTimeDiffToLt > implements ILocationDateTimeDiffToLt {
    locationRcd: string;
    displayDateTimeDiffToLt?: string;
}

export interface ILocationHotelBookingModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    transitionDate: Date;
    location: string;
    locationRoute: string;
    locationArrivalDateLt?: Date;
    locationArrivalFlightNumber: string;
    locationDepartureDateLt?: Date;
    locationDepartureFlightNumber: string;
    locationEmailArrivalLt?: string;
    locationEmailDepartureLt?: string;
    locationTimeDiff?: string;
    hotelDays: number;
    rooms: number;
    generatedBy?: string;
    generatedAtDateTimeUtc?: Date;
}
export class LocationHotelBookingModel extends BaseApiModelClass< ILocationHotelBookingModel > implements ILocationHotelBookingModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    transitionDate: Date;
    location: string;
    locationRoute: string;
    locationArrivalDateLt?: Date;
    locationArrivalFlightNumber: string;
    locationDepartureDateLt?: Date;
    locationDepartureFlightNumber: string;
    locationEmailArrivalLt?: string;
    locationEmailDepartureLt?: string;
    locationTimeDiff?: string;
    hotelDays: number;
    rooms: number;
    generatedBy?: string;
    generatedAtDateTimeUtc?: Date;
}

export interface ILocationHotelBookingModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}
export class LocationHotelBookingModelDataSourceLoadOptions extends BaseApiModelClass< ILocationHotelBookingModelDataSourceLoadOptions > implements ILocationHotelBookingModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}

export interface ILocationInfoHotelBookingFilter {
    rowLimit?: number;
    dateFrom: Date;
    dateTo: Date;
}
export class LocationInfoHotelBookingFilter extends BaseApiModelClass< ILocationInfoHotelBookingFilter > implements ILocationInfoHotelBookingFilter {
    rowLimit?: number;
    dateFrom: Date;
    dateTo: Date;
}

export interface ILocationMonthHotelBookingFilter {
    rowLimit?: number;
    year: number;
    month: number;
}
export class LocationMonthHotelBookingFilter extends BaseApiModelClass< ILocationMonthHotelBookingFilter > implements ILocationMonthHotelBookingFilter {
    rowLimit?: number;
    year: number;
    month: number;
}

export enum LogbookExportType {
    Pdf = "Pdf",
    Xlsx = "Xlsx",
}

export interface ILogbookFilter {
    date: Date;
}
export class LogbookFilter extends BaseApiModelClass< ILogbookFilter > implements ILogbookFilter {
    date: Date;
}

export interface ILogbookModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    date: Date;
    crew: string;
    departureAirport: string;
    departureTimeUtc: Date;
    arrivalAirport: string;
    arrivalTimeUtc: Date;
    isLongHaul: boolean;
    aircraftType: string;
    aircraftRegistration: string;
    landings: number;
    flightTime: number;
    functionTimePIC: number;
    functionTimeCopilot: number;
    crewRemarks: string;
}
export class LogbookModel extends BaseApiModelClass< ILogbookModel > implements ILogbookModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    date: Date;
    crew: string;
    departureAirport: string;
    departureTimeUtc: Date;
    arrivalAirport: string;
    arrivalTimeUtc: Date;
    isLongHaul: boolean;
    aircraftType: string;
    aircraftRegistration: string;
    landings: number;
    flightTime: number;
    functionTimePIC: number;
    functionTimeCopilot: number;
    crewRemarks: string;
}

export enum MailQueueStatus {
    Cancelled = "Cancelled",
    Failed = "Failed",
    NotSent = "NotSent",
    Sent = "Sent",
}

export enum MailQueueType {
    AircraftNotificationsMarshalsFse = "AircraftNotificationsMarshalsFse",
    CabinCrewAttestationBAZL = "CabinCrewAttestationBAZL",
    CabinCrewAttestationCheck = "CabinCrewAttestationCheck",
    CabinCrewAttestationCourseComplete = "CabinCrewAttestationCourseComplete",
    CabinCrewAttestationCourseIncorrect = "CabinCrewAttestationCourseIncorrect",
    CabinCrewAttestationReminder = "CabinCrewAttestationReminder",
    CrewApiAlert = "CrewApiAlert",
    CrewApiDirect = "CrewApiDirect",
    CrewApiDutyChange = "CrewApiDutyChange",
    CrewApiManual = "CrewApiManual",
    CrewApiMclDelete = "CrewApiMclDelete",
    CrewApiMclInsert = "CrewApiMclInsert",
    CrewApiMclUpdate = "CrewApiMclUpdate",
    CrewApiPersonChange = "CrewApiPersonChange",
    CrewApiRelated = "CrewApiRelated",
    CrewDutyListReport = "CrewDutyListReport",
    DosimetryBag = "DosimetryBag",
    FreelanceTool = "FreelanceTool",
    GenDecDutyChange = "GenDecDutyChange",
    GenDecManual = "GenDecManual",
    GenDecPlanned = "GenDecPlanned",
    HotelManagement = "HotelManagement",
    Logbook = "Logbook",
    NbuAlertControllerCompleted = "NbuAlertControllerCompleted",
    NbuAlertControllerPast = "NbuAlertControllerPast",
    NbuAlertCrew = "NbuAlertCrew",
    PersonDayIllNotify = "PersonDayIllNotify",
    PersonDayUnfitNotify = "PersonDayUnfitNotify",
    PersonRequestReserve = "PersonRequestReserve",
    PersonRequestVacBlock = "PersonRequestVacBlock",
    PersonRequestVacData = "PersonRequestVacData",
    ReleaseNotification = "ReleaseNotification",
    SabreReminder = "SabreReminder",
    StandbyReportAutomatization = "StandbyReportAutomatization",
    SummaryCrewMissingData = "SummaryCrewMissingData",
    SummaryErrorsData = "SummaryErrorsData",
}

export interface IMaintenanceModel {
    isMaintenanceOn: boolean;
    maintenanceMessage?: string;
    isNotifyingMaintenanceMessageOn: boolean;
    notifyingMessage?: string;
}
export class MaintenanceModel extends BaseApiModelClass< IMaintenanceModel > implements IMaintenanceModel {
    isMaintenanceOn: boolean;
    maintenanceMessage?: string;
    isNotifyingMaintenanceMessageOn: boolean;
    notifyingMessage?: string;
}

export interface IMclNotSentPeopleStatus {
    notSentPeople?: PersonMclModel[];
    endOfPlanningPeriodDate: Date;
}
export class MclNotSentPeopleStatus extends BaseApiModelClass< IMclNotSentPeopleStatus > implements IMclNotSentPeopleStatus {
    notSentPeople?: PersonMclModel[];
    endOfPlanningPeriodDate: Date;
}

export enum MealReportType {
    LH = "LH",
    SH = "SH",
}

export interface IMedicalLicenseReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    date: Date;
    personCode: string;
    personName?: string;
    contract?: string;
    function?: string;
    medicalStatus: number;
    visaChinaStatus: number;
    visaUsaBStatus: number;
    visaUsaCStatus: number;
    passportStatus: number;
    secondPassportStatus: number;
    backgroundCheckStatus: number;
    backgroundCheckStartDate?: Date;
    backgroundCheckEndDate?: Date;
    medicalExpireDate?: Date;
    visaChinaExpirationDate?: Date;
    visaUsaBExpirationDate?: Date;
    visaUsaCExpirationDate?: Date;
    passportExpirationDate?: Date;
    secondPassportExpirationDate?: Date;
    lineCheckExpireDate?: Date;
    latestPlanedTraineeDate?: Date;
    lineCheckStatus: number;
    medicalClearanceDate?: Date;
    isRequiredMedicalClearance: boolean;
}
export class MedicalLicenseReportModel extends BaseApiModelClass< IMedicalLicenseReportModel > implements IMedicalLicenseReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    date: Date;
    personCode: string;
    personName?: string;
    contract?: string;
    function?: string;
    medicalStatus: number;
    visaChinaStatus: number;
    visaUsaBStatus: number;
    visaUsaCStatus: number;
    passportStatus: number;
    secondPassportStatus: number;
    backgroundCheckStatus: number;
    backgroundCheckStartDate?: Date;
    backgroundCheckEndDate?: Date;
    medicalExpireDate?: Date;
    visaChinaExpirationDate?: Date;
    visaUsaBExpirationDate?: Date;
    visaUsaCExpirationDate?: Date;
    passportExpirationDate?: Date;
    secondPassportExpirationDate?: Date;
    lineCheckExpireDate?: Date;
    latestPlanedTraineeDate?: Date;
    lineCheckStatus: number;
    medicalClearanceDate?: Date;
    isRequiredMedicalClearance: boolean;
}

export interface IMedicalLicenseReportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}
export class MedicalLicenseReportModelDataSourceLoadOptions extends BaseApiModelClass< IMedicalLicenseReportModelDataSourceLoadOptions > implements IMedicalLicenseReportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}

export interface IMessageHistoryModel {
    id: string;
    processingDate: Date;
    label: string;
    message: string;
    isOutDirection: boolean;
}
export class MessageHistoryModel extends BaseApiModelClass< IMessageHistoryModel > implements IMessageHistoryModel {
    id: string;
    processingDate: Date;
    label: string;
    message: string;
    isOutDirection: boolean;
}

export enum MessageLabel {
    AcarsM45 = "AcarsM45",
    AcarsOooi = "AcarsOooi",
    Aircraft = "Aircraft",
    AircraftMaintenance = "AircraftMaintenance",
    AircraftsAssignment = "AircraftsAssignment",
    AircraftType = "AircraftType",
    Airport = "Airport",
    AlteaDcsCatering = "AlteaDcsCatering",
    CateredMeals = "CateredMeals",
    CrewAssignment = "CrewAssignment",
    CrewNotification = "CrewNotification",
    Error = "Error",
    Flight = "Flight",
    FlightMeal = "FlightMeal",
    FlightPilotStatus = "FlightPilotStatus",
    JeppesenCheckerTrainee = "JeppesenCheckerTrainee",
    JeppesenDuty = "JeppesenDuty",
    JeppesenError = "JeppesenError",
    JeppesenFlight = "JeppesenFlight",
    JeppesenTrip = "JeppesenTrip",
    LegDetail = "LegDetail",
    Person = "Person",
    PersonDay = "PersonDay",
    Rotation = "Rotation",
    SsimFlightAdded = "SsimFlightAdded",
    SsimFlightDeleted = "SsimFlightDeleted",
    SsimFlightModified = "SsimFlightModified",
    Unknown = "Unknown",
}

export interface IMessageStatisticsItemModel {
    key: string;
    value: number;
}
export class MessageStatisticsItemModel extends BaseApiModelClass< IMessageStatisticsItemModel > implements IMessageStatisticsItemModel {
    key: string;
    value: number;
}

export interface IMessageStatisticsModel {
    messageType: string;
    statistics: MessageStatisticsItemModel[];
    directionType: DirectionType;
}
export class MessageStatisticsModel extends BaseApiModelClass< IMessageStatisticsModel > implements IMessageStatisticsModel {
    messageType: string;
    statistics: MessageStatisticsItemModel[];
    directionType: DirectionType;
}

export enum MonthlyType {
    AcceptedError = "AcceptedError",
    AgreementError = "AgreementError",
    Blank = "Blank",
    COU = "COU",
    DTY = "DTY",
    EasaError = "EasaError",
    FlightRequest = "FlightRequest",
    FtlError = "FtlError",
    GavError = "GavError",
    LicenseExpired = "LicenseExpired",
    LTO = "LTO",
    NAS = "NAS",
    OtherError = "OtherError",
    PersonComments = "PersonComments",
    Reserve = "Reserve",
    STO = "STO",
    VAC = "VAC",
}

export interface IMonthlyTypeModel {
    name: string;
    value: number;
}
export class MonthlyTypeModel extends BaseApiModelClass< IMonthlyTypeModel > implements IMonthlyTypeModel {
    name: string;
    value: number;
}

export interface IMoveRotationModel {
    sourceRotationId: string;
    destinationRotationIds: string[];
    type: CrewType;
    overrideAllowed: boolean;
}
export class MoveRotationModel extends BaseApiModelClass< IMoveRotationModel > implements IMoveRotationModel {
    sourceRotationId: string;
    destinationRotationIds: string[];
    type: CrewType;
    overrideAllowed: boolean;
}

export interface IMoveSectorModel {
    sourceFlightId: string;
    destinationFlightIds: string[];
    type: CrewType;
    overrideAllowed: boolean;
}
export class MoveSectorModel extends BaseApiModelClass< IMoveSectorModel > implements IMoveSectorModel {
    sourceFlightId: string;
    destinationFlightIds: string[];
    type: CrewType;
    overrideAllowed: boolean;
}

export interface IMultiDayCommentCreateDto {
    text: string;
    isStandby: boolean;
    isVisibleByCrewMember: boolean;
    isVisibleToAllUsers: boolean;
    personDays: PersonDayDto[];
}
export class MultiDayCommentCreateDto extends BaseApiModelClass< IMultiDayCommentCreateDto > implements IMultiDayCommentCreateDto {
    text: string;
    isStandby: boolean;
    isVisibleByCrewMember: boolean;
    isVisibleToAllUsers: boolean;
    personDays: PersonDayDto[];
}

export interface INonFlightDutyInfoModel {
    title?: string;
    briefInfo?: string;
    codeName: string;
    dateTimeFromUtc?: Date;
    dateTimeToUtc?: Date;
}
export class NonFlightDutyInfoModel extends BaseApiModelClass< INonFlightDutyInfoModel > implements INonFlightDutyInfoModel {
    title?: string;
    briefInfo?: string;
    codeName: string;
    dateTimeFromUtc?: Date;
    dateTimeToUtc?: Date;
}

export interface IOffDaysModel {
    offDaysMonth: number;
    offDaysMonthInvalid: boolean;
    offDaysQuarter: number;
    offDaysQuarterMinDays: number;
    offDaysQuarterInvalid: boolean;
    offDaysYearPt: number;
    offDaysYearMinDays: number;
    offDaysYearInvalid: boolean;
    monthDooo2Date?: Date;
    rollingDooo2Date?: Date;
}
export class OffDaysModel extends BaseApiModelClass< IOffDaysModel > implements IOffDaysModel {
    offDaysMonth: number;
    offDaysMonthInvalid: boolean;
    offDaysQuarter: number;
    offDaysQuarterMinDays: number;
    offDaysQuarterInvalid: boolean;
    offDaysYearPt: number;
    offDaysYearMinDays: number;
    offDaysYearInvalid: boolean;
    monthDooo2Date?: Date;
    rollingDooo2Date?: Date;
}

export interface IOffDaysReportFilter {
    rowLimit?: number;
    year?: number;
    functionId?: string;
    personIds?: string[];
}
export class OffDaysReportFilter extends BaseApiModelClass< IOffDaysReportFilter > implements IOffDaysReportFilter {
    rowLimit?: number;
    year?: number;
    functionId?: string;
    personIds?: string[];
}

export interface IOffDaysReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    personId: string;
    personCode?: string;
    personName?: string;
    personEntryDate?: Date;
    personExitDate?: Date;
    personContract?: string;
    personFunction?: string;
    offDaysM1: number;
    offDaysM2: number;
    offDaysM3: number;
    offDaysM4: number;
    offDaysM5: number;
    offDaysM6: number;
    offDaysM7: number;
    offDaysM8: number;
    offDaysM9: number;
    offDaysM10: number;
    offDaysM11: number;
    offDaysM12: number;
    offDaysQ1: number;
    offDaysQ2: number;
    offDaysQ3: number;
    offDaysQ4: number;
    singleDaysM1: number;
    singleDaysM2: number;
    singleDaysM3: number;
    singleDaysM4: number;
    singleDaysM5: number;
    singleDaysM6: number;
    singleDaysM7: number;
    singleDaysM8: number;
    singleDaysM9: number;
    singleDaysM10: number;
    singleDaysM11: number;
    singleDaysM12: number;
    localDaysM1: number;
    localDaysM2: number;
    localDaysM3: number;
    localDaysM4: number;
    localDaysM5: number;
    localDaysM6: number;
    localDaysM7: number;
    localDaysM8: number;
    localDaysM9: number;
    localDaysM10: number;
    localDaysM11: number;
    localDaysM12: number;
    localDaysYear: number;
    offDaysYear: number;
    threeMonthNdjDays: number;
    threeMonthDjfDays: number;
    threeMonthJfmDays: number;
    threeMonthFmaDays: number;
    threeMonthMamDays: number;
    threeMonthAmjDays: number;
    threeMonthMjjDays: number;
    threeMonthJjaDays: number;
    threeMonthJasDays: number;
    threeMonthAsoDays: number;
    threeMonthSonDays: number;
    threeMonthOndDays: number;
    threeMonthNdjNextDays: number;
    threeMonthDjfNextDays: number;
}
export class OffDaysReportModel extends BaseApiModelClass< IOffDaysReportModel > implements IOffDaysReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    personId: string;
    personCode?: string;
    personName?: string;
    personEntryDate?: Date;
    personExitDate?: Date;
    personContract?: string;
    personFunction?: string;
    offDaysM1: number;
    offDaysM2: number;
    offDaysM3: number;
    offDaysM4: number;
    offDaysM5: number;
    offDaysM6: number;
    offDaysM7: number;
    offDaysM8: number;
    offDaysM9: number;
    offDaysM10: number;
    offDaysM11: number;
    offDaysM12: number;
    offDaysQ1: number;
    offDaysQ2: number;
    offDaysQ3: number;
    offDaysQ4: number;
    singleDaysM1: number;
    singleDaysM2: number;
    singleDaysM3: number;
    singleDaysM4: number;
    singleDaysM5: number;
    singleDaysM6: number;
    singleDaysM7: number;
    singleDaysM8: number;
    singleDaysM9: number;
    singleDaysM10: number;
    singleDaysM11: number;
    singleDaysM12: number;
    readonly localDaysM1: number;
    readonly localDaysM2: number;
    readonly localDaysM3: number;
    readonly localDaysM4: number;
    readonly localDaysM5: number;
    readonly localDaysM6: number;
    readonly localDaysM7: number;
    readonly localDaysM8: number;
    readonly localDaysM9: number;
    readonly localDaysM10: number;
    readonly localDaysM11: number;
    readonly localDaysM12: number;
    readonly localDaysYear: number;
    offDaysYear: number;
    threeMonthNdjDays: number;
    threeMonthDjfDays: number;
    threeMonthJfmDays: number;
    threeMonthFmaDays: number;
    threeMonthMamDays: number;
    threeMonthAmjDays: number;
    threeMonthMjjDays: number;
    threeMonthJjaDays: number;
    threeMonthJasDays: number;
    threeMonthAsoDays: number;
    threeMonthSonDays: number;
    threeMonthOndDays: number;
    threeMonthNdjNextDays: number;
    threeMonthDjfNextDays: number;
}

export interface IOffDaysReportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}
export class OffDaysReportModelDataSourceLoadOptions extends BaseApiModelClass< IOffDaysReportModelDataSourceLoadOptions > implements IOffDaysReportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}

export interface IOffLimitsDto {
    personId: string;
    ltoCountAllowedPerPeriod: number;
    ltoCountCurrent: number;
}
export class OffLimitsDto extends BaseApiModelClass< IOffLimitsDto > implements IOffLimitsDto {
    personId: string;
    ltoCountAllowedPerPeriod: number;
    ltoCountCurrent: number;
}

export interface IOperationGroup {
    principalId: string;
    principalName?: string;
    principalEmail: string;
    operations: OperationItem[];
}
export class OperationGroup extends BaseApiModelClass< IOperationGroup > implements IOperationGroup {
    principalId: string;
    principalName?: string;
    principalEmail: string;
    operations: OperationItem[];
}

export interface IOperationItem {
    operationId: string;
    operationName: string;
    operationTimestamp: string;
    operationDescription: string;
}
export class OperationItem extends BaseApiModelClass< IOperationItem > implements IOperationItem {
    operationId: string;
    operationName: string;
    operationTimestamp: string;
    operationDescription: string;
}

export interface IPageLocation {
    location?: string;
    locationName?: string;
    personId?: string;
    personCode?: string;
    date?: Date;
    groups: string[];
    isActive: boolean;
    lastActivityDate?: Date;
}
export class PageLocation extends BaseApiModelClass< IPageLocation > implements IPageLocation {
    location?: string;
    locationName?: string;
    personId?: string;
    personCode?: string;
    date?: Date;
    groups: string[];
    isActive: boolean;
    lastActivityDate?: Date;
}

export enum PartialLoadType {
    Part1_2 = "Part1_2",
    Part1_3 = "Part1_3",
    Part2_2 = "Part2_2",
    Part2_3 = "Part2_3",
    Part3_3 = "Part3_3",
}

export interface IPartialLoadTypeModel {
    name: string;
    value: PartialLoadType;
}
export class PartialLoadTypeModel extends BaseApiModelClass< IPartialLoadTypeModel > implements IPartialLoadTypeModel {
    name: string;
    value: PartialLoadType;
}

export interface IPeriodValidationErrorsModel {
    id: string;
    validationErrors: string[];
    canDeviateByCrew: boolean;
    cockpitJulOctReduction: number;
}
export class PeriodValidationErrorsModel extends BaseApiModelClass< IPeriodValidationErrorsModel > implements IPeriodValidationErrorsModel {
    id: string;
    validationErrors: string[];
    canDeviateByCrew: boolean;
    cockpitJulOctReduction: number;
}

export interface IPermissionModel {
    id: number;
    codeName: string;
    description: string;
}
export class PermissionModel extends BaseApiModelClass< IPermissionModel > implements IPermissionModel {
    id: number;
    codeName: string;
    description: string;
}

export interface IPersonAfterTrainingExperience {
    isCompleted: boolean;
    a320LegsCount?: number;
    scKurs1Date?: Date;
    a345LegsCount?: number;
    scKurs2Date?: Date;
}
export class PersonAfterTrainingExperience extends BaseApiModelClass< IPersonAfterTrainingExperience > implements IPersonAfterTrainingExperience {
    isCompleted: boolean;
    a320LegsCount?: number;
    scKurs1Date?: Date;
    a345LegsCount?: number;
    scKurs2Date?: Date;
}

export interface IPersonAirbusTypeModel {
    id: string;
    name: string;
    isVisible: boolean;
}
export class PersonAirbusTypeModel extends BaseApiModelClass< IPersonAirbusTypeModel > implements IPersonAirbusTypeModel {
    id: string;
    name: string;
    isVisible: boolean;
}

export interface IPersonAircraftTypeExperienceModel {
    aircraftTypeGroupId: string;
    activityName: string;
    blockHoursSec: number;
    sectorsCount: number;
    lastFlcDate?: Date;
    afterTrainingLegsCount: number;
    trainingDate?: Date;
    isExperienced: boolean;
    isNewcomer: boolean;
}
export class PersonAircraftTypeExperienceModel extends BaseApiModelClass< IPersonAircraftTypeExperienceModel > implements IPersonAircraftTypeExperienceModel {
    aircraftTypeGroupId: string;
    activityName: string;
    blockHoursSec: number;
    sectorsCount: number;
    lastFlcDate?: Date;
    afterTrainingLegsCount: number;
    trainingDate?: Date;
    isExperienced: boolean;
    isNewcomer: boolean;
}

export interface IPersonAircraftTypeExperienceOverrule {
    personId: string;
    code?: string;
    fullName?: string;
    activityId: string;
    activityCode?: string;
    aircraftTypeGroupId: string;
    aircraftTypeGroupName?: string;
    date: Date;
    thisPeriodExperiencedSinceDate?: Date;
    isExperienced: boolean;
    sectors: number;
    blockHoursSec: number;
    timestamp?: Date;
}
export class PersonAircraftTypeExperienceOverrule extends BaseApiModelClass< IPersonAircraftTypeExperienceOverrule > implements IPersonAircraftTypeExperienceOverrule {
    personId: string;
    code?: string;
    fullName?: string;
    activityId: string;
    activityCode?: string;
    aircraftTypeGroupId: string;
    aircraftTypeGroupName?: string;
    date: Date;
    thisPeriodExperiencedSinceDate?: Date;
    isExperienced: boolean;
    sectors: number;
    blockHoursSec: number;
    timestamp?: Date;
}

export interface IPersonAircraftTypeRecencyLandingModel {
    type: AircraftTypeRecencyLandingType;
    date: Date;
    aircraftTypeGroupId: string;
    count: number;
    airport?: string;
    arrivalDateTimeUtc?: Date;
    isCauseRecency: boolean;
    isForecast: boolean;
}
export class PersonAircraftTypeRecencyLandingModel extends BaseApiModelClass< IPersonAircraftTypeRecencyLandingModel > implements IPersonAircraftTypeRecencyLandingModel {
    type: AircraftTypeRecencyLandingType;
    date: Date;
    aircraftTypeGroupId: string;
    count: number;
    airport?: string;
    arrivalDateTimeUtc?: Date;
    isCauseRecency: boolean;
    isForecast: boolean;
}

export interface IPersonAircraftTypeRecencyModel {
    aircraftTypeGroupId: string;
    recencyTillDate?: Date;
    recencyLandingTillDate?: Date;
    recencyTakeoffTillDate?: Date;
    recencyTillDateWithFuture?: Date;
    recencyLandingTillDateWithFuture?: Date;
    recencyTakeoffTillDateWithFuture?: Date;
    lastRecencyTillDate?: Date;
    lastRecencyLandingTillDate?: Date;
    lastRecencyTakeoffTillDate?: Date;
    landings?: PersonAircraftTypeRecencyLandingModel[];
    takeoffs?: PersonAircraftTypeRecencyLandingModel[];
}
export class PersonAircraftTypeRecencyModel extends BaseApiModelClass< IPersonAircraftTypeRecencyModel > implements IPersonAircraftTypeRecencyModel {
    aircraftTypeGroupId: string;
    recencyTillDate?: Date;
    recencyLandingTillDate?: Date;
    recencyTakeoffTillDate?: Date;
    recencyTillDateWithFuture?: Date;
    recencyLandingTillDateWithFuture?: Date;
    recencyTakeoffTillDateWithFuture?: Date;
    lastRecencyTillDate?: Date;
    lastRecencyLandingTillDate?: Date;
    lastRecencyTakeoffTillDate?: Date;
    landings?: PersonAircraftTypeRecencyLandingModel[];
    takeoffs?: PersonAircraftTypeRecencyLandingModel[];
}

export enum PersonAlternativeRequestDecision {
    Accept = "Accept",
    Decline = "Decline",
}

export interface IPersonAvailableVacTypeDaysAndDeadline {
    type: PersonRequestVacType;
    options: PersonRequestVacDeadlineOption[];
}
export class PersonAvailableVacTypeDaysAndDeadline extends BaseApiModelClass< IPersonAvailableVacTypeDaysAndDeadline > implements IPersonAvailableVacTypeDaysAndDeadline {
    type: PersonRequestVacType;
    options: PersonRequestVacDeadlineOption[];
}

export interface IPersonChangeLogConfirmModel {
    id: string;
}
export class PersonChangeLogConfirmModel extends BaseApiModelClass< IPersonChangeLogConfirmModel > implements IPersonChangeLogConfirmModel {
    id: string;
}

export interface IPersonChangeLogModel {
    id: string;
    personId: string;
    date: Date;
    oldDuty: string;
    newDuty: string;
    reason: string;
    createDate: Date;
    confirmationDate?: Date;
    isConfirmed: boolean;
}
export class PersonChangeLogModel extends BaseApiModelClass< IPersonChangeLogModel > implements IPersonChangeLogModel {
    id: string;
    personId: string;
    date: Date;
    oldDuty: string;
    newDuty: string;
    reason: string;
    createDate: Date;
    confirmationDate?: Date;
    isConfirmed: boolean;
}

export interface IPersonCheckerTraineeModel {
    aircraftTypeGroupCodeName: string;
    activityCodeName: string;
    date: Date;
    checkerTraineeFunction: CheckerTraineeFunction;
    isOverrule?: boolean;
    rotationEndDate?: Date;
}
export class PersonCheckerTraineeModel extends BaseApiModelClass< IPersonCheckerTraineeModel > implements IPersonCheckerTraineeModel {
    aircraftTypeGroupCodeName: string;
    activityCodeName: string;
    date: Date;
    checkerTraineeFunction: CheckerTraineeFunction;
    isOverrule?: boolean;
    rotationEndDate?: Date;
}

export interface IPersonCommentCreateDto {
    text: string;
    isStandby: boolean;
    isVisibleByCrewMember: boolean;
    isVisibleToAllUsers: boolean;
    personId: string;
    validFromDate: Date;
    validToDate?: Date;
}
export class PersonCommentCreateDto extends BaseApiModelClass< IPersonCommentCreateDto > implements IPersonCommentCreateDto {
    text: string;
    isStandby: boolean;
    isVisibleByCrewMember: boolean;
    isVisibleToAllUsers: boolean;
    personId: string;
    validFromDate: Date;
    validToDate?: Date;
}

export interface IPersonCommentReadDto {
    text: string;
    isStandby: boolean;
    isVisibleByCrewMember: boolean;
    isVisibleToAllUsers: boolean;
    personId: string;
    validFromDate: Date;
    validToDate?: Date;
    commentId?: string;
    modifiedAtDateUtc?: Date;
    modifiedBy: string;
    createdAtDateUtc?: Date;
    createdBy: string;
}
export class PersonCommentReadDto extends BaseApiModelClass< IPersonCommentReadDto > implements IPersonCommentReadDto {
    text: string;
    isStandby: boolean;
    isVisibleByCrewMember: boolean;
    isVisibleToAllUsers: boolean;
    personId: string;
    validFromDate: Date;
    validToDate?: Date;
    commentId?: string;
    modifiedAtDateUtc?: Date;
    modifiedBy: string;
    createdAtDateUtc?: Date;
    createdBy: string;
}

export interface IPersonCommentUpdateDto {
    text: string;
    isStandby: boolean;
    isVisibleByCrewMember: boolean;
    isVisibleToAllUsers: boolean;
    personId: string;
    validFromDate: Date;
    validToDate?: Date;
    commentId?: string;
}
export class PersonCommentUpdateDto extends BaseApiModelClass< IPersonCommentUpdateDto > implements IPersonCommentUpdateDto {
    text: string;
    isStandby: boolean;
    isVisibleByCrewMember: boolean;
    isVisibleToAllUsers: boolean;
    personId: string;
    validFromDate: Date;
    validToDate?: Date;
    commentId?: string;
}

export interface IPersonConsecutiveMonthsDaysOffModel {
    personId: string;
    year: number;
    jfmMonths?: number;
    fmaMonths?: number;
    mamMonths?: number;
    amjMonths?: number;
    mjjMonths?: number;
    jjaMonths?: number;
    jasMonths?: number;
    asoMonths?: number;
    sonMonths?: number;
    ondMonths?: number;
    ndjMonths?: number;
    djfMonths?: number;
    jfmMonthsLimit?: number;
    fmaMonthsLimit?: number;
    mamMonthsLimit?: number;
    amjMonthsLimit?: number;
    mjjMonthsLimit?: number;
    jjaMonthsLimit?: number;
    jasMonthsLimit?: number;
    asoMonthsLimit?: number;
    sonMonthsLimit?: number;
    ondMonthsLimit?: number;
    ndjMonthsLimit?: number;
    djfMonthsLimit?: number;
}
export class PersonConsecutiveMonthsDaysOffModel extends BaseApiModelClass< IPersonConsecutiveMonthsDaysOffModel > implements IPersonConsecutiveMonthsDaysOffModel {
    personId: string;
    year: number;
    jfmMonths?: number;
    fmaMonths?: number;
    mamMonths?: number;
    amjMonths?: number;
    mjjMonths?: number;
    jjaMonths?: number;
    jasMonths?: number;
    asoMonths?: number;
    sonMonths?: number;
    ondMonths?: number;
    ndjMonths?: number;
    djfMonths?: number;
    jfmMonthsLimit?: number;
    fmaMonthsLimit?: number;
    mamMonthsLimit?: number;
    amjMonthsLimit?: number;
    mjjMonthsLimit?: number;
    jjaMonthsLimit?: number;
    jasMonthsLimit?: number;
    asoMonthsLimit?: number;
    sonMonthsLimit?: number;
    ondMonthsLimit?: number;
    ndjMonthsLimit?: number;
    djfMonthsLimit?: number;
}

export interface IPersonContractInfoModel {
    id: string;
    personId: string;
    actualContractType: string;
    actualContractPartTimePercentage?: number;
    contractType: ContractType;
    officePercentage?: number;
}
export class PersonContractInfoModel extends BaseApiModelClass< IPersonContractInfoModel > implements IPersonContractInfoModel {
    id: string;
    personId: string;
    readonly actualContractType: string;
    actualContractPartTimePercentage?: number;
    contractType: ContractType;
    officePercentage?: number;
}

export interface IPersonContractReserveLimitInfo {
    contractType: ContractType;
    contractModelType: ContractModelType;
    available: number;
    contractPartTimePercentage: number;
    dateFrom: Date;
    dateTo: Date;
}
export class PersonContractReserveLimitInfo extends BaseApiModelClass< IPersonContractReserveLimitInfo > implements IPersonContractReserveLimitInfo {
    contractType: ContractType;
    contractModelType: ContractModelType;
    available: number;
    contractPartTimePercentage: number;
    dateFrom: Date;
    dateTo: Date;
}

export interface IPersonCourseDto {
    id?: string;
    refId?: string;
    personId: string;
    personCode: string;
    status: CabinCrewAttestationStatus;
    isCourseDone: boolean;
    isDeleted: boolean;
    signatureId?: string;
    locationLatitude?: number;
    locationLongitude?: number;
    ipAddress?: string;
    firstName?: string;
    lastName?: string;
    birthDate?: Date;
    placeofBirth?: string;
    nationality?: string;
    hasAttestate?: boolean;
}
export class PersonCourseDto extends BaseApiModelClass< IPersonCourseDto > implements IPersonCourseDto {
    id?: string;
    refId?: string;
    personId: string;
    personCode: string;
    status: CabinCrewAttestationStatus;
    isCourseDone: boolean;
    isDeleted: boolean;
    signatureId?: string;
    locationLatitude?: number;
    locationLongitude?: number;
    ipAddress?: string;
    firstName?: string;
    lastName?: string;
    birthDate?: Date;
    placeofBirth?: string;
    nationality?: string;
    hasAttestate?: boolean;
}

export interface IPersonDatePopupDataModel {
    offDetails?: PersonDatePopupShadowOffDetails;
    validationErrors: DutyValidationErrorModel[];
    nonFlightDutyInfos: NonFlightDutyInfoModel[];
    flightsInfo: RotationFlightsInfoModel;
    shiftedFlightsInfo?: ShiftedFlightsInfoModel;
    checkerTraineeInfos: DutyTraineeCheckerPopupInfoModel[];
    dayComments: PopUpDayComment[];
    planningNotes: PopUpDayComment[];
    inProgressRequests: string[];
    approvedRequests: string[];
    rejectedRequests: string[];
    rotationComplementsInfos: PersonRotationComplementsDto[];
    planningDayInfo?: PlanningDayDto;
}
export class PersonDatePopupDataModel extends BaseApiModelClass< IPersonDatePopupDataModel > implements IPersonDatePopupDataModel {
    offDetails?: PersonDatePopupShadowOffDetails;
    validationErrors: DutyValidationErrorModel[];
    nonFlightDutyInfos: NonFlightDutyInfoModel[];
    flightsInfo: RotationFlightsInfoModel;
    shiftedFlightsInfo?: ShiftedFlightsInfoModel;
    checkerTraineeInfos: DutyTraineeCheckerPopupInfoModel[];
    dayComments: PopUpDayComment[];
    planningNotes: PopUpDayComment[];
    inProgressRequests: string[];
    approvedRequests: string[];
    rejectedRequests: string[];
    rotationComplementsInfos: PersonRotationComplementsDto[];
    planningDayInfo?: PlanningDayDto;
}

export interface IPersonDatePopupShadowOffDetails {
    shadowOffCategory: ShadowOffCategory;
    shadowOffCategoryDescription?: string;
    shadowOffType: ShadowOffType;
    shadowOffSource?: string;
    isShadowOffOptional?: boolean;
}
export class PersonDatePopupShadowOffDetails extends BaseApiModelClass< IPersonDatePopupShadowOffDetails > implements IPersonDatePopupShadowOffDetails {
    shadowOffCategory: ShadowOffCategory;
    shadowOffCategoryDescription?: string;
    shadowOffType: ShadowOffType;
    shadowOffSource?: string;
    isShadowOffOptional?: boolean;
}

export interface IPersonDateRange {
    dateFrom?: Date;
    dateTo?: Date;
}
export class PersonDateRange extends BaseApiModelClass< IPersonDateRange > implements IPersonDateRange {
    dateFrom?: Date;
    dateTo?: Date;
}

export interface IPersonDayDto {
    personId: string;
    date: Date;
}
export class PersonDayDto extends BaseApiModelClass< IPersonDayDto > implements IPersonDayDto {
    personId: string;
    date: Date;
}

export interface IPersonDayDutyFiguresFilter {
    type: DailyDutyFiguresType;
    dateFrom: Date;
    dateTo: Date;
    personIds?: string;
    functionGroupId: string;
    functionId?: string;
}
export class PersonDayDutyFiguresFilter extends BaseApiModelClass< IPersonDayDutyFiguresFilter > implements IPersonDayDutyFiguresFilter {
    type: DailyDutyFiguresType;
    dateFrom: Date;
    dateTo: Date;
    personIds?: string;
    functionGroupId: string;
    functionId?: string;
}

export interface IPersonDayDutyFiguresModel {
    date: Date;
    totalPersonWithOutDuties: number;
    dutySummaryList?: { [key: string]: number; };
    status: PlanningGroupDayStatus;
}
export class PersonDayDutyFiguresModel extends BaseApiModelClass< IPersonDayDutyFiguresModel > implements IPersonDayDutyFiguresModel {
    date: Date;
    totalPersonWithOutDuties: number;
    dutySummaryList?: { [key: string]: number; };
    status: PlanningGroupDayStatus;
}

export interface IPersonDayExtendedAugmentedRequest {
    personDays: PersonDayDto[];
    isExtended: boolean;
    isAugmented: boolean;
    isXStar: boolean;
}
export class PersonDayExtendedAugmentedRequest extends BaseApiModelClass< IPersonDayExtendedAugmentedRequest > implements IPersonDayExtendedAugmentedRequest {
    personDays: PersonDayDto[];
    isExtended: boolean;
    isAugmented: boolean;
    isXStar: boolean;
}

export interface IPersonDayFdpAmendmentTypeRequest {
    personDays: PersonDayDto[];
    fdpAmendmentType?: FdpAmendmentType;
}
export class PersonDayFdpAmendmentTypeRequest extends BaseApiModelClass< IPersonDayFdpAmendmentTypeRequest > implements IPersonDayFdpAmendmentTypeRequest {
    personDays: PersonDayDto[];
    fdpAmendmentType?: FdpAmendmentType;
}

export interface IPersonDayLandingRequest {
    date: Date;
    personId: string;
    landings: PersonDayLandingRequestItem[];
}
export class PersonDayLandingRequest extends BaseApiModelClass< IPersonDayLandingRequest > implements IPersonDayLandingRequest {
    date: Date;
    personId: string;
    landings: PersonDayLandingRequestItem[];
}

export interface IPersonDayLandingRequestItem {
    aircraftTypeGroupId: string;
    airportRcd?: string;
    count: number;
}
export class PersonDayLandingRequestItem extends BaseApiModelClass< IPersonDayLandingRequestItem > implements IPersonDayLandingRequestItem {
    aircraftTypeGroupId: string;
    airportRcd?: string;
    count: number;
}

export interface IPersonDaysModel {
    personId: string;
    date: Date;
}
export class PersonDaysModel extends BaseApiModelClass< IPersonDaysModel > implements IPersonDaysModel {
    personId: string;
    date: Date;
}

export interface IPersonDecisionModel {
    decision: PersonAlternativeRequestDecision;
}
export class PersonDecisionModel extends BaseApiModelClass< IPersonDecisionModel > implements IPersonDecisionModel {
    decision: PersonAlternativeRequestDecision;
}

export interface IPersonDeltaFiguresModel {
    personId: string;
    date: Date;
    deltaY: number;
    deltaQ: number;
}
export class PersonDeltaFiguresModel extends BaseApiModelClass< IPersonDeltaFiguresModel > implements IPersonDeltaFiguresModel {
    personId: string;
    date: Date;
    deltaY: number;
    deltaQ: number;
}

export interface IPersonDetailsHotelBookingFilter {
    rowLimit?: number;
    transitionDate: Date;
    departureDateTimeLt: Date;
    location: string;
    locationRoute: string;
    locationTimeDiff: string;
}
export class PersonDetailsHotelBookingFilter extends BaseApiModelClass< IPersonDetailsHotelBookingFilter > implements IPersonDetailsHotelBookingFilter {
    rowLimit?: number;
    transitionDate: Date;
    departureDateTimeLt: Date;
    location: string;
    locationRoute: string;
    locationTimeDiff: string;
}

export interface IPersonDosimetryFilter {
    rowLimit?: number;
    personId: string;
    dateFrom?: Date;
    dateTo?: Date;
}
export class PersonDosimetryFilter extends BaseApiModelClass< IPersonDosimetryFilter > implements IPersonDosimetryFilter {
    rowLimit?: number;
    personId: string;
    dateFrom?: Date;
    dateTo?: Date;
}

export interface IPersonDosimetryReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    personCode: string;
    lastName?: string;
    firstName?: string;
    gender?: string;
    birthDate?: Date;
    ahvNumber?: string;
    nationality?: string;
    crewId: string;
    functionName?: string;
    entryStart: Date;
    entryEnd?: Date;
    date: Date;
    flightNumber: number;
    originRcd: string;
    destinationRcd: string;
    dosimetry: number;
    dosimetryPerPeriod: number;
    dosimetryPerYear: number;
    dosimetryTotal: number;
}
export class PersonDosimetryReportModel extends BaseApiModelClass< IPersonDosimetryReportModel > implements IPersonDosimetryReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    personCode: string;
    lastName?: string;
    firstName?: string;
    gender?: string;
    birthDate?: Date;
    ahvNumber?: string;
    nationality?: string;
    crewId: string;
    functionName?: string;
    entryStart: Date;
    entryEnd?: Date;
    date: Date;
    flightNumber: number;
    originRcd: string;
    destinationRcd: string;
    dosimetry: number;
    dosimetryPerPeriod: number;
    dosimetryPerYear: number;
    dosimetryTotal: number;
}

export interface IPersonDosimetryReportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}
export class PersonDosimetryReportModelDataSourceLoadOptions extends BaseApiModelClass< IPersonDosimetryReportModelDataSourceLoadOptions > implements IPersonDosimetryReportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}

export interface IPersonDutyPeriodModel {
    date: Date;
    personId: string;
    hasDuty: boolean;
    mainSequentialPeriodSec: number;
    mainSequentialPeriodFormatted?: string;
    additionalPeriodSec: number;
    additionalPeriodFormatted?: string;
    isLateFinish: boolean;
    isNightDuty: boolean;
    isEarlyStart: boolean;
    isRed: boolean;
}
export class PersonDutyPeriodModel extends BaseApiModelClass< IPersonDutyPeriodModel > implements IPersonDutyPeriodModel {
    date: Date;
    personId: string;
    hasDuty: boolean;
    mainSequentialPeriodSec: number;
    mainSequentialPeriodFormatted?: string;
    additionalPeriodSec: number;
    additionalPeriodFormatted?: string;
    isLateFinish: boolean;
    isNightDuty: boolean;
    isEarlyStart: boolean;
    isRed: boolean;
}

export enum PersonDutySwapType {
    ByCrewControl = "ByCrewControl",
    ByCrewMember = "ByCrewMember",
}

export interface IPersonEntryModel {
    dateFrom: Date;
    dateTo?: Date;
}
export class PersonEntryModel extends BaseApiModelClass< IPersonEntryModel > implements IPersonEntryModel {
    dateFrom: Date;
    dateTo?: Date;
}

export interface IPersonExperienceModel {
    aircraftTypeGroupCodeName: string;
    activityCodeName: string;
    experienceStartsFrom?: Date;
    experiencedFrom?: Date;
}
export class PersonExperienceModel extends BaseApiModelClass< IPersonExperienceModel > implements IPersonExperienceModel {
    aircraftTypeGroupCodeName: string;
    activityCodeName: string;
    experienceStartsFrom?: Date;
    experiencedFrom?: Date;
}

export interface IPersonExperienceSummary {
    experiences: PersonExperienceModel[];
    checkerTrainees: PersonCheckerTraineeModel[];
    personEntries: PersonEntryModel[];
    functionOverrules: PersonPlanningFunctionOverruleInfo[];
}
export class PersonExperienceSummary extends BaseApiModelClass< IPersonExperienceSummary > implements IPersonExperienceSummary {
    experiences: PersonExperienceModel[];
    checkerTrainees: PersonCheckerTraineeModel[];
    personEntries: PersonEntryModel[];
    functionOverrules: PersonPlanningFunctionOverruleInfo[];
}

export interface IPersonFilter {
    ids?: string[];
    functionId?: string;
    functionIds?: string[];
    codes?: string[];
    referenceDate?: Date;
    referenceDateTo?: Date;
    qualificationIds?: string[];
    contractTypes?: ContractType[];
    contractFlagTypes?: ContractFlagType[];
    partialLoadType?: PartialLoadType;
    search?: string;
    searchByFullName: boolean;
    dutyFilter?: DutyFilter[];
    monthlyTypes?: MonthlyType[];
    releaseFilterTypes?: ReleaseFilterType[];
    sort: PersonSortOrder;
    order: SortOrder;
    sortBaseDate?: Date;
    functionFromDate?: Date;
    typeRatingFilters?: TypeRatingFilter[];
    instructorFilters?: string;
    aeropersMember: boolean;
    nbuCockpitRelated: boolean;
    nbuCabinRelated: boolean;
    includeInactive: boolean;
    page?: number;
    pageSize?: number;
    optInShowEfaSchedule: boolean;
    includeWithoutEmail: boolean;
}
export class PersonFilter extends BaseApiModelClass< IPersonFilter > implements IPersonFilter {
    ids?: string[];
    functionId?: string;
    functionIds?: string[];
    codes?: string[];
    referenceDate?: Date;
    referenceDateTo?: Date;
    qualificationIds?: string[];
    contractTypes?: ContractType[];
    contractFlagTypes?: ContractFlagType[];
    partialLoadType?: PartialLoadType;
    search?: string;
    searchByFullName: boolean;
    dutyFilter?: DutyFilter[];
    monthlyTypes?: MonthlyType[];
    releaseFilterTypes?: ReleaseFilterType[];
    sort: PersonSortOrder;
    order: SortOrder;
    sortBaseDate?: Date;
    functionFromDate?: Date;
    typeRatingFilters?: TypeRatingFilter[];
    instructorFilters?: string;
    aeropersMember: boolean;
    nbuCockpitRelated: boolean;
    nbuCabinRelated: boolean;
    includeInactive: boolean;
    page?: number;
    pageSize?: number;
    optInShowEfaSchedule: boolean;
    includeWithoutEmail: boolean;
}

export interface IPersonFlightOverviewModel {
    flightHoursBeforeEdwSec: number;
    flightHoursEdwShSec: number;
    flightHoursEdwLhSec: number;
    flightHoursTotalEdwSec: number;
    flightHoursTotalSec: number;
    ofcInsHoursTotalSec: number;
}
export class PersonFlightOverviewModel extends BaseApiModelClass< IPersonFlightOverviewModel > implements IPersonFlightOverviewModel {
    flightHoursBeforeEdwSec: number;
    flightHoursEdwShSec: number;
    flightHoursEdwLhSec: number;
    flightHoursTotalEdwSec: number;
    flightHoursTotalSec: number;
    ofcInsHoursTotalSec: number;
}

export interface IPersonFlightRequest {
    flightId: string;
    bidPoints: number;
    maxBidPoints?: number;
    skipLicenseWarning: boolean;
    termType: PersonRequestFlightTermType;
}
export class PersonFlightRequest extends BaseApiModelClass< IPersonFlightRequest > implements IPersonFlightRequest {
    flightId: string;
    bidPoints: number;
    maxBidPoints?: number;
    skipLicenseWarning: boolean;
    termType: PersonRequestFlightTermType;
}

export interface IPersonFreelanceContractInfo {
    dateFrom: Date;
    dateTo?: Date;
    typeModel: ContractModelType;
    contractDetails: string;
    flyingDutyPercentage?: number;
}
export class PersonFreelanceContractInfo extends BaseApiModelClass< IPersonFreelanceContractInfo > implements IPersonFreelanceContractInfo {
    dateFrom: Date;
    dateTo?: Date;
    typeModel: ContractModelType;
    contractDetails: string;
    flyingDutyPercentage?: number;
}

export interface IPersonFunctionDto {
    name?: string;
    dateFrom: Date;
    dateTo?: Date;
    functionGroupId?: string;
    planningFunctionId?: string;
    planningFunctionGroupId?: string;
    functionId: string;
    isFcm: boolean;
    isCabin: boolean;
    isGround: boolean;
    isCockpit: boolean;
}
export class PersonFunctionDto extends BaseApiModelClass< IPersonFunctionDto > implements IPersonFunctionDto {
    name?: string;
    dateFrom: Date;
    dateTo?: Date;
    functionGroupId?: string;
    planningFunctionId?: string;
    planningFunctionGroupId?: string;
    functionId: string;
    readonly isFcm: boolean;
    readonly isCabin: boolean;
    readonly isGround: boolean;
    readonly isCockpit: boolean;
}

export enum PersonGroupType {
    Cabin = "Cabin",
    Cockpit = "Cockpit",
    Ground = "Ground",
    None = "None",
}

export interface IPersonHotelBookingDetailModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    personId: string;
    personCode: string;
    email?: string;
    name?: string;
    currentLocationRouteCode?: string;
    currentLocationDepartureRouteCode?: string;
    firstPassportNumber?: string;
    firstPassportExpirationDate?: Date;
    firstNationality?: string;
    secondPassportNumber?: string;
    secondPassportExpirationDate?: Date;
    secondNationality?: string;
    passportNumber?: string;
    passportExpirationDate?: Date;
    nationality?: string;
    passportExpirationEmailDate?: string;
    birthDate?: Date;
    birthEmailDate?: string;
    rank: string;
    position?: string;
    positionSortOrder: number;
}
export class PersonHotelBookingDetailModel extends BaseApiModelClass< IPersonHotelBookingDetailModel > implements IPersonHotelBookingDetailModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    personId: string;
    personCode: string;
    email?: string;
    name?: string;
    currentLocationRouteCode?: string;
    currentLocationDepartureRouteCode?: string;
    firstPassportNumber?: string;
    firstPassportExpirationDate?: Date;
    firstNationality?: string;
    secondPassportNumber?: string;
    secondPassportExpirationDate?: Date;
    secondNationality?: string;
    passportNumber?: string;
    passportExpirationDate?: Date;
    nationality?: string;
    passportExpirationEmailDate?: string;
    birthDate?: Date;
    birthEmailDate?: string;
    rank: string;
    position?: string;
    positionSortOrder: number;
}

export interface IPersonHotelBookingDetailModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}
export class PersonHotelBookingDetailModelDataSourceLoadOptions extends BaseApiModelClass< IPersonHotelBookingDetailModelDataSourceLoadOptions > implements IPersonHotelBookingDetailModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}

export interface IPersonIdCodeModel {
    id: string;
    code: string;
}
export class PersonIdCodeModel extends BaseApiModelClass< IPersonIdCodeModel > implements IPersonIdCodeModel {
    id: string;
    code: string;
}

export interface IPersonInfoModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    date: Date;
    id: string;
    code: string;
    lastName?: string;
    firstName?: string;
    licenseFleet?: string;
    birthDate?: Date;
    entryDate?: Date;
    function?: FunctionModel;
    experience?: ExperienceModel;
    personContract?: PersonContractInfoModel;
    personLicenses?: LicenseModel[];
    hasComments: boolean;
    hasMedicalRestriction: boolean;
    department?: string;
}
export class PersonInfoModel extends BaseApiModelClass< IPersonInfoModel > implements IPersonInfoModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    date: Date;
    id: string;
    code: string;
    lastName?: string;
    firstName?: string;
    licenseFleet?: string;
    birthDate?: Date;
    entryDate?: Date;
    function?: FunctionModel;
    experience?: ExperienceModel;
    personContract?: PersonContractInfoModel;
    personLicenses?: LicenseModel[];
    hasComments: boolean;
    hasMedicalRestriction: boolean;
    department?: string;
}

export interface IPersonInfoModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}
export class PersonInfoModelDataSourceLoadOptions extends BaseApiModelClass< IPersonInfoModelDataSourceLoadOptions > implements IPersonInfoModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}

export interface IPersonLicenseInfo {
    id: string;
    personId: string;
    licenseId: string;
    licenseName: string;
    shortNameNeutral: string;
    expirationDate?: Date;
    dateFrom?: Date;
    dateTo?: Date;
    hardDateTo?: Date;
    isTrainee: boolean;
    isNewcomer: boolean;
    isExtension: boolean;
    isActiveSoft: boolean;
    isActiveHard: boolean;
    isAircraftRelated: boolean;
    isAirportRelated: boolean;
    isFlightRelated: boolean;
    sortOrder: number;
}
export class PersonLicenseInfo extends BaseApiModelClass< IPersonLicenseInfo > implements IPersonLicenseInfo {
    id: string;
    personId: string;
    licenseId: string;
    licenseName: string;
    shortNameNeutral: string;
    expirationDate?: Date;
    dateFrom?: Date;
    dateTo?: Date;
    hardDateTo?: Date;
    isTrainee: boolean;
    isNewcomer: boolean;
    isExtension: boolean;
    isActiveSoft: boolean;
    isActiveHard: boolean;
    isAircraftRelated: boolean;
    isAirportRelated: boolean;
    isFlightRelated: boolean;
    sortOrder: number;
}

export enum PersonLicenseStatus {
    DarkBlue = "DarkBlue",
    LightBlue = "LightBlue",
    None = "None",
}

export interface IPersonLicenseSuppressionItemModel {
    licenseId: string;
    personId: string;
    suppressStartDate: Date;
    suppressEndDate: Date;
    suppressReason: string;
    id: string;
    licenseName: string;
}
export class PersonLicenseSuppressionItemModel extends BaseApiModelClass< IPersonLicenseSuppressionItemModel > implements IPersonLicenseSuppressionItemModel {
    licenseId: string;
    personId: string;
    suppressStartDate: Date;
    suppressEndDate: Date;
    suppressReason: string;
    id: string;
    licenseName: string;
}

export interface IPersonLicenseValidationSuppressCreateModel {
    licenseId: string;
    personId: string;
    suppressStartDate: Date;
    suppressEndDate: Date;
    suppressReason: string;
}
export class PersonLicenseValidationSuppressCreateModel extends BaseApiModelClass< IPersonLicenseValidationSuppressCreateModel > implements IPersonLicenseValidationSuppressCreateModel {
    licenseId: string;
    personId: string;
    suppressStartDate: Date;
    suppressEndDate: Date;
    suppressReason: string;
}

export interface IPersonLicenseValidationSuppressUpdateModel {
    licenseId: string;
    personId: string;
    suppressStartDate: Date;
    suppressEndDate: Date;
    suppressReason: string;
    id: string;
}
export class PersonLicenseValidationSuppressUpdateModel extends BaseApiModelClass< IPersonLicenseValidationSuppressUpdateModel > implements IPersonLicenseValidationSuppressUpdateModel {
    licenseId: string;
    personId: string;
    suppressStartDate: Date;
    suppressEndDate: Date;
    suppressReason: string;
    id: string;
}

export interface IPersonLocation {
    personId: string;
    location: string;
    date: Date;
}
export class PersonLocation extends BaseApiModelClass< IPersonLocation > implements IPersonLocation {
    personId: string;
    location: string;
    date: Date;
}

export interface IPersonLookupByPhoneModel {
    code: string;
    functionId: string;
}
export class PersonLookupByPhoneModel extends BaseApiModelClass< IPersonLookupByPhoneModel > implements IPersonLookupByPhoneModel {
    code: string;
    functionId: string;
}

export interface IPersonLookupModel {
    id: string;
    code: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    searchState: SearchMatched;
    isActive: boolean;
}
export class PersonLookupModel extends BaseApiModelClass< IPersonLookupModel > implements IPersonLookupModel {
    id: string;
    code: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    searchState: SearchMatched;
    isActive: boolean;
}

export interface IPersonMclModel {
    id: string;
    code?: string;
    timestamp: Date;
    firstName?: string;
    lastName?: string;
    validationError?: string;
    function?: string;
    functionDateFrom?: Date;
    nearestDutyDate?: Date;
    nearestFlightDate?: Date;
    pendingAction?: CrewApiPersonChangeAction;
}
export class PersonMclModel extends BaseApiModelClass< IPersonMclModel > implements IPersonMclModel {
    id: string;
    code?: string;
    timestamp: Date;
    firstName?: string;
    lastName?: string;
    validationError?: string;
    function?: string;
    functionDateFrom?: Date;
    nearestDutyDate?: Date;
    nearestFlightDate?: Date;
    pendingAction?: CrewApiPersonChangeAction;
}

export interface IPersonMintLicenseInactivationInfo {
    licenseCode: string;
    dateFrom: Date;
    dateTo?: Date;
    comment?: string;
}
export class PersonMintLicenseInactivationInfo extends BaseApiModelClass< IPersonMintLicenseInactivationInfo > implements IPersonMintLicenseInactivationInfo {
    licenseCode: string;
    dateFrom: Date;
    dateTo?: Date;
    comment?: string;
}

export interface IPersonMintLicenseInfo {
    name: string;
    licenseCode: string;
    expirationDate?: Date;
    issueDate?: Date;
    deactivationDate?: Date;
    reactivationDate?: Date;
}
export class PersonMintLicenseInfo extends BaseApiModelClass< IPersonMintLicenseInfo > implements IPersonMintLicenseInfo {
    name: string;
    licenseCode: string;
    expirationDate?: Date;
    issueDate?: Date;
    deactivationDate?: Date;
    reactivationDate?: Date;
}

export interface IPersonModel {
    id: string;
    code: string;
    lastName?: string;
    firstName?: string;
    email?: string;
    phoneNumber?: string;
    phone?: string;
    phoneMobile?: string;
    phonePrivate?: string;
    phoneMobilePrivate?: string;
    birthDate?: Date;
    department?: string;
    isActive: boolean;
    functionId?: string;
    planningFunctionId?: string;
}
export class PersonModel extends BaseApiModelClass< IPersonModel > implements IPersonModel {
    id: string;
    code: string;
    lastName?: string;
    firstName?: string;
    email?: string;
    phoneNumber?: string;
    phone?: string;
    phoneMobile?: string;
    phonePrivate?: string;
    phoneMobilePrivate?: string;
    birthDate?: Date;
    department?: string;
    isActive: boolean;
    functionId?: string;
    planningFunctionId?: string;
}

export interface IPersonModifications {
    createdAtUtc: Date;
    createdBy: string;
    modifiedAtUtc?: Date;
    modifiedBy?: string;
}
export class PersonModifications extends BaseApiModelClass< IPersonModifications > implements IPersonModifications {
    createdAtUtc: Date;
    createdBy: string;
    modifiedAtUtc?: Date;
    modifiedBy?: string;
}

export interface IPersonMonthDataResponse {
    personId: string;
    workHours1MonthDiffToDateSecs: number;
    date: Date;
}
export class PersonMonthDataResponse extends BaseApiModelClass< IPersonMonthDataResponse > implements IPersonMonthDataResponse {
    personId: string;
    workHours1MonthDiffToDateSecs: number;
    date: Date;
}

export interface IPersonNbuFilter {
    dateMonthStart: Date;
    personId: string;
    periodFrom?: Date;
    periodTo?: Date;
}
export class PersonNbuFilter extends BaseApiModelClass< IPersonNbuFilter > implements IPersonNbuFilter {
    dateMonthStart: Date;
    personId: string;
    periodFrom?: Date;
    periodTo?: Date;
}

export interface IPersonNbuModel {
    date: Date;
    nbuType?: PersonNbuType;
    nbuId?: string;
    nbuStartUtc?: Date;
    nbuEndUtc?: Date;
    nbuBlockOnUtc?: Date;
    nbuBhSecs?: number;
    nbuDhSecs?: number;
    nbuDescription?: string;
    duty?: string;
    checkInUtc?: Date;
    checkOutUtc?: Date;
    validationErrors?: DutyValidationErrorModel[];
    bhSecs?: number;
    bh28DSecs?: number;
    bh1YSecs?: number;
    dhSecs?: number;
    dh7DSecs?: number;
    dh14DSecs?: number;
    dh28DSecs?: number;
    dh1YSecs?: number;
    fdpSecs?: number;
}
export class PersonNbuModel extends BaseApiModelClass< IPersonNbuModel > implements IPersonNbuModel {
    date: Date;
    nbuType?: PersonNbuType;
    nbuId?: string;
    nbuStartUtc?: Date;
    nbuEndUtc?: Date;
    nbuBlockOnUtc?: Date;
    nbuBhSecs?: number;
    nbuDhSecs?: number;
    nbuDescription?: string;
    duty?: string;
    checkInUtc?: Date;
    checkOutUtc?: Date;
    validationErrors?: DutyValidationErrorModel[];
    bhSecs?: number;
    bh28DSecs?: number;
    bh1YSecs?: number;
    dhSecs?: number;
    dh7DSecs?: number;
    dh14DSecs?: number;
    dh28DSecs?: number;
    dh1YSecs?: number;
    fdpSecs?: number;
}

export interface IPersonNbuMonthModel {
    isCompleted: boolean;
    completedAtUtc?: Date;
}
export class PersonNbuMonthModel extends BaseApiModelClass< IPersonNbuMonthModel > implements IPersonNbuMonthModel {
    isCompleted: boolean;
    completedAtUtc?: Date;
}

export enum PersonNbuType {
    Flight = "Flight",
    Other = "Other",
}

export interface IPersonNbuUpdateModel {
    id?: string;
    type: PersonNbuType;
    date: Date;
    startZrh: Date;
    endZrh: Date;
    bonZrh?: Date;
    dhSecs: number;
    bhSecs: number;
    description: string;
}
export class PersonNbuUpdateModel extends BaseApiModelClass< IPersonNbuUpdateModel > implements IPersonNbuUpdateModel {
    id?: string;
    type: PersonNbuType;
    date: Date;
    startZrh: Date;
    endZrh: Date;
    bonZrh?: Date;
    dhSecs: number;
    bhSecs: number;
    description: string;
}

export interface IPersonOffRequestCreate {
    periodDateFrom: Date;
    periodDateTo: Date;
    comment: string;
    type: PersonRequestOffType;
}
export class PersonOffRequestCreate extends BaseApiModelClass< IPersonOffRequestCreate > implements IPersonOffRequestCreate {
    periodDateFrom: Date;
    periodDateTo: Date;
    comment: string;
    type: PersonRequestOffType;
}

export interface IPersonOffRequestUpdate {
    comment: string;
}
export class PersonOffRequestUpdate extends BaseApiModelClass< IPersonOffRequestUpdate > implements IPersonOffRequestUpdate {
    comment: string;
}

export enum PersonPlanningDayType {
    Off = "Off",
    Rsv = "Rsv",
}

export interface IPersonPlanningFunctionOverruleInfo {
    functionName: string;
    functionOverruleType: FunctionOverruleType;
    dateFrom: Date;
    dateTo?: Date;
    comment?: string;
}
export class PersonPlanningFunctionOverruleInfo extends BaseApiModelClass< IPersonPlanningFunctionOverruleInfo > implements IPersonPlanningFunctionOverruleInfo {
    functionName: string;
    functionOverruleType: FunctionOverruleType;
    dateFrom: Date;
    dateTo?: Date;
    comment?: string;
}

export interface IPersonPointsPeriodDto {
    personId: string;
    dateFrom: Date;
    dateTo: Date;
    label: string;
}
export class PersonPointsPeriodDto extends BaseApiModelClass< IPersonPointsPeriodDto > implements IPersonPointsPeriodDto {
    personId: string;
    dateFrom: Date;
    dateTo: Date;
    label: string;
}

export interface IPersonQuarterDaysOffModel {
    personId: string;
    year: number;
    quarter1?: number;
    quarter2?: number;
    quarter3?: number;
    quarter4?: number;
    quarter1Limit?: number;
    quarter2Limit?: number;
    quarter3Limit?: number;
    quarter4Limit?: number;
}
export class PersonQuarterDaysOffModel extends BaseApiModelClass< IPersonQuarterDaysOffModel > implements IPersonQuarterDaysOffModel {
    personId: string;
    year: number;
    quarter1?: number;
    quarter2?: number;
    quarter3?: number;
    quarter4?: number;
    quarter1Limit?: number;
    quarter2Limit?: number;
    quarter3Limit?: number;
    quarter4Limit?: number;
}

export interface IPersonReportFilter {
    rowLimit?: number;
    functionId?: string;
    contractTypes?: ContractType[];
}
export class PersonReportFilter extends BaseApiModelClass< IPersonReportFilter > implements IPersonReportFilter {
    rowLimit?: number;
    functionId?: string;
    contractTypes?: ContractType[];
}

export interface IPersonRequestAvailableFlightDto {
    flightBids: PersonRequestFlightBidDto[];
    date: Date;
    flightId: string;
    rotationId: string;
    flightNumber: number;
    isLongHaul: boolean;
    originRcd?: string;
    destinationRcd?: string;
    aircraftTypeRcd?: string;
    departureDateTimeUtc?: Date;
    departureTimeDiffToLt?: string;
    arrivalDateTimeUtc?: Date;
    arrivalTimeDiffToLt?: string;
    functionId: string;
    locations?: string;
    days: number;
    isFlightUnavailable: boolean;
}
export class PersonRequestAvailableFlightDto extends BaseApiModelClass< IPersonRequestAvailableFlightDto > implements IPersonRequestAvailableFlightDto {
    flightBids: PersonRequestFlightBidDto[];
    date: Date;
    flightId: string;
    rotationId: string;
    flightNumber: number;
    isLongHaul: boolean;
    originRcd?: string;
    destinationRcd?: string;
    aircraftTypeRcd?: string;
    departureDateTimeUtc?: Date;
    departureTimeDiffToLt?: string;
    arrivalDateTimeUtc?: Date;
    arrivalTimeDiffToLt?: string;
    functionId: string;
    locations?: string;
    days: number;
    isFlightUnavailable: boolean;
}

export interface IPersonRequestAvailableFlightsDto {
    availableFlights: PersonRequestAvailableFlightDto[];
    isMoreFlightAvailable: boolean;
}
export class PersonRequestAvailableFlightsDto extends BaseApiModelClass< IPersonRequestAvailableFlightsDto > implements IPersonRequestAvailableFlightsDto {
    availableFlights: PersonRequestAvailableFlightDto[];
    isMoreFlightAvailable: boolean;
}

export interface IPersonRequestBlockedDayDto {
    date: Date;
    isForCockpit: boolean;
    isForCabin: boolean;
    comment?: string;
    type: BlockedDayType;
}
export class PersonRequestBlockedDayDto extends BaseApiModelClass< IPersonRequestBlockedDayDto > implements IPersonRequestBlockedDayDto {
    date: Date;
    isForCockpit: boolean;
    isForCabin: boolean;
    comment?: string;
    type: BlockedDayType;
}

export interface IPersonRequestBlockedFlightDto {
    flightId: string;
    isForCockpitSt: boolean;
    isForCockpitLt: boolean;
    isForCabin: boolean;
    comment?: string;
}
export class PersonRequestBlockedFlightDto extends BaseApiModelClass< IPersonRequestBlockedFlightDto > implements IPersonRequestBlockedFlightDto {
    flightId: string;
    isForCockpitSt: boolean;
    isForCockpitLt: boolean;
    isForCabin: boolean;
    comment?: string;
}

export interface IPersonRequestBlockedFlightInfoDto {
    date: Date;
    flightId: string;
    flightNumber: number;
    isLongHaul: boolean;
    originRcd: string;
    destinationRcd: string;
    aircraftTypeRcd?: string;
    aircraftRegistrationNumber?: string;
    departureDateTimeUtc: Date;
    departureTimeDiffToLt: string;
    arrivalDateTimeUtc: Date;
    arrivalTimeDiffToLt: string;
    isForCabin: boolean;
    isForCockpitSt: boolean;
    isForCockpitLt: boolean;
    comment?: string;
}
export class PersonRequestBlockedFlightInfoDto extends BaseApiModelClass< IPersonRequestBlockedFlightInfoDto > implements IPersonRequestBlockedFlightInfoDto {
    date: Date;
    flightId: string;
    flightNumber: number;
    isLongHaul: boolean;
    originRcd: string;
    destinationRcd: string;
    aircraftTypeRcd?: string;
    aircraftRegistrationNumber?: string;
    departureDateTimeUtc: Date;
    departureTimeDiffToLt: string;
    arrivalDateTimeUtc: Date;
    arrivalTimeDiffToLt: string;
    isForCabin: boolean;
    isForCockpitSt: boolean;
    isForCockpitLt: boolean;
    comment?: string;
}

export interface IPersonRequestDayDto {
    date: Date;
    type?: PersonRequestDayType;
}
export class PersonRequestDayDto extends BaseApiModelClass< IPersonRequestDayDto > implements IPersonRequestDayDto {
    date: Date;
    type?: PersonRequestDayType;
}

export enum PersonRequestDayType {
    And = "And",
    Bnd = "Bnd",
    Flight = "Flight",
    FlightAndPos = "FlightAndPos",
    Lay = "Lay",
    Off = "Off",
    Pos = "Pos",
    RsvP = "RsvP",
    Vac = "Vac",
}

export interface IPersonRequestDto {
    id: string;
    personId: string;
    dateFrom: Date;
    dateTo: Date;
    type: PersonRequestType;
    termType?: PersonRequestFlightTermType;
    vacationType?: PersonRequestVacType;
    isAlternative: boolean;
    summaryStatus: PersonRequestSummaryStatus;
    crewStatus: PersonRequestSummaryStatus;
    title?: string;
    daysInfo: PersonRequestDayDto[];
}
export class PersonRequestDto extends BaseApiModelClass< IPersonRequestDto > implements IPersonRequestDto {
    id: string;
    personId: string;
    dateFrom: Date;
    dateTo: Date;
    type: PersonRequestType;
    termType?: PersonRequestFlightTermType;
    vacationType?: PersonRequestVacType;
    isAlternative: boolean;
    summaryStatus: PersonRequestSummaryStatus;
    crewStatus: PersonRequestSummaryStatus;
    title?: string;
    daysInfo: PersonRequestDayDto[];
}

export interface IPersonRequestFlightBidDto {
    bidPoints: number;
    isMine?: boolean;
    functionId: string;
    personContractType: ContractType;
    senioritySortKey: number;
}
export class PersonRequestFlightBidDto extends BaseApiModelClass< IPersonRequestFlightBidDto > implements IPersonRequestFlightBidDto {
    bidPoints: number;
    isMine?: boolean;
    functionId: string;
    personContractType: ContractType;
    senioritySortKey: number;
}

export interface IPersonRequestFlightCreateResult {
    isValid: boolean;
    comment: string;
    requestId?: string;
    requestDto?: PersonRequestFlightWithBidsDto;
    isWarning: boolean;
}
export class PersonRequestFlightCreateResult extends BaseApiModelClass< IPersonRequestFlightCreateResult > implements IPersonRequestFlightCreateResult {
    isValid: boolean;
    comment: string;
    requestId?: string;
    requestDto?: PersonRequestFlightWithBidsDto;
    isWarning: boolean;
}

export interface IPersonRequestFlightRejectModel {
    id: string;
    comment: string;
}
export class PersonRequestFlightRejectModel extends BaseApiModelClass< IPersonRequestFlightRejectModel > implements IPersonRequestFlightRejectModel {
    id: string;
    comment: string;
}

export enum PersonRequestFlightStatus {
    Approved = "Approved",
    Rejected = "Rejected",
    RejectedByCancellation = "RejectedByCancellation",
    RejectedByCrew = "RejectedByCrew",
    RejectedByPlanning = "RejectedByPlanning",
    Requested = "Requested",
}

export enum PersonRequestFlightTermType {
    LTFR = "LTFR",
    STFR = "STFR",
}

export enum PersonRequestFlightType {
    LongHaul = "LongHaul",
    ShortHaul = "ShortHaul",
}

export interface IPersonRequestFlightWithBidsDto {
    id: string;
    requestDate: Date;
    personId: string;
    functionId: string;
    personCode: string;
    personFirstName?: string;
    personLastName?: string;
    flightId: string;
    flightNumber: number;
    flightDate: Date;
    originRcd: string;
    destinationRcd: string;
    departureDateTimeUtc?: Date;
    departureTimeDiffToLt?: string;
    arrivalDateTimeUtc?: Date;
    arrivalTimeDiffToLt?: string;
    commentPlanner?: string;
    isDeleted: boolean;
    personBidPoints: number;
    personMaxBidPoints?: number;
    status: PersonRequestFlightStatus;
    type: PersonRequestFlightType;
    termType: PersonRequestFlightTermType;
    senioritySortKey: number;
    personContractType?: ContractType;
    stfr12MCount: number;
    flightBids: PersonRequestFlightBidDto[];
    currentMaxBidPoints?: number;
    locations?: string;
    days: number;
}
export class PersonRequestFlightWithBidsDto extends BaseApiModelClass< IPersonRequestFlightWithBidsDto > implements IPersonRequestFlightWithBidsDto {
    id: string;
    requestDate: Date;
    personId: string;
    functionId: string;
    personCode: string;
    personFirstName?: string;
    personLastName?: string;
    flightId: string;
    flightNumber: number;
    flightDate: Date;
    originRcd: string;
    destinationRcd: string;
    departureDateTimeUtc?: Date;
    departureTimeDiffToLt?: string;
    arrivalDateTimeUtc?: Date;
    arrivalTimeDiffToLt?: string;
    commentPlanner?: string;
    isDeleted: boolean;
    personBidPoints: number;
    personMaxBidPoints?: number;
    status: PersonRequestFlightStatus;
    type: PersonRequestFlightType;
    termType: PersonRequestFlightTermType;
    senioritySortKey: number;
    personContractType?: ContractType;
    stfr12MCount: number;
    readonly flightBids: PersonRequestFlightBidDto[];
    currentMaxBidPoints?: number;
    locations?: string;
    days: number;
}

export interface IPersonRequestFreelanceConfirmModel {
    freelanceYearId: string;
    freelanceYearPeriodId: string;
    isConfirmed: boolean;
}
export class PersonRequestFreelanceConfirmModel extends BaseApiModelClass< IPersonRequestFreelanceConfirmModel > implements IPersonRequestFreelanceConfirmModel {
    freelanceYearId: string;
    freelanceYearPeriodId: string;
    isConfirmed: boolean;
}

export interface IPersonRequestFreelanceCreateModel {
    type: FreelanceActivityType;
    dates: Date[];
}
export class PersonRequestFreelanceCreateModel extends BaseApiModelClass< IPersonRequestFreelanceCreateModel > implements IPersonRequestFreelanceCreateModel {
    type: FreelanceActivityType;
    dates: Date[];
}

export interface IPersonRequestFreelanceDeviateModel {
    freelanceYearId: string;
    freelanceYearPeriodId: string;
    isConfirmed: boolean;
    isDeviated: boolean;
}
export class PersonRequestFreelanceDeviateModel extends BaseApiModelClass< IPersonRequestFreelanceDeviateModel > implements IPersonRequestFreelanceDeviateModel {
    freelanceYearId: string;
    freelanceYearPeriodId: string;
    isConfirmed: boolean;
    isDeviated: boolean;
}

export interface IPersonRequestFreelanceResultModel {
    errors?: string[];
}
export class PersonRequestFreelanceResultModel extends BaseApiModelClass< IPersonRequestFreelanceResultModel > implements IPersonRequestFreelanceResultModel {
    errors?: string[];
}

export interface IPersonRequestFunctionInfoDto {
    dateFrom: Date;
    dateTo?: Date;
    functionId: string;
    planningFunctionId?: string;
    functionGroupId?: string;
    planningFunctionGroupId?: string;
    functionName: string;
}
export class PersonRequestFunctionInfoDto extends BaseApiModelClass< IPersonRequestFunctionInfoDto > implements IPersonRequestFunctionInfoDto {
    dateFrom: Date;
    dateTo?: Date;
    functionId: string;
    planningFunctionId?: string;
    functionGroupId?: string;
    planningFunctionGroupId?: string;
    functionName: string;
}

export interface IPersonRequestItemDto {
    id: string;
    dateFrom: Date;
    dateTo: Date;
    type: PersonRequestType;
    termType?: PersonRequestFlightTermType;
}
export class PersonRequestItemDto extends BaseApiModelClass< IPersonRequestItemDto > implements IPersonRequestItemDto {
    id: string;
    dateFrom: Date;
    dateTo: Date;
    type: PersonRequestType;
    termType?: PersonRequestFlightTermType;
}

export interface IPersonRequestOffDto {
    id: string;
    personId: string;
    personCode: string;
    personFirstName?: string;
    personLastName?: string;
    createdDateAt: Date;
    periodDateFrom: Date;
    periodDateTo: Date;
    costPoints: number;
    status: PersonRequestOffStatus;
    type: PersonRequestOffType;
    commentPerson?: string;
    commentPlanner?: string;
    isDeleted: boolean;
}
export class PersonRequestOffDto extends BaseApiModelClass< IPersonRequestOffDto > implements IPersonRequestOffDto {
    id: string;
    personId: string;
    personCode: string;
    personFirstName?: string;
    personLastName?: string;
    createdDateAt: Date;
    periodDateFrom: Date;
    periodDateTo: Date;
    costPoints: number;
    status: PersonRequestOffStatus;
    type: PersonRequestOffType;
    commentPerson?: string;
    commentPlanner?: string;
    isDeleted: boolean;
}

export enum PersonRequestOffStatus {
    Approved = "Approved",
    ManualAction = "ManualAction",
    Rejected = "Rejected",
    RequestedToApprove = "RequestedToApprove",
    RequestedToRemove = "RequestedToRemove",
}

export enum PersonRequestOffType {
    LongTerm = "LongTerm",
    LongTermEvening = "LongTermEvening",
    ShortTerm = "ShortTerm",
}

export interface IPersonRequestOffValidationResult {
    comment: string;
    isValid: boolean;
}
export class PersonRequestOffValidationResult extends BaseApiModelClass< IPersonRequestOffValidationResult > implements IPersonRequestOffValidationResult {
    comment: string;
    isValid: boolean;
}

export interface IPersonRequestPersonInfoDto {
    personId: string;
    functions: PersonRequestFunctionInfoDto[];
    unconfirmedChangeLogCount: number;
    isAeropersMember: boolean;
    optInShowAeropersSchedule: boolean;
}
export class PersonRequestPersonInfoDto extends BaseApiModelClass< IPersonRequestPersonInfoDto > implements IPersonRequestPersonInfoDto {
    personId: string;
    functions: PersonRequestFunctionInfoDto[];
    unconfirmedChangeLogCount: number;
    isAeropersMember: boolean;
    optInShowAeropersSchedule: boolean;
}

export interface IPersonRequestPointsActualBalance {
    date: Date;
    personId: string;
    grantedByContractBalance: number;
    grantedTotalBalance: number;
    usedBalance: number;
    reservedPoints: number;
    nextFlightFee: number;
    totalReservedFee: number;
}
export class PersonRequestPointsActualBalance extends BaseApiModelClass< IPersonRequestPointsActualBalance > implements IPersonRequestPointsActualBalance {
    date: Date;
    personId: string;
    grantedByContractBalance: number;
    grantedTotalBalance: number;
    usedBalance: number;
    reservedPoints: number;
    nextFlightFee: number;
    totalReservedFee: number;
}

export interface IPersonRequestPointsLogDto {
    personId: string;
    dateTime: Date;
    useType: RequestPointUseType;
    subType?: RequestPointSubType;
    periodDateFrom?: Date;
    periodDateTo?: Date;
    costPoints: number;
    availableBalance: number;
    reason?: string[];
}
export class PersonRequestPointsLogDto extends BaseApiModelClass< IPersonRequestPointsLogDto > implements IPersonRequestPointsLogDto {
    personId: string;
    dateTime: Date;
    useType: RequestPointUseType;
    subType?: RequestPointSubType;
    periodDateFrom?: Date;
    periodDateTo?: Date;
    costPoints: number;
    availableBalance: number;
    reason?: string[];
}

export interface IPersonRequestReserveAvailableDto {
    requestedRequests: number;
    availableRequests: number;
}
export class PersonRequestReserveAvailableDto extends BaseApiModelClass< IPersonRequestReserveAvailableDto > implements IPersonRequestReserveAvailableDto {
    requestedRequests: number;
    availableRequests: number;
}

export interface IPersonRequestReserveBalance {
    available: number;
    used: number;
    free: number;
    contractInfos: PersonContractReserveLimitInfo[];
    usedDutyBlocks: DutiesBlocksGroupedByMonthModel[];
}
export class PersonRequestReserveBalance extends BaseApiModelClass< IPersonRequestReserveBalance > implements IPersonRequestReserveBalance {
    available: number;
    used: number;
    free: number;
    contractInfos: PersonContractReserveLimitInfo[];
    usedDutyBlocks: DutiesBlocksGroupedByMonthModel[];
}

export interface IPersonRequestReserveCreateResult {
    requestId?: string;
    dateFrom?: Date;
    dateTo?: Date;
    isValid: boolean;
    validationMessage?: string;
    blockId: string;
    isCabin: boolean;
}
export class PersonRequestReserveCreateResult extends BaseApiModelClass< IPersonRequestReserveCreateResult > implements IPersonRequestReserveCreateResult {
    requestId?: string;
    dateFrom?: Date;
    dateTo?: Date;
    isValid: boolean;
    validationMessage?: string;
    blockId: string;
    isCabin: boolean;
}

export interface IPersonRequestReserveDto {
    id: string;
    reserveBlockId: string;
    personId: string;
    personCode: string;
    reserveYearId: string;
    reserveYearPeriodId: string;
    status: PersonRequestReserveStatus;
    reserveBlockDateFrom: Date;
    reserveBlockDateTo: Date;
    createdDateAt: Date;
    createdByPrincipalId: string;
    modifiedAtUtc?: Date;
    modifiedByPrincipalId?: string;
    reserveBlockRsvGroup: PersonRequestReserveGroupType;
    reserveBlockFunction: string;
    commentVisibleToCrew?: string;
}
export class PersonRequestReserveDto extends BaseApiModelClass< IPersonRequestReserveDto > implements IPersonRequestReserveDto {
    id: string;
    reserveBlockId: string;
    personId: string;
    personCode: string;
    reserveYearId: string;
    reserveYearPeriodId: string;
    status: PersonRequestReserveStatus;
    reserveBlockDateFrom: Date;
    reserveBlockDateTo: Date;
    createdDateAt: Date;
    createdByPrincipalId: string;
    modifiedAtUtc?: Date;
    modifiedByPrincipalId?: string;
    reserveBlockRsvGroup: PersonRequestReserveGroupType;
    reserveBlockFunction: string;
    commentVisibleToCrew?: string;
}

export enum PersonRequestReserveGroupType {
    A320 = "A320",
    A345 = "A345",
}

export interface IPersonRequestReserveMandatoryDto {
    mandatoryRequests: number;
    summerRequested: number;
    winterRequested: number;
    isRuleFulfilled?: boolean;
}
export class PersonRequestReserveMandatoryDto extends BaseApiModelClass< IPersonRequestReserveMandatoryDto > implements IPersonRequestReserveMandatoryDto {
    mandatoryRequests: number;
    summerRequested: number;
    winterRequested: number;
    isRuleFulfilled?: boolean;
}

export enum PersonRequestReserveStatus {
    Approved = "Approved",
    Confirmed = "Confirmed",
    Denied = "Denied",
    ManualAction = "ManualAction",
    Requested = "Requested",
}

export enum PersonRequestSummaryStatus {
    Approved = "Approved",
    Deleted = "Deleted",
    InProgress = "InProgress",
    ManualAction = "ManualAction",
    Rejected = "Rejected",
}

export enum PersonRequestType {
    Changelog = "Changelog",
    FlightLt = "FlightLt",
    FlightSt = "FlightSt",
    LTE = "LTE",
    LTO = "LTO",
    Reserve = "Reserve",
    STO = "STO",
    Tzv = "Tzv",
    Vacation = "Vacation",
}

export enum PersonRequestVac14DaysRuleStatus {
    IsFulfilled = "IsFulfilled",
    IsNotFulfilled = "IsNotFulfilled",
    IsNotFulfilledYetButCanBe = "IsNotFulfilledYetButCanBe",
}

export interface IPersonRequestVacAlternativeCreate {
    periodDateFrom: Date;
    periodDateTo: Date;
    priority: PersonRequestVacPriority;
    ignoreValidationWarnings: boolean;
}
export class PersonRequestVacAlternativeCreate extends BaseApiModelClass< IPersonRequestVacAlternativeCreate > implements IPersonRequestVacAlternativeCreate {
    periodDateFrom: Date;
    periodDateTo: Date;
    priority: PersonRequestVacPriority;
    ignoreValidationWarnings: boolean;
}

export enum PersonRequestVacAnswer {
    PersonAvailable = "PersonAvailable",
    PersonNotAvailable = "PersonNotAvailable",
    PersonNotAvailableAtDateRange = "PersonNotAvailableAtDateRange",
}

export interface IPersonRequestVacApproveModel {
    ignoreValidationWarnings: boolean;
}
export class PersonRequestVacApproveModel extends BaseApiModelClass< IPersonRequestVacApproveModel > implements IPersonRequestVacApproveModel {
    ignoreValidationWarnings: boolean;
}

export enum PersonRequestVacBlockDecision {
    Confirmed = "Confirmed",
    ConfirmedAlternative = "ConfirmedAlternative",
    Denied = "Denied",
    DeniedAlternative = "DeniedAlternative",
    None = "None",
}

export interface IPersonRequestVacBlockDto {
    requestBlockId: string;
    personId: string;
    personCode: string;
    vacationYearId: string;
    vacationYearPeriodId: string;
    type: PersonRequestVacType;
    referenceDate: Date;
    blockStatus: PersonRequestVacBlockStatus;
    decision: PersonRequestVacBlockDecision;
    approvedDateFrom?: Date;
    approvedDateTo?: Date;
    approvedDays?: number;
    approvedVacDays?: number;
    minPeriodFrom: Date;
    commentVisibleToCrew?: string;
    isAutogenerated: boolean;
    personAnswer?: PersonRequestVacAnswer;
    personNotAvailableDateFrom?: Date;
    personNotAvailableDateTo?: Date;
    requests: PersonRequestVacDto[];
}
export class PersonRequestVacBlockDto extends BaseApiModelClass< IPersonRequestVacBlockDto > implements IPersonRequestVacBlockDto {
    requestBlockId: string;
    personId: string;
    personCode: string;
    vacationYearId: string;
    vacationYearPeriodId: string;
    type: PersonRequestVacType;
    referenceDate: Date;
    blockStatus: PersonRequestVacBlockStatus;
    decision: PersonRequestVacBlockDecision;
    approvedDateFrom?: Date;
    approvedDateTo?: Date;
    approvedDays?: number;
    approvedVacDays?: number;
    minPeriodFrom: Date;
    commentVisibleToCrew?: string;
    isAutogenerated: boolean;
    personAnswer?: PersonRequestVacAnswer;
    personNotAvailableDateFrom?: Date;
    personNotAvailableDateTo?: Date;
    requests: PersonRequestVacDto[];
}

export interface IPersonRequestVacBlockLogInfo {
    id: string;
    modifiedDate: Date;
    modifiedBy: string;
    requestBlockId: string;
    changedFields: ChangeField[];
    requestLogs?: PersonRequestVacLogInfo[];
}
export class PersonRequestVacBlockLogInfo extends BaseApiModelClass< IPersonRequestVacBlockLogInfo > implements IPersonRequestVacBlockLogInfo {
    id: string;
    modifiedDate: Date;
    modifiedBy: string;
    requestBlockId: string;
    changedFields: ChangeField[];
    requestLogs?: PersonRequestVacLogInfo[];
}

export interface IPersonRequestVacBlockPersonAnswerModel {
    requestBlockId: string;
    answer: PersonRequestVacAnswer;
    personNotAvailableDateFrom?: Date;
    personNotAvailableDateTo?: Date;
}
export class PersonRequestVacBlockPersonAnswerModel extends BaseApiModelClass< IPersonRequestVacBlockPersonAnswerModel > implements IPersonRequestVacBlockPersonAnswerModel {
    requestBlockId: string;
    answer: PersonRequestVacAnswer;
    personNotAvailableDateFrom?: Date;
    personNotAvailableDateTo?: Date;
}

export enum PersonRequestVacBlockStatus {
    Alternative_Offered = "Alternative_Offered",
    Alternative_Pending = "Alternative_Pending",
    Closed = "Closed",
    Pending = "Pending",
    Requested = "Requested",
}

export enum PersonRequestVacCategory {
    Alternative = "Alternative",
    Reality = "Reality",
    Variant = "Variant",
}

export interface IPersonRequestVacCommentDto {
    requestBlockId: string;
    comment?: string;
    isVisibleToCrewComment: boolean;
}
export class PersonRequestVacCommentDto extends BaseApiModelClass< IPersonRequestVacCommentDto > implements IPersonRequestVacCommentDto {
    requestBlockId: string;
    comment?: string;
    isVisibleToCrewComment: boolean;
}

export interface IPersonRequestVacCreate {
    requestBlockId?: string;
    periodDateFrom: Date;
    periodDateTo: Date;
    type: PersonRequestVacType;
    priority: PersonRequestVacPriority;
    days: number;
    daysMin?: number;
    commentPerson?: string;
    isRequestedFromManagement?: boolean;
}
export class PersonRequestVacCreate extends BaseApiModelClass< IPersonRequestVacCreate > implements IPersonRequestVacCreate {
    requestBlockId?: string;
    periodDateFrom: Date;
    periodDateTo: Date;
    type: PersonRequestVacType;
    priority: PersonRequestVacPriority;
    days: number;
    daysMin?: number;
    commentPerson?: string;
    isRequestedFromManagement?: boolean;
}

export interface IPersonRequestVacDeadlineOption {
    amount: number;
    days: number;
}
export class PersonRequestVacDeadlineOption extends BaseApiModelClass< IPersonRequestVacDeadlineOption > implements IPersonRequestVacDeadlineOption {
    amount: number;
    days: number;
}

export interface IPersonRequestVacDto {
    id: string;
    personId: string;
    createdDateAt: Date;
    requestBlockId: string;
    blockStatus: PersonRequestVacBlockStatus;
    decision: PersonRequestVacBlockDecision;
    vacationYearId: string;
    vacationYearPeriodId: string;
    requestedByPrincipalId: string;
    periodDateFrom: Date;
    periodDateTo: Date;
    selectedDateFrom: Date;
    selectedDateTo: Date;
    days: number;
    daysMin?: number;
    type: PersonRequestVacType;
    priority: PersonRequestVacPriority;
    status: PersonRequestVacStatus;
    category: PersonRequestVacCategory;
    isAlternative: boolean;
    isDeleted: boolean;
    approvedAtUtc?: Date;
    approvedByPrincipalId?: string;
    commentPerson?: string;
}
export class PersonRequestVacDto extends BaseApiModelClass< IPersonRequestVacDto > implements IPersonRequestVacDto {
    id: string;
    personId: string;
    createdDateAt: Date;
    requestBlockId: string;
    blockStatus: PersonRequestVacBlockStatus;
    decision: PersonRequestVacBlockDecision;
    vacationYearId: string;
    vacationYearPeriodId: string;
    requestedByPrincipalId: string;
    periodDateFrom: Date;
    periodDateTo: Date;
    selectedDateFrom: Date;
    selectedDateTo: Date;
    days: number;
    daysMin?: number;
    type: PersonRequestVacType;
    priority: PersonRequestVacPriority;
    status: PersonRequestVacStatus;
    category: PersonRequestVacCategory;
    readonly isAlternative: boolean;
    isDeleted: boolean;
    approvedAtUtc?: Date;
    approvedByPrincipalId?: string;
    commentPerson?: string;
}

export interface IPersonRequestVacInformModel {
    doNotSendEmail: boolean;
    overrideAllowed: boolean;
}
export class PersonRequestVacInformModel extends BaseApiModelClass< IPersonRequestVacInformModel > implements IPersonRequestVacInformModel {
    doNotSendEmail: boolean;
    overrideAllowed: boolean;
}

export interface IPersonRequestVacLogInfo {
    id?: string;
    requestPeriodFromDate: Date;
    requestPeriodToDate: Date;
    changedFields: ChangeField[];
}
export class PersonRequestVacLogInfo extends BaseApiModelClass< IPersonRequestVacLogInfo > implements IPersonRequestVacLogInfo {
    id?: string;
    requestPeriodFromDate: Date;
    requestPeriodToDate: Date;
    changedFields: ChangeField[];
}

export enum PersonRequestVacLogUseType {
    GrantedAeropersReduction = "GrantedAeropersReduction",
    GrantedBonus = "GrantedBonus",
    GrantedByContract = "GrantedByContract",
    ManualCorrection = "ManualCorrection",
    PreviousVacationYearBalance = "PreviousVacationYearBalance",
    ReductionBlockIllAccMil = "ReductionBlockIllAccMil",
    ReductionBlockPre = "ReductionBlockPre",
    ReductionBlockUbu = "ReductionBlockUbu",
    ReductionByTzv = "ReductionByTzv",
    VacAdded = "VacAdded",
    VacDeleted = "VacDeleted",
}

export enum PersonRequestVacPriority {
    High = "High",
    Low = "Low",
    Medium = "Medium",
}

export interface IPersonRequestVacRulesStatus {
    vacationYearId: string;
    is14DaysRuleFulfilled: PersonRequestVac14DaysRuleStatus;
    isHalfYearRuleFulfilled: boolean;
}
export class PersonRequestVacRulesStatus extends BaseApiModelClass< IPersonRequestVacRulesStatus > implements IPersonRequestVacRulesStatus {
    vacationYearId: string;
    is14DaysRuleFulfilled: PersonRequestVac14DaysRuleStatus;
    isHalfYearRuleFulfilled: boolean;
}

export enum PersonRequestVacStatus {
    Confirmed = "Confirmed",
    Denied = "Denied",
    ManualAction = "ManualAction",
    Pending = "Pending",
    RequestedToApprove = "RequestedToApprove",
}

export enum PersonRequestVacType {
    U_UBU = "U_UBU",
    UBU = "UBU",
    UBU_C = "UBU_C",
    UBU_J_S = "UBU_J_S",
    UBU_K = "UBU_K",
    UBU_P = "UBU_P",
    UBUplus = "UBUplus",
    VAC = "VAC",
    VAC_N = "VAC_N",
    VAC_P = "VAC_P",
    VAC_S = "VAC_S",
    VAC_V = "VAC_V",
    VAC_W = "VAC_W",
}

export interface IPersonRequestVacTypeModel {
    type: PersonRequestVacType;
    isDisabled: boolean;
    reason: string;
}
export class PersonRequestVacTypeModel extends BaseApiModelClass< IPersonRequestVacTypeModel > implements IPersonRequestVacTypeModel {
    type: PersonRequestVacType;
    isDisabled: boolean;
    reason: string;
}

export interface IPersonRequestVacUpdate {
    requestBlockId?: string;
    periodDateFrom: Date;
    periodDateTo: Date;
    type: PersonRequestVacType;
    priority: PersonRequestVacPriority;
    days: number;
    daysMin?: number;
    commentPerson?: string;
    isRequestedFromManagement?: boolean;
    id: string;
}
export class PersonRequestVacUpdate extends BaseApiModelClass< IPersonRequestVacUpdate > implements IPersonRequestVacUpdate {
    requestBlockId?: string;
    periodDateFrom: Date;
    periodDateTo: Date;
    type: PersonRequestVacType;
    priority: PersonRequestVacPriority;
    days: number;
    daysMin?: number;
    commentPerson?: string;
    isRequestedFromManagement?: boolean;
    id: string;
}

export interface IPersonRequestVacValidationContext {
    dateFrom: Date;
    personId: string;
    vacationYearPeriodId: string;
    vacationYear: VacationYearDto;
    contextCreationErrors?: string[];
    personGroupType: PersonGroupType;
}
export class PersonRequestVacValidationContext extends BaseApiModelClass< IPersonRequestVacValidationContext > implements IPersonRequestVacValidationContext {
    dateFrom: Date;
    personId: string;
    vacationYearPeriodId: string;
    vacationYear: VacationYearDto;
    contextCreationErrors?: string[];
    personGroupType: PersonGroupType;
}

export interface IPersonRequestVacValidationResult {
    warnings: string[];
    errors: string[];
    context: PersonRequestVacValidationContext;
}
export class PersonRequestVacValidationResult extends BaseApiModelClass< IPersonRequestVacValidationResult > implements IPersonRequestVacValidationResult {
    warnings: string[];
    errors: string[];
    context: PersonRequestVacValidationContext;
}

export interface IPersonRequestVacationDaysBalanceInfo {
    personId: string;
    vacationYearId: string;
    previousVacationYearBalance: number;
    grantedByContract: number;
    grantedByContractRounded: number;
    grantedByContract80Rounded: number;
    bonus: number;
    bonusRounded: number;
    aeropersReductions: number;
    aeropersReductionsRounded: number;
    tzvReduction: number;
    tzvReductionRounded: number;
    tzvReductionComment?: string;
    correctionRounded: number;
    grantedTotal: number;
    reductions: PersonRequestVacationDaysReductionDto[];
    reductionTotal: number;
    manualCorrections: PersonRequestVacationDaysManualCorrectionDto[];
    manualCorrectionsTotal: number;
    correctedYearlyEntitlement: number;
    totalCanBeUsedThisYear: number;
    vacNCount: number;
    vacPCount: number;
    vacSCount: number;
    vacVCount: number;
    vacCount: number;
    vacWCount: number;
    vacCountTotal: number;
    reserved: number;
    plannable: number;
    daysAvailableFromThisYearOnly: number;
    available: number;
}
export class PersonRequestVacationDaysBalanceInfo extends BaseApiModelClass< IPersonRequestVacationDaysBalanceInfo > implements IPersonRequestVacationDaysBalanceInfo {
    personId: string;
    vacationYearId: string;
    previousVacationYearBalance: number;
    grantedByContract: number;
    grantedByContractRounded: number;
    grantedByContract80Rounded: number;
    bonus: number;
    bonusRounded: number;
    aeropersReductions: number;
    aeropersReductionsRounded: number;
    tzvReduction: number;
    tzvReductionRounded: number;
    tzvReductionComment?: string;
    correctionRounded: number;
    grantedTotal: number;
    reductions: PersonRequestVacationDaysReductionDto[];
    reductionTotal: number;
    manualCorrections: PersonRequestVacationDaysManualCorrectionDto[];
    manualCorrectionsTotal: number;
    correctedYearlyEntitlement: number;
    totalCanBeUsedThisYear: number;
    vacNCount: number;
    vacPCount: number;
    vacSCount: number;
    vacVCount: number;
    vacCount: number;
    vacWCount: number;
    vacCountTotal: number;
    reserved: number;
    plannable: number;
    daysAvailableFromThisYearOnly: number;
    available: number;
}

export interface IPersonRequestVacationDaysManualCorrectionDto {
    id: string;
    description: string;
    vacationDaysDelta: number;
}
export class PersonRequestVacationDaysManualCorrectionDto extends BaseApiModelClass< IPersonRequestVacationDaysManualCorrectionDto > implements IPersonRequestVacationDaysManualCorrectionDto {
    id: string;
    description: string;
    vacationDaysDelta: number;
}

export interface IPersonRequestVacationDaysReductionDto {
    reductionType: PersonRequestVacLogUseType;
    description: string;
    days: number;
    vacationDaysDelta: number;
}
export class PersonRequestVacationDaysReductionDto extends BaseApiModelClass< IPersonRequestVacationDaysReductionDto > implements IPersonRequestVacationDaysReductionDto {
    reductionType: PersonRequestVacLogUseType;
    description: string;
    days: number;
    vacationDaysDelta: number;
}

export interface IPersonRequestWishModel {
    date: Date;
    wishType: string;
    id: string;
    status: PersonWishStatus;
}
export class PersonRequestWishModel extends BaseApiModelClass< IPersonRequestWishModel > implements IPersonRequestWishModel {
    date: Date;
    wishType: string;
    id: string;
    status: PersonWishStatus;
}

export interface IPersonReserveRequestCreate {
    reserveBlockId: string;
}
export class PersonReserveRequestCreate extends BaseApiModelClass< IPersonReserveRequestCreate > implements IPersonReserveRequestCreate {
    reserveBlockId: string;
}

export interface IPersonRosterActivityModel {
    identity: string;
    fullName?: string;
    roles: string[];
    cells: RosterSelectedCell[];
}
export class PersonRosterActivityModel extends BaseApiModelClass< IPersonRosterActivityModel > implements IPersonRosterActivityModel {
    identity: string;
    fullName?: string;
    roles: string[];
    cells: RosterSelectedCell[];
}

export interface IPersonRotationComplementsDto {
    activityCodeName: string;
    flightNumbers: number[];
    rotationComplements: RotationCrewComplement[];
}
export class PersonRotationComplementsDto extends BaseApiModelClass< IPersonRotationComplementsDto > implements IPersonRotationComplementsDto {
    activityCodeName: string;
    flightNumbers: number[];
    rotationComplements: RotationCrewComplement[];
}

export interface IPersonShortInfoModel {
    id: string;
    code: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    phoneNumber?: string;
    isAeropersMember: boolean;
    optInShowAeropersSchedule: boolean;
    nbuRelated: boolean;
}
export class PersonShortInfoModel extends BaseApiModelClass< IPersonShortInfoModel > implements IPersonShortInfoModel {
    id: string;
    code: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    phoneNumber?: string;
    isAeropersMember: boolean;
    optInShowAeropersSchedule: boolean;
    nbuRelated: boolean;
}

export enum PersonSortOrder {
    Activity = "Activity",
    AmjMonths = "AmjMonths",
    AsoMonths = "AsoMonths",
    BlockHours = "BlockHours",
    Code = "Code",
    Default = "Default",
    DeltaQ = "DeltaQ",
    DeltaY = "DeltaY",
    Department = "Department",
    DjfMonths = "DjfMonths",
    DutyHours = "DutyHours",
    FmaMonths = "FmaMonths",
    FreeOfDutyDays = "FreeOfDutyDays",
    GroundAd1Count = "GroundAd1Count",
    GroundAd2Count = "GroundAd2Count",
    GroundAdmCount = "GroundAdmCount",
    GroundDisCount = "GroundDisCount",
    GroundECount = "GroundECount",
    GroundLCount = "GroundLCount",
    GroundNitCount = "GroundNitCount",
    GroundOfcCircleCount = "GroundOfcCircleCount",
    GroundOfcCircleHoCount = "GroundOfcCircleHoCount",
    GroundOfcCount = "GroundOfcCount",
    GroundOfcFlexCount = "GroundOfcFlexCount",
    GroundOfcHoCount = "GroundOfcHoCount",
    GroundOfcOpcCount = "GroundOfcOpcCount",
    GroundOffCount = "GroundOffCount",
    GroundOpsCount = "GroundOpsCount",
    GroundTrvCount = "GroundTrvCount",
    GroundVacCount = "GroundVacCount",
    HasOffDaysBlockError = "HasOffDaysBlockError",
    JasMonths = "JasMonths",
    JfmMonths = "JfmMonths",
    JjaMonths = "JjaMonths",
    LocalDays = "LocalDays",
    MamMonths = "MamMonths",
    MjjMonths = "MjjMonths",
    NdjMonths = "NdjMonths",
    None = "None",
    OffCount = "OffCount",
    OndMonths = "OndMonths",
    Ox2Count = "Ox2Count",
    Quarter1 = "Quarter1",
    Quarter2 = "Quarter2",
    Quarter3 = "Quarter3",
    Quarter4 = "Quarter4",
    SingleDays = "SingleDays",
    SonMonths = "SonMonths",
}

export interface IPersonSummaryFiguresModel {
    personId: string;
    date: Date;
    offCount: number;
    freeOfDutyDays: number;
    hasOffDaysBlockError?: boolean;
    ox2Count: number;
    singleDays: number;
    localDaysPts: number;
    localDays: number;
    blockHoursSecs: number;
    blockHoursLimit: number;
    dutyHoursSecs: number;
    blockHours: number;
    dutyHours: number;
    groundOffCount: number;
    groundOpsCount: number;
    groundDisCount: number;
    groundNitCount: number;
    groundAdmCount: number;
    groundTrvCount: number;
    groundVacCount: number;
    groundAd1Count: number;
    groundAd2Count: number;
    groundECount: number;
    groundLCount: number;
    groundOfcCount: number;
    groundOfcOpcCount: number;
    groundOfcCircleCount: number;
    groundOfcHoCount: number;
    groundOfcCircleHoCount: number;
    groundOfcFlexCount: number;
}
export class PersonSummaryFiguresModel extends BaseApiModelClass< IPersonSummaryFiguresModel > implements IPersonSummaryFiguresModel {
    personId: string;
    date: Date;
    offCount: number;
    freeOfDutyDays: number;
    hasOffDaysBlockError?: boolean;
    ox2Count: number;
    singleDays: number;
    localDaysPts: number;
    readonly localDays: number;
    blockHoursSecs: number;
    blockHoursLimit: number;
    dutyHoursSecs: number;
    readonly blockHours: number;
    readonly dutyHours: number;
    groundOffCount: number;
    groundOpsCount: number;
    groundDisCount: number;
    groundNitCount: number;
    groundAdmCount: number;
    groundTrvCount: number;
    groundVacCount: number;
    groundAd1Count: number;
    groundAd2Count: number;
    groundECount: number;
    groundLCount: number;
    groundOfcCount: number;
    groundOfcOpcCount: number;
    groundOfcCircleCount: number;
    groundOfcHoCount: number;
    groundOfcCircleHoCount: number;
    groundOfcFlexCount: number;
}

export interface IPersonTzvContractInfo {
    dateFrom: Date;
    dateTo?: Date;
    partTimePercentage: number;
    typeModel: ContractModelType;
    typeModelDisplayName: string;
    typeModelDetails: string;
    typeModelSpecialDetails?: string;
    combinationVariableDayBlockLength?: number;
    combinationVariableDaySplitType?: BlockSplitType;
}
export class PersonTzvContractInfo extends BaseApiModelClass< IPersonTzvContractInfo > implements IPersonTzvContractInfo {
    dateFrom: Date;
    dateTo?: Date;
    partTimePercentage: number;
    typeModel: ContractModelType;
    typeModelDisplayName: string;
    typeModelDetails: string;
    typeModelSpecialDetails?: string;
    combinationVariableDayBlockLength?: number;
    combinationVariableDaySplitType?: BlockSplitType;
}

export interface IPersonTzvDayAssignmentModel {
    id: string;
    date: Date;
    status: PersonTzvDayAssignmentType;
    comment?: string;
    timestamp: Date;
    createdByPrincipal: string;
}
export class PersonTzvDayAssignmentModel extends BaseApiModelClass< IPersonTzvDayAssignmentModel > implements IPersonTzvDayAssignmentModel {
    id: string;
    date: Date;
    status: PersonTzvDayAssignmentType;
    comment?: string;
    timestamp: Date;
    createdByPrincipal: string;
}

export enum PersonTzvDayAssignmentType {
    Added = "Added",
    Removed = "Removed",
}

export interface IPersonVacDetailsModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    personId: string;
    crewId: string;
    personCode: string;
    personName?: string;
    entryDate?: Date;
    exitDate?: Date;
    personSeniority: number;
    personSeniorityRank: number;
    personFunction?: string;
    personContract?: number;
    personContractType: ContractType;
    contractModelType: ContractModelType;
    personContractTypeModel?: string;
    vacEntitlement?: number;
    licenseFleet?: string;
    fleetType?: FleetType;
    fleetGroup?: string;
    vacationYear: string;
    vacationYearId: string;
    backlogPreviousYear: number;
    entitlementActualYear: number;
    otherGranted: number;
    reductionTotal: number;
    manualCorrection: number;
    correctedEntitlement: number;
    requestedVac: number;
    pendingConfirmed: number;
    confirmedPeriod1: number;
    confirmedPeriod2: number;
    confirmed: number;
    daysRemaining?: number;
    balance: number;
    confirmedVacP: number;
    confirmedVacS: number;
    confirmedVacN: number;
    confirmedVacV: number;
    confirmedVacVac: number;
    confirmedVacW: number;
    ubuCount: number;
    illCount: number;
    accCount: number;
    milCount: number;
    preCount: number;
    m_pCount: number;
    m_uCount: number;
    tzvCount: number;
    lastVacDate?: Date;
    req14DaysRuleStatus: PersonRequestVac14DaysRuleStatus;
    cfm14DaysRuleStatus: PersonRequestVac14DaysRuleStatus;
    cfm28DaysRuleStatus: PersonRequestVac14DaysRuleStatus;
    cabinHalfYearRuleStatus: PersonRequestVac14DaysRuleStatus;
    alternativeOfferedFirstPeriodStatus: PersonRequestVac14DaysRuleStatus;
    alternativeOfferedSecondPeriodStatus: PersonRequestVac14DaysRuleStatus;
    combinationVariableDayBlockLength?: number;
    combinationVariableDaySplitType?: BlockSplitType;
}
export class PersonVacDetailsModel extends BaseApiModelClass< IPersonVacDetailsModel > implements IPersonVacDetailsModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    personId: string;
    readonly crewId: string;
    personCode: string;
    personName?: string;
    entryDate?: Date;
    exitDate?: Date;
    personSeniority: number;
    personSeniorityRank: number;
    personFunction?: string;
    personContract?: number;
    personContractType: ContractType;
    contractModelType: ContractModelType;
    readonly personContractTypeModel?: string;
    vacEntitlement?: number;
    licenseFleet?: string;
    fleetType?: FleetType;
    readonly fleetGroup?: string;
    vacationYear: string;
    vacationYearId: string;
    backlogPreviousYear: number;
    entitlementActualYear: number;
    otherGranted: number;
    reductionTotal: number;
    manualCorrection: number;
    correctedEntitlement: number;
    requestedVac: number;
    pendingConfirmed: number;
    confirmedPeriod1: number;
    confirmedPeriod2: number;
    confirmed: number;
    daysRemaining?: number;
    balance: number;
    confirmedVacP: number;
    confirmedVacS: number;
    confirmedVacN: number;
    confirmedVacV: number;
    confirmedVacVac: number;
    confirmedVacW: number;
    ubuCount: number;
    illCount: number;
    accCount: number;
    milCount: number;
    preCount: number;
    m_pCount: number;
    m_uCount: number;
    tzvCount: number;
    lastVacDate?: Date;
    req14DaysRuleStatus: PersonRequestVac14DaysRuleStatus;
    cfm14DaysRuleStatus: PersonRequestVac14DaysRuleStatus;
    cfm28DaysRuleStatus: PersonRequestVac14DaysRuleStatus;
    cabinHalfYearRuleStatus: PersonRequestVac14DaysRuleStatus;
    alternativeOfferedFirstPeriodStatus: PersonRequestVac14DaysRuleStatus;
    alternativeOfferedSecondPeriodStatus: PersonRequestVac14DaysRuleStatus;
    combinationVariableDayBlockLength?: number;
    combinationVariableDaySplitType?: BlockSplitType;
}

export interface IPersonVacDetailsModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}
export class PersonVacDetailsModelDataSourceLoadOptions extends BaseApiModelClass< IPersonVacDetailsModelDataSourceLoadOptions > implements IPersonVacDetailsModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}

export interface IPersonViewLicenseModel {
    licenseName: string;
    licenseId: string;
    expiryDate?: Date;
    showExpired: boolean;
}
export class PersonViewLicenseModel extends BaseApiModelClass< IPersonViewLicenseModel > implements IPersonViewLicenseModel {
    licenseName: string;
    licenseId: string;
    expiryDate?: Date;
    showExpired: boolean;
}

export interface IPersonViewModel {
    passportExpiryDate?: Date;
    secondPassportExpiryDate?: Date;
    nationality?: string;
    secondNationality?: string;
    medicalExpiryDate?: Date;
    visaUsaBExpiryDate?: Date;
    visaUsaCExpiryDate?: Date;
    visaRUExpiryDate?: Date;
    cmcDate?: Date;
    function?: string;
    entryDateFrom?: Date;
    planningSeniorityBaseDate?: Date;
    experience320: string;
    experience340: string;
    experience350: string;
    dosimetryTotalMsv: number;
    dosimetryYearToDateMsv: number;
    showCrewScheduleLink: boolean;
    showFlightDutyTimeRecord: boolean;
    optInShowAeropersSchedule: boolean;
    licenses: PersonViewLicenseModel[];
    qualifications: PersonViewLicenseModel[];
    seniorityRank: number;
    seniorityRankMax: number;
    backgroundCheckDate?: Date;
}
export class PersonViewModel extends BaseApiModelClass< IPersonViewModel > implements IPersonViewModel {
    passportExpiryDate?: Date;
    secondPassportExpiryDate?: Date;
    nationality?: string;
    secondNationality?: string;
    medicalExpiryDate?: Date;
    visaUsaBExpiryDate?: Date;
    visaUsaCExpiryDate?: Date;
    visaRUExpiryDate?: Date;
    cmcDate?: Date;
    function?: string;
    entryDateFrom?: Date;
    planningSeniorityBaseDate?: Date;
    experience320: string;
    experience340: string;
    experience350: string;
    dosimetryTotalMsv: number;
    dosimetryYearToDateMsv: number;
    showCrewScheduleLink: boolean;
    showFlightDutyTimeRecord: boolean;
    optInShowAeropersSchedule: boolean;
    licenses: PersonViewLicenseModel[];
    qualifications: PersonViewLicenseModel[];
    seniorityRank: number;
    seniorityRankMax: number;
    backgroundCheckDate?: Date;
}

export interface IPersonWishCreateModel {
    wishTypeId: string;
}
export class PersonWishCreateModel extends BaseApiModelClass< IPersonWishCreateModel > implements IPersonWishCreateModel {
    wishTypeId: string;
}

export enum PersonWishStatus {
    Approved = "Approved",
    Complete = "Complete",
    Pending = "Pending",
    Rejected = "Rejected",
}

export interface IPlannedSimulationInfo {
    memberType: SimulationMemberType;
    personCode: string;
    personId: string;
    lpl4PersonCode?: string;
}
export class PlannedSimulationInfo extends BaseApiModelClass< IPlannedSimulationInfo > implements IPlannedSimulationInfo {
    memberType: SimulationMemberType;
    personCode: string;
    personId: string;
    lpl4PersonCode?: string;
}

export interface IPlannedSimulationModel {
    aircraftType: SimulationAircraftType;
    simulationType: SimulationType;
    startDateUtc: Date;
    endDateUtc: Date;
    plannedSimulations: PlannedSimulationInfo[];
    airportRcd?: string;
    ebtModuleType?: EbtModuleType;
}
export class PlannedSimulationModel extends BaseApiModelClass< IPlannedSimulationModel > implements IPlannedSimulationModel {
    aircraftType: SimulationAircraftType;
    simulationType: SimulationType;
    startDateUtc: Date;
    endDateUtc: Date;
    plannedSimulations: PlannedSimulationInfo[];
    airportRcd?: string;
    ebtModuleType?: EbtModuleType;
}

export interface IPlannedTrainingReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    flightDate?: Date;
    checkerPersonId?: string;
    checkerPersonDisplayName?: string;
    checkerPersonCode?: string;
    traineePersonId: string;
    traineePersonDisplayName?: string;
    traineePersonCode?: string;
    traineePersonContractType?: string;
    traineePersonFunction?: string;
    flightNumber: string;
    flightLegs?: string;
    aircraftTypeGroupDisplayName?: string;
    function: CheckerTraineeFunction;
    functionDisplayName: string;
}
export class PlannedTrainingReportModel extends BaseApiModelClass< IPlannedTrainingReportModel > implements IPlannedTrainingReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    flightDate?: Date;
    checkerPersonId?: string;
    checkerPersonDisplayName?: string;
    checkerPersonCode?: string;
    traineePersonId: string;
    traineePersonDisplayName?: string;
    traineePersonCode?: string;
    traineePersonContractType?: string;
    traineePersonFunction?: string;
    flightNumber: string;
    flightLegs?: string;
    aircraftTypeGroupDisplayName?: string;
    function: CheckerTraineeFunction;
    readonly functionDisplayName: string;
}

export interface IPlannedTrainingReportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}
export class PlannedTrainingReportModelDataSourceLoadOptions extends BaseApiModelClass< IPlannedTrainingReportModelDataSourceLoadOptions > implements IPlannedTrainingReportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}

export interface IPlannedTrainingsReportFilter {
    rowLimit?: number;
    dateFrom: Date;
    dateTo: Date;
}
export class PlannedTrainingsReportFilter extends BaseApiModelClass< IPlannedTrainingsReportFilter > implements IPlannedTrainingsReportFilter {
    rowLimit?: number;
    dateFrom: Date;
    dateTo: Date;
}

export interface IPlanningDayDto {
    personId: string;
    id: string;
    date: Date;
    type: PersonPlanningDayType;
    createdAtUtc: Date;
    createdByPrincipalIdentity?: string;
    activityRcd: string;
    dateTimeFromUtc?: Date;
    dateTimeToUtc?: Date;
    dateTimeFromDiffToLt?: string;
    dateTimeToDiffToLt?: string;
    customDayTitle?: string;
    title?: string;
    dutyTimeSec: number;
    blockTimeSec: number;
    oldText?: string;
    isAfterNightDuty: boolean;
    isBeforeNightDuty: boolean;
    fdpExtensionType: number;
    isGav: boolean;
    isFtl: boolean;
    fdpAmendmentType?: number;
    isAfterLongTermEvening: boolean;
    duties?: PlanningDayDtoDuty[];
}
export class PlanningDayDto extends BaseApiModelClass< IPlanningDayDto > implements IPlanningDayDto {
    personId: string;
    id: string;
    date: Date;
    type: PersonPlanningDayType;
    createdAtUtc: Date;
    createdByPrincipalIdentity?: string;
    activityRcd: string;
    dateTimeFromUtc?: Date;
    dateTimeToUtc?: Date;
    dateTimeFromDiffToLt?: string;
    dateTimeToDiffToLt?: string;
    customDayTitle?: string;
    title?: string;
    dutyTimeSec: number;
    blockTimeSec: number;
    oldText?: string;
    isAfterNightDuty: boolean;
    isBeforeNightDuty: boolean;
    fdpExtensionType: number;
    isGav: boolean;
    isFtl: boolean;
    fdpAmendmentType?: number;
    isAfterLongTermEvening: boolean;
    duties?: PlanningDayDtoDuty[];
}

export interface IPlanningDayDtoDuty {
    planningDayId: string;
    activityId: string;
    flightId?: string;
    positioningId?: string;
    departureTimeDiffToLt?: string;
    arrivalTimeDiffToLt?: string;
    outOfTheGateUtc?: Date;
    offTheGroundUtc?: Date;
    intoTheGateUtc?: Date;
    planedFlightFromUtc?: Date;
    planedFlightToUtc?: Date;
    flightEstimatedDepartureDateTimeUtc?: Date;
    flightEstimatedArrivalDateTimeUtc?: Date;
    aircraftTypeId?: string;
    aircraftTypeGroupId?: string;
    aircraftRegistrationNumber?: string;
    requestId?: string;
}
export class PlanningDayDtoDuty extends BaseApiModelClass< IPlanningDayDtoDuty > implements IPlanningDayDtoDuty {
    planningDayId: string;
    activityId: string;
    flightId?: string;
    positioningId?: string;
    departureTimeDiffToLt?: string;
    arrivalTimeDiffToLt?: string;
    outOfTheGateUtc?: Date;
    offTheGroundUtc?: Date;
    intoTheGateUtc?: Date;
    planedFlightFromUtc?: Date;
    planedFlightToUtc?: Date;
    flightEstimatedDepartureDateTimeUtc?: Date;
    flightEstimatedArrivalDateTimeUtc?: Date;
    aircraftTypeId?: string;
    aircraftTypeGroupId?: string;
    aircraftRegistrationNumber?: string;
    requestId?: string;
}

export enum PlanningGroupDayStatus {
    None = "None",
    Planned = "Planned",
}

export interface IPlanningGroupDayStatusRequest {
    date: Date;
    functionGroupId: string;
    functionId?: string;
    status: PlanningGroupDayStatus;
}
export class PlanningGroupDayStatusRequest extends BaseApiModelClass< IPlanningGroupDayStatusRequest > implements IPlanningGroupDayStatusRequest {
    date: Date;
    functionGroupId: string;
    functionId?: string;
    status: PlanningGroupDayStatus;
}

export interface IPlanningGroupDto {
    name?: string;
    functionGroupId: string;
    functionId?: string;
    functionName?: string;
    functionGroupName?: string;
    releaseLevel: ReleaseLevel;
}
export class PlanningGroupDto extends BaseApiModelClass< IPlanningGroupDto > implements IPlanningGroupDto {
    name?: string;
    functionGroupId: string;
    functionId?: string;
    functionName?: string;
    functionGroupName?: string;
    releaseLevel: ReleaseLevel;
}

export interface IPlanningPeriodConfigRequest {
    hidePlanningPeriod: boolean;
    functionGroupId: string;
    functionId?: string;
}
export class PlanningPeriodConfigRequest extends BaseApiModelClass< IPlanningPeriodConfigRequest > implements IPlanningPeriodConfigRequest {
    hidePlanningPeriod: boolean;
    functionGroupId: string;
    functionId?: string;
}

export interface IPlanningPeriodDto {
    id: string;
    periodFrom: Date;
    periodTo: Date;
    functionGroupId: string;
    functionId?: string;
}
export class PlanningPeriodDto extends BaseApiModelClass< IPlanningPeriodDto > implements IPlanningPeriodDto {
    id: string;
    periodFrom: Date;
    periodTo: Date;
    functionGroupId: string;
    functionId?: string;
}

export interface IPlanningRequestModel {
    functionId: string;
    periodFrom: Date;
    periodTo: Date;
}
export class PlanningRequestModel extends BaseApiModelClass< IPlanningRequestModel > implements IPlanningRequestModel {
    functionId: string;
    periodFrom: Date;
    periodTo: Date;
}

export interface IPointsManualCorrectionModel {
    referenceDate: Date;
    points: number;
    reason: string;
}
export class PointsManualCorrectionModel extends BaseApiModelClass< IPointsManualCorrectionModel > implements IPointsManualCorrectionModel {
    referenceDate: Date;
    points: number;
    reason: string;
}

export interface IPopUpDayComment {
    text: string;
    isStandby: boolean;
    isVisibleByCrewMember: boolean;
    isVisibleToAllUsers: boolean;
    personId: string;
    id?: string;
    date: Date;
    createdOnDateUtc: Date;
    createdBy: string;
    category: CommentCategory;
}
export class PopUpDayComment extends BaseApiModelClass< IPopUpDayComment > implements IPopUpDayComment {
    text: string;
    isStandby: boolean;
    isVisibleByCrewMember: boolean;
    isVisibleToAllUsers: boolean;
    personId: string;
    id?: string;
    date: Date;
    createdOnDateUtc: Date;
    createdBy: string;
    category: CommentCategory;
}

export interface IPosDutyData {
    positioningId?: string;
    positioningType: PositioningType;
    positioningCustom?: string;
    append: boolean;
    flightId?: string;
    originRcd: string;
    destinationRcd: string;
    startLocal: Date;
    endLocal: Date;
}
export class PosDutyData extends BaseApiModelClass< IPosDutyData > implements IPosDutyData {
    positioningId?: string;
    positioningType: PositioningType;
    positioningCustom?: string;
    append: boolean;
    flightId?: string;
    originRcd: string;
    destinationRcd: string;
    startLocal: Date;
    endLocal: Date;
}

export interface IPositioningCustomModel {
    custom?: string;
    originRcd: string;
    destinationRcd: string;
    dateTimeFrom: Date;
    dateTimeTo: Date;
    dateTimeFromDiffToLt?: string;
    dateTimeToDiffToLt?: string;
    checkIn: number;
    checkOut: number;
}
export class PositioningCustomModel extends BaseApiModelClass< IPositioningCustomModel > implements IPositioningCustomModel {
    custom?: string;
    originRcd: string;
    destinationRcd: string;
    dateTimeFrom: Date;
    dateTimeTo: Date;
    dateTimeFromDiffToLt?: string;
    dateTimeToDiffToLt?: string;
    checkIn: number;
    checkOut: number;
}

export interface IPositioningModel {
    id: string;
    custom?: string;
    type: PositioningType;
    flightId?: string;
    originRcd?: string;
    destinationRcd?: string;
    startDateUtc: Date;
    endDateUtc: Date;
    checkinDateUtc: Date;
    checkoutDateUtc: Date;
    dateTimeFromDiffToLt?: string;
    dateTimeToDiffToLt?: string;
}
export class PositioningModel extends BaseApiModelClass< IPositioningModel > implements IPositioningModel {
    id: string;
    custom?: string;
    type: PositioningType;
    flightId?: string;
    originRcd?: string;
    destinationRcd?: string;
    startDateUtc: Date;
    endDateUtc: Date;
    checkinDateUtc: Date;
    checkoutDateUtc: Date;
    dateTimeFromDiffToLt?: string;
    dateTimeToDiffToLt?: string;
}

export enum PositioningType {
    Other = "Other",
    OtherFlight = "OtherFlight",
    WkFlight = "WkFlight",
}

export interface IPreReservationHotelBookingDetailModel {
    hotelEmail?: string;
    hotelTitle?: string;
    location: string;
    transitionDate: Date;
}
export class PreReservationHotelBookingDetailModel extends BaseApiModelClass< IPreReservationHotelBookingDetailModel > implements IPreReservationHotelBookingDetailModel {
    hotelEmail?: string;
    hotelTitle?: string;
    location: string;
    transitionDate: Date;
}

export interface IPreReservationLocationsModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    location: string;
}
export class PreReservationLocationsModel extends BaseApiModelClass< IPreReservationLocationsModel > implements IPreReservationLocationsModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    location: string;
}

export interface IPreReservationLocationsModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}
export class PreReservationLocationsModelDataSourceLoadOptions extends BaseApiModelClass< IPreReservationLocationsModelDataSourceLoadOptions > implements IPreReservationLocationsModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}

export interface IPredefinedRoleModel {
    id: number;
    codeName: string;
    description: string;
    permissionIds: number[];
}
export class PredefinedRoleModel extends BaseApiModelClass< IPredefinedRoleModel > implements IPredefinedRoleModel {
    id: number;
    codeName: string;
    description: string;
    permissionIds: number[];
}

export enum QualificationCategory {
    Aircraft = "Aircraft",
    Airport = "Airport",
    Ignore = "Ignore",
    Instructor = "Instructor",
    Language = "Language",
    Medical = "Medical",
    Other = "Other",
    Recurrent = "Recurrent",
    Restriction = "Restriction",
}

export interface IQualityLoopExportReportItem {
    id: string;
    principalDisplayName?: string;
    principalEmail?: string;
    createdAtUtc: Date;
    periodFrom: Date;
    periodTo: Date;
}
export class QualityLoopExportReportItem extends BaseApiModelClass< IQualityLoopExportReportItem > implements IQualityLoopExportReportItem {
    id: string;
    principalDisplayName?: string;
    principalEmail?: string;
    createdAtUtc: Date;
    periodFrom: Date;
    periodTo: Date;
}

export interface IQualityLoopJobStartModel {
    periodFrom?: Date;
    periodTo?: Date;
}
export class QualityLoopJobStartModel extends BaseApiModelClass< IQualityLoopJobStartModel > implements IQualityLoopJobStartModel {
    periodFrom?: Date;
    periodTo?: Date;
}

export interface IQueueStatisticsModel {
    queueName: string;
    messagesCount?: number;
    deadletterMessagesCount?: number;
    messagesPerMinuteIn: number;
    messagesPerMinuteOut: number;
    status: SelfTestResultStatus;
    statusMessage?: string;
}
export class QueueStatisticsModel extends BaseApiModelClass< IQueueStatisticsModel > implements IQueueStatisticsModel {
    queueName: string;
    messagesCount?: number;
    deadletterMessagesCount?: number;
    messagesPerMinuteIn: number;
    messagesPerMinuteOut: number;
    status: SelfTestResultStatus;
    statusMessage?: string;
}

export interface IReccurentTrainingReportFilter {
    rowLimit?: number;
    functionId?: string;
    contractTypes?: ContractType[];
}
export class ReccurentTrainingReportFilter extends BaseApiModelClass< IReccurentTrainingReportFilter > implements IReccurentTrainingReportFilter {
    rowLimit?: number;
    functionId?: string;
    contractTypes?: ContractType[];
}

export interface IRecencyItem {
    aircraftType: AircraftType;
    landingType: LandingType;
    date?: Date;
    landings: RecencyItemEvent[];
    events: RecencyItemEvent[];
}
export class RecencyItem extends BaseApiModelClass< IRecencyItem > implements IRecencyItem {
    aircraftType: AircraftType;
    landingType: LandingType;
    date?: Date;
    readonly landings: RecencyItemEvent[];
    events: RecencyItemEvent[];
}

export interface IRecencyItemEvent {
    date: Date;
}
export class RecencyItemEvent extends BaseApiModelClass< IRecencyItemEvent > implements IRecencyItemEvent {
    date: Date;
}

export interface IRecencyResponse {
    personId: string;
    date: Date;
    items: RecencyItem[];
    landings: RecencyItem[];
    takeOffs: RecencyItem[];
    combined: RecencyItem[];
}
export class RecencyResponse extends BaseApiModelClass< IRecencyResponse > implements IRecencyResponse {
    personId: string;
    date: Date;
    readonly items: RecencyItem[];
    landings: RecencyItem[];
    takeOffs: RecencyItem[];
    combined: RecencyItem[];
}

export interface IRecurrentTrainingReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    date: Date;
    personCode: string;
    personName?: string;
    contract?: string;
    function?: string;
    licenseFleet?: string;
    entryDate?: Date;
    exitDate?: Date;
    lineCheckExpireDate?: Date;
    lastTraineeDate?: Date;
    lastTraineeAircraftType?: string;
    nextTraineeDate?: Date;
    nextTraineeFunction?: string;
    lineCheckRemainingDays?: number;
    nextTraineeAircraftType?: string;
}
export class RecurrentTrainingReportModel extends BaseApiModelClass< IRecurrentTrainingReportModel > implements IRecurrentTrainingReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    date: Date;
    personCode: string;
    personName?: string;
    contract?: string;
    function?: string;
    licenseFleet?: string;
    entryDate?: Date;
    exitDate?: Date;
    lineCheckExpireDate?: Date;
    lastTraineeDate?: Date;
    lastTraineeAircraftType?: string;
    nextTraineeDate?: Date;
    nextTraineeFunction?: string;
    lineCheckRemainingDays?: number;
    nextTraineeAircraftType?: string;
}

export interface IRecurrentTrainingReportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}
export class RecurrentTrainingReportModelDataSourceLoadOptions extends BaseApiModelClass< IRecurrentTrainingReportModelDataSourceLoadOptions > implements IRecurrentTrainingReportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}

export interface IRejectRequestModel {
    commentVisibleToCrew?: string;
}
export class RejectRequestModel extends BaseApiModelClass< IRejectRequestModel > implements IRejectRequestModel {
    commentVisibleToCrew?: string;
}

export interface IRejectReserveRequestModel {
    id: string;
    commentVisibleToCrew?: string;
}
export class RejectReserveRequestModel extends BaseApiModelClass< IRejectReserveRequestModel > implements IRejectReserveRequestModel {
    id: string;
    commentVisibleToCrew?: string;
}

export interface IRelatedPersonResponse {
    currentPerson: PersonShortInfoModel;
    authenticatedPerson?: PersonModel;
    actualPerson?: PersonModel;
}
export class RelatedPersonResponse extends BaseApiModelClass< IRelatedPersonResponse > implements IRelatedPersonResponse {
    currentPerson: PersonShortInfoModel;
    authenticatedPerson?: PersonModel;
    actualPerson?: PersonModel;
}

export enum ReleaseFilterType {
    AgreementError = "AgreementError",
    Blank = "Blank",
    COU = "COU",
    DTY = "DTY",
    EasaError = "EasaError",
    EasaNext2hError = "EasaNext2hError",
    FtlError = "FtlError",
    GavError = "GavError",
    LicenseExpired = "LicenseExpired",
    OtherError = "OtherError",
    VAC = "VAC",
}

export interface IReleaseHistoryDateItem {
    functionGroupId: string;
    functionId?: string;
    date: Date;
}
export class ReleaseHistoryDateItem extends BaseApiModelClass< IReleaseHistoryDateItem > implements IReleaseHistoryDateItem {
    functionGroupId: string;
    functionId?: string;
    date: Date;
}

export enum ReleaseLevel {
    Function = "Function",
    FunctionGroup = "FunctionGroup",
    None = "None",
}

export interface IReleaseNoteDtoShort {
    id: string;
    title: string;
    text: string;
    isForCrewPage: boolean;
    isForCrewPortal: boolean;
    isDraft: boolean;
    showAfterDateUtc?: Date;
    releasedAtUtc?: Date;
    releasedWithCommitId?: string;
    isNew: boolean;
}
export class ReleaseNoteDtoShort extends BaseApiModelClass< IReleaseNoteDtoShort > implements IReleaseNoteDtoShort {
    id: string;
    title: string;
    text: string;
    isForCrewPage: boolean;
    isForCrewPortal: boolean;
    isDraft: boolean;
    showAfterDateUtc?: Date;
    releasedAtUtc?: Date;
    releasedWithCommitId?: string;
    isNew: boolean;
}

export interface IReleaseNoteModel {
    title: string;
    text: string;
    isForCrewPage: boolean;
    isForCrewPortal: boolean;
    isDraft: boolean;
    showAfterDateUtc?: Date;
    releasedAtUtc?: Date;
    releasedWithCommitId?: string;
}
export class ReleaseNoteModel extends BaseApiModelClass< IReleaseNoteModel > implements IReleaseNoteModel {
    title: string;
    text: string;
    isForCrewPage: boolean;
    isForCrewPortal: boolean;
    isDraft: boolean;
    showAfterDateUtc?: Date;
    releasedAtUtc?: Date;
    releasedWithCommitId?: string;
}

export interface IReleaseNoteResponseItem {
    id: string;
    title: string;
    text: string;
    isForCrewPage: boolean;
    isForCrewPortal: boolean;
    isDraft: boolean;
    showAfterDateUtc?: Date;
    releasedAtUtc?: Date;
    releasedWithCommitId?: string;
}
export class ReleaseNoteResponseItem extends BaseApiModelClass< IReleaseNoteResponseItem > implements IReleaseNoteResponseItem {
    id: string;
    title: string;
    text: string;
    isForCrewPage: boolean;
    isForCrewPortal: boolean;
    isDraft: boolean;
    showAfterDateUtc?: Date;
    releasedAtUtc?: Date;
    releasedWithCommitId?: string;
}

export interface IReleasePeriodModel {
    periodFromUtc: Date;
    periodToUtc: Date;
}
export class ReleasePeriodModel extends BaseApiModelClass< IReleasePeriodModel > implements IReleasePeriodModel {
    periodFromUtc: Date;
    periodToUtc: Date;
}

export interface IReleaseStatus {
    principalId?: string;
    principalDisplayName?: string;
    isReleasedDate: boolean;
    isPendingReleaseDate: boolean;
}
export class ReleaseStatus extends BaseApiModelClass< IReleaseStatus > implements IReleaseStatus {
    principalId?: string;
    principalDisplayName?: string;
    isReleasedDate: boolean;
    isPendingReleaseDate: boolean;
}

export interface IReleasedPeriodDto {
    name?: string;
    functionGroupId: string;
    functionId?: string;
    functionName?: string;
    functionGroupName?: string;
    releaseLevel: ReleaseLevel;
    periodFromUtc: Date;
    periodToUtc: Date;
    releasedBy?: string;
    releasedAtUtc?: Date;
    isReleased: boolean;
    isLast: boolean;
}
export class ReleasedPeriodDto extends BaseApiModelClass< IReleasedPeriodDto > implements IReleasedPeriodDto {
    name?: string;
    functionGroupId: string;
    functionId?: string;
    functionName?: string;
    functionGroupName?: string;
    releaseLevel: ReleaseLevel;
    periodFromUtc: Date;
    periodToUtc: Date;
    releasedBy?: string;
    releasedAtUtc?: Date;
    readonly isReleased: boolean;
    isLast: boolean;
}

export interface IRequestCapacityAnalyzedModel {
    excelFileId: string;
    capacities: RequestCapacityValueModel[];
}
export class RequestCapacityAnalyzedModel extends BaseApiModelClass< IRequestCapacityAnalyzedModel > implements IRequestCapacityAnalyzedModel {
    excelFileId: string;
    capacities: RequestCapacityValueModel[];
}

export enum RequestCapacityDateStatus {
    InPast = "InPast",
    Normal = "Normal",
    Overlapping = "Overlapping",
}

export enum RequestCapacityFileImportedStatus {
    Imported = "Imported",
    Uploaded = "Uploaded",
}

export interface IRequestCapacityToolOverview {
    offCapacity: RequestCapacityToolOverviewItem[];
    vacCapacity: RequestCapacityToolOverviewItem[];
    freelanceCapacity: RequestCapacityToolOverviewItem[];
    stfrCapacity: RequestCapacityToolOverviewItem[];
}
export class RequestCapacityToolOverview extends BaseApiModelClass< IRequestCapacityToolOverview > implements IRequestCapacityToolOverview {
    offCapacity: RequestCapacityToolOverviewItem[];
    vacCapacity: RequestCapacityToolOverviewItem[];
    freelanceCapacity: RequestCapacityToolOverviewItem[];
    stfrCapacity: RequestCapacityToolOverviewItem[];
}

export interface IRequestCapacityToolOverviewDay {
    date: Date;
    capacity?: number;
    usedCapacity?: number;
    remainingCapacity?: number;
}
export class RequestCapacityToolOverviewDay extends BaseApiModelClass< IRequestCapacityToolOverviewDay > implements IRequestCapacityToolOverviewDay {
    date: Date;
    capacity?: number;
    usedCapacity?: number;
    readonly remainingCapacity?: number;
}

export interface IRequestCapacityToolOverviewItem {
    type: RequestCapacityType;
    functionId: string;
    fleetType: FleetType;
    days: RequestCapacityToolOverviewDay[];
}
export class RequestCapacityToolOverviewItem extends BaseApiModelClass< IRequestCapacityToolOverviewItem > implements IRequestCapacityToolOverviewItem {
    type: RequestCapacityType;
    functionId: string;
    fleetType: FleetType;
    days: RequestCapacityToolOverviewDay[];
}

export enum RequestCapacityType {
    Freelance = "Freelance",
    Off = "Off",
    Stfr = "Stfr",
    Vac = "Vac",
}

export interface IRequestCapacityValueModel {
    capacityType: RequestCapacityType;
    fleet: FleetType;
    functionName?: string;
    functionId: string;
    dateFrom: Date;
    dateFromStatus: RequestCapacityDateStatus;
    dateTo: Date;
    dateToStatus: RequestCapacityDateStatus;
    values: CapacityModel[];
}
export class RequestCapacityValueModel extends BaseApiModelClass< IRequestCapacityValueModel > implements IRequestCapacityValueModel {
    capacityType: RequestCapacityType;
    fleet: FleetType;
    functionName?: string;
    functionId: string;
    dateFrom: Date;
    dateFromStatus: RequestCapacityDateStatus;
    dateTo: Date;
    dateToStatus: RequestCapacityDateStatus;
    values: CapacityModel[];
}

export interface IRequestDutyData {
    bid: number;
}
export class RequestDutyData extends BaseApiModelClass< IRequestDutyData > implements IRequestDutyData {
    bid: number;
}

export enum RequestPointSubType {
    GrantByContract = "GrantByContract",
    PointsReducedUbu = "PointsReducedUbu",
}

export enum RequestPointUseType {
    FlightAdded = "FlightAdded",
    FlightAddedByUndo = "FlightAddedByUndo",
    FlightDeleted = "FlightDeleted",
    FlightDeletedWithoutRevertPoints = "FlightDeletedWithoutRevertPoints",
    FlightRequestFee = "FlightRequestFee",
    GrantByContract = "GrantByContract",
    GrantedRequests = "GrantedRequests",
    LTEAdded = "LTEAdded",
    LTEAddedByUndo = "LTEAddedByUndo",
    LTEDeleted = "LTEDeleted",
    LTEDeletedWithoutRevertPoints = "LTEDeletedWithoutRevertPoints",
    LTEOverlapped = "LTEOverlapped",
    LTOAdded = "LTOAdded",
    LTOAddedByUndo = "LTOAddedByUndo",
    LTODeleted = "LTODeleted",
    LTODeletedWithoutRevertPoints = "LTODeletedWithoutRevertPoints",
    ManualCorrection = "ManualCorrection",
    STOAdded = "STOAdded",
    STODeleted = "STODeleted",
}

export interface IReserveBlockDTO {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    id?: string;
    dateFrom: Date;
    dateTo: Date;
    rsvGroup: PersonRequestReserveGroupType;
    function: string;
    hasRequested: boolean;
    hasConfirmed: boolean;
}
export class ReserveBlockDTO extends BaseApiModelClass< IReserveBlockDTO > implements IReserveBlockDTO {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    id?: string;
    dateFrom: Date;
    dateTo: Date;
    rsvGroup: PersonRequestReserveGroupType;
    function: string;
    hasRequested: boolean;
    hasConfirmed: boolean;
}

export interface IReserveBlockDTODataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}
export class ReserveBlockDTODataSourceLoadOptions extends BaseApiModelClass< IReserveBlockDTODataSourceLoadOptions > implements IReserveBlockDTODataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}

export interface IReserveBlockGroupDTO {
    firstBlockId: string;
    dateFrom: Date;
    dateTo: Date;
    rsvGroup: PersonRequestReserveGroupType;
    function: string;
    blocks: ReserveBlockDTO[];
    isAllowed: boolean;
}
export class ReserveBlockGroupDTO extends BaseApiModelClass< IReserveBlockGroupDTO > implements IReserveBlockGroupDTO {
    firstBlockId: string;
    dateFrom: Date;
    dateTo: Date;
    rsvGroup: PersonRequestReserveGroupType;
    function: string;
    blocks: ReserveBlockDTO[];
    isAllowed: boolean;
}

export interface IReserveBlocksFilter {
    rowLimit?: number;
}
export class ReserveBlocksFilter extends BaseApiModelClass< IReserveBlocksFilter > implements IReserveBlocksFilter {
    rowLimit?: number;
}

export interface IReserveManagementReportFilter {
    rowLimit?: number;
    isForCabin: boolean;
    isForCockpit: boolean;
}
export class ReserveManagementReportFilter extends BaseApiModelClass< IReserveManagementReportFilter > implements IReserveManagementReportFilter {
    rowLimit?: number;
    isForCabin: boolean;
    isForCockpit: boolean;
}

export interface IReservePeriodChangeStatusModel {
    status: VacationYearPeriodStatus;
}
export class ReservePeriodChangeStatusModel extends BaseApiModelClass< IReservePeriodChangeStatusModel > implements IReservePeriodChangeStatusModel {
    status: VacationYearPeriodStatus;
}

export interface IReserveRequestChangePlannersCommentModel {
    requestId: string;
    comment?: string;
}
export class ReserveRequestChangePlannersCommentModel extends BaseApiModelClass< IReserveRequestChangePlannersCommentModel > implements IReserveRequestChangePlannersCommentModel {
    requestId: string;
    comment?: string;
}

export interface IReserveRequestModel {
    id: string;
}
export class ReserveRequestModel extends BaseApiModelClass< IReserveRequestModel > implements IReserveRequestModel {
    id: string;
}

export interface IReserveRequestReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    requestId: string;
    personId: string;
    personCode: string;
    personName?: string;
    personSeniority: number;
    rsvGroup: PersonRequestReserveGroupType;
    function: string;
    createdDate: Date;
    reserveYear: string;
    reserveYearPeriod: string;
    dateFrom: Date;
    dateTo: Date;
    commentVisibleToCrew?: string;
    status: PersonRequestReserveStatus;
    typeRating?: string;
    isInstructor: boolean;
    reserveBlockId: string;
    requestPriority: number;
    approvedRequests: number;
}
export class ReserveRequestReportModel extends BaseApiModelClass< IReserveRequestReportModel > implements IReserveRequestReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    requestId: string;
    personId: string;
    personCode: string;
    personName?: string;
    personSeniority: number;
    rsvGroup: PersonRequestReserveGroupType;
    function: string;
    createdDate: Date;
    reserveYear: string;
    reserveYearPeriod: string;
    dateFrom: Date;
    dateTo: Date;
    commentVisibleToCrew?: string;
    status: PersonRequestReserveStatus;
    typeRating?: string;
    isInstructor: boolean;
    reserveBlockId: string;
    requestPriority: number;
    approvedRequests: number;
}

export interface IReserveRequestReportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}
export class ReserveRequestReportModelDataSourceLoadOptions extends BaseApiModelClass< IReserveRequestReportModelDataSourceLoadOptions > implements IReserveRequestReportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}

export interface IReserveYearPeriodDto {
    id: string;
    codeName: string;
    dateFrom: Date;
    dateTo: Date;
    status: VacationYearPeriodStatus;
    yearId: string;
    yearCodeName: string;
    yearDateFrom: Date;
    yearDateTo: Date;
    functionGroupId: string;
    personYoS: number;
}
export class ReserveYearPeriodDto extends BaseApiModelClass< IReserveYearPeriodDto > implements IReserveYearPeriodDto {
    id: string;
    codeName: string;
    dateFrom: Date;
    dateTo: Date;
    status: VacationYearPeriodStatus;
    yearId: string;
    yearCodeName: string;
    yearDateFrom: Date;
    yearDateTo: Date;
    functionGroupId: string;
    personYoS: number;
}

export interface IReserveYearPeriodModel {
    label: string;
    value: string;
    yearId: string;
    status: VacationYearPeriodStatus;
    functionGroupId: string;
}
export class ReserveYearPeriodModel extends BaseApiModelClass< IReserveYearPeriodModel > implements IReserveYearPeriodModel {
    label: string;
    value: string;
    yearId: string;
    status: VacationYearPeriodStatus;
    functionGroupId: string;
}

export interface IReserveYearPeriodReportFilterOption {
    codeName: string;
    status: VacationYearPeriodStatus;
}
export class ReserveYearPeriodReportFilterOption extends BaseApiModelClass< IReserveYearPeriodReportFilterOption > implements IReserveYearPeriodReportFilterOption {
    codeName: string;
    status: VacationYearPeriodStatus;
}

export interface IResumeValidationModel {
    date: Date;
    personId: string;
    errorKey: string;
}
export class ResumeValidationModel extends BaseApiModelClass< IResumeValidationModel > implements IResumeValidationModel {
    date: Date;
    personId: string;
    errorKey: string;
}

export interface IRevalidatePersonModel {
    personId: string;
    date: Date;
    functionGroupId: string;
}
export class RevalidatePersonModel extends BaseApiModelClass< IRevalidatePersonModel > implements IRevalidatePersonModel {
    personId: string;
    date: Date;
    functionGroupId: string;
}

export interface IRosterImportDetailsFilter {
    rowLimit?: number;
    importId: string;
}
export class RosterImportDetailsFilter extends BaseApiModelClass< IRosterImportDetailsFilter > implements IRosterImportDetailsFilter {
    rowLimit?: number;
    importId: string;
}

export interface IRosterImportErrorExceptionModel {
    message: string;
}
export class RosterImportErrorExceptionModel extends BaseApiModelClass< IRosterImportErrorExceptionModel > implements IRosterImportErrorExceptionModel {
    message: string;
}

export interface IRosterImportErrorMessageModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    date: Date;
    personId?: string;
    crewId?: string;
    personCode: string;
    activity: string;
    message: string;
    errorType: RosterImportErrorType;
}
export class RosterImportErrorMessageModel extends BaseApiModelClass< IRosterImportErrorMessageModel > implements IRosterImportErrorMessageModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    date: Date;
    personId?: string;
    readonly crewId?: string;
    personCode: string;
    activity: string;
    message: string;
    errorType: RosterImportErrorType;
}

export interface IRosterImportErrorMessageModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}
export class RosterImportErrorMessageModelDataSourceLoadOptions extends BaseApiModelClass< IRosterImportErrorMessageModelDataSourceLoadOptions > implements IRosterImportErrorMessageModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}

export enum RosterImportErrorType {
    Flight = "Flight",
    Roster = "Roster",
    Rotation = "Rotation",
}

export interface IRosterImportFilter {
    rowLimit?: number;
}
export class RosterImportFilter extends BaseApiModelClass< IRosterImportFilter > implements IRosterImportFilter {
    rowLimit?: number;
}

export interface IRosterImportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    id: string;
    status: string;
    principalDisplayName: string;
    startDateTimeUtc: Date;
    periodStartDateTimeUtc?: Date;
    periodEndDateTimeUtc?: Date;
    flightsCount: number;
    tripsCount: number;
    rostersCount: number;
    duration: number;
    jobParameters?: string;
    hasErrorMessages: boolean;
    hasFile: boolean;
    fileUri?: string;
}
export class RosterImportModel extends BaseApiModelClass< IRosterImportModel > implements IRosterImportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    id: string;
    status: string;
    principalDisplayName: string;
    startDateTimeUtc: Date;
    periodStartDateTimeUtc?: Date;
    periodEndDateTimeUtc?: Date;
    flightsCount: number;
    tripsCount: number;
    rostersCount: number;
    duration: number;
    jobParameters?: string;
    hasErrorMessages: boolean;
    hasFile: boolean;
    fileUri?: string;
}

export interface IRosterImportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}
export class RosterImportModelDataSourceLoadOptions extends BaseApiModelClass< IRosterImportModelDataSourceLoadOptions > implements IRosterImportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}

export interface IRosterSelectedCell {
    personId: string;
    personCode?: string;
    date: Date;
    isActive: boolean;
}
export class RosterSelectedCell extends BaseApiModelClass< IRosterSelectedCell > implements IRosterSelectedCell {
    personId: string;
    personCode?: string;
    date: Date;
    isActive: boolean;
}

export enum RosterType {
    Full = "Full",
    Jeppesen = "Jeppesen",
    Person = "Person",
    Report = "Report",
    RequestToolCalendar = "RequestToolCalendar",
    RequestToolFlight = "RequestToolFlight",
    RequestToolFreelance = "RequestToolFreelance",
    RequestToolGeneral = "RequestToolGeneral",
    RequestToolOff = "RequestToolOff",
    RequestToolShortTermFlight = "RequestToolShortTermFlight",
    RequestToolVacCabin = "RequestToolVacCabin",
    RequestToolVacCockpit = "RequestToolVacCockpit",
    RequestToolVacGround = "RequestToolVacGround",
    VacationManagement = "VacationManagement",
}

export interface IRotationActionResult {
    errors: string[];
    hasErrors: boolean;
    rotationId?: string;
}
export class RotationActionResult extends BaseApiModelClass< IRotationActionResult > implements IRotationActionResult {
    errors: string[];
    readonly hasErrors: boolean;
    rotationId?: string;
}

export interface IRotationCopyModel {
    rotationId: string;
    name: string;
    isForCabin: boolean;
    isForCockpit: boolean;
    startDate?: Date;
    rotationCrewComplements: RotationCrewComplement[];
}
export class RotationCopyModel extends BaseApiModelClass< IRotationCopyModel > implements IRotationCopyModel {
    rotationId: string;
    name: string;
    isForCabin: boolean;
    isForCockpit: boolean;
    startDate?: Date;
    rotationCrewComplements: RotationCrewComplement[];
}

export interface IRotationCrewComplement {
    crewComplementFunction: string;
    crewComplementCount: number;
}
export class RotationCrewComplement extends BaseApiModelClass< IRotationCrewComplement > implements IRotationCrewComplement {
    crewComplementFunction: string;
    crewComplementCount: number;
}

export enum RotationCrewComplementsFunction {
    CC = "CC",
    FO = "FO",
    OBS1 = "OBS1",
    OBS2 = "OBS2",
    PIC = "PIC",
    SC = "SC",
}

export interface IRotationDay {
    activities: RotationDayActivity[];
    date: Date;
}
export class RotationDay extends BaseApiModelClass< IRotationDay > implements IRotationDay {
    activities: RotationDayActivity[];
    date: Date;
}

export interface IRotationDayActivity {
    flightNumber?: number;
    flightLegNumber?: number;
    operationalSuffix?: string;
    flightId?: string;
    activityRcd: string;
    originRcd?: string;
    destinationRcd?: string;
    flightComment?: string;
    flightIsDeleted: boolean;
    departureDateTimeUtc?: Date;
    arrivalDateTimeUtc?: Date;
    estimatedDepartureDateTimeUtc?: Date;
    estimatedArrivalDateTimeUtc?: Date;
    scheduledArrivalDateTimeUtc?: Date;
    intoTheGateDateTimeUtc?: Date;
    isGav: boolean;
    isFtl: boolean;
    isAfterNightDuty: boolean;
    isBeforeNightDuty: boolean;
    flightCrewComplements: RotationCrewComplement[];
    flightIsAugmentedCockpit: boolean;
    flightIsAugmentedCabin: boolean;
    flightIsExtendedCabin: boolean;
    flightIsExtendedCockpit: boolean;
    flightIsXStarCockpit: boolean;
    actualAircraftTypeGroupId?: string;
}
export class RotationDayActivity extends BaseApiModelClass< IRotationDayActivity > implements IRotationDayActivity {
    flightNumber?: number;
    flightLegNumber?: number;
    operationalSuffix?: string;
    flightId?: string;
    activityRcd: string;
    originRcd?: string;
    destinationRcd?: string;
    flightComment?: string;
    flightIsDeleted: boolean;
    departureDateTimeUtc?: Date;
    arrivalDateTimeUtc?: Date;
    estimatedDepartureDateTimeUtc?: Date;
    estimatedArrivalDateTimeUtc?: Date;
    scheduledArrivalDateTimeUtc?: Date;
    intoTheGateDateTimeUtc?: Date;
    isGav: boolean;
    isFtl: boolean;
    isAfterNightDuty: boolean;
    isBeforeNightDuty: boolean;
    flightCrewComplements: RotationCrewComplement[];
    flightIsAugmentedCockpit: boolean;
    flightIsAugmentedCabin: boolean;
    flightIsExtendedCabin: boolean;
    flightIsExtendedCockpit: boolean;
    flightIsXStarCockpit: boolean;
    actualAircraftTypeGroupId?: string;
}

export interface IRotationDayActivityInfo {
    id?: string;
    flightNumber?: number;
    operationalSuffix?: string;
    flightId?: string;
    activityRcd: string;
    aircraftTypeRcd?: string;
    departureRcd?: string;
    departureUtcDate?: Date;
    departureDiffToLt?: string;
    startUtcDate?: Date;
    arrivalRcd?: string;
    arrivalUtcDate?: Date;
    arrivalDiffToLt?: string;
    endUtcDate?: Date;
    positioningBy?: string;
    positioningType?: PositioningType;
    airlineRcd?: string;
}
export class RotationDayActivityInfo extends BaseApiModelClass< IRotationDayActivityInfo > implements IRotationDayActivityInfo {
    id?: string;
    flightNumber?: number;
    operationalSuffix?: string;
    flightId?: string;
    activityRcd: string;
    aircraftTypeRcd?: string;
    departureRcd?: string;
    departureUtcDate?: Date;
    departureDiffToLt?: string;
    startUtcDate?: Date;
    arrivalRcd?: string;
    arrivalUtcDate?: Date;
    arrivalDiffToLt?: string;
    endUtcDate?: Date;
    positioningBy?: string;
    positioningType?: PositioningType;
    airlineRcd?: string;
}

export interface IRotationDayInfo {
    activities: RotationDayActivityInfo[];
    date: Date;
    isGav: boolean;
    isFtl: boolean;
    isAfterNightDuty: boolean;
    isBeforeNightDuty: boolean;
    isAugmentedFlight: boolean;
    isExtendedFlight: boolean;
    isXStarFlight: boolean;
    acclimatisationStatus?: AcclimatisationStatus;
    errors: ValidationErrorModel[];
    hasErrors: boolean;
    hasOffDayDifference: boolean;
    hasOffTypeDifference: boolean;
}
export class RotationDayInfo extends BaseApiModelClass< IRotationDayInfo > implements IRotationDayInfo {
    activities: RotationDayActivityInfo[];
    date: Date;
    isGav: boolean;
    isFtl: boolean;
    isAfterNightDuty: boolean;
    isBeforeNightDuty: boolean;
    isAugmentedFlight: boolean;
    isExtendedFlight: boolean;
    isXStarFlight: boolean;
    acclimatisationStatus?: AcclimatisationStatus;
    readonly errors: ValidationErrorModel[];
    readonly hasErrors: boolean;
    hasOffDayDifference: boolean;
    hasOffTypeDifference: boolean;
}

export interface IRotationDutiesItem {
    id: string;
    isLongHaul: boolean;
    aircraftTypeRcd: string;
    flights: RotationFlightItem[];
    duties: RotationDutyActivity[];
    flightCount: number;
    codeName: string;
    departureDateTimeUtc: Date;
    arrivalDateTimeUtc: Date;
    scheduledArrivalDateTimeUtc: Date;
    isOperatedByWk: boolean;
    hasPositioning: boolean;
    isForCabin: boolean;
    isForCockpit: boolean;
    isDeleted: boolean;
    intoTheGateDateTimeUtc?: Date;
    isValid: boolean;
    isInvalidCabin: boolean;
    isInvalidCockpit: boolean;
    rotationCrewComplements: RotationCrewComplement[];
}
export class RotationDutiesItem extends BaseApiModelClass< IRotationDutiesItem > implements IRotationDutiesItem {
    id: string;
    isLongHaul: boolean;
    aircraftTypeRcd: string;
    flights: RotationFlightItem[];
    duties: RotationDutyActivity[];
    readonly flightCount: number;
    codeName: string;
    departureDateTimeUtc: Date;
    arrivalDateTimeUtc: Date;
    scheduledArrivalDateTimeUtc: Date;
    isOperatedByWk: boolean;
    hasPositioning: boolean;
    isForCabin: boolean;
    isForCockpit: boolean;
    isDeleted: boolean;
    intoTheGateDateTimeUtc?: Date;
    readonly isValid: boolean;
    isInvalidCabin: boolean;
    isInvalidCockpit: boolean;
    rotationCrewComplements: RotationCrewComplement[];
}

export interface IRotationDutyActivity {
    date: Date;
    personId: string;
    personCodeName: string;
    activityCodeName: string;
    flightId?: string;
    personBirthDate?: Date;
    flightIsAugmentedCockpit?: boolean;
    flightIsExtendedCockpit?: boolean;
    flightIsXStarCockpit?: boolean;
    flightIsAugmentedCabin?: boolean;
    flightIsExtendedCabin?: boolean;
    flightIsDeleted?: boolean;
    personHasMedicalRestrictions?: boolean;
    personLicenseStatus: PersonLicenseStatus;
    personExperienceCodeName?: string;
    functionName?: string;
    hasFtlErrors: boolean;
    hasGavErrors: boolean;
    hasEasaErrors: boolean;
    hasAgreementErrors: boolean;
    hasOtherErrors: boolean;
    flightNumber: number;
    flightDepartureDateTimeUtc?: Date;
}
export class RotationDutyActivity extends BaseApiModelClass< IRotationDutyActivity > implements IRotationDutyActivity {
    date: Date;
    personId: string;
    personCodeName: string;
    activityCodeName: string;
    flightId?: string;
    personBirthDate?: Date;
    flightIsAugmentedCockpit?: boolean;
    flightIsExtendedCockpit?: boolean;
    flightIsXStarCockpit?: boolean;
    flightIsAugmentedCabin?: boolean;
    flightIsExtendedCabin?: boolean;
    flightIsDeleted?: boolean;
    personHasMedicalRestrictions?: boolean;
    personLicenseStatus: PersonLicenseStatus;
    personExperienceCodeName?: string;
    functionName?: string;
    hasFtlErrors: boolean;
    hasGavErrors: boolean;
    hasEasaErrors: boolean;
    hasAgreementErrors: boolean;
    hasOtherErrors: boolean;
    flightNumber: number;
    flightDepartureDateTimeUtc?: Date;
}

export interface IRotationFlightItem {
    flightId: string;
    flightNumber: number;
    operationalSuffix: string;
    flightDestinationRcd: string;
    flightOriginRcd: string;
    flightArrivalDateTimeUtc: Date;
    flightDepartureDateTimeUtc: Date;
    flightEstimatedArrivalDateTimeUtc?: Date;
    flightEstimatedDepartureDateTimeUtc?: Date;
    flightIsAugmentedCockpit: boolean;
    flightIsExtendedCockpit: boolean;
    flightIsXStarCockpit: boolean;
    flightIsAugmentedCabin: boolean;
    flightIsExtendedCabin: boolean;
    aircraftRegistrationNumber: string;
    flightComment: string;
    flightCrewComplements: RotationCrewComplement[];
}
export class RotationFlightItem extends BaseApiModelClass< IRotationFlightItem > implements IRotationFlightItem {
    flightId: string;
    flightNumber: number;
    operationalSuffix: string;
    flightDestinationRcd: string;
    flightOriginRcd: string;
    flightArrivalDateTimeUtc: Date;
    flightDepartureDateTimeUtc: Date;
    flightEstimatedArrivalDateTimeUtc?: Date;
    flightEstimatedDepartureDateTimeUtc?: Date;
    flightIsAugmentedCockpit: boolean;
    flightIsExtendedCockpit: boolean;
    flightIsXStarCockpit: boolean;
    flightIsAugmentedCabin: boolean;
    flightIsExtendedCabin: boolean;
    aircraftRegistrationNumber: string;
    flightComment: string;
    flightCrewComplements: RotationCrewComplement[];
}

export interface IRotationFlightsInfoModel {
    flightsNumbers: string;
    flightsCodeName: string;
    startDateTimeUtc?: Date;
    endDateTimeUtc?: Date;
    startDateTimeLocal?: Date;
    endDateTimeLocal?: Date;
    fdpExtensionType: FdpExtensionType;
}
export class RotationFlightsInfoModel extends BaseApiModelClass< IRotationFlightsInfoModel > implements IRotationFlightsInfoModel {
    flightsNumbers: string;
    flightsCodeName: string;
    startDateTimeUtc?: Date;
    endDateTimeUtc?: Date;
    startDateTimeLocal?: Date;
    endDateTimeLocal?: Date;
    fdpExtensionType: FdpExtensionType;
}

export interface IRotationInfo {
    days: RotationDay[];
    id: string;
    isLongHaul: boolean;
    routing?: string;
    name?: string;
    flightsCount: number;
    firstRotationDeparture: Date;
    lastRotationArrival: Date;
    isForCockpit: boolean;
    isForCabin: boolean;
    flightNumbers: string;
}
export class RotationInfo extends BaseApiModelClass< IRotationInfo > implements IRotationInfo {
    days: RotationDay[];
    id: string;
    isLongHaul: boolean;
    routing?: string;
    name?: string;
    readonly flightsCount: number;
    readonly firstRotationDeparture: Date;
    readonly lastRotationArrival: Date;
    isForCockpit: boolean;
    isForCabin: boolean;
    readonly flightNumbers: string;
}

export interface IRotationInfoWithActivities {
    rotation: RotationInfo;
    assignedActivities: RotationDutyActivity[];
}
export class RotationInfoWithActivities extends BaseApiModelClass< IRotationInfoWithActivities > implements IRotationInfoWithActivities {
    rotation: RotationInfo;
    assignedActivities: RotationDutyActivity[];
}

export interface IRotationModel {
    id?: string;
    days: RotationDayInfo[];
    isLongHaul: boolean;
    name: string;
    direction: string;
    aircraftTypeGroupId?: string;
    startRotationDate: Date;
    endRotationDate: Date;
    startUtc?: Date;
    isForCockpit: boolean;
    isForCabin: boolean;
    errors: string[];
    hasErrors: boolean;
    rotationCrewComplements: RotationCrewComplement[];
    isCockpitComplements: boolean;
    isCabinComplements: boolean;
}
export class RotationModel extends BaseApiModelClass< IRotationModel > implements IRotationModel {
    id?: string;
    days: RotationDayInfo[];
    isLongHaul: boolean;
    name: string;
    direction: string;
    aircraftTypeGroupId?: string;
    readonly startRotationDate: Date;
    readonly endRotationDate: Date;
    readonly startUtc?: Date;
    isForCockpit: boolean;
    isForCabin: boolean;
    errors: string[];
    readonly hasErrors: boolean;
    rotationCrewComplements: RotationCrewComplement[];
    readonly isCockpitComplements: boolean;
    readonly isCabinComplements: boolean;
}

export interface IRotationOffsItemModel {
    offCount: number;
    rotationId: string;
    hasBlockedDays: boolean;
}
export class RotationOffsItemModel extends BaseApiModelClass< IRotationOffsItemModel > implements IRotationOffsItemModel {
    offCount: number;
    rotationId: string;
    hasBlockedDays: boolean;
}

export interface IRotationOffsModel {
    items: RotationOffsItemModel[];
    parallelCalculations: number;
}
export class RotationOffsModel extends BaseApiModelClass< IRotationOffsModel > implements IRotationOffsModel {
    items: RotationOffsItemModel[];
    parallelCalculations: number;
}

export interface IRotationOffsRequestModel {
    rotationIds?: string[];
    personId: string;
    packSize?: number;
}
export class RotationOffsRequestModel extends BaseApiModelClass< IRotationOffsRequestModel > implements IRotationOffsRequestModel {
    rotationIds?: string[];
    personId: string;
    packSize?: number;
}

export enum RotationType {
    Longhaul = "Longhaul",
    Sector = "Sector",
    Shorthaul = "Shorthaul",
}

export enum SchedulerStatus {
    FailedToStart = "FailedToStart",
    SchedulingJobs = "SchedulingJobs",
    SchedulingPostponedJobs = "SchedulingPostponedJobs",
    ServiceNotStarted = "ServiceNotStarted",
    ShuttingDown = "ShuttingDown",
    Started = "Started",
    Starting = "Starting",
    StutDown = "StutDown",
    WaitingForDatabase = "WaitingForDatabase",
}

export enum SearchMatched {
    FullMatched = "FullMatched",
    SearchMatched = "SearchMatched",
    Selected = "Selected",
}

export interface ISectorDutyItem {
    date: Date;
    personId: string;
    personCodeName: string;
    activityCodeName: string;
    flightId?: string;
    personBirthDate?: Date;
    flightIsAugmentedCockpit?: boolean;
    flightIsExtendedCockpit?: boolean;
    flightIsXStarCockpit?: boolean;
    flightIsAugmentedCabin?: boolean;
    flightIsExtendedCabin?: boolean;
    flightIsDeleted?: boolean;
    personHasMedicalRestrictions?: boolean;
    personLicenseStatus: PersonLicenseStatus;
    personExperienceCodeName?: string;
    functionName?: string;
    hasFtlErrors: boolean;
    hasGavErrors: boolean;
    hasEasaErrors: boolean;
    hasAgreementErrors: boolean;
    hasOtherErrors: boolean;
}
export class SectorDutyItem extends BaseApiModelClass< ISectorDutyItem > implements ISectorDutyItem {
    date: Date;
    personId: string;
    personCodeName: string;
    activityCodeName: string;
    flightId?: string;
    personBirthDate?: Date;
    flightIsAugmentedCockpit?: boolean;
    flightIsExtendedCockpit?: boolean;
    flightIsXStarCockpit?: boolean;
    flightIsAugmentedCabin?: boolean;
    flightIsExtendedCabin?: boolean;
    flightIsDeleted?: boolean;
    personHasMedicalRestrictions?: boolean;
    personLicenseStatus: PersonLicenseStatus;
    personExperienceCodeName?: string;
    functionName?: string;
    hasFtlErrors: boolean;
    hasGavErrors: boolean;
    hasEasaErrors: boolean;
    hasAgreementErrors: boolean;
    hasOtherErrors: boolean;
}

export interface ISectorItem {
    flightId: string;
    flightNumber: number;
    operationalSuffix?: string;
    flightLegSequenceNumber: number;
    aircraftTypeRcd?: string;
    aircraftTypeId?: string;
    flightDestinationRcd: string;
    flightOriginRcd: string;
    flightComment?: string;
    flightDepartureDateTimeUtc: Date;
    flightArrivalDateTimeUtc: Date;
    flightDepartureTimeDiffToLt: string;
    flightArrivalTimeDiffToLt: string;
    flightEstimatedDepartureDateTimeUtc?: Date;
    flightEstimatedArrivalDateTimeUtc?: Date;
    flightStatusIdentifier?: string;
    flightStatusActionIdentifier?: string;
    flightCabinOperatedByWk: boolean;
    flightCockpitOperatedByWk: boolean;
    isOperatedByWk: boolean;
    flightUrgentIsCrewCompleteSuppressed: boolean;
    flightUrgentCommentText?: string;
    flightUrgentSuppressReason?: UrgentFlightSupressType;
    flightUrgentModifiedDateTime?: Date;
    flightUrgentPrincipalDisplayName?: string;
    flightIntoTheGateDateTimeUtc?: Date;
    isValid: boolean;
    isInvalidCabin: boolean;
    isInvalidCockpit: boolean;
    duties: SectorDutyItem[];
    flightIsDeleted: boolean;
    flightIsAugmentedCockpit: boolean;
    flightIsAugmentedCabin: boolean;
    flightIsExtendedCockpit: boolean;
    flightIsExtendedCabin: boolean;
    flightIsXStarCockpit: boolean;
    isLongHaulFlight: boolean;
    aircraftRegistrationNumber?: string;
    flightCrewComplements: RotationCrewComplement[];
}
export class SectorItem extends BaseApiModelClass< ISectorItem > implements ISectorItem {
    flightId: string;
    flightNumber: number;
    operationalSuffix?: string;
    flightLegSequenceNumber: number;
    aircraftTypeRcd?: string;
    aircraftTypeId?: string;
    flightDestinationRcd: string;
    flightOriginRcd: string;
    flightComment?: string;
    flightDepartureDateTimeUtc: Date;
    flightArrivalDateTimeUtc: Date;
    flightDepartureTimeDiffToLt: string;
    flightArrivalTimeDiffToLt: string;
    flightEstimatedDepartureDateTimeUtc?: Date;
    flightEstimatedArrivalDateTimeUtc?: Date;
    flightStatusIdentifier?: string;
    flightStatusActionIdentifier?: string;
    flightCabinOperatedByWk: boolean;
    flightCockpitOperatedByWk: boolean;
    isOperatedByWk: boolean;
    flightUrgentIsCrewCompleteSuppressed: boolean;
    flightUrgentCommentText?: string;
    flightUrgentSuppressReason?: UrgentFlightSupressType;
    flightUrgentModifiedDateTime?: Date;
    flightUrgentPrincipalDisplayName?: string;
    flightIntoTheGateDateTimeUtc?: Date;
    readonly isValid: boolean;
    readonly isInvalidCabin: boolean;
    readonly isInvalidCockpit: boolean;
    duties: SectorDutyItem[];
    flightIsDeleted: boolean;
    flightIsAugmentedCockpit: boolean;
    flightIsAugmentedCabin: boolean;
    flightIsExtendedCockpit: boolean;
    flightIsExtendedCabin: boolean;
    flightIsXStarCockpit: boolean;
    isLongHaulFlight: boolean;
    aircraftRegistrationNumber?: string;
    flightCrewComplements: RotationCrewComplement[];
}

export interface ISectorsReportFilter {
    rowLimit?: number;
    dateFrom: Date;
    dateTo: Date;
}
export class SectorsReportFilter extends BaseApiModelClass< ISectorsReportFilter > implements ISectorsReportFilter {
    rowLimit?: number;
    dateFrom: Date;
    dateTo: Date;
}

export interface ISectorsReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    date: Date;
    isDeleted: boolean;
    rotationType: string;
    aircraftType: string;
    flightNumber: number;
    route?: string;
    departureDateUtc: Date;
    arrivalDateUtc: Date;
    pic?: string;
    fo?: string;
    obs1?: string;
    obs2?: string;
    sc?: string;
    cc2?: string;
    cc3?: string;
    cc4?: string;
    cc5?: string;
    cc6?: string;
    cc7?: string;
    cc8?: string;
    cc9?: string;
    cc10?: string;
    cc11?: string;
    cc12?: string;
    cc13?: string;
    aircraftRegistation?: string;
}
export class SectorsReportModel extends BaseApiModelClass< ISectorsReportModel > implements ISectorsReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    date: Date;
    isDeleted: boolean;
    rotationType: string;
    aircraftType: string;
    flightNumber: number;
    route?: string;
    departureDateUtc: Date;
    arrivalDateUtc: Date;
    pic?: string;
    fo?: string;
    obs1?: string;
    obs2?: string;
    sc?: string;
    cc2?: string;
    cc3?: string;
    cc4?: string;
    cc5?: string;
    cc6?: string;
    cc7?: string;
    cc8?: string;
    cc9?: string;
    cc10?: string;
    cc11?: string;
    cc12?: string;
    cc13?: string;
    aircraftRegistation?: string;
}

export interface ISectorsReportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}
export class SectorsReportModelDataSourceLoadOptions extends BaseApiModelClass< ISectorsReportModelDataSourceLoadOptions > implements ISectorsReportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}

export interface ISelectValueItem {
    id: string;
    name: string;
}
export class SelectValueItem extends BaseApiModelClass< ISelectValueItem > implements ISelectValueItem {
    id: string;
    name: string;
}

export interface ISelfTestResult {
    name: string;
    status: SelfTestResultStatus;
    title?: string;
    message?: string;
    payload?: any;
}
export class SelfTestResult extends BaseApiModelClass< ISelfTestResult > implements ISelfTestResult {
    name: string;
    status: SelfTestResultStatus;
    title?: string;
    message?: string;
    payload?: any;
}

export enum SelfTestResultStatus {
    Fail = "Fail",
    Success = "Success",
    Warning = "Warning",
}

export interface ISendCrewSmsInfo {
    phoneNumbers: string[];
    text: string;
    occEmailSubject: string;
}
export class SendCrewSmsInfo extends BaseApiModelClass< ISendCrewSmsInfo > implements ISendCrewSmsInfo {
    phoneNumbers: string[];
    text: string;
    occEmailSubject: string;
}

export interface ISendSmsBody {
    phoneNumbers: string[];
    text: string;
    notifyOccEmailSubject?: string;
}
export class SendSmsBody extends BaseApiModelClass< ISendSmsBody > implements ISendSmsBody {
    phoneNumbers: string[];
    text: string;
    notifyOccEmailSubject?: string;
}

export interface ISendSmsResponse {
    result: SendSmsResponseItem[];
}
export class SendSmsResponse extends BaseApiModelClass< ISendSmsResponse > implements ISendSmsResponse {
    result: SendSmsResponseItem[];
}

export interface ISendSmsResponseItem {
    principalId: string;
    phoneNumber: string;
    error?: string;
}
export class SendSmsResponseItem extends BaseApiModelClass< ISendSmsResponseItem > implements ISendSmsResponseItem {
    principalId: string;
    phoneNumber: string;
    error?: string;
}

export interface ISeniorityCommentModel {
    personId: string;
    comment: string;
}
export class SeniorityCommentModel extends BaseApiModelClass< ISeniorityCommentModel > implements ISeniorityCommentModel {
    personId: string;
    comment: string;
}

export interface ISeniorityEntryDateModel {
    personId: string;
    entryDate?: Date;
}
export class SeniorityEntryDateModel extends BaseApiModelClass< ISeniorityEntryDateModel > implements ISeniorityEntryDateModel {
    personId: string;
    entryDate?: Date;
}

export interface ISeniorityExitDateModel {
    personId: string;
    exitDate?: Date;
}
export class SeniorityExitDateModel extends BaseApiModelClass< ISeniorityExitDateModel > implements ISeniorityExitDateModel {
    personId: string;
    exitDate?: Date;
}

export interface ISeniorityReportFilter {
    rowLimit?: number;
    personId?: string;
}
export class SeniorityReportFilter extends BaseApiModelClass< ISeniorityReportFilter > implements ISeniorityReportFilter {
    rowLimit?: number;
    personId?: string;
}

export interface ISeniorityReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    personRank: number;
    personCode: string;
    personFirstName?: string;
    personLastName?: string;
    personSuperior?: string;
    personEntryDate: Date;
    personBirthDate?: Date;
    personFunction: string;
    personContractType: ContractType;
    personContract?: string;
    personExitDate?: Date;
    flightHoursBeforeEdwSec: number;
    flightHoursEdwShSec: number;
    flightHoursEdwLhSec: number;
    flightHoursTotalEdwSec: number;
    flightHoursTotalSec: number;
    ofcInsHoursTotalSec: number;
    personWishCreatedDate?: Date;
    personWishType?: string;
    personWishStatus?: PersonWishStatus;
    personCrpInputDate?: Date;
    personId: string;
    nextStep?: string;
    typeRating?: string;
    typeRatingMint?: string;
    seniorityComment?: string;
    commentChangedBy?: string;
    commentChangedDate?: Date;
    projectedExitDate?: Date;
    manualPlannedExitDate?: Date;
    manualEntryDate?: Date;
}
export class SeniorityReportModel extends BaseApiModelClass< ISeniorityReportModel > implements ISeniorityReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    personRank: number;
    personCode: string;
    personFirstName?: string;
    personLastName?: string;
    personSuperior?: string;
    personEntryDate: Date;
    personBirthDate?: Date;
    personFunction: string;
    personContractType: ContractType;
    personContract?: string;
    personExitDate?: Date;
    flightHoursBeforeEdwSec: number;
    flightHoursEdwShSec: number;
    flightHoursEdwLhSec: number;
    flightHoursTotalEdwSec: number;
    flightHoursTotalSec: number;
    ofcInsHoursTotalSec: number;
    personWishCreatedDate?: Date;
    personWishType?: string;
    personWishStatus?: PersonWishStatus;
    personCrpInputDate?: Date;
    personId: string;
    nextStep?: string;
    typeRating?: string;
    typeRatingMint?: string;
    seniorityComment?: string;
    commentChangedBy?: string;
    commentChangedDate?: Date;
    readonly projectedExitDate?: Date;
    manualPlannedExitDate?: Date;
    manualEntryDate?: Date;
}

export interface ISeniorityReportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}
export class SeniorityReportModelDataSourceLoadOptions extends BaseApiModelClass< ISeniorityReportModelDataSourceLoadOptions > implements ISeniorityReportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}

export interface ISetEstimatedCiCoModel {
    cells: CheckInCheckOutModel[];
}
export class SetEstimatedCiCoModel extends BaseApiModelClass< ISetEstimatedCiCoModel > implements ISetEstimatedCiCoModel {
    cells: CheckInCheckOutModel[];
}

export interface ISetEstimatedCiCoResult {
    operationId: string;
    flightIds: string[];
}
export class SetEstimatedCiCoResult extends BaseApiModelClass< ISetEstimatedCiCoResult > implements ISetEstimatedCiCoResult {
    operationId: string;
    flightIds: string[];
}

export enum ShadowDutyType {
    Lay = "Lay",
    None = "None",
    Off = "Off",
}

export enum ShadowOffCategory {
    AfterDub = "AfterDub",
    AfterLhRotation = "AfterLhRotation",
    AfterReserve = "AfterReserve",
    AfterShBlock = "AfterShBlock",
    AfterVac = "AfterVac",
    BeforeAbsence = "BeforeAbsence",
    BeforeLhRotation = "BeforeLhRotation",
    BeforeNightDuty = "BeforeNightDuty",
    BeforeReserve = "BeforeReserve",
    BeforeSim = "BeforeSim",
    BeforeVac = "BeforeVac",
    Military = "Military",
    None = "None",
}

export enum ShadowOffType {
    Ftl = "Ftl",
    Gav = "Gav",
    LayT = "LayT",
    None = "None",
}

export interface IShiftedFlightsInfoModel {
    flightsNumbers: string;
    fdpExtensionType: FdpExtensionType;
}
export class ShiftedFlightsInfoModel extends BaseApiModelClass< IShiftedFlightsInfoModel > implements IShiftedFlightsInfoModel {
    flightsNumbers: string;
    fdpExtensionType: FdpExtensionType;
}

export interface IShowSettingModel {
    value: boolean;
}
export class ShowSettingModel extends BaseApiModelClass< IShowSettingModel > implements IShowSettingModel {
    value: boolean;
}

export interface ISignAttestateDto {
    courseId: string;
    firstName: string;
    lastName: string;
    nationality: string;
    birthDate: Date;
    placeOfBirth: string;
    isAlreadyHaveCCA: boolean;
    locationLatitude?: number;
    locationLongitude?: number;
    signature: string;
}
export class SignAttestateDto extends BaseApiModelClass< ISignAttestateDto > implements ISignAttestateDto {
    courseId: string;
    firstName: string;
    lastName: string;
    nationality: string;
    birthDate: Date;
    placeOfBirth: string;
    isAlreadyHaveCCA: boolean;
    locationLatitude?: number;
    locationLongitude?: number;
    signature: string;
}

export interface ISimCoursePositionInfo {
    oldSimCourseId?: string;
    newSimCourseId?: string;
    timestamp: Date;
    date: Date;
    operationName: string;
    personId: string;
    personCode: string;
    principalName: string;
    isChangeLogEnabled: boolean;
}
export class SimCoursePositionInfo extends BaseApiModelClass< ISimCoursePositionInfo > implements ISimCoursePositionInfo {
    oldSimCourseId?: string;
    newSimCourseId?: string;
    timestamp: Date;
    date: Date;
    operationName: string;
    personId: string;
    personCode: string;
    principalName: string;
    isChangeLogEnabled: boolean;
}

export interface ISimCoursePositionLogInfo {
    timestamp: Date;
    operationName: string;
    principalName: string;
    oldCount?: number;
    newCount?: number;
    oldInstructorRequirements?: InstructorRequirements;
    newInstructorRequirements?: InstructorRequirements;
    isRolledBack: boolean;
}
export class SimCoursePositionLogInfo extends BaseApiModelClass< ISimCoursePositionLogInfo > implements ISimCoursePositionLogInfo {
    timestamp: Date;
    operationName: string;
    principalName: string;
    oldCount?: number;
    newCount?: number;
    oldInstructorRequirements?: InstructorRequirements;
    newInstructorRequirements?: InstructorRequirements;
    isRolledBack: boolean;
}

export interface ISimDutyData {
    aircraftType: SimulationAircraftType;
    memberType: SimulationMemberType;
    simulationType: SimulationType;
    instructorRequirements?: InstructorRequirements;
    airportRcd?: string;
    locationRcd?: string;
    startTimezone: string;
    lpl4TraineePersonId?: string;
    simulationCourseId?: string;
    crewPosition?: SimulationCoursePosition;
    ebtModuleId?: string;
    startUtc: Date;
    endUtc: Date;
}
export class SimDutyData extends BaseApiModelClass< ISimDutyData > implements ISimDutyData {
    aircraftType: SimulationAircraftType;
    memberType: SimulationMemberType;
    simulationType: SimulationType;
    instructorRequirements?: InstructorRequirements;
    airportRcd?: string;
    locationRcd?: string;
    startTimezone: string;
    lpl4TraineePersonId?: string;
    simulationCourseId?: string;
    crewPosition?: SimulationCoursePosition;
    ebtModuleId?: string;
    startUtc: Date;
    endUtc: Date;
}

export interface ISimLogItem {
    id: string;
    timestamp: Date;
    operationName: string;
    modifiedBy: string;
    date: Date;
    simulationCourseId: string;
    isRolledBack: boolean;
    type: number;
    oldAircraftType?: SimulationAircraftType;
    newAircraftType?: SimulationAircraftType;
    oldSimulationType?: SimulationType;
    newSimulationType?: SimulationType;
    oldAirportRcd?: string;
    newAirportRcd?: string;
    oldLocationRcd?: string;
    newLocationRcd?: string;
    oldSimName?: string;
    newSimName?: string;
    oldStartBriefingUtc?: Date;
    newStartBriefingUtc?: Date;
    oldStartUtc?: Date;
    newStartUtc?: Date;
    oldEndUtc?: Date;
    newEndUtc?: Date;
    oldEndDebriefingUtc?: Date;
    newEndDebriefingUtc?: Date;
    oldCourseId?: string;
    newCourseId?: string;
    oldCourseName?: string;
    newCourseName?: string;
    oldCourseGroup?: string;
    newCourseGroup?: string;
    oldSimSession?: string;
    newSimSession?: string;
    oldFreetext?: string;
    newFreetext?: string;
    oldEbtModuleType?: EbtModuleType;
    newEbtModuleType?: EbtModuleType;
    oldStartTimeZone?: string;
    newStartTimeZone?: string;
}
export class SimLogItem extends BaseApiModelClass< ISimLogItem > implements ISimLogItem {
    id: string;
    timestamp: Date;
    operationName: string;
    modifiedBy: string;
    date: Date;
    simulationCourseId: string;
    isRolledBack: boolean;
    type: number;
    oldAircraftType?: SimulationAircraftType;
    newAircraftType?: SimulationAircraftType;
    oldSimulationType?: SimulationType;
    newSimulationType?: SimulationType;
    oldAirportRcd?: string;
    newAirportRcd?: string;
    oldLocationRcd?: string;
    newLocationRcd?: string;
    oldSimName?: string;
    newSimName?: string;
    oldStartBriefingUtc?: Date;
    newStartBriefingUtc?: Date;
    oldStartUtc?: Date;
    newStartUtc?: Date;
    oldEndUtc?: Date;
    newEndUtc?: Date;
    oldEndDebriefingUtc?: Date;
    newEndDebriefingUtc?: Date;
    oldCourseId?: string;
    newCourseId?: string;
    oldCourseName?: string;
    newCourseName?: string;
    oldCourseGroup?: string;
    newCourseGroup?: string;
    oldSimSession?: string;
    newSimSession?: string;
    oldFreetext?: string;
    newFreetext?: string;
    oldEbtModuleType?: EbtModuleType;
    newEbtModuleType?: EbtModuleType;
    oldStartTimeZone?: string;
    newStartTimeZone?: string;
}

export enum SimulationAircraftType {
    Is320 = "Is320",
    Is330 = "Is330",
    Is340 = "Is340",
    Is350 = "Is350",
    IsM83 = "IsM83",
}

export interface ISimulationBriefInfo {
    id: string;
    referenceDate: Date;
    startDateUtc: Date;
    endDateUtc: Date;
    startOffsetLt: string;
    endOffsetLt: string;
    aircraftType: SimulationAircraftType;
    memberType: SimulationMemberType;
    simulationType: SimulationType;
    instructorRequirements?: InstructorRequirements;
    lpl4TraineePersonName?: string;
    locationRcd?: string;
    ebtModuleType?: EbtModuleType;
}
export class SimulationBriefInfo extends BaseApiModelClass< ISimulationBriefInfo > implements ISimulationBriefInfo {
    id: string;
    referenceDate: Date;
    startDateUtc: Date;
    endDateUtc: Date;
    startOffsetLt: string;
    endOffsetLt: string;
    aircraftType: SimulationAircraftType;
    memberType: SimulationMemberType;
    simulationType: SimulationType;
    instructorRequirements?: InstructorRequirements;
    lpl4TraineePersonName?: string;
    locationRcd?: string;
    ebtModuleType?: EbtModuleType;
}

export interface ISimulationCourseCrewDto {
    id: string;
    code: string;
    memberType: SimulationMemberType;
    coursePosition?: SimulationCoursePosition;
    lpl4TraineePerson?: string;
    instructorRequirements?: InstructorRequirements;
}
export class SimulationCourseCrewDto extends BaseApiModelClass< ISimulationCourseCrewDto > implements ISimulationCourseCrewDto {
    id: string;
    code: string;
    memberType: SimulationMemberType;
    coursePosition?: SimulationCoursePosition;
    lpl4TraineePerson?: string;
    instructorRequirements?: InstructorRequirements;
}

export interface ISimulationCourseDto {
    overrideAllowed: boolean;
    comment?: string;
    commentIdsToDelete: string[];
    swapType?: PersonDutySwapType;
    ltoRequestComment?: string;
    stoRequestComment?: string;
    flightRequestComment?: string;
    doNotRevertPoints: boolean;
    id?: string;
    aircraftType: SimulationAircraftType;
    courseId: string;
    courseGroup?: string;
    courseName?: string;
    simName?: string;
    simSession?: string;
    simulationType: SimulationType;
    date: Date;
    startBriefingUtc: Date;
    startUtc: Date;
    endDebriefingUtc: Date;
    endUtc: Date;
    freetext?: string;
    locationRcd: string;
    airportRcd?: string;
    ebtModuleType?: EbtModuleType;
    startTimeZone: string;
    endTimeZone?: string;
    dutyIds: string[];
    positions: SimulationCoursePositionDto[];
    crews?: SimulationCourseCrewDto[];
}
export class SimulationCourseDto extends BaseApiModelClass< ISimulationCourseDto > implements ISimulationCourseDto {
    overrideAllowed: boolean;
    comment?: string;
    commentIdsToDelete: string[];
    swapType?: PersonDutySwapType;
    ltoRequestComment?: string;
    stoRequestComment?: string;
    flightRequestComment?: string;
    doNotRevertPoints: boolean;
    id?: string;
    aircraftType: SimulationAircraftType;
    courseId: string;
    courseGroup?: string;
    courseName?: string;
    simName?: string;
    simSession?: string;
    simulationType: SimulationType;
    date: Date;
    startBriefingUtc: Date;
    startUtc: Date;
    endDebriefingUtc: Date;
    endUtc: Date;
    freetext?: string;
    locationRcd: string;
    airportRcd?: string;
    ebtModuleType?: EbtModuleType;
    startTimeZone: string;
    endTimeZone?: string;
    dutyIds: string[];
    positions: SimulationCoursePositionDto[];
    crews?: SimulationCourseCrewDto[];
}

export enum SimulationCoursePosition {
    Assist = "Assist",
    CM = "CM",
    FO = "FO",
    Instructor = "Instructor",
    Instructor2 = "Instructor2",
    Observer = "Observer",
}

export interface ISimulationCoursePositionDto {
    coursePosition: SimulationCoursePosition;
    count: number;
    instructorRequirements?: InstructorRequirements;
}
export class SimulationCoursePositionDto extends BaseApiModelClass< ISimulationCoursePositionDto > implements ISimulationCoursePositionDto {
    coursePosition: SimulationCoursePosition;
    count: number;
    instructorRequirements?: InstructorRequirements;
}

export interface ISimulationCourseResult {
    duties: DutyItem[];
    operationId?: string;
    errorMessage?: string;
    simulationCourseId: string;
}
export class SimulationCourseResult extends BaseApiModelClass< ISimulationCourseResult > implements ISimulationCourseResult {
    duties: DutyItem[];
    operationId?: string;
    errorMessage?: string;
    simulationCourseId: string;
}

export enum SimulationMemberType {
    Assist = "Assist",
    Crew = "Crew",
    Instructor = "Instructor",
    Observer = "Observer",
}

export interface ISimulationModel {
    id: string;
    aircraftType: SimulationAircraftType;
    memberType: SimulationMemberType;
    simulationType: SimulationType;
    instructorRequirements?: InstructorRequirements;
    airportRcd?: string;
    locationRcd?: string;
    startDateUtc: Date;
    endDateUtc: Date;
    checkinDateUtc: Date;
    checkoutDateUtc: Date;
    lp4TraineePersonId?: string;
    simulationCourseId?: string;
    coursePosition?: SimulationCoursePosition;
    ebtModuleId?: string;
    startTimeZone: string;
}
export class SimulationModel extends BaseApiModelClass< ISimulationModel > implements ISimulationModel {
    id: string;
    aircraftType: SimulationAircraftType;
    memberType: SimulationMemberType;
    simulationType: SimulationType;
    instructorRequirements?: InstructorRequirements;
    airportRcd?: string;
    locationRcd?: string;
    startDateUtc: Date;
    endDateUtc: Date;
    checkinDateUtc: Date;
    checkoutDateUtc: Date;
    lp4TraineePersonId?: string;
    simulationCourseId?: string;
    coursePosition?: SimulationCoursePosition;
    ebtModuleId?: string;
    startTimeZone: string;
}

export interface ISimulationReportFilter {
    rowLimit?: number;
    dateFrom: Date;
    dateTo: Date;
    simulationType: SimulationType[];
}
export class SimulationReportFilter extends BaseApiModelClass< ISimulationReportFilter > implements ISimulationReportFilter {
    rowLimit?: number;
    dateFrom: Date;
    dateTo: Date;
    simulationType: SimulationType[];
}

export interface ISimulationReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    aircraftType: SimulationAircraftType;
    simName?: string;
    simSession?: string;
    locationRcd: string;
    instructorId?: string;
    instructorCode?: string;
    instructorFirstName?: string;
    instructorLastName?: string;
    crewCmId?: string;
    crewCmCode?: string;
    crewCmFirstName?: string;
    crewCmLastName?: string;
    crewFoId?: string;
    crewFoCode?: string;
    crewFoFirstName?: string;
    crewFoLastName?: string;
    startDate: Date;
    endDate: Date;
    timeFromLt: Date;
    timeToLt: Date;
    simulationType: SimulationType;
}
export class SimulationReportModel extends BaseApiModelClass< ISimulationReportModel > implements ISimulationReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    aircraftType: SimulationAircraftType;
    simName?: string;
    simSession?: string;
    locationRcd: string;
    instructorId?: string;
    instructorCode?: string;
    instructorFirstName?: string;
    instructorLastName?: string;
    crewCmId?: string;
    crewCmCode?: string;
    crewCmFirstName?: string;
    crewCmLastName?: string;
    crewFoId?: string;
    crewFoCode?: string;
    crewFoFirstName?: string;
    crewFoLastName?: string;
    startDate: Date;
    endDate: Date;
    timeFromLt: Date;
    timeToLt: Date;
    simulationType: SimulationType;
}

export interface ISimulationReportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}
export class SimulationReportModelDataSourceLoadOptions extends BaseApiModelClass< ISimulationReportModelDataSourceLoadOptions > implements ISimulationReportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}

export enum SimulationType {
    AirportRecency = "AirportRecency",
    Check = "Check",
    EbtDay1 = "EbtDay1",
    EbtDay2 = "EbtDay2",
    LdgRecency = "LdgRecency",
    None = "None",
    Refresher = "Refresher",
    Skilltest = "Skilltest",
    Training = "Training",
}

export interface ISimulatorLicenseStatusReportFilter {
    rowLimit?: number;
    isShowOverrides: boolean;
}
export class SimulatorLicenseStatusReportFilter extends BaseApiModelClass< ISimulatorLicenseStatusReportFilter > implements ISimulatorLicenseStatusReportFilter {
    rowLimit?: number;
    isShowOverrides: boolean;
}

export interface ISimulatorLicenseStatusReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    personId: string;
    crewId: string;
    personCode: string;
    personFirstName?: string;
    personLastName?: string;
    function?: string;
    a320: boolean;
    a340: boolean;
    a350: boolean;
    licenseFleet?: string;
    opcDate?: Date;
    tr320Date?: Date;
    tr340Date?: Date;
    tr350Date?: Date;
    lastSimDutyDate?: Date;
    lastSimDutyType?: string;
    lastSimDutyEbtModuleType?: string;
    nextSimDutyDate?: Date;
    nextSimDutyType?: string;
    nextSimDutyEbtModuleType?: string;
}
export class SimulatorLicenseStatusReportModel extends BaseApiModelClass< ISimulatorLicenseStatusReportModel > implements ISimulatorLicenseStatusReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    personId: string;
    crewId: string;
    personCode: string;
    personFirstName?: string;
    personLastName?: string;
    function?: string;
    a320: boolean;
    a340: boolean;
    a350: boolean;
    licenseFleet?: string;
    opcDate?: Date;
    tr320Date?: Date;
    tr340Date?: Date;
    tr350Date?: Date;
    lastSimDutyDate?: Date;
    lastSimDutyType?: string;
    lastSimDutyEbtModuleType?: string;
    nextSimDutyDate?: Date;
    nextSimDutyType?: string;
    nextSimDutyEbtModuleType?: string;
}

export interface ISimulatorLicenseStatusReportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}
export class SimulatorLicenseStatusReportModelDataSourceLoadOptions extends BaseApiModelClass< ISimulatorLicenseStatusReportModelDataSourceLoadOptions > implements ISimulatorLicenseStatusReportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}

export interface ISingleDaysModel {
    singleDaysMonthPt: number;
    singleDaysMonthInvalid: boolean;
}
export class SingleDaysModel extends BaseApiModelClass< ISingleDaysModel > implements ISingleDaysModel {
    singleDaysMonthPt: number;
    singleDaysMonthInvalid: boolean;
}

export enum SortOrder {
    Asc = "Asc",
    Desc = "Desc",
}

export interface ISortingInfo {
    selector?: string;
    desc: boolean;
}
export class SortingInfo extends BaseApiModelClass< ISortingInfo > implements ISortingInfo {
    selector?: string;
    desc: boolean;
}

export interface IStandbyReportComment {
    personId?: string;
    id: string;
    text?: string;
    validFromDate: Date;
    category: CommentCategory;
}
export class StandbyReportComment extends BaseApiModelClass< IStandbyReportComment > implements IStandbyReportComment {
    personId?: string;
    id: string;
    text?: string;
    validFromDate: Date;
    category: CommentCategory;
}

export interface IStandbyReportFilter {
    rowLimit?: number;
    date?: Date;
    functionId?: string;
    contractTypes?: ContractType[];
    personIds?: string[];
    isIncludeFormerSbx: boolean;
    isOnlyFormerSbx: boolean;
}
export class StandbyReportFilter extends BaseApiModelClass< IStandbyReportFilter > implements IStandbyReportFilter {
    rowLimit?: number;
    date?: Date;
    functionId?: string;
    contractTypes?: ContractType[];
    personIds?: string[];
    isIncludeFormerSbx: boolean;
    isOnlyFormerSbx: boolean;
}

export interface IStandbyReportLicenseInfo {
    personId: string;
    name: string;
    shortName: string;
    shortNameNeutral?: string;
    licenseId: string;
}
export class StandbyReportLicenseInfo extends BaseApiModelClass< IStandbyReportLicenseInfo > implements IStandbyReportLicenseInfo {
    personId: string;
    name: string;
    shortName: string;
    shortNameNeutral?: string;
    licenseId: string;
}

export interface IStandbyReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    id: string;
    code: string;
    name?: string;
    function: string;
    contract: string;
    licenses: StandbyReportLicenseInfo[];
    a320: string;
    comments: StandbyReportComment[];
    title?: string;
    dayDuty: string;
    offDaysMonth: number;
    offDaysQuarter: number;
    offDaysYear: number;
    dh7?: string;
    dh14?: string;
    dh28?: string;
    bh28?: string;
    email?: string;
    phoneNumber?: string;
    phone?: string;
    phoneMobile?: string;
    phoneMobilePrivate?: string;
    phonePrivate?: string;
    fromDate?: string;
    toDate?: string;
}
export class StandbyReportModel extends BaseApiModelClass< IStandbyReportModel > implements IStandbyReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    id: string;
    code: string;
    name?: string;
    function: string;
    contract: string;
    licenses: StandbyReportLicenseInfo[];
    a320: string;
    comments: StandbyReportComment[];
    title?: string;
    dayDuty: string;
    offDaysMonth: number;
    offDaysQuarter: number;
    offDaysYear: number;
    dh7?: string;
    dh14?: string;
    dh28?: string;
    bh28?: string;
    email?: string;
    phoneNumber?: string;
    phone?: string;
    phoneMobile?: string;
    phoneMobilePrivate?: string;
    phonePrivate?: string;
    fromDate?: string;
    toDate?: string;
}

export interface IStandbyReportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}
export class StandbyReportModelDataSourceLoadOptions extends BaseApiModelClass< IStandbyReportModelDataSourceLoadOptions > implements IStandbyReportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}

export interface ISummaryInfo {
    selector?: string;
    summaryType?: string;
}
export class SummaryInfo extends BaseApiModelClass< ISummaryInfo > implements ISummaryInfo {
    selector?: string;
    summaryType?: string;
}

export interface ISuppressErrorsRequest {
    dutyCells: DutyCellModel[];
    errorType: string;
    reason: SuppressValidationErrorReason;
    commentText: string;
}
export class SuppressErrorsRequest extends BaseApiModelClass< ISuppressErrorsRequest > implements ISuppressErrorsRequest {
    dutyCells: DutyCellModel[];
    errorType: string;
    reason: SuppressValidationErrorReason;
    commentText: string;
}

export interface ISuppressErrorsResult {
    resolvedErrorsCount: number;
}
export class SuppressErrorsResult extends BaseApiModelClass< ISuppressErrorsResult > implements ISuppressErrorsResult {
    resolvedErrorsCount: number;
}

export enum SuppressValidationErrorReason {
    CrewControl = "CrewControl",
    CrewRequest = "CrewRequest",
    Irregularity = "Irregularity",
    Other = "Other",
    Planning = "Planning",
    Training = "Training",
}

export interface ISuppressValidationModel {
    date: Date;
    personId: string;
    errorType?: string;
    errorKey: string;
    commentText: string;
    errorMessage: string;
    errorCategory?: ValidationErrorCategory;
    suppressReason: SuppressValidationErrorReason;
    isSecond: boolean;
}
export class SuppressValidationModel extends BaseApiModelClass< ISuppressValidationModel > implements ISuppressValidationModel {
    date: Date;
    personId: string;
    errorType?: string;
    errorKey: string;
    commentText: string;
    errorMessage: string;
    errorCategory?: ValidationErrorCategory;
    suppressReason: SuppressValidationErrorReason;
    isSecond: boolean;
}

export interface ISwapDutyData {
    personOne: string;
    personTwo: string;
}
export class SwapDutyData extends BaseApiModelClass< ISwapDutyData > implements ISwapDutyData {
    personOne: string;
    personTwo: string;
}

export interface ISwapRotationModel {
    sourceRotationId?: string;
    destinationRotationId: string;
    type: CrewType;
    overrideAllowed: boolean;
}
export class SwapRotationModel extends BaseApiModelClass< ISwapRotationModel > implements ISwapRotationModel {
    sourceRotationId?: string;
    destinationRotationId: string;
    type: CrewType;
    overrideAllowed: boolean;
}

export interface ISwapSectorModel {
    sourceFlightId?: string;
    destinationFlightId: string;
    type: CrewType;
    overrideAllowed: boolean;
}
export class SwapSectorModel extends BaseApiModelClass< ISwapSectorModel > implements ISwapSectorModel {
    sourceFlightId?: string;
    destinationFlightId: string;
    type: CrewType;
    overrideAllowed: boolean;
}

export interface ITempFileDto {
    id: string;
    fileName?: string;
    timestamp: Date;
    principalId: string;
}
export class TempFileDto extends BaseApiModelClass< ITempFileDto > implements ITempFileDto {
    id: string;
    fileName?: string;
    timestamp: Date;
    principalId: string;
}

export interface ITemplateFormattingModel {
    template: TemplateModel;
    dataModel?: string;
}
export class TemplateFormattingModel extends BaseApiModelClass< ITemplateFormattingModel > implements ITemplateFormattingModel {
    template: TemplateModel;
    dataModel?: string;
}

export interface ITemplateGenericParameterDescriptionModel {
    displayName?: string;
    text?: string;
}
export class TemplateGenericParameterDescriptionModel extends BaseApiModelClass< ITemplateGenericParameterDescriptionModel > implements ITemplateGenericParameterDescriptionModel {
    displayName?: string;
    text?: string;
}

export interface ITemplateGroupModel {
    name?: string;
    codes: string[];
}
export class TemplateGroupModel extends BaseApiModelClass< ITemplateGroupModel > implements ITemplateGroupModel {
    name?: string;
    codes: string[];
}

export interface ITemplateModel {
    group?: string;
    to?: string;
    cc?: string;
    bcc?: string;
    subject: string;
    body: string;
    genericParameters: TemplateGenericParameterDescriptionModel[];
    errors: { [key: string]: string; };
}
export class TemplateModel extends BaseApiModelClass< ITemplateModel > implements ITemplateModel {
    group?: string;
    to?: string;
    cc?: string;
    bcc?: string;
    subject: string;
    body: string;
    genericParameters: TemplateGenericParameterDescriptionModel[];
    errors: { [key: string]: string; };
}

export interface ITimeModel {
    dateTime: Date;
    timeZone?: string;
}
export class TimeModel extends BaseApiModelClass< ITimeModel > implements ITimeModel {
    dateTime: Date;
    timeZone?: string;
}

export interface ITimeTransitionEvent {
    timeUtc: Date;
    minutesUtcTimeDiff: number;
}
export class TimeTransitionEvent extends BaseApiModelClass< ITimeTransitionEvent > implements ITimeTransitionEvent {
    timeUtc: Date;
    minutesUtcTimeDiff: number;
}

export interface ITradeUnionButtonInfoModel {
    lastModifiedDateTimeUtc?: Date;
    exportedFileName?: string;
    isFileExist: boolean;
    fileSize: number;
    id: string;
}
export class TradeUnionButtonInfoModel extends BaseApiModelClass< ITradeUnionButtonInfoModel > implements ITradeUnionButtonInfoModel {
    lastModifiedDateTimeUtc?: Date;
    exportedFileName?: string;
    isFileExist: boolean;
    fileSize: number;
    id: string;
}

export interface ITradeUnionExportFilter {
    rowLimit?: number;
}
export class TradeUnionExportFilter extends BaseApiModelClass< ITradeUnionExportFilter > implements ITradeUnionExportFilter {
    rowLimit?: number;
}

export interface ITradeUnionExportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    id: string;
    jobStatus: string;
    principalDisplayName: string;
    startDateTimeUtc: Date;
    duration: number;
    jobParameters?: string;
    exception?: string;
    hasFile: boolean;
}
export class TradeUnionExportModel extends BaseApiModelClass< ITradeUnionExportModel > implements ITradeUnionExportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    id: string;
    jobStatus: string;
    principalDisplayName: string;
    startDateTimeUtc: Date;
    duration: number;
    jobParameters?: string;
    exception?: string;
    hasFile: boolean;
}

export interface ITradeUnionExportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}
export class TradeUnionExportModelDataSourceLoadOptions extends BaseApiModelClass< ITradeUnionExportModelDataSourceLoadOptions > implements ITradeUnionExportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}

export enum TradeUnionExportType {
    AeroPers = "AeroPers",
    Efa = "Efa",
}

export enum TypeRatingFilter {
    A320 = "A320",
    A320And330Only = "A320And330Only",
    A320And340Only = "A320And340Only",
    A320And350Only = "A320And350Only",
    A320Only = "A320Only",
    A330 = "A330",
    A330And340Only = "A330And340Only",
    A330Only = "A330Only",
    A334 = "A334",
    A340 = "A340",
    A340And350Only = "A340And350Only",
    A340Only = "A340Only",
    A345 = "A345",
    A350 = "A350",
    A350Only = "A350Only",
    NewCommer = "NewCommer",
    Training = "Training",
}

export interface ITzvDayAssigmentCreateModel {
    date: Date;
    comment?: string;
}
export class TzvDayAssigmentCreateModel extends BaseApiModelClass< ITzvDayAssigmentCreateModel > implements ITzvDayAssigmentCreateModel {
    date: Date;
    comment?: string;
}

export interface ITzvDaysBalanceInfo {
    personId: string;
    tzvYearId: string;
    grantedByContract: number;
    reductionByVac: number;
    backlogPreviousYear: number;
    manualCorrections: TzvDaysManualCorrectionDto[];
    manualCorrectionsTotal: number;
    availableThisYear: number;
    totalAvailable: number;
    tzvCount: number;
    tzvFCount: number;
    tzvMCount: number;
    tzvVBCount: number;
    tzvCountTotal: number;
    remainingThisYear: number;
    balanceTotal: number;
}
export class TzvDaysBalanceInfo extends BaseApiModelClass< ITzvDaysBalanceInfo > implements ITzvDaysBalanceInfo {
    personId: string;
    tzvYearId: string;
    grantedByContract: number;
    reductionByVac: number;
    backlogPreviousYear: number;
    manualCorrections: TzvDaysManualCorrectionDto[];
    manualCorrectionsTotal: number;
    availableThisYear: number;
    totalAvailable: number;
    tzvCount: number;
    tzvFCount: number;
    tzvMCount: number;
    tzvVBCount: number;
    tzvCountTotal: number;
    remainingThisYear: number;
    balanceTotal: number;
}

export interface ITzvDaysManualCorrectionDto {
    id: string;
    description: string;
    tzvDaysDelta: number;
}
export class TzvDaysManualCorrectionDto extends BaseApiModelClass< ITzvDaysManualCorrectionDto > implements ITzvDaysManualCorrectionDto {
    id: string;
    description: string;
    tzvDaysDelta: number;
}

export interface ITzvYearDto {
    id: string;
    codeName: string;
    dateFrom: Date;
    dateTo: Date;
    personGroupType: PersonGroupType;
}
export class TzvYearDto extends BaseApiModelClass< ITzvYearDto > implements ITzvYearDto {
    id: string;
    codeName: string;
    dateFrom: Date;
    dateTo: Date;
    personGroupType: PersonGroupType;
}

export interface ITzvYearFilterModel {
    value: string;
    label: string;
    personGroupType: PersonGroupType;
}
export class TzvYearFilterModel extends BaseApiModelClass< ITzvYearFilterModel > implements ITzvYearFilterModel {
    value: string;
    label: string;
    personGroupType: PersonGroupType;
}

export interface ITzvYearOverviewFilter {
    rowLimit?: number;
    isForCabin: boolean;
    isForCockpit: boolean;
}
export class TzvYearOverviewFilter extends BaseApiModelClass< ITzvYearOverviewFilter > implements ITzvYearOverviewFilter {
    rowLimit?: number;
    isForCabin: boolean;
    isForCockpit: boolean;
}

export interface ITzvYearOverviewModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    personCode: string;
    personId: string;
    crewId: string;
    personName?: string;
    personFunction?: string;
    personContract?: number;
    personContractTypeModel: string;
    contractModelType: ContractModelType;
    personContractTypeModelDetails?: string;
    personContractComment?: string;
    combinationVariableDayBlockLength?: number;
    combinationVariableDaySplitType?: BlockSplitType;
    vacEntitlement?: number;
    personSeniorityRank: number;
    entryDate?: Date;
    exitDate?: Date;
    fleetGroup?: string;
    licenseFleet?: string;
    tzvYear: string;
    tzvYearId: string;
    backlogPreviousYear: number;
    entitlementActualYear: number;
    reductionByVac: number;
    manualCorrection: number;
    correctedEntitlement: number;
    confirmedTzv: number;
    daysRemainingActualYear: number;
    balance: number;
    cabinConfirmedJan?: number;
    cabinConfirmedFeb?: number;
    cabinConfirmedMar?: number;
    cabinConfirmedApr?: number;
    cabinConfirmedMay?: number;
    cabinConfirmedJun?: number;
    cabinConfirmedJul?: number;
    cabinConfirmedAug?: number;
    cabinConfirmedSep?: number;
    cabinConfirmedOct?: number;
    cabinConfirmedNov?: number;
    cabinConfirmedDec?: number;
    cockpitConfirmedJan?: number;
    cockpitConfirmedFeb?: number;
    cockpitConfirmedMar?: number;
    cockpitConfirmedApr?: number;
    cockpitConfirmedMay?: number;
    cockpitConfirmedJun?: number;
    cockpitConfirmedJul?: number;
    cockpitConfirmedAug?: number;
    cockpitConfirmedSep?: number;
    cockpitConfirmedOct?: number;
    cockpitConfirmedNov?: number;
    cockpitConfirmedDec?: number;
    plannerComment?: string;
}
export class TzvYearOverviewModel extends BaseApiModelClass< ITzvYearOverviewModel > implements ITzvYearOverviewModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    personCode: string;
    personId: string;
    readonly crewId: string;
    personName?: string;
    personFunction?: string;
    personContract?: number;
    readonly personContractTypeModel: string;
    contractModelType: ContractModelType;
    personContractTypeModelDetails?: string;
    personContractComment?: string;
    combinationVariableDayBlockLength?: number;
    combinationVariableDaySplitType?: BlockSplitType;
    vacEntitlement?: number;
    personSeniorityRank: number;
    entryDate?: Date;
    exitDate?: Date;
    fleetGroup?: string;
    licenseFleet?: string;
    tzvYear: string;
    tzvYearId: string;
    backlogPreviousYear: number;
    entitlementActualYear: number;
    reductionByVac: number;
    manualCorrection: number;
    correctedEntitlement: number;
    confirmedTzv: number;
    daysRemainingActualYear: number;
    balance: number;
    cabinConfirmedJan?: number;
    cabinConfirmedFeb?: number;
    cabinConfirmedMar?: number;
    cabinConfirmedApr?: number;
    cabinConfirmedMay?: number;
    cabinConfirmedJun?: number;
    cabinConfirmedJul?: number;
    cabinConfirmedAug?: number;
    cabinConfirmedSep?: number;
    cabinConfirmedOct?: number;
    cabinConfirmedNov?: number;
    cabinConfirmedDec?: number;
    cockpitConfirmedJan?: number;
    cockpitConfirmedFeb?: number;
    cockpitConfirmedMar?: number;
    cockpitConfirmedApr?: number;
    cockpitConfirmedMay?: number;
    cockpitConfirmedJun?: number;
    cockpitConfirmedJul?: number;
    cockpitConfirmedAug?: number;
    cockpitConfirmedSep?: number;
    cockpitConfirmedOct?: number;
    cockpitConfirmedNov?: number;
    cockpitConfirmedDec?: number;
    plannerComment?: string;
}

export interface ITzvYearOverviewModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}
export class TzvYearOverviewModelDataSourceLoadOptions extends BaseApiModelClass< ITzvYearOverviewModelDataSourceLoadOptions > implements ITzvYearOverviewModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}

export interface ITzvYearPlannersCommentModel {
    personId: string;
    tzvYearId: string;
    comment: string;
}
export class TzvYearPlannersCommentModel extends BaseApiModelClass< ITzvYearPlannersCommentModel > implements ITzvYearPlannersCommentModel {
    personId: string;
    tzvYearId: string;
    comment: string;
}

export interface IUndoOperationModel {
    operationId: string;
    operationDateUtc: Date;
    name: string;
    isChangeLogEnabled: boolean;
}
export class UndoOperationModel extends BaseApiModelClass< IUndoOperationModel > implements IUndoOperationModel {
    operationId: string;
    operationDateUtc: Date;
    name: string;
    isChangeLogEnabled: boolean;
}

export interface IUpdateChangeLogTextModel {
    changeLogItemId: string;
    text: string;
}
export class UpdateChangeLogTextModel extends BaseApiModelClass< IUpdateChangeLogTextModel > implements IUpdateChangeLogTextModel {
    changeLogItemId: string;
    text: string;
}

export interface IUpdateDutyResult {
    changes: DutyChangeRegions;
    warnings: DutyWarningModel[];
    errors: string[];
    changedFlights: string[];
    changedRotationWithRequests: string[];
    updatePendingDutyIds: string[];
    operationId: string;
    isUpdatePending: boolean;
}
export class UpdateDutyResult extends BaseApiModelClass< IUpdateDutyResult > implements IUpdateDutyResult {
    readonly changes: DutyChangeRegions;
    readonly warnings: DutyWarningModel[];
    readonly errors: string[];
    readonly changedFlights: string[];
    readonly changedRotationWithRequests: string[];
    readonly updatePendingDutyIds: string[];
    readonly operationId: string;
    readonly isUpdatePending: boolean;
}

export interface IUpdateNbuMonthRequest {
    date: Date;
    isCompete: boolean;
}
export class UpdateNbuMonthRequest extends BaseApiModelClass< IUpdateNbuMonthRequest > implements IUpdateNbuMonthRequest {
    date: Date;
    isCompete: boolean;
}

export interface IUrgentErrorDetail {
    personId: string;
    code: string;
    email?: string;
    phone?: string;
    date: Date;
    isCockpit: boolean;
}
export class UrgentErrorDetail extends BaseApiModelClass< IUrgentErrorDetail > implements IUrgentErrorDetail {
    personId: string;
    code: string;
    email?: string;
    phone?: string;
    date: Date;
    isCockpit: boolean;
}

export interface IUrgentErrorDetailOperation {
    name: string;
    person: string;
    date?: Date;
}
export class UrgentErrorDetailOperation extends BaseApiModelClass< IUrgentErrorDetailOperation > implements IUrgentErrorDetailOperation {
    name: string;
    person: string;
    date?: Date;
}

export interface IUrgentErrorsModel {
    errors: UrgentErrorDetail[];
    periodFrom: Date;
    periodTo: Date;
}
export class UrgentErrorsModel extends BaseApiModelClass< IUrgentErrorsModel > implements IUrgentErrorsModel {
    errors: UrgentErrorDetail[];
    periodFrom: Date;
    periodTo: Date;
}

export interface IUrgentFlightDetailsModel {
    duties: DutyPersonActivity[];
    complements: RotationCrewComplement[];
    causeOperations: UrgentErrorDetailOperation[];
}
export class UrgentFlightDetailsModel extends BaseApiModelClass< IUrgentFlightDetailsModel > implements IUrgentFlightDetailsModel {
    duties: DutyPersonActivity[];
    complements: RotationCrewComplement[];
    causeOperations: UrgentErrorDetailOperation[];
}

export interface IUrgentFlightModel {
    flightId: string;
    flightNumber: number;
    originRcd: string;
    destinationRcd: string;
    date: Date;
    departureDateTimeUtc: Date;
    arrivalDateTimeUtc: Date;
    departureTimeDiffToLt: string;
    arrivalTimeDiffToLt: string;
    statusActionIdentifier?: string;
    isCrewComplete: boolean;
    isCrewCompleteSuppressed: boolean;
    message?: string;
}
export class UrgentFlightModel extends BaseApiModelClass< IUrgentFlightModel > implements IUrgentFlightModel {
    flightId: string;
    flightNumber: number;
    originRcd: string;
    destinationRcd: string;
    date: Date;
    departureDateTimeUtc: Date;
    arrivalDateTimeUtc: Date;
    departureTimeDiffToLt: string;
    arrivalTimeDiffToLt: string;
    statusActionIdentifier?: string;
    isCrewComplete: boolean;
    isCrewCompleteSuppressed: boolean;
    message?: string;
}

export interface IUrgentFlightRequest {
    flightId: string;
    isCrewCompleteSuppressed: boolean;
    commentText?: string;
    suppressReason: UrgentFlightSupressType;
}
export class UrgentFlightRequest extends BaseApiModelClass< IUrgentFlightRequest > implements IUrgentFlightRequest {
    flightId: string;
    isCrewCompleteSuppressed: boolean;
    commentText?: string;
    suppressReason: UrgentFlightSupressType;
}

export enum UrgentFlightSupressType {
    Cancelled = "Cancelled",
    CrewIsComplete = "CrewIsComplete",
    NotOperatedByWK = "NotOperatedByWK",
    Other = "Other",
}

export interface IUrgentFlightsModel {
    periodFrom: Date;
    periodTo: Date;
    flights: UrgentFlightModel[];
}
export class UrgentFlightsModel extends BaseApiModelClass< IUrgentFlightsModel > implements IUrgentFlightsModel {
    periodFrom: Date;
    periodTo: Date;
    flights: UrgentFlightModel[];
}

export interface IVacCapacityFiguresModel {
    date: Date;
    fleetType: FleetType;
    dailyCapacityAvailable: number;
    personTakeCapacity: number;
}
export class VacCapacityFiguresModel extends BaseApiModelClass< IVacCapacityFiguresModel > implements IVacCapacityFiguresModel {
    date: Date;
    fleetType: FleetType;
    dailyCapacityAvailable: number;
    personTakeCapacity: number;
}

export interface IVacCapacityMonthFiguresModel {
    personFleetType: string;
    capacityMonthValue: number;
    daysInMonth: number;
    monthStartDate: Date;
    monthEndDate: Date;
}
export class VacCapacityMonthFiguresModel extends BaseApiModelClass< IVacCapacityMonthFiguresModel > implements IVacCapacityMonthFiguresModel {
    personFleetType: string;
    capacityMonthValue: number;
    daysInMonth: number;
    monthStartDate: Date;
    monthEndDate: Date;
}

export interface IVacManagementCapacityGroupingModel {
    date: Date;
    capacityFigures: VacCapacityFiguresModel[];
}
export class VacManagementCapacityGroupingModel extends BaseApiModelClass< IVacManagementCapacityGroupingModel > implements IVacManagementCapacityGroupingModel {
    date: Date;
    capacityFigures: VacCapacityFiguresModel[];
}

export interface IVacManagementCapacityMonthGroupingModel {
    month: number;
    year: number;
    capacityMonthFigures: VacCapacityMonthFiguresModel[];
}
export class VacManagementCapacityMonthGroupingModel extends BaseApiModelClass< IVacManagementCapacityMonthGroupingModel > implements IVacManagementCapacityMonthGroupingModel {
    month: number;
    year: number;
    capacityMonthFigures: VacCapacityMonthFiguresModel[];
}

export interface IVacManagementMonthOptions {
    value: number;
    label: string;
}
export class VacManagementMonthOptions extends BaseApiModelClass< IVacManagementMonthOptions > implements IVacManagementMonthOptions {
    value: number;
    label: string;
}

export interface IVacManagementPersonVacDetailsFilter {
    rowLimit?: number;
    isForCabin: boolean;
    isForCockpit: boolean;
}
export class VacManagementPersonVacDetailsFilter extends BaseApiModelClass< IVacManagementPersonVacDetailsFilter > implements IVacManagementPersonVacDetailsFilter {
    rowLimit?: number;
    isForCabin: boolean;
    isForCockpit: boolean;
}

export interface IVacManagementReportFilter {
    rowLimit?: number;
    isForCabin: boolean;
    isForCockpit: boolean;
    isForGround: boolean;
}
export class VacManagementReportFilter extends BaseApiModelClass< IVacManagementReportFilter > implements IVacManagementReportFilter {
    rowLimit?: number;
    isForCabin: boolean;
    isForCockpit: boolean;
    isForGround: boolean;
}

export interface IVacPeriodChangeStatusModel {
    status: VacationYearPeriodStatus;
}
export class VacPeriodChangeStatusModel extends BaseApiModelClass< IVacPeriodChangeStatusModel > implements IVacPeriodChangeStatusModel {
    status: VacationYearPeriodStatus;
}

export interface IVacRequestChangePlannersCommentModel {
    comment?: string;
    isVisibleToCrewComment: boolean;
}
export class VacRequestChangePlannersCommentModel extends BaseApiModelClass< IVacRequestChangePlannersCommentModel > implements IVacRequestChangePlannersCommentModel {
    comment?: string;
    isVisibleToCrewComment: boolean;
}

export interface IVacRequestChangePlannersPointsModel {
    points: number;
}
export class VacRequestChangePlannersPointsModel extends BaseApiModelClass< IVacRequestChangePlannersPointsModel > implements IVacRequestChangePlannersPointsModel {
    points: number;
}

export interface IVacRequestReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    requestBlockId: string;
    requestBlockStatus: PersonRequestVacBlockStatus;
    decision: PersonRequestVacBlockDecision;
    personId: string;
    personCode: string;
    personName?: string;
    personSeniority: number;
    personSeniorityRank: number;
    entryDate?: Date;
    exitDate?: Date;
    personContract?: number;
    personFunction?: string;
    personAircrafts?: string;
    fleetType?: string;
    createdDate: Date;
    vacationYear: string;
    vacationYearPeriod: string;
    type: PersonRequestVacType;
    vacationDaysGrantedPerYear: number;
    isEntitlementActualYear80: boolean;
    vacationDaysConfirmed: number;
    vacationDaysPendingConfirmed: number;
    vacationDaysSumConfirmed: number;
    vacationDaysRemaining: number;
    vacationPointsP: number;
    vacationPointsS: number;
    vacationPointsN: number;
    points: number;
    approvedDateFrom?: Date;
    approvedDateTo?: Date;
    approvedDaysInBlock?: number;
    approvedVacDaysInBlock?: number;
    variantHighPrioId: string;
    variantHighPrioPeriodDateFrom: Date;
    variantHighPrioPeriodDateTo: Date;
    variantHighPrioEntryDate: Date;
    variantHighPrioDays: number;
    variantHighPrioDaysMin?: number;
    variantHighPrioStatus: PersonRequestVacStatus;
    variantMediumPrioId?: string;
    variantMediumPrioPeriodDateFrom?: Date;
    variantMediumPrioPeriodDateTo?: Date;
    variantMediumPrioEntryDate?: Date;
    variantMediumPrioDays?: number;
    variantMediumPrioDaysMin?: number;
    variantMediumPrioStatus?: PersonRequestVacStatus;
    variantLowPrioId?: string;
    variantLowPrioPeriodDateFrom?: Date;
    variantLowPrioPeriodDateTo?: Date;
    variantLowPrioEntryDate?: Date;
    variantLowPrioDays?: number;
    variantLowPrioDaysMin?: number;
    variantLowPrioStatus?: PersonRequestVacStatus;
    firstAlternativeId?: string;
    firstAlternativePeriodDateFrom?: Date;
    firstAlternativePeriodDateTo?: Date;
    firstAlternativeEntryDate?: Date;
    firstAlternativeDays?: number;
    firstAlternativeStatus?: PersonRequestVacStatus;
    secondAlternativeId?: string;
    secondAlternativePeriodDateFrom?: Date;
    secondAlternativePeriodDateTo?: Date;
    secondAlternativeEntryDate?: Date;
    secondAlternativeDays?: number;
    secondAlternativeStatus?: PersonRequestVacStatus;
    commentPerson?: string;
    commentPlanner?: string;
    commentVisibleToCrew?: string;
    minRequestDate: Date;
    maxRequestDate: Date;
}
export class VacRequestReportModel extends BaseApiModelClass< IVacRequestReportModel > implements IVacRequestReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    requestBlockId: string;
    requestBlockStatus: PersonRequestVacBlockStatus;
    decision: PersonRequestVacBlockDecision;
    personId: string;
    personCode: string;
    personName?: string;
    personSeniority: number;
    personSeniorityRank: number;
    entryDate?: Date;
    exitDate?: Date;
    personContract?: number;
    personFunction?: string;
    personAircrafts?: string;
    fleetType?: string;
    createdDate: Date;
    vacationYear: string;
    vacationYearPeriod: string;
    type: PersonRequestVacType;
    vacationDaysGrantedPerYear: number;
    isEntitlementActualYear80: boolean;
    vacationDaysConfirmed: number;
    vacationDaysPendingConfirmed: number;
    vacationDaysSumConfirmed: number;
    vacationDaysRemaining: number;
    vacationPointsP: number;
    vacationPointsS: number;
    vacationPointsN: number;
    points: number;
    approvedDateFrom?: Date;
    approvedDateTo?: Date;
    approvedDaysInBlock?: number;
    approvedVacDaysInBlock?: number;
    variantHighPrioId: string;
    variantHighPrioPeriodDateFrom: Date;
    variantHighPrioPeriodDateTo: Date;
    variantHighPrioEntryDate: Date;
    variantHighPrioDays: number;
    variantHighPrioDaysMin?: number;
    variantHighPrioStatus: PersonRequestVacStatus;
    variantMediumPrioId?: string;
    variantMediumPrioPeriodDateFrom?: Date;
    variantMediumPrioPeriodDateTo?: Date;
    variantMediumPrioEntryDate?: Date;
    variantMediumPrioDays?: number;
    variantMediumPrioDaysMin?: number;
    variantMediumPrioStatus?: PersonRequestVacStatus;
    variantLowPrioId?: string;
    variantLowPrioPeriodDateFrom?: Date;
    variantLowPrioPeriodDateTo?: Date;
    variantLowPrioEntryDate?: Date;
    variantLowPrioDays?: number;
    variantLowPrioDaysMin?: number;
    variantLowPrioStatus?: PersonRequestVacStatus;
    firstAlternativeId?: string;
    firstAlternativePeriodDateFrom?: Date;
    firstAlternativePeriodDateTo?: Date;
    firstAlternativeEntryDate?: Date;
    firstAlternativeDays?: number;
    firstAlternativeStatus?: PersonRequestVacStatus;
    secondAlternativeId?: string;
    secondAlternativePeriodDateFrom?: Date;
    secondAlternativePeriodDateTo?: Date;
    secondAlternativeEntryDate?: Date;
    secondAlternativeDays?: number;
    secondAlternativeStatus?: PersonRequestVacStatus;
    commentPerson?: string;
    commentPlanner?: string;
    commentVisibleToCrew?: string;
    minRequestDate: Date;
    maxRequestDate: Date;
}

export interface IVacRequestReportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}
export class VacRequestReportModelDataSourceLoadOptions extends BaseApiModelClass< IVacRequestReportModelDataSourceLoadOptions > implements IVacRequestReportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}

export interface IVacRequestTypeModel {
    label: string;
    value: string;
}
export class VacRequestTypeModel extends BaseApiModelClass< IVacRequestTypeModel > implements IVacRequestTypeModel {
    label: string;
    value: string;
}

export interface IVacRequestUpdateSelectedRangeModel {
    requestId: string;
    selectedDateFrom: Date;
    selectedDateTo: Date;
}
export class VacRequestUpdateSelectedRangeModel extends BaseApiModelClass< IVacRequestUpdateSelectedRangeModel > implements IVacRequestUpdateSelectedRangeModel {
    requestId: string;
    selectedDateFrom: Date;
    selectedDateTo: Date;
}

export interface IVacYearFilterModel {
    value: string;
    label: string;
    personGroupType: PersonGroupType;
}
export class VacYearFilterModel extends BaseApiModelClass< IVacYearFilterModel > implements IVacYearFilterModel {
    value: string;
    label: string;
    personGroupType: PersonGroupType;
}

export interface IVacYearPeriodModel {
    label: string;
    value: string;
    vacationYear: string;
    personGroupType: PersonGroupType;
    status: VacationYearPeriodStatus;
}
export class VacYearPeriodModel extends BaseApiModelClass< IVacYearPeriodModel > implements IVacYearPeriodModel {
    label: string;
    value: string;
    vacationYear: string;
    personGroupType: PersonGroupType;
    status: VacationYearPeriodStatus;
}

export interface IVacYearPeriodReportFilterModel {
    label: string;
    value: string;
}
export class VacYearPeriodReportFilterModel extends BaseApiModelClass< IVacYearPeriodReportFilterModel > implements IVacYearPeriodReportFilterModel {
    label: string;
    value: string;
}

export interface IVacYearPeriodReportFilterOption {
    codeName: string;
    status: VacationYearPeriodStatus;
}
export class VacYearPeriodReportFilterOption extends BaseApiModelClass< IVacYearPeriodReportFilterOption > implements IVacYearPeriodReportFilterOption {
    codeName: string;
    status: VacationYearPeriodStatus;
}

export interface IVacYearReportFilterModel {
    value: string;
    label: string;
}
export class VacYearReportFilterModel extends BaseApiModelClass< IVacYearReportFilterModel > implements IVacYearReportFilterModel {
    value: string;
    label: string;
}

export enum VacationType {
    Normal = "Normal",
    Priority = "Priority",
    School = "School",
    U_UBU = "U_UBU",
    U_VAC = "U_VAC",
    UBU_C = "UBU_C",
    UBU_JS = "UBU_JS",
    UBU_P = "UBU_P",
    UBUplus = "UBUplus",
    Unpaid = "Unpaid",
    UnpaidReleased = "UnpaidReleased",
    VAC = "VAC",
    Variable = "Variable",
    Wish = "Wish",
}

export interface IVacationYearDto {
    id: string;
    codeName: string;
    dateFrom: Date;
    dateTo: Date;
    personGroupType: PersonGroupType;
    functionGroupId: string;
    hasOpenedPeriods: boolean;
}
export class VacationYearDto extends BaseApiModelClass< IVacationYearDto > implements IVacationYearDto {
    id: string;
    codeName: string;
    dateFrom: Date;
    dateTo: Date;
    personGroupType: PersonGroupType;
    readonly functionGroupId: string;
    hasOpenedPeriods: boolean;
}

export interface IVacationYearPeriodDto {
    id: string;
    codeName: string;
    personGroupType: PersonGroupType;
    dateFrom: Date;
    dateTo: Date;
    status: VacationYearPeriodStatus;
    vacationYearId: string;
    vacationYearCodeName: string;
    vacationYearDateFrom: Date;
    vacationYearDateTo: Date;
}
export class VacationYearPeriodDto extends BaseApiModelClass< IVacationYearPeriodDto > implements IVacationYearPeriodDto {
    id: string;
    codeName: string;
    personGroupType: PersonGroupType;
    dateFrom: Date;
    dateTo: Date;
    status: VacationYearPeriodStatus;
    vacationYearId: string;
    vacationYearCodeName: string;
    vacationYearDateFrom: Date;
    vacationYearDateTo: Date;
}

export enum VacationYearPeriodStatus {
    Approval = "Approval",
    Closed = "Closed",
    Extended = "Extended",
    OpenRoundOne = "OpenRoundOne",
    OpenRoundTwo = "OpenRoundTwo",
    Upcoming = "Upcoming",
}

export interface IValidationCommentDto {
    commentId?: string;
    personId: string;
    date: Date;
    text: string;
}
export class ValidationCommentDto extends BaseApiModelClass< IValidationCommentDto > implements IValidationCommentDto {
    commentId?: string;
    personId: string;
    date: Date;
    text: string;
}

export enum ValidationErrorCategory {
    Agreement = "Agreement",
    EASA = "EASA",
    Ftl = "Ftl",
    Gav = "Gav",
    GroundError = "GroundError",
    GroundWarning = "GroundWarning",
    License = "License",
    Lte = "Lte",
    None = "None",
    Other = "Other",
    RequestTool = "RequestTool",
    Roster = "Roster",
    RosterGround = "RosterGround",
    Warning = "Warning",
}

export interface IValidationErrorModel {
    message: string;
    errorType: string;
}
export class ValidationErrorModel extends BaseApiModelClass< IValidationErrorModel > implements IValidationErrorModel {
    message: string;
    errorType: string;
}

export interface IValidationErrorsRequestModel {
    dutyCells: DutyCellModel[];
}
export class ValidationErrorsRequestModel extends BaseApiModelClass< IValidationErrorsRequestModel > implements IValidationErrorsRequestModel {
    dutyCells: DutyCellModel[];
}

export interface IValidatorCustomLanding {
    date: Date;
    airportRcd?: string;
    aircraftTypeId: string;
    count: number;
}
export class ValidatorCustomLanding extends BaseApiModelClass< IValidatorCustomLanding > implements IValidatorCustomLanding {
    date: Date;
    airportRcd?: string;
    aircraftTypeId: string;
    count: number;
}

export interface IValidatorCustomTakeoff {
    date: Date;
    airportRcd?: string;
    aircraftTypeId: string;
    count: number;
}
export class ValidatorCustomTakeoff extends BaseApiModelClass< IValidatorCustomTakeoff > implements IValidatorCustomTakeoff {
    date: Date;
    airportRcd?: string;
    aircraftTypeId: string;
    count: number;
}

export enum VasaSalaryPeriodStatus {
    Failed = "Failed",
    Imported = "Imported",
    Pending = "Pending",
    ReadyToRelease = "ReadyToRelease",
    Released = "Released",
}

export interface IWebBasedTrainingCreateModel {
    personId: string;
    competencyId: string;
    date: Date;
}
export class WebBasedTrainingCreateModel extends BaseApiModelClass< IWebBasedTrainingCreateModel > implements IWebBasedTrainingCreateModel {
    personId: string;
    competencyId: string;
    date: Date;
}

export interface IWebBasedTrainingDto {
    competencyId: string;
    competencyName: string;
    date: Date;
}
export class WebBasedTrainingDto extends BaseApiModelClass< IWebBasedTrainingDto > implements IWebBasedTrainingDto {
    competencyId: string;
    competencyName: string;
    date: Date;
}

export interface IWishHistoryModel {
    principalName: string;
    wishName: string;
    newStatus?: PersonWishStatus;
    olStatus?: PersonWishStatus;
    timestamp: Date;
    type: DutyLogType;
}
export class WishHistoryModel extends BaseApiModelClass< IWishHistoryModel > implements IWishHistoryModel {
    principalName: string;
    wishName: string;
    newStatus?: PersonWishStatus;
    olStatus?: PersonWishStatus;
    timestamp: Date;
    type: DutyLogType;
}

export interface IWishTypeModel {
    id: string;
    name: string;
}
export class WishTypeModel extends BaseApiModelClass< IWishTypeModel > implements IWishTypeModel {
    id: string;
    name: string;
}

export interface IWorkHoursModel {
    workHoursActualSecs: number;
    workHoursPlannedSecs: number;
    workHoursBalanceSecs: number;
    workHoursDiffSecs: number;
    workHours1DaySecs: number;
    workHourTib1DaySecs: number;
    workHourTib1DayMidnight: number;
    workHoursActualTibSecs: number;
    workHours1DayPlannedSecs: number;
}
export class WorkHoursModel extends BaseApiModelClass< IWorkHoursModel > implements IWorkHoursModel {
    workHoursActualSecs: number;
    workHoursPlannedSecs: number;
    workHoursBalanceSecs: number;
    workHoursDiffSecs: number;
    workHours1DaySecs: number;
    workHourTib1DaySecs: number;
    workHourTib1DayMidnight: number;
    workHoursActualTibSecs: number;
    workHours1DayPlannedSecs: number;
}

export interface IXStarCommentModel {
    dutyId: string;
    comment: string;
}
export class XStarCommentModel extends BaseApiModelClass< IXStarCommentModel > implements IXStarCommentModel {
    dutyId: string;
    comment: string;
}

export interface IXStarMonitoringReportFilter {
    rowLimit?: number;
    dutyId?: string;
    dateFrom: Date;
    dateTo: Date;
}
export class XStarMonitoringReportFilter extends BaseApiModelClass< IXStarMonitoringReportFilter > implements IXStarMonitoringReportFilter {
    rowLimit?: number;
    dutyId?: string;
    dateFrom: Date;
    dateTo: Date;
}

export interface IXStarMonitoringReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    dutyId: string;
    date: Date;
    airlineRcd: string;
    flightNumber: number;
    originRcd: string;
    destinationRcd: string;
    plannedDepartureDateTimeUtc: Date;
    plannedArrivalDateTimeUtc: Date;
    estimatedDepartureDateTimeUtc?: Date;
    estimatedArrivalDateTimeUtc?: Date;
    departureDateTimeUtc: Date;
    arrivalDateTimeUtc: Date;
    checkinDateTimeUtc?: Date;
    plannedCheckinDateTimeUtc?: Date;
    checkoutDateTimeUtc?: Date;
    outOfTheGateUtc?: Date;
    onTheGroundUtc?: Date;
    intoTheGateUtc?: Date;
    dutyPeriodFrom?: Date;
    dutyPeriodTo?: Date;
    personCode: string;
    activityCodeName: string;
    cas?: number;
    overdutyMinutes?: number;
    actualFdpMinutes?: number;
    actualMfdpSecs?: number;
    comment?: string;
    commentModifiedBy?: string;
    commentModifiedAt?: Date;
}
export class XStarMonitoringReportModel extends BaseApiModelClass< IXStarMonitoringReportModel > implements IXStarMonitoringReportModel {
    key?: any;
    items: any[];
    count?: number;
    summary?: any[];
    dutyId: string;
    date: Date;
    airlineRcd: string;
    flightNumber: number;
    originRcd: string;
    destinationRcd: string;
    plannedDepartureDateTimeUtc: Date;
    plannedArrivalDateTimeUtc: Date;
    estimatedDepartureDateTimeUtc?: Date;
    estimatedArrivalDateTimeUtc?: Date;
    readonly departureDateTimeUtc: Date;
    readonly arrivalDateTimeUtc: Date;
    checkinDateTimeUtc?: Date;
    plannedCheckinDateTimeUtc?: Date;
    checkoutDateTimeUtc?: Date;
    outOfTheGateUtc?: Date;
    onTheGroundUtc?: Date;
    intoTheGateUtc?: Date;
    dutyPeriodFrom?: Date;
    dutyPeriodTo?: Date;
    personCode: string;
    activityCodeName: string;
    cas?: number;
    overdutyMinutes?: number;
    actualFdpMinutes?: number;
    actualMfdpSecs?: number;
    comment?: string;
    commentModifiedBy?: string;
    commentModifiedAt?: Date;
}

export interface IXStarMonitoringReportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}
export class XStarMonitoringReportModelDataSourceLoadOptions extends BaseApiModelClass< IXStarMonitoringReportModelDataSourceLoadOptions > implements IXStarMonitoringReportModelDataSourceLoadOptions {
    requireTotalCount: boolean;
    requireGroupCount: boolean;
    isCountQuery: boolean;
    isSummaryQuery: boolean;
    skip: number;
    take: number;
    sort?: SortingInfo[];
    group?: GroupingInfo[];
    totalSummary?: SummaryInfo[];
    groupSummary?: SummaryInfo[];
    select?: string[];
    preSelect?: string[];
    remoteSelect?: boolean;
    remoteGrouping?: boolean;
    expandLinqSumType?: boolean;
    primaryKey?: string[];
    defaultSort?: string;
    stringToLower?: boolean;
    paginateViaPrimaryKey?: boolean;
    sortByPrimaryKey?: boolean;
    allowAsyncOverSync: boolean;
    hasInvalidEntries: boolean;
    filter?: any[];
}
export interface FileParameter {
    data: any;
    fileName: string;
}